/*!
 * package : @gip-recia/esco-content-menu-lit
 * version : 0.4.1
 * author : Julien Gribonvald <julien.gribonvald@gmail.com>
 * build time : 4/24/2025, 12:08:45 PM
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 8947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "api": function() { return /* binding */ api; },
/* harmony export */   "config": function() { return /* binding */ config$1; },
/* harmony export */   "counter": function() { return /* binding */ counter; },
/* harmony export */   "dom": function() { return /* binding */ dom$1; },
/* harmony export */   "findIconDefinition": function() { return /* binding */ findIconDefinition$1; },
/* harmony export */   "icon": function() { return /* binding */ icon; },
/* harmony export */   "layer": function() { return /* binding */ layer; },
/* harmony export */   "library": function() { return /* binding */ library$1; },
/* harmony export */   "noAuto": function() { return /* binding */ noAuto$1; },
/* harmony export */   "parse": function() { return /* binding */ parse$1; },
/* harmony export */   "text": function() { return /* binding */ text; },
/* harmony export */   "toHtml": function() { return /* binding */ toHtml$1; }
/* harmony export */ });
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.1.1\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;




/***/ }),

/***/ 8512:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [61446,11088];
var unicode = 'f005';
var svgPathData = 'M287.9 0C297.1 0 305.5 5.25 309.5 13.52L378.1 154.8L531.4 177.5C540.4 178.8 547.8 185.1 550.7 193.7C553.5 202.4 551.2 211.9 544.8 218.2L433.6 328.4L459.9 483.9C461.4 492.9 457.7 502.1 450.2 507.4C442.8 512.7 432.1 513.4 424.9 509.1L287.9 435.9L150.1 509.1C142.9 513.4 133.1 512.7 125.6 507.4C118.2 502.1 114.5 492.9 115.1 483.9L142.2 328.4L31.11 218.2C24.65 211.9 22.36 202.4 25.2 193.7C28.03 185.1 35.5 178.8 44.49 177.5L197.7 154.8L266.3 13.52C270.4 5.249 278.7 0 287.9 0L287.9 0zM287.9 78.95L235.4 187.2C231.9 194.3 225.1 199.3 217.3 200.5L98.98 217.9L184.9 303C190.4 308.5 192.9 316.4 191.6 324.1L171.4 443.7L276.6 387.5C283.7 383.7 292.2 383.7 299.2 387.5L404.4 443.7L384.2 324.1C382.9 316.4 385.5 308.5 391 303L476.9 217.9L358.6 200.5C350.7 199.3 343.9 194.3 340.5 187.2L287.9 78.95z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5020:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'chevron-left';
var width = 320;
var height = 512;
var aliases = [9001];
var unicode = 'f053';
var svgPathData = 'M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5394:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var aliases = [9002];
var unicode = 'f054';
var svgPathData = 'M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var source = __webpack_require__(9740);
exports.definition = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.faExchangeAlt = exports.definition;
exports.prefix = source.prefix;
exports.iconName = source.iconName;
exports.width = source.width;
exports.height = source.height;
exports.ligatures = source.aliases;
exports.unicode = source.unicode;
exports.svgPathData = source.svgPathData;
exports.aliases = source.aliases;

/***/ }),

/***/ 7982:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'magnifying-glass';
var width = 512;
var height = 512;
var aliases = [128269,"search"];
var unicode = 'f002';
var svgPathData = 'M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMagnifyingGlass = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5216:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'right-from-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-out-alt"];
var unicode = 'f2f5';
var svgPathData = 'M96 480h64C177.7 480 192 465.7 192 448S177.7 416 160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64C177.7 96 192 81.67 192 64S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256C0 437 42.98 480 96 480zM504.8 238.5l-144.1-136c-6.975-6.578-17.2-8.375-26-4.594c-8.803 3.797-14.51 12.47-14.51 22.05l-.0918 72l-128-.001c-17.69 0-32.02 14.33-32.02 32v64c0 17.67 14.34 32 32.02 32l128 .001l.0918 71.1c0 9.578 5.707 18.25 14.51 22.05c8.803 3.781 19.03 1.984 26-4.594l144.1-136C514.4 264.4 514.4 247.6 504.8 238.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRightFromBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 9740:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'right-left';
var width = 512;
var height = 512;
var aliases = ["exchange-alt"];
var unicode = 'f362';
var svgPathData = 'M32 160h319.9l.0791 72c0 9.547 5.652 18.19 14.41 22c8.754 3.812 18.93 2.078 25.93-4.406l112-104c10.24-9.5 10.24-25.69 0-35.19l-112-104c-6.992-6.484-17.17-8.217-25.93-4.408c-8.758 3.816-14.41 12.46-14.41 22L351.9 96H32C14.31 96 0 110.3 0 127.1S14.31 160 32 160zM480 352H160.1L160 279.1c0-9.547-5.652-18.19-14.41-22C136.9 254.2 126.7 255.9 119.7 262.4l-112 104c-10.24 9.5-10.24 25.69 0 35.19l112 104c6.992 6.484 17.17 8.219 25.93 4.406C154.4 506.2 160 497.5 160 488L160.1 416H480c17.69 0 32-14.31 32-32S497.7 352 480 352z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRightLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 5337:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var source = __webpack_require__(7982);
exports.definition = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.faSearch = exports.definition;
exports.prefix = source.prefix;
exports.iconName = source.iconName;
exports.width = source.width;
exports.height = source.height;
exports.ligatures = source.aliases;
exports.unicode = source.unicode;
exports.svgPathData = source.svgPathData;
exports.aliases = source.aliases;

/***/ }),

/***/ 6427:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var source = __webpack_require__(5216);
exports.definition = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.faSignOutAlt = exports.definition;
exports.prefix = source.prefix;
exports.iconName = source.iconName;
exports.width = source.width;
exports.height = source.height;
exports.ligatures = source.aliases;
exports.unicode = source.unicode;
exports.svgPathData = source.svgPathData;
exports.aliases = source.aliases;

/***/ }),

/***/ 3461:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [61446,11088];
var unicode = 'f005';
var svgPathData = 'M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 9545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var source = __webpack_require__(7709);
exports.definition = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.faTimes = exports.definition;
exports.prefix = source.prefix;
exports.iconName = source.iconName;
exports.width = source.width;
exports.height = source.height;
exports.ligatures = source.aliases;
exports.unicode = source.unicode;
exports.svgPathData = source.svgPathData;
exports.aliases = source.aliases;

/***/ }),

/***/ 7879:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'user';
var width = 448;
var height = 512;
var aliases = [62144,128100];
var unicode = 'f007';
var svgPathData = 'M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7709:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 320;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 7220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ openIdConnect; },
  "tokenize": function() { return /* binding */ tokenize; }
});

;// CONCATENATED MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@uportal/open-id-connect/esm/open-id-connect.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Options for getting tokens
 * @typedef {Object} Options
 * @property {string} [userInfoApiUrl] - url to Open ID Connect endpoint
 * @property {number} [timeout] - time in milliseconds until token will be
 *                                invalid
 * @property {Object} [propertyTransforms] - apply additional transforms to
 *                                           specific properties
 */

/**
 * Callback to resolve Open ID Connect token
 * @callback tokenCallback
 * @param {?Error} err -
 * @param {?Object} token - with encoded and decoded values
 */

/**
 * Get token from uPortal Open ID Connect service
 * @param {Options} [options] - allow setting a custom user info API url and a
 *                              custom clock smear
 * @param {tokenCallback} [callback] - optional callback, alternative to Promise
 *                                     API
 * @return {Promise<Object>} Promise that resolves with the encoded and decoded
 *                           token in an Object
 */

function openIdConnect() {
  return _openIdConnect.apply(this, arguments);
}
/**
 * Extract JWT contents
 * @param {string} jwt - JSON Web Token to decode
 * @return {Object} with encoded and decoded values
 */

function _openIdConnect() {
  _openIdConnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref,
        _ref$userInfoApiUrl,
        userInfoApiUrl,
        _ref$propertyTransfor,
        propertyTransforms,
        callback,
        response,
        data,
        token,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$userInfoApiUrl = _ref.userInfoApiUrl, userInfoApiUrl = _ref$userInfoApiUrl === void 0 ? '/uPortal/api/v5-1/userinfo' : _ref$userInfoApiUrl, _ref$propertyTransfor = _ref.propertyTransforms, propertyTransforms = _ref$propertyTransfor === void 0 ? {} : _ref$propertyTransfor;
            callback = _args.length > 1 ? _args[1] : undefined;
            _context.prev = 2;
            _context.next = 5;
            return fetch(userInfoApiUrl, {
              method: 'GET',
              credentials: 'include'
            });

          case 5:
            response = _context.sent;

            if (response.ok) {
              _context.next = 8;
              break;
            }

            throw new Error(response.statusText);

          case 8:
            _context.next = 10;
            return response.text();

          case 10:
            data = _context.sent;
            // store the encoded and decoded versions
            token = tokenize(data); // Allow for additional transforms to be applied to decoded properties

            Object.entries(propertyTransforms).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  property = _ref3[0],
                  transform = _ref3[1];

              token.decoded[property] = transform(token.decoded[property]);
            }); // pass value to optional call back

            if (!callback) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", callback(null, token));

          case 15:
            return _context.abrupt("return", token);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);

            /*tslint:disable no-console */
            console.error(_context.t0); // pass back error for callback

            if (!callback) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", callback(_context.t0));

          case 23:
            throw _context.t0;

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 18]]);
  }));
  return _openIdConnect.apply(this, arguments);
}

function tokenize(jwt) {
  return {
    encoded: jwt,
    decoded: jwt_decode_esm(jwt)
  };
}




/***/ }),

/***/ 776:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ActionFavorites = void 0;
/*Lit */

const lit_1 = __webpack_require__(9392);

const unsafe_html_js_1 = __webpack_require__(1943);

const decorators_js_1 = __webpack_require__(5595);

const class_map_js_1 = __webpack_require__(9455);
/*SCSS*/


const action_favorites_scss_1 = __importDefault(__webpack_require__(4104));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Dependencies*/


const fontawesome_svg_core_1 = __webpack_require__(8947);

const faStar_1 = __webpack_require__(3461);

const faStar_2 = __webpack_require__(8512);

let ActionFavorites = class ActionFavorites extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super();
    this.messages = [];
    this.fname = '';
    this.chanId = 0;
    this.backGroundIsDark = false;
    this.isFavorite = false;
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  shouldUpdate() {
    if (this.fname === '') {
      this.errorLog('fname attribute is required');
      return false;
    }

    return true;
  }

  firstUpdated() {
    this.setLogIdentifier(this.fname);
    this.debugLog('First update');
  }

  favoriteMessage() {
    return this.isFavorite ? langHelper_1.default.localTransation('favorites.remove', (0, localize_1.msg)((0, localize_1.str)`Remove from favorites`)) : langHelper_1.default.localTransation('favorites.add', (0, localize_1.msg)((0, localize_1.str)`Add to favorites`));
  }

  toggleFavorite(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isFavorite = !this.isFavorite;
    const toggleEvt = new CustomEvent('toggle', {
      detail: {
        fname: this.fname,
        chanId: this.chanId,
        isFavorite: this.isFavorite,
        send: false
      }
    });
    this.dispatchEvent(toggleEvt);
  }

  render() {
    const classList = {
      [this.fname]: true,
      'background-dark': this.backGroundIsDark
    };
    const starIcon = this.isFavorite ? `${(0, fontawesome_svg_core_1.icon)(faStar_1.faStar).html}` : `${(0, fontawesome_svg_core_1.icon)(faStar_2.faStar).html}`;
    return (0, lit_1.html)`
      <div
        class="action-favorites ${(0, class_map_js_1.classMap)(classList)}"
        title="${this.favoriteMessage()}"
        @click="${this.toggleFavorite}"
      >
        <button class="favorite-button">
          <span class="sr-only">${this.favoriteMessage()}</span>
          ${(0, unsafe_html_js_1.unsafeHTML)(starIcon)}
        </button>
      </div>
    `;
  }

};
ActionFavorites.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(action_favorites_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ActionFavorites.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String
})], ActionFavorites.prototype, "fname", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'chan-id'
})], ActionFavorites.prototype, "chanId", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'background-is-dark'
})], ActionFavorites.prototype, "backGroundIsDark", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], ActionFavorites.prototype, "isFavorite", void 0);

ActionFavorites = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-action-favorites')], ActionFavorites);
exports.ActionFavorites = ActionFavorites;

/***/ }),

/***/ 4525:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6699);

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContentFavorites = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const unsafe_html_js_1 = __webpack_require__(1943);

const decorators_js_1 = __webpack_require__(5595);

const class_map_js_1 = __webpack_require__(9455);

const style_map_js_1 = __webpack_require__(3959);

const repeat_js_1 = __webpack_require__(2386);
/*SCSS*/


const content_favorites_scss_1 = __importDefault(__webpack_require__(5150));

const swiper_bundle_min_css_1 = __importDefault(__webpack_require__(5641));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Services*/


const portletService_1 = __importDefault(__webpack_require__(9273));
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));

const pathHelper_1 = __importDefault(__webpack_require__(4093));
/*Dependencies*/


const fontawesome_svg_core_1 = __webpack_require__(8947);

const faChevronLeft_1 = __webpack_require__(5020);

const faChevronRight_1 = __webpack_require__(5394);

const debounce_1 = __importDefault(__webpack_require__(3279));

const swiper_1 = __importStar(__webpack_require__(1020));
/*Components*/


__webpack_require__(9832);

__webpack_require__(5830);

let ContentFavorites = class ContentFavorites extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    super();
    this.messages = [];
    this.portalBaseUrl = (_a = "") !== null && _a !== void 0 ? _a : '';
    this.parentScreenSize = 'medium';
    this.cardSize = 'small';
    this.backgroundColor = 'rgba(0, 0, 0, 0)';
    this.contextApiUrl = (_b = "/uPortal") !== null && _b !== void 0 ? _b : '';
    this.favoriteApiUrl = ((_c = "/uPortal") !== null && _c !== void 0 ? _c : '') + ((_d = "/api/layout") !== null && _d !== void 0 ? _d : '');
    this.portletApiUrl = ((_e = "/uPortal") !== null && _e !== void 0 ? _e : '') + ((_f = "/api/v4-3/dlm/portletRegistry.json") !== null && _f !== void 0 ? _f : '');
    this.userInfoApiUrl = ((_g = "/uPortal") !== null && _g !== void 0 ? _g : '') + ((_h = "/api/v5-1/userinfo") !== null && _h !== void 0 ? _h : '');
    this.userInfo = null;
    this.portlets = [];
    this.favorites = [];
    this.hide = false;
    this.hideAction = false;
    this.disableSwiper = false;
    this.disableCache = false;
    this.cacheTTL = parseInt((_j = "60") !== null && _j !== void 0 ? _j : '60');
    this.debug = false;
    this._elementSize = 'medium';
    this._swiperObj = undefined;
    this._prevSiperBtnIsAtive = false;
    this._nextSiperBtnIsAtive = true;
    this.debounceCalculateSize = (0, debounce_1.default)(this.calculateSize, 300);
    this.debounceUpdateNavigation = (0, debounce_1.default)(this.updateNavigation, 500);
    this.debugLog('Component loaded');
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.debounceCalculateSize.bind(this), false);
  }

  disconnectedCallback() {
    super.connectedCallback();
    window.removeEventListener('resize', this.debounceCalculateSize.bind(this), false);
  }

  shouldUpdate(changedProperties) {
    if (changedProperties.has('cacheTTL')) {
      portletService_1.default.cacheTtl = this.cacheTTL;
    }

    if (changedProperties.has('disableCache')) {
      portletService_1.default.enabled = !this.disableCache;
    }

    return true;
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('messages')) {
      langHelper_1.default.setReference(this.messages);
    }
  }

  firstUpdated(changedProperties) {
    super.firstUpdated && super.firstUpdated(changedProperties);
    const swiperEl = this.renderRoot.querySelector('#swiper');

    if (swiperEl) {
      this._swiperObj = new swiper_1.default(swiperEl, {
        modules: [swiper_1.Navigation],
        slidesPerView: 'auto',
        spaceBetween: 5,
        speed: 800,
        freeMode: true,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        }
      });

      this._swiperObj.on('sliderMove', this.debounceUpdateNavigation.bind(this));

      this._swiperObj.on('reachEnd', this.debounceUpdateNavigation.bind(this));

      this._swiperObj.on('reachBeginning', this.debounceUpdateNavigation.bind(this));

      this.debounceUpdateNavigation.bind(this);
    }

    this.calculateSize();
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);
    this.updateNavigation();
  }

  calculateSize() {
    var _a;

    if (this.cardSize === 'auto') {
      const _size = sizeHelper_1.default.elementWidth((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#favsSection'));

      if (this.parentScreenSize === 'smaller' || _size < 660) {
        this._elementSize = 'smaller';
      } else if (this.parentScreenSize === 'small' || _size < 1280) {
        this._elementSize = 'small';
      } else if (this.parentScreenSize === 'medium' || _size < 1680) {
        this._elementSize = 'medium';
      } else {
        this._elementSize = 'large';
      }
    } else {
      this._elementSize = this.cardSize;
    }

    this.updateNavigation();
  }

  portletCardSize() {
    if (this.cardSize === 'auto') {
      return this._elementSize;
    }

    return this.cardSize;
  }

  getRenderPortletUrl(portlet) {
    return portletService_1.default.getRenderUrl(portlet, this.contextApiUrl);
  }

  hasAlternativeMaximizedUrl(portlet) {
    var _a;

    return ((_a = portletService_1.default.getAlternativeMaximizedUrl(portlet)) === null || _a === void 0 ? void 0 : _a.length) > 0;
  }

  getAlternativeMaximizedTarget(portlet) {
    return portletService_1.default.getAlternativeMaximizedTarget(portlet);
  }

  updateNavigation() {
    var _a, _b, _c;

    (_a = this._swiperObj) === null || _a === void 0 ? void 0 : _a.update();
    this._prevSiperBtnIsAtive = ((_b = this._swiperObj) === null || _b === void 0 ? void 0 : _b.isBeginning) ? false : true;
    this._nextSiperBtnIsAtive = ((_c = this._swiperObj) === null || _c === void 0 ? void 0 : _c.isEnd) ? false : true;
  }

  swipeRight() {
    var _a;

    (_a = this._swiperObj) === null || _a === void 0 ? void 0 : _a.slideNext();
    this.debounceUpdateNavigation();
  }

  swipeLeft() {
    var _a;

    (_a = this._swiperObj) === null || _a === void 0 ? void 0 : _a.slidePrev();
    this.debounceUpdateNavigation();
  }

  favorited() {
    return this.portlets.filter(portlet => this.favorites.includes(portlet.fname)).sort((a, b) => {
      return this.favorites.indexOf(a.fname) - this.favorites.indexOf(b.fname);
    });
  }

  toggleFavorite(e) {
    const event = new CustomEvent('toggle-favorite', {
      bubbles: true,
      detail: e.detail
    });
    this.dispatchEvent(event);
  }

  render() {
    const calcFavorites = this.favorited();
    const displayFavs = calcFavorites.length > 0;
    return (0, lit_1.html)`
      <section
        class="content-favorites ${(0, class_map_js_1.classMap)({
      ['parent-' + this.parentScreenSize]: true,
      [this._elementSize]: true
    })}"
        style="${(0, style_map_js_1.styleMap)({
      'background-color': this.backgroundColor
    })}"
      >
        <div class="content-favorites-title">
          <h1>
            ${langHelper_1.default.localTransation('favorites.title', (0, localize_1.msg)((0, localize_1.str)`My favorites`))}
          </h1>
        </div>
        <div
          id="favsSection"
          class="${(0, class_map_js_1.classMap)({
      favorites: displayFavs,
      'empty-favorites': !displayFavs
    })}"
        >
          ${displayFavs ? (0, lit_1.html)`
                ${!this.disableSwiper ? (0, lit_1.html)`
                      <div id="swiper" class="swiper">
                        <div class="swiper-wrapper">
                          ${(0, repeat_js_1.repeat)(calcFavorites, portlet => portlet.fname, portlet => {
      const hasAlternativeMaximizedUrl = this.hasAlternativeMaximizedUrl(portlet);
      return (0, lit_1.html)`
                                <div class="swiper-slide">
                                  <a
                                    href="${pathHelper_1.default.getUrl(this.getRenderPortletUrl(portlet), this.portalBaseUrl, this.debug)}"
                                    target="${hasAlternativeMaximizedUrl ? this.getAlternativeMaximizedTarget(portlet) : '_self'}"
                                    rel="${hasAlternativeMaximizedUrl ? 'noopener noreferrer' : ''}"
                                    class="no-style"
                                  >
                                    <esco-portlet-card
                                      .messages="${this.messages}"
                                      base-url="${this.portalBaseUrl}"
                                      .portletDesc="${portlet}"
                                      is-favorite
                                      size="${this.portletCardSize()}"
                                      ?hide-action=${this.hideAction}
                                      ?debug="${this.debug}"
                                      @toggle-favorite=${this.toggleFavorite}
                                      background-is-dark
                                    ></esco-portlet-card>
                                  </a>
                                </div>
                              `;
    })}
                        </div>
                      </div>
                      <div
                        slot="button-prev"
                        class="swiper-button-prev ${(0, class_map_js_1.classMap)({
      'fav-swiper-button-disabled': !this._prevSiperBtnIsAtive
    })}"
                        @click=${this.swipeLeft.bind(this)}
                      >
                        ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faChevronLeft_1.faChevronLeft).html}`)}
                      </div>
                      <div
                        slot="button-next"
                        class="swiper-button-next ${(0, class_map_js_1.classMap)({
      'fav-swiper-button-disabled': !this._nextSiperBtnIsAtive
    })}"
                        @click=${this.swipeRight.bind(this)}
                      >
                        ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faChevronRight_1.faChevronRight).html}`)}
                      </div>
                    ` : (0, lit_1.html)`
                      <esco-content-grid
                        hide-title
                        portal-base-url="${this.portalBaseUrl}"
                        portlet-card-size="${this._elementSize}"
                        .favorites="${this.favorites}"
                        .portlets="${calcFavorites}"
                        ?hide-action="${this.hideAction}"
                        favorite-api-url="${this.favoriteApiUrl}"
                        user-info-api-url="${this.userInfoApiUrl}"
                        user-info=${this.userInfo ? JSON.stringify(this.userInfo) : lit_1.nothing}
                        portlet-background-is-dark
                        parent-screen-size="${this.parentScreenSize}"
                        context-api-url="${this.contextApiUrl}"
                        portlet-api-url="${this.portletApiUrl}"
                        ?disable-cache="${this.disableCache}"
                        cache-ttl="${this.cacheTTL}"
                        ?debug=${this.debug}
                        @gridFavoritesUpdated="${this.toggleFavorite}"
                      ></esco-content-grid>
                    `}
              ` : (0, lit_1.html)`
                <div>
                  ${langHelper_1.default.localTransation('favorites.empty', (0, localize_1.msg)((0, localize_1.str)`You have no favorites`))}
                </div>
              `}
        </div>
      </section>
    `;
  }

};
ContentFavorites.styles = [(0, lit_1.css)`
      ${(0, lit_1.unsafeCSS)(content_favorites_scss_1.default)}
    `, (0, lit_1.css)`
      ${(0, lit_1.unsafeCSS)(swiper_bundle_min_css_1.default)}
    `];

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentFavorites.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portal-base-url'
})], ContentFavorites.prototype, "portalBaseUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'parent-screen-size'
})], ContentFavorites.prototype, "parentScreenSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'card-size'
})], ContentFavorites.prototype, "cardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'background-color'
})], ContentFavorites.prototype, "backgroundColor", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'context-api-url'
})], ContentFavorites.prototype, "contextApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'favorite-api-url'
})], ContentFavorites.prototype, "favoriteApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portlet-api-url'
})], ContentFavorites.prototype, "portletApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-api-url'
})], ContentFavorites.prototype, "userInfoApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Object,
  attribute: 'user-info'
})], ContentFavorites.prototype, "userInfo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentFavorites.prototype, "portlets", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentFavorites.prototype, "favorites", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], ContentFavorites.prototype, "hide", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'hide-action'
})], ContentFavorites.prototype, "hideAction", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'disable-swiper'
})], ContentFavorites.prototype, "disableSwiper", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'disable-cache'
})], ContentFavorites.prototype, "disableCache", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'cache-ttl'
})], ContentFavorites.prototype, "cacheTTL", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], ContentFavorites.prototype, "debug", void 0);

__decorate([(0, decorators_js_1.state)()], ContentFavorites.prototype, "_elementSize", void 0);

__decorate([(0, decorators_js_1.state)()], ContentFavorites.prototype, "_swiperObj", void 0);

__decorate([(0, decorators_js_1.state)()], ContentFavorites.prototype, "_prevSiperBtnIsAtive", void 0);

__decorate([(0, decorators_js_1.state)()], ContentFavorites.prototype, "_nextSiperBtnIsAtive", void 0);

__decorate([(0, decorators_js_1.query)('#swiper')], ContentFavorites.prototype, "swiper", void 0);

ContentFavorites = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-content-favorites')], ContentFavorites);
exports.ContentFavorites = ContentFavorites;

/***/ }),

/***/ 5830:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6699);

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContentGrid = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);

const unsafe_html_js_1 = __webpack_require__(1943);

const class_map_js_1 = __webpack_require__(9455);

const style_map_js_1 = __webpack_require__(3959);
/*SCSS*/


const content_grid_scss_1 = __importDefault(__webpack_require__(5636));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Services*/


const open_id_connect_1 = __importDefault(__webpack_require__(7220));

const portletService_1 = __importDefault(__webpack_require__(9273));

const favoritesService_1 = __importDefault(__webpack_require__(5925));
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));

const pathHelper_1 = __importDefault(__webpack_require__(4093));
/*Dependencies*/


const fontawesome_svg_core_1 = __webpack_require__(8947);

const faSearch_1 = __webpack_require__(5337);

const match_sorter_1 = __webpack_require__(4044);

const debounce_1 = __importDefault(__webpack_require__(3279));
/*Components*/


__webpack_require__(9832);

let ContentGrid = class ContentGrid extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

    super();
    this.messages = [];
    this.portalBaseUrl = (_a = "") !== null && _a !== void 0 ? _a : '';
    this.parentScreenSize = 'medium';
    this.cardSize = 'auto';
    this.elementSize = 'medium';
    this.backgroundColor = 'rgba(0, 0, 0, 0)';
    this.contextApiUrl = (_b = "/uPortal") !== null && _b !== void 0 ? _b : '';
    this.favoriteApiUrl = ((_c = "/uPortal") !== null && _c !== void 0 ? _c : '') + ((_d = "/api/layout") !== null && _d !== void 0 ? _d : '');
    this.layoutApiUrl = ((_e = "/uPortal") !== null && _e !== void 0 ? _e : '') + ((_f = "/api/v4-3/dlm/layout.json") !== null && _f !== void 0 ? _f : '');
    this.portletApiUrl = ((_g = "/uPortal") !== null && _g !== void 0 ? _g : '') + ((_h = "/api/v4-3/dlm/portletRegistry.json") !== null && _h !== void 0 ? _h : '');
    this.userInfoApiUrl = ((_j = "/uPortal") !== null && _j !== void 0 ? _j : '') + ((_k = "/api/v5-1/userinfo") !== null && _k !== void 0 ? _k : '');
    this.userInfo = null;
    this.cardHoverSrc = 'none';
    this.favorites = [];
    this.allCategories = [];
    this.portlets = [];
    this.hideTitle = false;
    this.showFooterCategories = false;
    this.hideAction = false;
    this.useExternalFilter = false;
    this.disableCache = false;
    this.cacheTTL = parseInt((_l = "60") !== null && _l !== void 0 ? _l : '60');
    this.debug = false;
    this.portletBackgroundIsDark = false;
    this._isVisible = false;
    this._filterValue = '';
    this._filterCategory = '';
    this._localFavorites = undefined;
    this._localPortlets = undefined;
    this._loading = false;
    this.debounceCalculateSize = (0, debounce_1.default)(this.calculateSize, 500);
    this.debounceCatFilterChange = (0, debounce_1.default)(value => {
      this._filterCategory = value;
      this.sendExternalFilter();
    }, 500);
    this.debounceValFilterChange = (0, debounce_1.default)(value => {
      this._filterValue = value;
      this.sendExternalFilter();
    }, 500);
    this.debugLog('Component loaded');
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('esco-cm-grid-filter', this.getExternalFilter.bind(this));
    window.addEventListener('esco-cm-request-grid-filter', this.sendExternalFilter);
    window.addEventListener('esco-cm-request-categories', this.sendCategories);
    window.addEventListener('gridFavoritesUpdated', this.reload.bind(this));
  }

  disconnectedCallback() {
    super.connectedCallback();
    window.removeEventListener('esco-cm-grid-filter', this.getExternalFilter);
    window.removeEventListener('esco-cm-request-grid-filter', this.sendExternalFilter);
    window.removeEventListener('esco-cm-request-categories', this.sendCategories);
    window.removeEventListener('gridFavoritesUpdated', this.reload.bind(this));
    window.removeEventListener('resize', this.debounceCalculateSize.bind(this), false);
  }

  shouldUpdate(changedProperties) {
    if (changedProperties.has('cacheTTL')) {
      portletService_1.default.cacheTtl = this.cacheTTL;
      favoritesService_1.default.cacheTtl = this.cacheTTL;
    }

    if (changedProperties.has('disableCache')) {
      portletService_1.default.enabled = !this.disableCache && !this.debug;
      favoritesService_1.default.enabled = !this.disableCache && !this.debug;
    }

    this.loadData(changedProperties.has('userInfo'));
    return this.portlets.length > 0 || this._localPortlets !== undefined;
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('parentScreenSize')) {
      this.elementSize = this.parentScreenSize;
    }

    if (changedProperties.has('messages')) {
      langHelper_1.default.setReference(this.messages);
    }
  }

  async loadData(reload) {
    if (this._loading) return;
    let userInfos = null;

    if (!this.debug) {
      this._loading = true;

      if (this.userInfo) {
        userInfos = this.userInfo;
      } else {
        userInfos = await (0, open_id_connect_1.default)({
          userInfoApiUrl: pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug)
        });
      }

      this._loading = false;
    }

    if (this.portlets.length < 1 || reload) this.fetchPortlets(userInfos);
    if (this.favorites.length < 1 || reload) this.fetchFavorites(userInfos);
    window.addEventListener('resize', this.debounceCalculateSize.bind(this), false);
  }

  async fetchPortlets(userInfos) {
    const portlets = await portletService_1.default.fetch(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.portletApiUrl, this.portalBaseUrl, this.debug), userInfos, this.debug);

    if (portlets !== null) {
      this._localPortlets = portletService_1.default.portletRegistryToArray(portlets);
    } else {
      this.errorLog('No portlets found');
    }
  }

  async fetchFavorites(userInfos) {
    const favoritesTree = await favoritesService_1.default.fetch(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.layoutApiUrl, this.portalBaseUrl, this.debug), userInfos, this.debug);

    if (favoritesTree != null) {
      this._localFavorites = favoritesService_1.default.flattenFavorites(favoritesTree);
    }
  }

  reload() {
    if (!this.debug) this.fetchPortlets(null);
  }

  calculateSize() {
    var _a;

    const element = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('content-grid');
    const size = sizeHelper_1.default.elementWidth(element);
    this.elementSize = sizeHelper_1.default.breakPointName(size);
  }

  calculateCategories() {
    const portlets = this.portlets.length > 0 ? this.portlets : this._localPortlets;
    const allCategories = portlets === null || portlets === void 0 ? void 0 : portlets.flatMap(({
      categories
    }) => categories);
    this.allCategories = [...new Set(allCategories)].sort();
    this.sendCategories();
  }

  filteredPortlets() {
    var _a;

    const portlets = this.portlets.length > 0 ? this.portlets : (_a = this._localPortlets) !== null && _a !== void 0 ? _a : [];
    const categoryFilter = this._filterCategory.trim() === '' ? // no filter applied return everything
    portlets => portlets : // filter by category
    portlets => (0, match_sorter_1.matchSorter)(portlets, this._filterCategory, {
      keys: ['categories'],
      threshold: match_sorter_1.matchSorter.rankings.EQUAL
    });
    const valueFilter = this._filterValue.trim() === '' ? // no filter applied return everything
    portlets => portlets : // filter and sort by best match
    portlets => (0, match_sorter_1.matchSorter)(portlets, this._filterValue, {
      keys: ['title', 'name', 'description'],
      threshold: match_sorter_1.matchSorter.rankings.ACRONYM
    });
    return valueFilter(categoryFilter(portlets).sort(portletService_1.default.sortPortlets));
  }

  portletCardSize() {
    // this.calculateSize();
    if (this.cardSize === 'auto') {
      return this.elementSize;
    }

    return this.cardSize;
  }

  getRenderPortletUrl(portlet) {
    return portletService_1.default.getRenderUrl(portlet, this.contextApiUrl);
  }

  hasAlternativeMaximizedUrl(portlet) {
    return portletService_1.default.getAlternativeMaximizedUrl(portlet);
  }

  getAlternativeMaximizedTarget(portlet) {
    return portletService_1.default.getAlternativeMaximizedTarget(portlet);
  }

  isFavorite(fname) {
    const favorites = this.favorites.length > 0 ? this.favorites : this._localFavorites;
    return (favorites === null || favorites === void 0 ? void 0 : favorites.includes(fname)) || false;
  }

  catFilterChange(e) {
    const target = e.target || e.srcElement;
    const value = target === null || target === void 0 ? void 0 : target.value;
    this.debounceCatFilterChange(value);
  }

  valFilterChange(e) {
    const target = e.target || e.srcElement;
    const value = target === null || target === void 0 ? void 0 : target.value;
    this.debounceValFilterChange(value);
  }

  getExternalFilter(e) {
    var _a;

    if ((this.allCategories.includes(e.detail.category) || e.detail.category == '') && this._filterCategory != e.detail.category) {
      this._filterCategory = e.detail.category;
    }

    if (((_a = e.detail) === null || _a === void 0 ? void 0 : _a.value) && this._filterValue != e.detail.value) {
      this._filterValue = e.detail.value;
    }
  }

  sendExternalFilter() {
    const filterEvt = new CustomEvent('esco-cm-grid-filter', {
      detail: {
        category: this._filterCategory,
        value: this._filterValue
      }
    });
    window.dispatchEvent(filterEvt);
  }

  sendCategories() {
    const catsEvt = new CustomEvent('esco-cm-categories', {
      detail: {
        categories: this.allCategories
      }
    });
    window.dispatchEvent(catsEvt);
  }

  toggleFavorite(e) {
    var _a, _b;

    if (this.favorites.length == 0) {
      if (this._localFavorites === undefined) this._localFavorites = [];

      if (!this._localFavorites.includes(e.detail.fname)) {
        this._localFavorites.push(e.detail.fname);
      } else {
        this._localFavorites.splice(this._localFavorites.indexOf(e.detail.fname), 1);
      }
    }

    if (!this.debug && ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.chanId) !== undefined && this.portlets.length >= 1) {
      if ((_b = e.detail) === null || _b === void 0 ? void 0 : _b.isFavorite) {
        favoritesService_1.default.add(this.userInfoApiUrl, this.favoriteApiUrl, e.detail.chanId);
      } else {
        favoritesService_1.default.remove(this.userInfoApiUrl, this.favoriteApiUrl, e.detail.chanId);
      }

      favoritesService_1.default.deleteCachedData(this.layoutApiUrl);
      e.detail.send = true;
    }

    const GFUevent = new CustomEvent('gridFavoritesUpdated', {
      bubbles: true,
      detail: e.detail
    });
    window.dispatchEvent(GFUevent);
    const TFevent = new CustomEvent('toggle-favorite', {
      bubbles: true,
      detail: e.detail
    });
    this.dispatchEvent(TFevent);
  }

  render() {
    this.calculateCategories();
    return (0, lit_1.html)`
      <section
        class="content-grid ${(0, class_map_js_1.classMap)({
      ['parent-' + this.parentScreenSize]: true,
      [this.elementSize]: true
    })}"
        style="${(0, style_map_js_1.styleMap)({
      'background-color': this.backgroundColor
    })}"
        id="content-grid"
      >
        <div>
          ${this.hideTitle ? (0, lit_1.html)`` : (0, lit_1.html)`
                <div class="title">
                  <slot name="header-left">
                    <h1>
                      ${langHelper_1.default.localTransation('services.title', (0, localize_1.msg)((0, localize_1.str)`All the services`))}
                    </h1>
                  </slot>
                  <slot name="header-right">${this.renderCatFilter()}</slot>
                </div>
              `}

          <div class="preamble">
            <slot name="preamble" class="preamble"></slot>
          </div>
          <div class="flex-grid">${this.renderPortlets()}</div>
          <slot name="footer">${this.renderCatFilterFooter()} </slot>
        </div>
      </section>
    `;
  }

  renderCatFilter() {
    if (this.hideTitle) {
      return (0, lit_1.html)``;
    } else {
      return (0, lit_1.html)`
        <div
          class="filter custom-caret ${(0, class_map_js_1.classMap)({
        opened: this._isVisible,
        closed: !this._isVisible
      })}"
        >
          <input
            title="${langHelper_1.default.localTransation('services.filter', (0, localize_1.msg)((0, localize_1.str)`Search a service...`))}"
            .value="${this._filterValue}"
            placeholder="${langHelper_1.default.localTransation('services.filter', (0, localize_1.msg)((0, localize_1.str)`Search a service...`))}"
            type="text"
            @keyup=${this.valFilterChange}
            @focus=${() => {
        this._filterValue = '';
        this.sendExternalFilter();
      }}
            autofocus
          />
          <select id="catFilter" @change=${this.catFilterChange}>
            <option class="default" selected value="">
              ${langHelper_1.default.localTransation('filter.selectOption', (0, localize_1.msg)((0, localize_1.str)`All the categories`))}
            </option>
            ${this.allCategories.map(cat => {
        var _a;

        return (0, lit_1.html)`<option
                  value="${(_a = cat) !== null && _a !== void 0 ? _a : ''}"
                  ?selected=${this._filterCategory === cat}
                >
                  ${cat}
                </option> `;
      })}
          </select>
          <div
            @click="${() => {
        this._isVisible = !this._isVisible;
      }}"
          >
            ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faSearch_1.faSearch).html}`)}
          </div>
        </div>
      `;
    }
  }

  renderCatFilterFooter() {
    if (this.showFooterCategories) {
      return (0, lit_1.html)`
        <select class="footer-categories" @change=${this.catFilterChange}>
          <option class="default" selected value="">
            ${langHelper_1.default.localTransation('filter.selectOption', (0, localize_1.msg)((0, localize_1.str)`All the categories`))}
          </option>
          ${this.allCategories.map(cat => {
        var _a;

        return (0, lit_1.html)`<option
                value="${(_a = cat) !== null && _a !== void 0 ? _a : ''}"
                ?selected=${this._filterCategory === cat}
              >
                ${cat}
              </option> `;
      })}
        </select>
      `;
    } else {
      return (0, lit_1.html)``;
    }
  }

  renderPortlets() {
    const portlets = this.filteredPortlets();
    const cardSize = this.portletCardSize();
    const template = (0, lit_1.html)`${portlets.map(portlet => {
      return (0, lit_1.html)`
        <div
          data-key="${portlet.id}"
          class="flex-item ma-3 text-xs-center ${(0, class_map_js_1.classMap)({
        ['portlet-card-' + cardSize]: true
      })}"
        >
          <a
            href="${pathHelper_1.default.getUrl(this.getRenderPortletUrl(portlet), this.portalBaseUrl, this.debug)}"
            target="${this.hasAlternativeMaximizedUrl(portlet) ? this.getAlternativeMaximizedTarget(portlet) : '_self'}"
            rel="${this.hasAlternativeMaximizedUrl(portlet) ? 'noopener noreferrer' : ''}"
            class="no-style"
          >
            <esco-portlet-card
              .messages=${this.messages}
              base-url=${this.portalBaseUrl}
              .portletDesc="${portlet}"
              ?is-favorite=${this.isFavorite(portlet.fname)}
              size="${cardSize}"
              card-hover-src="${this.cardHoverSrc}"
              ?hide-action=${this.hideAction}
              ?background-is-dark="${this.portletBackgroundIsDark}"
              ?debug="${this.debug}"
              @toggle-favorite=${this.toggleFavorite}
            ></esco-portlet-card>
          </a>
        </div>
      `;
    })} `;
    return template;
  }

};
ContentGrid.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(content_grid_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentGrid.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portal-base-url'
})], ContentGrid.prototype, "portalBaseUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'parent-screen-size'
})], ContentGrid.prototype, "parentScreenSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'portlet-card-size'
})], ContentGrid.prototype, "cardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: false
})], ContentGrid.prototype, "elementSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'background-color'
})], ContentGrid.prototype, "backgroundColor", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'context-api-url'
})], ContentGrid.prototype, "contextApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'favorite-api-url'
})], ContentGrid.prototype, "favoriteApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'layout-api-url'
})], ContentGrid.prototype, "layoutApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portlet-api-url'
})], ContentGrid.prototype, "portletApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-api-url'
})], ContentGrid.prototype, "userInfoApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Object,
  attribute: 'user-info'
})], ContentGrid.prototype, "userInfo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'card-hover-src'
})], ContentGrid.prototype, "cardHoverSrc", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Array,
  reflect: true
})], ContentGrid.prototype, "favorites", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Array,
  attribute: 'all-categories',
  reflect: true
})], ContentGrid.prototype, "allCategories", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentGrid.prototype, "portlets", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'hide-title'
})], ContentGrid.prototype, "hideTitle", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'show-footer-categories'
})], ContentGrid.prototype, "showFooterCategories", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'hide-action'
})], ContentGrid.prototype, "hideAction", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'use-external-filter'
})], ContentGrid.prototype, "useExternalFilter", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'disable-cache'
})], ContentGrid.prototype, "disableCache", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'cache-ttl'
})], ContentGrid.prototype, "cacheTTL", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], ContentGrid.prototype, "debug", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'portlet-background-is-dark'
})], ContentGrid.prototype, "portletBackgroundIsDark", void 0);

__decorate([(0, decorators_js_1.state)()], ContentGrid.prototype, "_isVisible", void 0);

__decorate([(0, decorators_js_1.state)()], ContentGrid.prototype, "_filterValue", void 0);

__decorate([(0, decorators_js_1.state)()], ContentGrid.prototype, "_filterCategory", void 0);

__decorate([(0, decorators_js_1.state)()], ContentGrid.prototype, "_localFavorites", void 0);

__decorate([(0, decorators_js_1.state)()], ContentGrid.prototype, "_localPortlets", void 0);

ContentGrid = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-content-grid')], ContentGrid);
exports.ContentGrid = ContentGrid;

/***/ }),

/***/ 589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6699);

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContentMenu = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);

const class_map_js_1 = __webpack_require__(9455);

const style_map_js_1 = __webpack_require__(3959);
/*SCSS*/


const content_menu_scss_1 = __importDefault(__webpack_require__(1818));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Services*/


const open_id_connect_1 = __importDefault(__webpack_require__(7220));

const portletService_1 = __importDefault(__webpack_require__(9273));

const favoritesService_1 = __importDefault(__webpack_require__(5925));

const organizationService_1 = __importDefault(__webpack_require__(4443));
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));

const pathHelper_1 = __importDefault(__webpack_require__(4093));
/*Components*/


__webpack_require__(5526);

__webpack_require__(4525);

__webpack_require__(5830);

__webpack_require__(6580);

__webpack_require__(9628);

let ContentMenu = class ContentMenu extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

    super();
    this.messages = [];
    this.portalBaseUrl = (_a = "") !== null && _a !== void 0 ? _a : '';
    this.favoritesPortletCardSize = 'small';
    this.gridPortletCardSize = 'auto';
    this.defaultOrgLogo = '';
    this.forceOrgLogo = '';
    this.contextApiUrl = (_b = "/uPortal") !== null && _b !== void 0 ? _b : '';
    this.favoriteApiUrl = ((_c = "/uPortal") !== null && _c !== void 0 ? _c : '') + ((_d = "/api/layout") !== null && _d !== void 0 ? _d : '');
    this.layoutApiUrl = ((_e = "/uPortal") !== null && _e !== void 0 ? _e : '') + ((_f = "/api/v4-3/dlm/layout.json") !== null && _f !== void 0 ? _f : '');
    this.portletApiUrl = ((_g = "/uPortal") !== null && _g !== void 0 ? _g : '') + ((_h = "/api/v4-3/dlm/portletRegistry.json") !== null && _h !== void 0 ? _h : '');
    this.organizationApiUrl = '';
    this.userInfoApiUrl = ((_j = "/uPortal") !== null && _j !== void 0 ? _j : '') + ((_k = "/api/v5-1/userinfo") !== null && _k !== void 0 ? _k : '');
    this.userInfo = null;
    this.signoutUrl = (_l = "/uPortal/Logout") !== null && _l !== void 0 ? _l : '';
    this.userInfoPortletUrl = '';
    this.switchOrgPortletUrl = '';
    this.switchOrgEvent = false;
    this.orgAttributeName = 'ESCOSIRENCourant[0]';
    this.orgLogoUrlAttributeName = 'otherAttributes.ESCOStructureLogo[0]';
    this.userAllOrgsIdAttributeName = 'ESCOSIREN';
    this.cardHoverSrc = 'none';
    this.hideActionMode = 'auto';
    this.isHidden = false;
    this.showFavoritesInSlider = false;
    this.disableCache = false;
    this.cacheTTL = parseInt((_m = "60") !== null && _m !== void 0 ? _m : '60');
    this.debug = false;
    this.fakeAttribute = false;
    this._screenSize = 'medium';
    this._hideAction = false;
    this._currentOrg = null;
    this._currentUser = null;
    this._currentUserOrgs = null;
    this._portlets = null;
    this._favorites = null;
    this._inError = false;
    this._forceOrgDisplayName = '';
    this._errorMessage = '';
    this._userInfos = null;
    this._loading = false;
    this.debugLog('Component loaded');
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.calculateSize.bind(this));
    window.addEventListener('update-structure-name', this.updateStructureName.bind(this));
    window.addEventListener('update-structure-logo', this.updateStructureLogo.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.calculateSize.bind(this));
    window.removeEventListener('update-structure-name', this.updateStructureName.bind(this));
    window.removeEventListener('update-structure-logo', this.updateStructureLogo.bind(this));
  }

  shouldUpdate(changedProperties) {
    if (this.defaultOrgLogo === '') {
      this.errorLog('default-org-logo attribute is required');
      return false;
    }

    if (changedProperties.has('cacheTTL')) {
      portletService_1.default.cacheTtl = this.cacheTTL;
      favoritesService_1.default.cacheTtl = this.cacheTTL;
      organizationService_1.default.cacheTtl = this.cacheTTL;
    }

    if (changedProperties.has('disableCache')) {
      portletService_1.default.enabled = !this.disableCache;
      favoritesService_1.default.enabled = !this.disableCache;
      organizationService_1.default.enabled = !this.disableCache;
    }

    this.loadDatas(changedProperties);
    return true;
  }

  updated(changedProperties) {
    if (changedProperties.has('isHidden')) {
      this.calculateSize();
    }
  }

  async loadDatas(changedProperties) {
    if (changedProperties.has('userInfo') || changedProperties.has('userInfoApiUrl') || changedProperties.has('portletApiUrl') || changedProperties.has('layoutApiUrl') || changedProperties.has('organizationApiUrl') || changedProperties.has('userAllOrgsIdAttributeName')) {
      const userInfoUpdated = changedProperties.has('userInfo');
      if (this._loading) return;

      if (!this.debug) {
        this._loading = true;

        if (this.userInfo) {
          this._userInfos = this.userInfo;
        } else {
          this._userInfos = await (0, open_id_connect_1.default)({
            userInfoApiUrl: pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug)
          });
        }

        this._loading = false;
      }

      if (!this._portlets || userInfoUpdated) this.fetchPortlets(this._userInfos);
      if (!this._favorites || userInfoUpdated) this.fetchFavorites(this._userInfos);
      if (!this._currentOrg || !this._currentUser || userInfoUpdated) this.fetchUserInfo(this._userInfos);
    }
  }

  async fetchPortlets(userInfos) {
    const portlets = await portletService_1.default.fetch(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.portletApiUrl, this.portalBaseUrl, this.debug), userInfos, this.debug);

    if (portlets) {
      this._portlets = portletService_1.default.portletRegistryToArray(portlets).sort(portletService_1.default.sortPortlets);
    } else {
      this._error('No portlets fetch from API');
    }
  }

  async fetchFavorites(userInfos) {
    const favoritesTree = await favoritesService_1.default.fetch(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.layoutApiUrl, this.portalBaseUrl, this.debug), userInfos, this.debug);

    if (favoritesTree) {
      this._favorites = favoritesService_1.default.flattenFavorites(favoritesTree);
    }
  }

  async fetchUserInfo(userInfos) {
    const fetchResult = await organizationService_1.default.fetch(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.organizationApiUrl, this.portalBaseUrl, this.debug), this.userAllOrgsIdAttributeName, userInfos, this.debug);

    if (fetchResult) {
      this.debugLog('userInfo API result', fetchResult);
      this._currentUser = fetchResult === null || fetchResult === void 0 ? void 0 : fetchResult.user;
      this._currentUserOrgs = fetchResult === null || fetchResult === void 0 ? void 0 : fetchResult.organizations;
      if (this._currentUser && this._currentUserOrgs) this._currentOrg = organizationService_1.default.getCurrentOrganization(this._currentUser, this.orgAttributeName, this._currentUserOrgs);
    } else {
      this._error('No user infos fetch from API');
    }
  }

  calculateSize() {
    var _a, _b;

    if (this.isHidden) return;
    this._screenSize = sizeHelper_1.default.breakPointName(sizeHelper_1.default.elementWidth((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#content-menu')));
    this.debugLog('calculateSize', (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('#content-menu'));

    switch (this.hideActionMode) {
      case 'auto':
        this._hideAction = this._screenSize === 'small' || this._screenSize === 'smaller';
        break;

      case 'never':
        this._hideAction = false;
        break;

      default:
        // case of 'always' hidden
        this._hideAction = true;
    }

    this.debugLog('calculateSize', this._screenSize);
  }

  updateStructureName(e) {
    var _a;

    const name = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.structName;
    if (name) this._forceOrgDisplayName = name;
  }

  updateStructureLogo(e) {
    var _a;

    const logo = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.logo;
    if (logo) this.forceOrgLogo = logo;
  }

  onClose(e) {
    e.preventDefault();
    const closeEvt = new CustomEvent('close');
    this.dispatchEvent(closeEvt);
  }

  isOtherOrgs() {
    var _a;

    return (_a = this._currentUserOrgs && Object.keys(this._currentUserOrgs).length > 1) !== null && _a !== void 0 ? _a : false;
  }

  getOrgImage() {
    var _a;

    const orgImage = this.forceOrgLogo != '' ? this.forceOrgLogo : (_a = organizationService_1.default.getOrganizationLogo(this._currentOrg, this.orgLogoUrlAttributeName)) !== null && _a !== void 0 ? _a : this.defaultOrgLogo;
    return orgImage;
  }

  actionToggleFav(e) {
    var _a, _b;

    if (!this._favorites) this._favorites = [];

    if (!this._favorites.includes(e.detail.fname)) {
      this._favorites = [...this._favorites, e.detail.fname];
    } else {
      this._favorites = this._favorites.filter(name => name != e.detail.fname);
    }

    if (!this.debug && !e.detail.send && ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.chanId) !== undefined) {
      if ((_b = e.detail) === null || _b === void 0 ? void 0 : _b.isFavorite) {
        favoritesService_1.default.add(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.favoriteApiUrl, this.portalBaseUrl, this.debug), e.detail.chanId);
      } else {
        favoritesService_1.default.remove(pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug), pathHelper_1.default.getUrl(this.favoriteApiUrl, this.portalBaseUrl, this.debug), e.detail.chanId);
      }

      favoritesService_1.default.deleteCachedData(this.layoutApiUrl);
    }
  }

  toogleSwitchOrg(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent('switch-org'));
  }

  render() {
    var _a, _b, _c, _d, _e;

    this.debugLog('Render');
    const orgDisplayName = this._forceOrgDisplayName != '' ? this._forceOrgDisplayName : (_b = (_a = this._currentOrg) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : '';
    const orgImageUrl = pathHelper_1.default.getUrl(this.getOrgImage(), this.portalBaseUrl, this.debug);
    const signOutUrl = pathHelper_1.default.getUrl(this.signoutUrl, this.portalBaseUrl, this.debug);
    const avatarUrl = ((_c = this._currentUser) === null || _c === void 0 ? void 0 : _c.picture) ? pathHelper_1.default.getUrl(this._currentUser.picture, this.portalBaseUrl, this.debug) : '';
    const userInfoUrl = pathHelper_1.default.getUrl(this.userInfoPortletUrl, this.portalBaseUrl, this.debug);
    const switchOrgUrl = pathHelper_1.default.getUrl(this.switchOrgPortletUrl, this.portalBaseUrl, this.debug);
    const headerBGImg = {
      backgroundImage: `linear-gradient(0deg, rgba(0,0,0,.2),rgba(0,0,0,.2)), url(${orgImageUrl})`
    };
    return this._portlets && this._favorites && this._currentUser ? (0, lit_1.html)`
          <div
            id="content-menu"
            class="content-menu toggler-menu ${(0, class_map_js_1.classMap)({
      [this._screenSize]: true,
      'active-menu': !this.isHidden
    })}"
          >
            <header>
              <div id="header-buttons">
                <slot name="header-buttons">
                  <esco-header-buttons
                    .messages=${this.messages}
                    sign-out-url="${signOutUrl}"
                    @close=${this.onClose}
                  ></esco-header-buttons>
                </slot>
              </div>

              <div class="wrapper">
                <slot name="content-user">
                  <esco-content-user
                    .messages=${this.messages}
                    parent-screen-size="${this._screenSize}"
                    user-display-name="${(_e = (_d = this._currentUser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ''}"
                    user-avatar-url="${avatarUrl}"
                    org-display-name="${orgDisplayName}"
                    org-img-url="${orgImageUrl}"
                    user-info-portlet-url="${userInfoUrl}"
                    switch-org-portlet-url="${this.isOtherOrgs() ? switchOrgUrl : ''}"
                    ?switch-org-event="${this.switchOrgEvent}"
                    @switch-org="${this.toogleSwitchOrg}"
                  ></esco-content-user>
                </slot>
                <esco-content-favorites
                  .messages=${this.messages}
                  portal-base-url="${this.portalBaseUrl}"
                  .portlets="${this._portlets}"
                  .favorites="${this._favorites}"
                  parent-screen-size="${this._screenSize}"
                  card-size="${this.favoritesPortletCardSize}"
                  ?hide-action="${this._hideAction}"
                  favorite-api-url="${this.favoriteApiUrl}"
                  ?hide="${this.isHidden}"
                  user-info-api-url="${this.userInfoApiUrl}"
                  user-info=${this._userInfos ? JSON.stringify(this._userInfos) : lit_1.nothing}
                  context-api-url="${this.contextApiUrl}"
                  ?debug="${this.debug}"
                  ?disable-swiper="${!this.showFavoritesInSlider}"
                  ?disable-cache="${this.disableCache}"
                  cache-ttl="${this.cacheTTL}"
                  @toggle-favorite=${this.actionToggleFav}
                ></esco-content-favorites>
              </div>
              <div style="${(0, style_map_js_1.styleMap)(headerBGImg)}" class="background"></div>
            </header>
            <esco-content-grid
              .messages=${this.messages}
              portal-base-url="${this.portalBaseUrl}"
              .portlets="${this._portlets}"
              .favorites="${this._favorites}"
              parent-screen-size="${this._screenSize}"
              portlet-card-size="${this.gridPortletCardSize}"
              ?hide-action="${this._hideAction}"
              favorite-api-url="${this.favoriteApiUrl}"
              layout-api-url="${this.layoutApiUrl}"
              user-info-api-url="${this.userInfoApiUrl}"
              user-info=${this._userInfos ? JSON.stringify(this._userInfos) : lit_1.nothing}
              context-api-url="${this.contextApiUrl}"
              portlet-api-url="${this.portletApiUrl}"
              card-hover-src="${this.cardHoverSrc}"
              ?disable-cache="${this.disableCache}"
              cache-ttl="${this.cacheTTL}"
              ?debug="${this.debug}"
              @toggle-favorite=${this.actionToggleFav}
            ></esco-content-grid>
          </div>
        ` : this._inError ? (0, lit_1.html)`<div id="content-menu" class="content-menu error">
          <header>
            <esco-header-buttons
              .messages=${this.messages}
              only-close
              @close=${this.onClose}
            ></esco-header-buttons>
          </header>
          <section>
            <p class="error-message">${this._errorMessage}</p>
          </section>
        </div>` : (0, lit_1.html)`<div id="content-menu" class="content-menu spinner">
          <header>
            <esco-header-buttons
              .messages=${this.messages}
              only-close
              @close=${this.onClose}
            ></esco-header-buttons>
          </header>
          <section>
            <lit-spinner></lit-spinner>
          </section>
        </div>`;
  }

  _error(errorMessage) {
    this._inError = true;
    this._errorMessage = errorMessage;
    this.errorLog(errorMessage);
  }

};
ContentMenu.styles = [(0, lit_1.css)`
      ${(0, lit_1.unsafeCSS)(content_menu_scss_1.default)}
    `];

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentMenu.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portal-base-url'
})], ContentMenu.prototype, "portalBaseUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'favorites-Portlet-card-size'
})], ContentMenu.prototype, "favoritesPortletCardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'grid-Portlet-card-size'
})], ContentMenu.prototype, "gridPortletCardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'default-org-logo'
})], ContentMenu.prototype, "defaultOrgLogo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'force-org-logo'
})], ContentMenu.prototype, "forceOrgLogo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'context-api-url'
})], ContentMenu.prototype, "contextApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'favorite-api-url'
})], ContentMenu.prototype, "favoriteApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'layout-api-url'
})], ContentMenu.prototype, "layoutApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portlet-api-url'
})], ContentMenu.prototype, "portletApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'organization-api-url'
})], ContentMenu.prototype, "organizationApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-api-url'
})], ContentMenu.prototype, "userInfoApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Object,
  attribute: 'user-info'
})], ContentMenu.prototype, "userInfo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'sign-out-url'
})], ContentMenu.prototype, "signoutUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-portlet-url'
})], ContentMenu.prototype, "userInfoPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'switch-org-portlet-url'
})], ContentMenu.prototype, "switchOrgPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'switch-org-event'
})], ContentMenu.prototype, "switchOrgEvent", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-org-id-attribute-name'
})], ContentMenu.prototype, "orgAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'org-logo-url-attribute-name'
})], ContentMenu.prototype, "orgLogoUrlAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-all-orgs-id-attribute-name'
})], ContentMenu.prototype, "userAllOrgsIdAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'card-hover-src'
})], ContentMenu.prototype, "cardHoverSrc", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return ['auto', 'always', 'never'].includes(newVal);
  },

  attribute: 'hide-action-mode'
})], ContentMenu.prototype, "hideActionMode", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'is-hidden'
})], ContentMenu.prototype, "isHidden", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'show-favorites-in-slider'
})], ContentMenu.prototype, "showFavoritesInSlider", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'disable-cache'
})], ContentMenu.prototype, "disableCache", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'cache-ttl'
})], ContentMenu.prototype, "cacheTTL", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], ContentMenu.prototype, "debug", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'fake-attribute'
})], ContentMenu.prototype, "fakeAttribute", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_screenSize", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_hideAction", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_currentOrg", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_currentUser", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_currentUserOrgs", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_portlets", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_favorites", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_inError", void 0);

__decorate([(0, decorators_js_1.state)()], ContentMenu.prototype, "_forceOrgDisplayName", void 0);

ContentMenu = __decorate([(0, decorators_js_1.customElement)('esco-content-menu')], ContentMenu);
exports.ContentMenu = ContentMenu;

/***/ }),

/***/ 5526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContentUser = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const unsafe_html_js_1 = __webpack_require__(1943);

const decorators_js_1 = __webpack_require__(5595);

const style_map_js_1 = __webpack_require__(3959);
/*SCSS*/


const content_user_scss_1 = __importDefault(__webpack_require__(1284));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));
/*Dependencies*/


const fontawesome_svg_core_1 = __webpack_require__(8947);

const faUser_1 = __webpack_require__(7879);

const faExchangeAlt_1 = __webpack_require__(7007);

let ContentUser = class ContentUser extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    var _a;

    super();
    this.messages = [];
    this.parentScreenSize = 'medium';
    this.orgDisplayName = '';
    this.orgImgUrl = '';
    this.userDisplayName = '';
    this.userAvatarUrl = '';
    this.switchOrgPortletUrl = (_a = "MISSING_ENV_VAR".VUE_APP_ORG_SWITCH_URI) !== null && _a !== void 0 ? _a : '';
    this.switchOrgEvent = false;
    this.userInfoPortletUrl = '';
    this.enableSwitch = false;
    this.debugLog('Component loaded');
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  willUpdate(_changedProperties) {
    if (_changedProperties.has('messages')) {
      langHelper_1.default.setReference(this.messages);
    }
  }

  toogleSwitchOrg(e) {
    if (!this.switchOrgEvent) return;
    e.preventDefault();
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent('switch-org'));
  }

  render() {
    this.debugLog('Render', this.parentScreenSize);
    const style = this.parentScreenSize == 'small' || this.parentScreenSize == 'smaller' ? {
      background: 'linear-gradient(0deg, rgba(0,0,0,.2),rgba(0,0,0,.2)), url(' + this.orgImgUrl + ')',
      'background-repeat': 'no-repeat',
      'background-size': 'cover'
    } : {};
    this.debugLog('Style : ', style);
    return (0, lit_1.html)`
      <section
        class="content-user ${this.parentScreenSize}"
        style="${(0, style_map_js_1.styleMap)(style)}"
      >
        <div>
          <div class="org-img">
            <img
              src="${this.orgImgUrl}"
              title="${this.orgDisplayName}"
              alt="${this.orgDisplayName}"
            />
          </div>
          <div class="user-info">
            <div>
              <div class="user-avatar">
                ${this.userInfoPortletUrl.length > 0 ? (0, lit_1.html)`
                      <a
                        href="${this.userInfoPortletUrl}"
                        title="${langHelper_1.default.localTransation('userInfoPortletUrl.title', (0, localize_1.msg)((0, localize_1.str)`See my account informations`))}"
                      >
                        ${this.renderAvatar()}
                      </a>
                    ` : (0, lit_1.html)` ${this.renderAvatar()} `}
              </div>

              <div class="wrapper-info">
                <div class="user-name">
                  <span title="${this.userDisplayName}">
                    ${this.userDisplayName}
                  </span>
                </div>
                <div class="user-org">
                  <span title="${this.orgDisplayName}"
                    >${this.orgDisplayName}</span
                  >
                </div>
              </div>
              ${this.switchOrgPortletUrl !== '' ? (0, lit_1.html)`
                    <div class="other-orgs">
                      ${this.switchOrgEvent ? (0, lit_1.html)`
                            <button
                              title="${langHelper_1.default.localTransation('userChangeEtabUrl.title', (0, localize_1.msg)((0, localize_1.str)`Select an other organization`))}"
                              @click="${this.toogleSwitchOrg}"
                            >
                              ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faExchangeAlt_1.faExchangeAlt).html}`)}
                            </button>
                          ` : (0, lit_1.html)`
                            <a
                              href="${this.switchOrgPortletUrl}"
                              title="${langHelper_1.default.localTransation('userChangeEtabUrl.title', (0, localize_1.msg)((0, localize_1.str)`Select an other organization`))}"
                            >
                              ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faExchangeAlt_1.faExchangeAlt).html}`)}
                            </a>
                          `}
                    </div>
                  ` : (0, lit_1.html)``}
            </div>
          </div>
        </div>
      </section>
    `;
  }

  renderAvatar() {
    return this.userAvatarUrl && this.userAvatarUrl.length > 0 ? (0, lit_1.html)`
          <img
            src="${this.userAvatarUrl}"
            alt="${langHelper_1.default.localTransation('user.avatar', (0, localize_1.msg)((0, localize_1.str)`Avatar`))}"
          />
        ` : (0, lit_1.html)`${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faUser_1.faUser).html}`)}`;
  }

};
ContentUser.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(content_user_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentUser.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'parent-screen-size'
})], ContentUser.prototype, "parentScreenSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'org-display-name'
})], ContentUser.prototype, "orgDisplayName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'org-img-url'
})], ContentUser.prototype, "orgImgUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-display-name'
})], ContentUser.prototype, "userDisplayName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-avatar-url'
})], ContentUser.prototype, "userAvatarUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'switch-org-portlet-url'
})], ContentUser.prototype, "switchOrgPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'switch-org-event'
})], ContentUser.prototype, "switchOrgEvent", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-portlet-url'
})], ContentUser.prototype, "userInfoPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'enable-switch'
})], ContentUser.prototype, "enableSwitch", void 0);

ContentUser = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-content-user')], ContentUser);
exports.ContentUser = ContentUser;

/***/ }),

/***/ 6580:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.HeaderButtons = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const unsafe_html_js_1 = __webpack_require__(1943);

const decorators_js_1 = __webpack_require__(5595);
/*SCSS*/


const header_button_scss_1 = __importDefault(__webpack_require__(4872));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Dependencies*/


const fontawesome_svg_core_1 = __webpack_require__(8947);

const faSignOutAlt_1 = __webpack_require__(6427);

const faTimes_1 = __webpack_require__(9545);

let HeaderButtons = class HeaderButtons extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super();
    this.messages = [];
    this.signOutUrl = "/uPortal/Logout";
    this.onlyClose = false;
    this.debugLog('Component loaded');
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  willUpdate(_changedProperties) {
    if (_changedProperties.has('messages')) {
      langHelper_1.default.setReference(this.messages);
    }
  }

  onClose(e) {
    e.preventDefault();
    const closeEvt = new CustomEvent('close');
    this.dispatchEvent(closeEvt);
  }

  render() {
    return (0, lit_1.html)` <section class="content-menu-header-buttons">
      <button
        title="${langHelper_1.default.localTransation('buttons.menuClose', (0, localize_1.msg)((0, localize_1.str)`Close menu`))}"
        type="button"
        class="content-menu-close"
        aria-label="Close"
        @click=${this.onClose}
      >
        ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faTimes_1.faTimes).html}`)}
      </button>
      ${this.onlyClose ? (0, lit_1.html)`` : (0, lit_1.html)`
            <a
              href="${this.signOutUrl || '#'}"
              title="${langHelper_1.default.localTransation('buttons.logout', (0, localize_1.msg)((0, localize_1.str)`Sign Out`))}"
              class="signout"
            >
              ${(0, unsafe_html_js_1.unsafeHTML)(`${(0, fontawesome_svg_core_1.icon)(faSignOutAlt_1.faSignOutAlt).html}`)}
            </a>
          `}
    </section>`;
  }

};
HeaderButtons.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(header_button_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], HeaderButtons.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'sign-out-url'
})], HeaderButtons.prototype, "signOutUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'only-close'
})], HeaderButtons.prototype, "onlyClose", void 0);

HeaderButtons = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-header-buttons')], HeaderButtons);
exports.HeaderButtons = HeaderButtons;

/***/ }),

/***/ 203:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6699);

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

const get_1 = __importDefault(__webpack_require__(7361));

class langHelper {
  static setLocale(lang) {
    this.locale = lang;
  }

  static setReference(ref) {
    this.reference = ref;
  }

  static getBrowserLocales(options = {}) {
    const defaultOptions = {
      languageCodeOnly: true,
      defaultLanguage: 'en'
    };
    const opt = { ...defaultOptions,
      ...options
    };
    const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;

    if (!browserLocales) {
      return [opt.defaultLanguage];
    }

    return browserLocales.map(locale => {
      const trimmedLocale = locale.trim();
      return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
    });
  }

  static getPageLang(options = {}) {
    const defaultOptions = {
      languageCodeOnly: true,
      availableLanguages: ['en'],
      defaultLanguage: 'en'
    };
    const opt = { ...defaultOptions,
      ...options
    };
    const pageLang = document.documentElement.lang;
    let allLangs = [];

    if (pageLang) {
      allLangs = opt.languageCodeOnly ? [pageLang.split(/-|_/)[0]] : [pageLang];
    } else {
      const fOpts = {
        anguageCodeOnly: opt.languageCodeOnly,
        defaultLanguage: opt.defaultLanguage
      };
      allLangs = this.getBrowserLocales(fOpts);
    }

    const detectedLocale = allLangs.find(x => opt.availableLanguages.includes(x));
    return detectedLocale || opt.defaultLanguage;
  }

  static localTransation(stringId, defaultString) {
    var _a, _b;

    const currentRef = (_a = this.reference) === null || _a === void 0 ? void 0 : _a.find(ref => ref.locales.includes(this.locale));
    const currentMessages = (_b = currentRef === null || currentRef === void 0 ? void 0 : currentRef.messages) === null || _b === void 0 ? void 0 : _b.message;
    return currentMessages ? (0, get_1.default)(currentMessages, stringId, defaultString) : defaultString;
  }

}

exports["default"] = langHelper;
langHelper.locale = 'en';

/***/ }),

/***/ 82:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setLocale = void 0;

const localize_1 = __webpack_require__(1799);

exports.setLocale = (0, localize_1.configureLocalization)({
  sourceLocale: 'en',
  targetLocales: ['fr'],
  loadLocale: locale => Promise.resolve().then(() => __importStar(__webpack_require__(4972)(`./${locale}.ts`)))
}).setLocale;

/***/ }),

/***/ 4093:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

class pathHelper {
  static getUrl(path, baseUrl = '', debug = false) {
    var _a;

    if (!path.startsWith('http')) {
      baseUrl = baseUrl !== '' ? baseUrl : (_a = "") !== null && _a !== void 0 ? _a : '';

      if (baseUrl !== '' && !baseUrl.startsWith('http')) {
        baseUrl = `${debug ? 'http' : 'https'}://${baseUrl}`;
      }

      return baseUrl + path;
    }

    return path;
  }

}

exports["default"] = pathHelper;

/***/ }),

/***/ 6995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


__webpack_require__(6699);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

class sizeHelper {
  static validate(size, withAuto, withCustom) {
    let options = ['large', 'medium', 'small', 'smaller'];

    if (withAuto) {
      options = [...options, 'auto'];
    }

    if (withCustom) {
      options = [...options, 'custom'];
    }

    return options.includes(size);
  }

  static breakPointName(size) {
    if (typeof size === 'number' && isFinite(size)) {
      if (size < 480) {
        return 'smaller';
      } else if (size < 768) {
        return 'small';
      } else if (size < 1680) {
        return 'medium';
      }
    }

    return 'large';
  }

  static elementWidth(element) {
    var _a;

    return (_a = element === null || element === void 0 ? void 0 : element.clientWidth) !== null && _a !== void 0 ? _a : 0;
  }

}

exports["default"] = sizeHelper;

/***/ }),

/***/ 2742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

class textHelper {
  static truncate(string) {
    if (string) {
      const text = string.split('   ');
      return text[0].trim();
    }

    return string;
  }

  static sanitize(string) {
    if (string) {
      string = string.replace(/[^a-z0-9]/gim, '_');
      return string.trim();
    }

    return string;
  }

  static getAcronym(str) {
    return str.split(/[\s,']+/).map(word => {
      return word.length >= 4 || word != word.toLowerCase() ? word.split('')[0].toUpperCase() : '';
    }).join('');
  }

  static hashCode(str) {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      hash = (hash << 5) - hash + code;
      hash = hash & hash;
    }

    return hash.toString();
  }

}

exports["default"] = textHelper;

/***/ }),

/***/ 3031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Ellipsis = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);

const style_map_js_1 = __webpack_require__(3959);
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Dependencies*/


const debounce_1 = __importDefault(__webpack_require__(3279)); // import striptags from 'striptags';


let Ellipsis = class Ellipsis extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super();
    this.message = '';
    this.clamp = 0;
    this.height = '22px';
    this.endChar = '...';
    this._ellipsisContent = '';
    this._nbLines = 'auto';
    this.debounceRun = (0, debounce_1.default)(this.run, 200);
    this.debugLog('Component loaded');
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('resize', this.debounceRun.bind(this), false);
  }

  disconnectedCallback() {
    super.connectedCallback();
    window.removeEventListener('resize', this.debounceRun.bind(this), false);
  }

  willUpdate( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _changedProperties) {
    if (_changedProperties.has('message')) {
      this._ellipsisContent = this.message;
    }
  }

  firstUpdated() {
    this.setLogIdentifier('ellipsis');
    this.debugLog('First update', this);
    this.debounceRun();
  }

  async run() {
    var _a;

    this.debugLog('running', this.message);
    await this.updateComplete;

    if (this.sentence.offsetWidth < 1 || this.sentence.offsetHeight < 1) {
      this.messageLog('Component is hidden, stop running');
      return;
    }

    if (((_a = this.message) === null || _a === void 0 ? void 0 : _a.length) <= 0) return;
    const lineHeight = parseInt(this.height, 10);
    this._ellipsisContent = '';
    await this.updateComplete;
    this.sentence.style.height = '100%';
    const availableHeight = this.sentence.getBoundingClientRect().height || lineHeight;
    if (availableHeight < lineHeight) return;
    const autoNbLines = Math.floor(availableHeight / lineHeight);
    this._nbLines = this.clamp > 0 && this.clamp < autoNbLines ? this.clamp.toString() : autoNbLines.toString();
    this._ellipsisContent = this.message;
    this.sentence.style.height = 'auto';
  }

  forceRender() {
    this.debugLog('forceRender', this);
    this.debounceRun();
  }

  render() {
    const ellipsis = this.endChar !== '...' ? this.endChar : 'ellipsis';
    const style = {
      '-webkit-line-clamp': this._nbLines,
      'text-overflow': `'${ellipsis}'`
    };
    return (0, lit_1.html)`
      <div class="autofit-ellipsis" style="${(0, style_map_js_1.styleMap)(style)}" id="sentence">
        ${this._ellipsisContent}
      </div>
    `;
  }

};
Ellipsis.styles = (0, lit_1.css)`
    .autofit-ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  `;

__decorate([(0, decorators_js_1.property)({
  type: String
})], Ellipsis.prototype, "message", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'line-clamp'
})], Ellipsis.prototype, "clamp", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'line-height'
})], Ellipsis.prototype, "height", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'end-char'
})], Ellipsis.prototype, "endChar", void 0);

__decorate([(0, decorators_js_1.state)()], Ellipsis.prototype, "_ellipsisContent", void 0);

__decorate([(0, decorators_js_1.state)()], Ellipsis.prototype, "_nbLines", void 0);

__decorate([(0, decorators_js_1.query)('#sentence')], Ellipsis.prototype, "sentence", void 0);

Ellipsis = __decorate([(0, decorators_js_1.customElement)('lit-ellipsis')], Ellipsis);
exports.Ellipsis = Ellipsis;

/***/ }),

/***/ 9628:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Spinner = void 0;
/**
 * Source : css & html from loading.io
 */

/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);

let Spinner = class Spinner extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super();
    this.debugLog('Component loaded');
  }

  render() {
    return (0, lit_1.html)`
      <div class="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
  }

};
Spinner.styles = (0, lit_1.css)`
    .lds-facebook {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
    }
    .lds-facebook div {
      display: inline-block;
      position: absolute;
      left: 8px;
      width: 16px;
      background: var(--lit-spinner-color, #fff);
      animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
    .lds-facebook div:nth-child(1) {
      left: 8px;
      animation-delay: -0.24s;
    }
    .lds-facebook div:nth-child(2) {
      left: 32px;
      animation-delay: -0.12s;
    }
    .lds-facebook div:nth-child(3) {
      left: 56px;
      animation-delay: 0;
    }
    @keyframes lds-facebook {
      0% {
        top: 8px;
        height: 64px;
      }
      50%,
      100% {
        top: 24px;
        height: 32px;
      }
    }
  `;
Spinner = __decorate([(0, decorators_js_1.customElement)('lit-spinner')], Spinner);
exports.Spinner = Spinner;

/***/ }),

/***/ 2258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
 // Do not modify this file by hand!
// Re-generate this file by running lit-localize

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.templates = void 0;

const localize_1 = __webpack_require__(1799);
/* eslint-disable no-irregular-whitespace */

/* eslint-disable @typescript-eslint/no-explicit-any */


exports.templates = {
  s1d5d2564d7aae78e: (0, localize_1.str)`Fermer le menu`,
  s222b63bb7b6cf89d: (0, localize_1.str)`Changer d'établissement`,
  s380927a4d5b227ed: (0, localize_1.str)`Tous les services`,
  s4b0eba4268a3c045: (0, localize_1.str)`Rechercher un service...`,
  s5379e362403c02bc: (0, localize_1.str)`Vous n'avez pas de favoris`,
  s79529ae47e56fbd5: (0, localize_1.str)`Toutes les catégories`,
  s8bdf1e8dfd70aa2c: (0, localize_1.str)`Voir les informations de mon compte`,
  s8f1dff5d47459b5e: (0, localize_1.str)`Mes favoris`,
  s8fa032cdafb3c9b0: (0, localize_1.str)`Se déconnecter`,
  s9e226e0a027f39a6: (0, localize_1.str)`Supprimer des favoris`,
  scff3aac0935b2a74: (0, localize_1.str)`Ajouter aux favoris`,
  s1967faf9ed8d3504: (0, localize_1.str)`Avatar`
};

/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LitLoggable = void 0; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

const LitLoggable = superClass => {
  class LoggableElement extends superClass {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
      var _a, _b, _c;

      super(...args);
      this._module = 'unknown';
      this._identifier = null;
      this._localLevel = 1;
      LoggableElement._bundle = (_a = "content-menu") !== null && _a !== void 0 ? _a : 'unknown';
      LoggableElement._globalLevel = (_c = parseInt((_b = "1") !== null && _b !== void 0 ? _b : '1')) !== null && _c !== void 0 ? _c : 1;
      this._module = this.constructor.name;
    }

    setLogBundle(bundle) {
      if (LoggableElement._bundle === 'unknown') LoggableElement._bundle = bundle;
    }

    setLogModule(module) {
      this._module = module;
    }

    setLogIdentifier(identifier) {
      this._identifier = identifier;
    }

    setLogLevel(level) {
      this._localLevel = level;
    }

    getLogLevel() {
      return Math.max(LoggableElement._globalLevel, this._localLevel);
    }

    handleLog(type, message, ...paramaters) {
      const level = this.getLogLevel();
      const logMessage = `%c[${LoggableElement._bundle}][${this._module}] ${this._identifier ? this._identifier + ' >' : ''} ${message}`;

      switch (type) {
        case 'error':
          if (level > 0) {
            console.error(logMessage, 'display: inline-block; background-color:#EBD3D3; color: #c80000;font-weight: bold ; padding: 3px 7px 3px 7px ; border-radius: 3px 3px 3px 3px ;', ...paramaters);
          }

          break;

        case 'log':
          if (level > 1) {
            console.log(logMessage, 'display: inline-block; background-color:#CFDAE6; color: #004999;font-weight: bold ; padding: 3px 7px 3px 7px ; border-radius: 3px 3px 3px 3px ;', ...paramaters);
          }

          break;

        case 'debug':
          if (level > 2) {
            console.debug(logMessage, 'display: inline-block; background-color:#D9D9D9; color: #6c6c6c;font-weight: bold ; padding: 3px 7px 3px 7px ; border-radius: 3px 3px 3px 3px ;', ...paramaters);
          }

          break;
      }
    }

    errorLog(message, ...paramaters) {
      this.handleLog('error', message, ...paramaters);
    }

    messageLog(message, ...paramaters) {
      this.handleLog('log', message, ...paramaters);
    }

    debugLog(message, ...paramaters) {
      this.handleLog('debug', message, ...paramaters);
    }

  }

  LoggableElement._bundle = 'unknown';
  LoggableElement._globalLevel = 1;
  return LoggableElement;
};

exports.LitLoggable = LitLoggable;

/***/ }),

/***/ 9832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PortletCard = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);

const class_map_js_1 = __webpack_require__(9455);

const style_map_js_1 = __webpack_require__(3959);
/*SCSS*/


const portlet_card_scss_1 = __importDefault(__webpack_require__(5356));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));

const pathHelper_1 = __importDefault(__webpack_require__(4093));

const textHelper_1 = __importDefault(__webpack_require__(2742));
/*Components*/


__webpack_require__(3031);

__webpack_require__(776);

let PortletCard = class PortletCard extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super(...arguments);
    this.messages = [];
    this.baseUrl = '';
    this.cssClass = 'portlet-card';
    this.iconBackgroundColor = 'transparent';
    this.size = 'medium';
    this.cardHoverSrc = 'none';
    this.backgroundIsDark = false;
    this.isFavorite = false;
    this.hideAction = false;
    this.debug = false;
    this._dataIsParsed = false;
    this._fname = '';
    this._chanId = 0;
    this._pTitle = '';
    this._description = '';
    this._portletTitle = '';
    this._canFavorite = false;
    this._iconUrl = '';
  }

  shouldUpdate() {
    if (this.portletDesc !== undefined) return true;
    this.errorLog('Attribute portlet-desc or property portletDesc must be defined');
    return false;
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('portletDesc')) {
      this.parseDesc();
      this.debugLog('portletDesc update', this.portletDesc);
    }
  }

  firstUpdated() {
    this.setLogIdentifier(this._fname);
    this.debugLog('First update', this);
  }

  updated() {
    var _a;

    this.debugLog('Updated', this);
    const ellipsis = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('lit-ellipsis');
    ellipsis.forceRender();
  }

  parseDesc() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;

    if (this.portletDesc !== undefined) {
      this._fname = (_b = (_a = this.portletDesc) === null || _a === void 0 ? void 0 : _a.fname) !== null && _b !== void 0 ? _b : '';
      this._chanId = (_d = (_c = this.portletDesc) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : 0;
      this._pTitle = (_f = (_e = this.portletDesc) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : '';
      this._description = (_h = (_g = this.portletDesc) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : '';
      this._portletTitle = (_k = (_j = this.portletDesc) === null || _j === void 0 ? void 0 : _j.title) !== null && _k !== void 0 ? _k : '';
      this._canFavorite = ((_l = this.portletDesc) === null || _l === void 0 ? void 0 : _l.canAdd) ? this.portletDesc.canAdd : true;
      this._iconUrl = ((_o = (_m = this.portletDesc.parameters) === null || _m === void 0 ? void 0 : _m.iconUrl) === null || _o === void 0 ? void 0 : _o.value) ? pathHelper_1.default.getUrl(this.portletDesc.parameters.iconUrl.value, this.baseUrl, this.debug) : '';
      this._dataIsParsed = true;
    }
  }

  getHoverText() {
    switch (this.cardHoverSrc) {
      case 'title':
        return this._pTitle;

      case 'desc':
      case 'description':
        return this._description;

      default:
        return '';
    }
  }

  toggleFavorite(e) {
    const toggleEvt = new CustomEvent('toggle-favorite', {
      detail: e.detail
    });
    this.dispatchEvent(toggleEvt);
  }

  clickOnCard(e) {
    const clickEvt = new CustomEvent('click-portlet-card', {
      detail: {
        event: e,
        target: this,
        fname: this._fname
      },
      bubbles: true,
      composed: true
    });
    document.dispatchEvent(clickEvt);
  }

  render() {
    const appClasses = {
      [this.cssClass.toLowerCase()]: true,
      [textHelper_1.default.sanitize(this._fname.toLowerCase())]: true,
      [this.size.toLowerCase() + '-card']: true,
      'background-dark': this.backgroundIsDark,
      'hide-action': this.hideAction
    };
    if (this.portletDesc && this.portletDesc.categories) this.portletDesc.categories.forEach(cat => {
      const sanCat = textHelper_1.default.sanitize(cat);
      appClasses[sanCat] = true;
    });
    return (0, lit_1.html)`
      <div
        class="${(0, class_map_js_1.classMap)(appClasses)}"
        title="${this.getHoverText()}"
        @click="${this.clickOnCard}"
      >
        <div class="portlet-card-icon">${this.renderIcon()}</div>
        <div class="portlet-card-title">${this._portletTitle}</div>
        <div class="portlet-card-description">${this.renderEllipsis()}</div>
        ${this.renderActionFavorites()}
      </div>
    `;
  }

  renderIcon() {
    const style = {
      'background-color': this.iconBackgroundColor
    };
    const img = (0, lit_1.html)`<img
      src="${this._iconUrl}"
      alt="${this._portletTitle}"
    />`;
    return (0, lit_1.html)`
      <div style=${(0, style_map_js_1.styleMap)(style)} class="img-wrapper">
        ${this._iconUrl ? img : (0, lit_1.html)`<div class="defaultIcon">
              <p>${textHelper_1.default.getAcronym(this._portletTitle)}</p>
            </div>`}
      </div>
    `;
  }

  renderEllipsis() {
    if (this._dataIsParsed) {
      return (0, lit_1.html)`
        <lit-ellipsis
          message="${textHelper_1.default.truncate(this._description)}"
          line-height="20px"
          end-char="..."
        ></lit-ellipsis>
      `;
    } else {
      return (0, lit_1.html)``;
    }
  }

  renderActionFavorites() {
    let returnHTML = (0, lit_1.html)``;
    let afHTML = (0, lit_1.html)``;

    if (this._canFavorite) {
      afHTML = (0, lit_1.html)`
        <esco-action-favorites
          .messages="${this.messages}"
          fname="${this._fname}"
          chan-id="${this._chanId}"
          .isFavorite="${this.isFavorite}"
          ?background-is-dark="${this.backgroundIsDark}"
          @toggle=${this.toggleFavorite}
        /></esco-action-favorites>
      `;
    }

    if (!this.hideAction) {
      returnHTML = (0, lit_1.html)`<div class="portlet-card-action">${afHTML}</div> `;
    }

    return returnHTML;
  }

};
PortletCard.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(portlet_card_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], PortletCard.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'base-url'
})], PortletCard.prototype, "baseUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Object,
  attribute: 'portlet-desc'
})], PortletCard.prototype, "portletDesc", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'css-class'
})], PortletCard.prototype, "cssClass", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'icon-background-color'
})], PortletCard.prototype, "iconBackgroundColor", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  }

})], PortletCard.prototype, "size", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'card-hover-src'
})], PortletCard.prototype, "cardHoverSrc", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'background-is-dark'
})], PortletCard.prototype, "backgroundIsDark", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'is-favorite'
})], PortletCard.prototype, "isFavorite", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'hide-action'
})], PortletCard.prototype, "hideAction", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], PortletCard.prototype, "debug", void 0);

__decorate([(0, decorators_js_1.state)()], PortletCard.prototype, "_dataIsParsed", void 0);

PortletCard = __decorate([(0, decorators_js_1.customElement)('esco-portlet-card')], PortletCard);
exports.PortletCard = PortletCard;

/***/ }),

/***/ 4880:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

class cachedService {
  static set enabled(enabled) {
    this._enabled = enabled;
  }

  static set token(token) {
    if (this._token == '') this._token = token;
  }

  static set cacheTtl(ttl) {
    this._ttl = ttl;
  }

  static async getDatas(url, options) {
    const isCacheAvailable = await this.isCacheAvailable();

    if (!this._enabled || !isCacheAvailable) {
      const response = await fetch(url, options);

      if (!response.ok) {
        console.error(response.statusText);
      }

      return response.json();
    }

    const cacheName = this.generateCacheName(this._token);
    let cachedDatas = await this.getCachedData(cacheName, url);

    if (!cachedDatas) {
      await this.addToCache(cacheName, url, options);
      cachedDatas = await this.getCachedData(cacheName, url);
      await this.deleteOldCaches(cacheName, url);
    }

    return cachedDatas;
  }

  static async getCachedData(cacheName, url) {
    const cacheStorage = await caches.open(cacheName);
    const cachedResponse = await cacheStorage.match(url);

    if (!cachedResponse || !cachedResponse.ok) {
      return false;
    }

    return await cachedResponse.json();
  }

  static async addToCache(cacheName, url, options) {
    const cacheStorage = await caches.open(cacheName);
    const response = await fetch(url, options);

    if (!response.ok) {
      console.error(url, options, response.statusText);
    }

    return await cacheStorage.put(url, response);
  }

  static async deleteCachedData(url) {
    const cacheName = this.generateCacheName(this._token);
    const cacheStorage = await caches.open(cacheName);
    return await cacheStorage.delete(url);
  }

  static async deleteOldCaches(cacheName, url) {
    const keys = await caches.keys();

    for (const key of keys) {
      if (cacheName === key) {
        continue;
      } else {
        if (await this.getCachedData(key, url)) {
          caches.delete(key);
        }
      }
    }
  }

  static generateCacheName(token) {
    const timestamp = Math.floor(Date.now() / (1000 * this._ttl));
    return `${timestamp}_${token}`;
  }

  static async isCacheAvailable() {
    if (!window.caches) return false;

    try {
      await caches.open('test');
      return true;
    } catch (e) {
      console.warn('Cache not available');
      return false;
    }
  }

}

exports["default"] = cachedService;
cachedService._enabled = true;
cachedService._token = '';
cachedService._ttl = 60; // default cache timeout

/***/ }),

/***/ 5925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

const cachedService_1 = __importDefault(__webpack_require__(4880));

const open_id_connect_1 = __importDefault(__webpack_require__(7220));

const textHelper_1 = __importDefault(__webpack_require__(2742));

class favoritesService extends cachedService_1.default {
  static async fetch(userInfoApiUrl, layoutApiUrl, userInfo = null, debug = false) {
    var _a, _b, _c;

    try {
      const requestHeaders = new Headers();

      if (!debug) {
        if (userInfo === null || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.encoded)) {
          userInfo = await (0, open_id_connect_1.default)({
            userInfoApiUrl
          });
        }

        requestHeaders.set('Authorization', `Bearer ${userInfo.encoded}`);
        this.token = textHelper_1.default.hashCode(userInfo.decoded.iss + userInfo.decoded.name);
      } else {
        this.token = textHelper_1.default.hashCode('debug');
      }

      const options = {
        method: 'GET',
        credentials: 'same-origin',
        headers: requestHeaders
      };
      const layout = await this.getDatas(layoutApiUrl, options);

      if ((layout === null || layout === void 0 ? void 0 : layout.authenticated) && ((_b = (_a = layout === null || layout === void 0 ? void 0 : layout.layout) === null || _a === void 0 ? void 0 : _a.globals) === null || _b === void 0 ? void 0 : _b.hasFavorites) && ((_c = layout === null || layout === void 0 ? void 0 : layout.layout) === null || _c === void 0 ? void 0 : _c.favorites)) {
        return layout.layout.favorites;
      }

      return null;
    } catch (err) {
      // eslint-disable-next-line
      console.error(err, userInfoApiUrl, layoutApiUrl, debug);
      return null;
    }
  }

  static async renew(userInfoApiUrl, layoutApiUrl, debug) {
    await this.deleteCachedData(layoutApiUrl);
    return await this.fetch(userInfoApiUrl, layoutApiUrl, null, debug);
  }

  static async add(userInfoApiUrl, favoriteApiUrl, chanId) {
    try {
      const requestHeaders = new Headers();
      requestHeaders.set('Authorization', (await (0, open_id_connect_1.default)({
        userInfoApiUrl
      })).encoded);
      const options = {
        method: 'POST',
        credentials: 'same-origin',
        headers: requestHeaders
      };
      const addUrl = favoriteApiUrl + '?action=addFavorite&channelId=' + chanId;
      const response = await fetch(addUrl, options);

      if (response.ok) {
        return true;
      } else {
        throw new Error(response.statusText);
      }
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      return false;
    }
  }

  static async remove(userInfoApiUrl, favoriteApiUrl, chanId) {
    try {
      const requestHeaders = new Headers();
      requestHeaders.set('Authorization', (await (0, open_id_connect_1.default)({
        userInfoApiUrl
      })).encoded);
      const options = {
        method: 'POST',
        credentials: 'same-origin',
        headers: requestHeaders
      };
      const addUrl = favoriteApiUrl + '?action=removeFavorite&channelId=' + chanId;
      const response = await fetch(addUrl, options);

      if (response.ok) {
        return true;
      } else {
        throw new Error(response.statusText);
      }
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      return false;
    }
  }

  static flattenFavorites(favorites) {
    // undefined has no favorites
    if (!favorites) {
      return [];
    } // recursively cycle through children


    if (Array.isArray(favorites)) {
      return favorites.flatMap(favoritesService.flattenFavorites);
    }

    if (favorites.content !== undefined) {
      return favoritesService.flattenFavorites(favorites.content);
    }

    if (favorites.fname !== undefined) {
      return [favorites.fname];
    }

    return [];
  }

}

exports["default"] = favoritesService;

/***/ }),

/***/ 4443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

const cachedService_1 = __importDefault(__webpack_require__(4880));

const open_id_connect_1 = __importDefault(__webpack_require__(7220));

const get_1 = __importDefault(__webpack_require__(7361));

const isString_1 = __importDefault(__webpack_require__(7037));

const textHelper_1 = __importDefault(__webpack_require__(2742));

class OrganizationService extends cachedService_1.default {
  static async fetch(userInfoApiUrl, orgApiUrl, userAllOrgIdAttribute, userInfo = null, debug = false) {
    let orgInfo = null;
    let fetchUrl = '';

    try {
      const requestHeaders = new Headers();

      if (debug) {
        const userInfoRequest = await fetch(userInfoApiUrl);
        userInfo = {
          encoded: '',
          decoded: await userInfoRequest.json()
        };
        fetchUrl = orgApiUrl;
        this.token = textHelper_1.default.hashCode('debug');
      } else {
        if (userInfo === null || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.encoded)) {
          userInfo = await (0, open_id_connect_1.default)({
            userInfoApiUrl
          });
        }

        this.token = textHelper_1.default.hashCode(userInfo.decoded.iss + userInfo.decoded.name);
        const orgIds = (0, get_1.default)(userInfo.decoded, userAllOrgIdAttribute, null);
        requestHeaders.set('Authorization', `Bearer ${userInfo.encoded}`);
        if ((orgIds === null || orgIds === void 0 ? void 0 : orgIds.length) > 0) fetchUrl = orgApiUrl + '?ids=' + orgIds;
      }

      if ((orgApiUrl === null || orgApiUrl === void 0 ? void 0 : orgApiUrl.length) > 0 && fetchUrl.length > 0) {
        const options = {
          method: 'GET',
          credentials: 'same-origin',
          headers: requestHeaders
        };
        orgInfo = await this.getDatas(fetchUrl, options);
      }

      return {
        user: userInfo === null || userInfo === void 0 ? void 0 : userInfo.decoded,
        organizations: orgInfo
      };
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      return null;
    }
  }

  static getCurrentOrganization(user, userOrgIdAttribute, organizations) {
    var _a;

    const currentUserOrgId = (0, get_1.default)(user, userOrgIdAttribute, null);
    const orgs = Object.keys(organizations).map(index => {
      return organizations[index];
    });

    if ((0, isString_1.default)(currentUserOrgId) && (orgs === null || orgs === void 0 ? void 0 : orgs.length) > 0) {
      return (_a = orgs.find(entry => entry.id === currentUserOrgId)) !== null && _a !== void 0 ? _a : null;
    } else if ((orgs === null || orgs === void 0 ? void 0 : orgs.length) > 0) {
      return orgs[0];
    }

    return null;
  }

  static getOrganizationLogo(organization, attributeName) {
    if (!organization) return '';
    const entry = (0, get_1.default)(organization, attributeName, null);

    if (Array.isArray(entry)) {
      return (0, isString_1.default)(entry[0]) ? entry[0] : null;
    }

    return (0, isString_1.default)(entry) ? entry : null;
  }

}

exports["default"] = OrganizationService;

/***/ }),

/***/ 9273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

const cachedService_1 = __importDefault(__webpack_require__(4880));

const open_id_connect_1 = __importDefault(__webpack_require__(7220));

const uniqBy_1 = __importDefault(__webpack_require__(5578));

const textHelper_1 = __importDefault(__webpack_require__(2742));

class portletService extends cachedService_1.default {
  static async fetch(userInfoApiUrl, portletApiUrl, userInfo = null, debug) {
    try {
      const requestHeaders = new Headers();

      if (!debug) {
        if (userInfo === null || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.encoded)) {
          userInfo = await (0, open_id_connect_1.default)({
            userInfoApiUrl
          });
        }

        requestHeaders.set('Authorization', `Bearer ${userInfo.encoded}`);
        this.token = textHelper_1.default.hashCode(userInfo.decoded.iss + userInfo.decoded.name);
      } else {
        this.token = textHelper_1.default.hashCode('debug');
      }

      const options = {
        method: 'GET',
        credentials: 'same-origin',
        headers: requestHeaders
      };
      const portlets = await this.getDatas(portletApiUrl, options);
      return portlets;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
  /**
   * Combines a array of arrays into a single level array
   * @param {Array<Portlet>} acc - accumulator that combines all the arrays
   * @param {Array<Portlet>} arr - new array to add to the accumulator
   * @return {Array<Portlet>} merged arrays
   */


  static flatten(acc, arr) {
    return acc.concat(arr);
  }
  /**
   * Takes the returned array from treeWalker and removes duplicates
   * based on "fname"
   * @param {Object} registryJson Portlet Registry Tree
   * @return {Array<Portlet>} list of portlets
   */


  static portletRegistryToArray(registryJson) {
    return portletService.customUnique(portletService.treeWalker(registryJson));
  }
  /**
   * Walks the portlet registry tree
   * @param {Object} registryJson Portlet Registry Tree
   * @return {Array<Portlet>} list of portlets
   */


  static treeWalker(registryJson) {
    // If result
    if (registryJson.registry !== undefined) {
      return portletService.treeWalker(registryJson.registry);
    }

    let portlets = []; // If Category

    if (registryJson.portlets !== undefined) {
      portlets = registryJson.portlets;

      if (portlets.length > 0) {
        portlets.forEach(portlet => portlet.categories = new Array(registryJson.name));
      }
    } // If Registry


    if (registryJson.categories !== undefined) {
      return portlets.concat(registryJson.categories.map(portletService.portletRegistryToArray)).reduce(portletService.flatten, []);
    } // If Category 2


    if (registryJson.subcategories !== undefined) {
      return portlets.concat(registryJson.subcategories.map(portletService.portletRegistryToArray)).reduce(portletService.flatten, []);
    }

    return portlets;
  }
  /**
   * Custom function to remove duplicates portlet on fname, but with merging categories.
   * @param {Array<Portlet>} array - Portlet List with duplicates.
   * @return {Array<Portlet>} Portlet List without duplicates.
   */


  static customUnique(array) {
    const unique = (0, uniqBy_1.default)(array, 'fname'); // we construct unique portlets array will all linked categories (reversing category and portlets child)

    unique.forEach(elem => {
      const dupl = array.filter(e => e.fname === elem.fname);
      const allCategories = dupl.flatMap(({
        categories
      }) => categories);
      elem.categories = [...new Set(allCategories)];
    });
    return unique;
  }

  static getAlternativeMaximizedUrl(portlet) {
    var _a, _b;

    return (_b = (_a = portlet === null || portlet === void 0 ? void 0 : portlet.parameters) === null || _a === void 0 ? void 0 : _a.alternativeMaximizedLink) === null || _b === void 0 ? void 0 : _b.value;
  }

  static getAlternativeMaximizedTarget(portlet) {
    var _a, _b, _c;

    return (_c = (_b = (_a = portlet === null || portlet === void 0 ? void 0 : portlet.parameters) === null || _a === void 0 ? void 0 : _a.alternativeMaximizedLinkTarget) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '_blank';
  }

  static getRenderUrl(portlet, context) {
    var _a, _b;

    return ((_b = (_a = portlet === null || portlet === void 0 ? void 0 : portlet.parameters) === null || _a === void 0 ? void 0 : _a.alternativeMaximizedLink) === null || _b === void 0 ? void 0 : _b.value) ? portlet.parameters.alternativeMaximizedLink.value : `${context}/p/${portlet.fname}`;
  }

  static sortPortlets(a, b) {
    var _a, _b, _c, _d, _e, _f; // if parameter is missing or an invalid integer, Not a Number (NaN) will be set


    let aCustomOrder = parseInt((_b = (_a = a === null || a === void 0 ? void 0 : a.parameters) === null || _a === void 0 ? void 0 : _a.escoMenuOrder) === null || _b === void 0 ? void 0 : _b.value, 10);
    let bCustomOrder = parseInt((_d = (_c = b === null || b === void 0 ? void 0 : b.parameters) === null || _c === void 0 ? void 0 : _c.escoMenuOrder) === null || _d === void 0 ? void 0 : _d.value, 10);

    if (isNaN(aCustomOrder)) {
      aCustomOrder = parseInt((_e = a === null || a === void 0 ? void 0 : a.layoutObject) === null || _e === void 0 ? void 0 : _e.parameters.escoMenuOrder, 10);
    }

    if (isNaN(bCustomOrder)) {
      bCustomOrder = parseInt((_f = b === null || b === void 0 ? void 0 : b.layoutObject) === null || _f === void 0 ? void 0 : _f.parameters.escoMenuOrder, 10);
    } // if neither has a custom order, sort by title


    if (isNaN(aCustomOrder) && isNaN(bCustomOrder)) {
      return a.title.trim().toLowerCase().localeCompare(b.title.trim().toLowerCase(), undefined, {
        numeric: true
      });
    } // sort the items with custom order in front of items without


    if (isNaN(aCustomOrder)) {
      return 1;
    }

    if (isNaN(bCustomOrder)) {
      return -1;
    } // both items are custom, sort using the number line
    // lower numbers first, higher numbers after


    return aCustomOrder - bCustomOrder;
  }

}

exports["default"] = portletService;

/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 1223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(30);
var defineProperty = (__webpack_require__(3070).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var createNonEnumerableProperty = __webpack_require__(8880);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    if (!options.unsafe) delete O[key];
    else if (O[key]) simple = true;
    if (simple) O[key] = value;
    else createNonEnumerableProperty(O, key, value);
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 8113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(9662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(8536);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 614:
/***/ (function(module) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    defineProperty(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 8536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);
var inspectSource = __webpack_require__(2788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(9670);
var definePropertiesModule = __webpack_require__(6048);
var enumBugKeys = __webpack_require__(748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(490);
var documentCreateElement = __webpack_require__(317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var objectKeys = __webpack_require__(1956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4488:
/***/ (function(module) {

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.8',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.8/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(133);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 6699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $includes = (__webpack_require__(1318).includes);
var fails = __webpack_require__(7293);
var addToUnscopables = __webpack_require__(1223);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 5641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1667);
/* harmony import */ var _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
// Imports



var ___CSS_LOADER_URL_IMPORT_0___ = new URL(/* asset import */ __webpack_require__(9954), __webpack_require__.b);
var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}@font-face{font-family:swiper-icons;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px, 0, 0)}.swiper-pointer-events{touch-action:pan-y}.swiper-pointer-events.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);backface-visibility:hidden}.swiper-3d,.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d .swiper-slide,.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-bottom,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:rgba(0,0,0,.15)}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-horizontal.swiper-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-vertical.swiper-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-centered>.swiper-wrapper::before{content:\"\";flex-shrink:0;order:9999}.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center}.swiper-virtual .swiper-slide{-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:\"\";position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:root{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:calc(var(--swiper-navigation-size)/44*27);height:var(--swiper-navigation-size);margin-top:calc(0px - var(--swiper-navigation-size)/2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color, var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none !important}.swiper-button-next:after,.swiper-button-prev:after{font-family:swiper-icons;font-size:var(--swiper-navigation-size);text-transform:none !important;letter-spacing:0;font-variant:initial;line-height:1}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:10px;right:auto}.swiper-button-prev:after,.swiper-rtl .swiper-button-next:after{content:\"prev\"}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:10px;left:auto}.swiper-button-next:after,.swiper-rtl .swiper-button-prev:after{content:\"next\"}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0, 0, 0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none !important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(0.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(0.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(0.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(0.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(0.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));display:inline-block;border-radius:50%;background:var(--swiper-pagination-bullet-inactive-color, #000);opacity:var(--swiper-pagination-bullet-inactive-opacity, 0.2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none !important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color, var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px, -50%, 0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color, var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none !important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color, var(--swiper-theme-color));border-radius:50%;border-top-color:rgba(0,0,0,0)}.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader,.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color:#fff}.swiper-lazy-preloader-black{--swiper-preloader-color:#000}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-fade .swiper-slide-active,.swiper-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube .swiper-slide{pointer-events:none;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-cube.swiper-rtl .swiper-slide{transform-origin:100% 0}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-cube .swiper-slide-active,.swiper-cube .swiper-slide-next,.swiper-cube .swiper-slide-next+.swiper-slide,.swiper-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-cube .swiper-slide-shadow-bottom,.swiper-cube .swiper-slide-shadow-left,.swiper-cube .swiper-slide-shadow-right,.swiper-cube .swiper-slide-shadow-top{z-index:0;backface-visibility:hidden}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:\"\";background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-flip{overflow:visible}.swiper-flip .swiper-slide{pointer-events:none;backface-visibility:hidden;z-index:1}.swiper-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-flip .swiper-slide-active,.swiper-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-flip .swiper-slide-shadow-bottom,.swiper-flip .swiper-slide-shadow-left,.swiper-flip .swiper-slide-shadow-right,.swiper-flip .swiper-slide-shadow-top{z-index:0;backface-visibility:hidden}.swiper-creative .swiper-slide{backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards .swiper-slide{transform-origin:center bottom;backface-visibility:hidden;overflow:hidden}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.action-favorites.background-dark .favorite-button>.svg-inline--fa{color:var(--action-favorites-dark-background-icon-color, #f2f2f2)}.action-favorites .favorite-button{padding:0;text-align:center;text-transform:uppercase;text-decoration:none;border:none;outline:none;background-color:rgba(0,0,0,0);box-shadow:none;cursor:pointer;transition:all .2s ease-in-out;width:44px;height:44px}.action-favorites .favorite-button:hover>.svg-inline--fa{transform:scale(1.4, 1.4)}.action-favorites .favorite-button>.svg-inline--fa{width:60%;height:60%;color:var(--action-favorites-normal-icon-color, #b7b7b7)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.content-favorites{width:inherit;color:#fff;padding-bottom:1.5em;display:flex;flex-flow:column;justify-content:center;text-align:left}.content-favorites>.content-favorites-title{margin:0 0 5px 2em;text-transform:uppercase;filter:grayscale(1)}.content-favorites>.content-favorites-title h1{font-size:24px;font-weight:normal;margin:10px 0 5px 10px;color:#fff}.content-favorites>.favorites{position:relative;padding:0 2em;overflow-x:inherit}.content-favorites>.favorites>::v-deep .content-grid>div .flex-grid{justify-content:flex-start}.content-favorites>.favorites>::v-deep .content-grid>div .flex-grid .flex-item{margin:0}.content-favorites>.favorites>::v-deep .content-grid>div .flex-grid .flex-item.portlet-card-medium,.content-favorites>.favorites>::v-deep .content-grid>div .flex-grid .flix-item.portlet-card-large{margin:32px 5px 5px 0}.content-favorites>.favorites>.swiper{padding-bottom:30px}.content-favorites>.favorites>.swiper>.swiper-wrapper>.swiper-slide{width:255px;height:170px;margin:32px auto}.content-favorites>.favorites>.swiper>.swiper-wrapper>.swiper-slide:first-child{margin-left:20px}.content-favorites>.favorites>.swiper .swiper-pagination{bottom:0}.content-favorites>.favorites>.swiper .swiper-pagination>span.swiper-pagination-bullet{width:16px;height:16px;margin:0 8px;color:#fff}.content-favorites>.favorites .swiper-button-prev,.content-favorites>.favorites .swiper-button-next{height:100%;background-image:none;color:#fff;margin-top:0;width:32px;height:32px;text-align:center}.content-favorites>.favorites .swiper-button-prev:after,.content-favorites>.favorites .swiper-button-next:after{content:none}.content-favorites>.favorites .swiper-button-prev{left:0}.content-favorites>.favorites .swiper-button-next{right:0}.content-favorites>.favorites .fav-swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.content-favorites>.favorites a.no-style{text-decoration:none;color:inherit}.content-favorites>.empty-favorites{padding-left:2em}.content-favorites.parent-small>.content-favorites-title h1,.content-favorites.parent-smaller>.content-favorites-title h1{font-size:initial;font-weight:bold}.content-favorites.small>.favorites>.swiper,.content-favorites.small>.favorites>.content-grid,.content-favorites.smaller>.favorites>.swiper,.content-favorites.smaller>.favorites>.content-grid{margin:0}.content-favorites.small>.favorites>.swiper>.swiper-wrapper>.swiper-slide,.content-favorites.smaller>.favorites>.swiper>.swiper-wrapper>.swiper-slide{height:auto;margin:0}.content-favorites.small>.favorites>.swiper>.swiper-wrapper .swiper-slide~.swiper-slide,.content-favorites.smaller>.favorites>.swiper>.swiper-wrapper .swiper-slide~.swiper-slide{margin-left:5px}.content-favorites.medium>.favorites>.swiper>.swiper-wrapper>.swiper-slide{width:205px;height:160px}.content-favorites.small>.favorites>.swiper>.swiper-wrapper>.swiper-slide{width:120px}.content-favorites.smaller>.favorites>.swiper>.swiper-wrapper>.swiper-slide{width:100px}@media(hover: none)and (pointer: coarse){.content-favorites .swiper-button-prev,.content-favorites .swiper-button-next{display:none}}.content-favorites .svg-inline--fa{width:auto;height:2em;max-width:100%;max-height:100%}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.grid-categories{display:inline-block;width:100%;max-width:50rem;height:calc(2.5rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background-color:#fff;background-size:auto auto;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.content-grid{min-width:250px;padding:.5em 1.5em}.content-grid ::-moz-placeholder{font-style:italic}.content-grid ::placeholder{font-style:italic}.content-grid ::-webkit-input-placeholder{font-style:italic}.content-grid ::-ms-input-placeholder{font-style:italic}.content-grid ::-moz-placeholder{font-style:italic}.content-grid :-moz-placeholder{font-style:italic}.content-grid :-ms-input-placeholder{font-style:italic}.content-grid .svg-inline--fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome,sans-serif;font-size:inherit;height:1em;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.content-grid .svg-inline--fa.fa-search:before{content:\"\"}.content-grid .footer-categories{display:inline-block;width:100%;max-width:50rem;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background-color:#fff;background-size:auto auto;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.content-grid>div{display:block;color:#000}.content-grid>div>.title{padding:0 20px;margin-bottom:15px;text-transform:uppercase;display:flex;flex-flow:row wrap;justify-content:space-between}.content-grid>div>.title>h1,.content-grid>div>.title>slot>h1{margin-bottom:15px;margin-top:15px;font-weight:normal;font-size:24px}.content-grid>div>.title>.filter,.content-grid>div>.title slot>.filter{margin:auto 0;width:100%;height:32px;max-width:400px;display:flex;flex-flow:row nowrap}.content-grid>div>.title>.filter.custom-caret,.content-grid>div>.title slot>.filter.custom-caret{position:relative;cursor:pointer}.content-grid>div>.title>.filter.custom-caret::after,.content-grid>div>.title slot>.filter.custom-caret::after{content:\"\";position:absolute;width:0;height:0;display:inline-block;top:48%;right:10px;border-top:6px solid #000;border-left:6px solid rgba(0,0,0,0);border-right:6px solid rgba(0,0,0,0);pointer-events:none}.content-grid>div>.title>.filter.custom-caret select,.content-grid>div>.title slot>.filter.custom-caret select{-webkit-appearance:none;-moz-appearance:none;padding:5px 24px 5px 5px}.content-grid>div>.title>.filter.custom-caret select::-ms-expand,.content-grid>div>.title slot>.filter.custom-caret select::-ms-expand{display:none}.content-grid>div>.title>.filter input,.content-grid>div>.title>.filter select,.content-grid>div>.title slot>.filter input,.content-grid>div>.title slot>.filter select{border:none;height:100%;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2);outline:none;padding:0;margin:0}.content-grid>div>.title>.filter input,.content-grid>div>.title slot>.filter input{line-height:32px;border-top-left-radius:48px;border-bottom-left-radius:48px;width:60%;text-indent:10px;font-size:16px}.content-grid>div>.title>.filter select,.content-grid>div>.title slot>.filter select{border-top-right-radius:48px;border-bottom-right-radius:48px;width:40%}.content-grid>div>.title>.filter select option.default,.content-grid>div>.title slot>.filter select option.default{font-style:italic;color:gray}.content-grid>div>.title>.filter>div,.content-grid>div>.title slot>.filter>div{display:none}.content-grid>div .preamble{display:flex;flex-flow:row wrap;padding:0 20px}.content-grid>div .flex-grid{display:flex;flex-flow:row wrap;justify-content:var(--content-grid-flex-grid-justify, center)}.content-grid>div .flex-grid .flex-item{margin:20px auto;margin:var(--content-griditem-margin, 20px auto);padding:0 2.5px}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.content-grid>div .flex-grid .flex-item{margin:20px 5px}}.content-grid>div a.no-style{text-decoration:none;color:inherit}.content-grid.small,.content-grid.smaller{padding:.5em}.content-grid.small>div,.content-grid.smaller>div{border-radius:5px;background-color:#f3f3f3}.content-grid.small>div>.title,.content-grid.smaller>div>.title{position:relative;border-radius:5px;background-color:#fff}.content-grid.small>div>.title>h1,.content-grid.small>div>.title>slot>h1,.content-grid.smaller>div>.title>h1,.content-grid.smaller>div>.title>slot>h1{margin-right:32px}.content-grid.small>div>.title>.filter,.content-grid.small>div>.title slot>.filter,.content-grid.smaller>div>.title>.filter,.content-grid.smaller>div>.title slot>.filter{margin:auto 0;position:absolute;display:flex;flex-flow:row nowrap;width:calc(100% - 30px);height:calc(100% - 10px);padding:5px 0;max-width:unset;right:15px}.content-grid.small>div>.title>.filter.closed,.content-grid.small>div>.title slot>.filter.closed,.content-grid.smaller>div>.title>.filter.closed,.content-grid.smaller>div>.title slot>.filter.closed{width:32px}.content-grid.small>div>.title>.filter.closed>input,.content-grid.small>div>.title>.filter.closed>select,.content-grid.small>div>.title>.filter.closed::after,.content-grid.small>div>.title slot>.filter.closed>input,.content-grid.small>div>.title slot>.filter.closed>select,.content-grid.small>div>.title slot>.filter.closed::after,.content-grid.smaller>div>.title>.filter.closed>input,.content-grid.smaller>div>.title>.filter.closed>select,.content-grid.smaller>div>.title>.filter.closed::after,.content-grid.smaller>div>.title slot>.filter.closed>input,.content-grid.smaller>div>.title slot>.filter.closed>select,.content-grid.smaller>div>.title slot>.filter.closed::after{visibility:hidden;padding:0;display:none}.content-grid.small>div>.title>.filter>div,.content-grid.small>div>.title slot>.filter>div,.content-grid.smaller>div>.title>.filter>div,.content-grid.smaller>div>.title slot>.filter>div{display:flex;align-items:center;text-align:center}.content-grid.small>div>.title>.filter>div>.fa,.content-grid.small>div>.title slot>.filter>div>.fa,.content-grid.smaller>div>.title>.filter>div>.fa,.content-grid.smaller>div>.title slot>.filter>div>.fa{margin-left:5px;font-size:32px;opacity:.4}.content-grid.small>div>.title>.filter.opened,.content-grid.small>div>.title slot>.filter.opened,.content-grid.smaller>div>.title>.filter.opened,.content-grid.smaller>div>.title slot>.filter.opened{transition:width 1s;backface-visibility:hidden}.content-grid.small>div>.title>.filter.opened::after,.content-grid.small>div>.title slot>.filter.opened::after,.content-grid.smaller>div>.title>.filter.opened::after,.content-grid.smaller>div>.title slot>.filter.opened::after{right:40px}@media screen and (max-width: 400px){.content-grid.small>div>.title>.filter.opened,.content-grid.small>div>.title slot>.filter.opened,.content-grid.smaller>div>.title>.filter.opened,.content-grid.smaller>div>.title slot>.filter.opened{flex-flow:column wrap;height:100%}.content-grid.small>div>.title>.filter.opened>input,.content-grid.small>div>.title>.filter.opened>select,.content-grid.small>div>.title slot>.filter.opened>input,.content-grid.small>div>.title slot>.filter.opened>select,.content-grid.smaller>div>.title>.filter.opened>input,.content-grid.smaller>div>.title>.filter.opened>select,.content-grid.smaller>div>.title slot>.filter.opened>input,.content-grid.smaller>div>.title slot>.filter.opened>select{width:calc(100% - 42px);height:50%;border-radius:unset}.content-grid.small>div>.title>.filter.opened::after,.content-grid.small>div>.title slot>.filter.opened::after,.content-grid.smaller>div>.title>.filter.opened::after,.content-grid.smaller>div>.title slot>.filter.opened::after{right:50px;top:75%}.content-grid.small>div>.title>.filter.opened>div,.content-grid.small>div>.title slot>.filter.opened>div,.content-grid.smaller>div>.title>.filter.opened>div,.content-grid.smaller>div>.title slot>.filter.opened>div{flex:1 1 100%}}.content-grid.small>div>.title>.filter.opened>div>.fa,.content-grid.small>div>.title slot>.filter.opened>div>.fa,.content-grid.smaller>div>.title>.filter.opened>div>.fa,.content-grid.smaller>div>.title slot>.filter.opened>div>.fa{opacity:1}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}:host{--lit-spinner-color: #fff;min-width:280px;background-color:#d0d0d0;z-index:1030}:host *{font-family:Roboto,sans-serif}:host>section{padding:.5em 1.5em}:host header{position:relative;overflow:hidden}:host header esco-header-buttons,:host header slot esco-header-buttons{position:relative;width:100%;z-index:2}:host header>:not(:last-child){position:relative;z-index:1}:host header>.wrapper{display:flex;flex-flow:row nowrap}:host header>.wrapper esco-content-favorites{flex-grow:1;filter:none;overflow:hidden}:host header div.background{background-position:center;background-repeat:no-repeat;background-size:cover;position:absolute;width:110%;height:110%;overflow:hidden;top:0;z-index:0;filter:blur(7px)}:host .spinner,:host .error{position:fixed;z-index:1040;top:0;left:0;width:100%;height:100%;background-color:#000;opacity:.7;display:flex;flex-direction:column}:host .spinner>*,:host .error>*{width:100%}:host .spinner header,:host .error header{flex:0 auto}:host .spinner section,:host .error section{flex:1 auto;display:flex;align-items:center;justify-content:center}:host .spinner{background-color:#545454}:host .error{background-color:#bd9494;color:#5f0101;font-weight:bold}:host .small,:host .smaller{background-color:#545454}:host .small>section,:host .smaller>section{padding:.5em}:host .small header div.background,:host .smaller header div.background{background-image:none}:host .small header slot,:host .smaller header slot{width:100%}:host .small header>.wrapper,:host .smaller header>.wrapper{flex-flow:row wrap}:host .small>::v-deep section.content-grid>div,:host .smaller>::v-deep section.content-grid>div{background-color:#f3f3f3}:host .small>::v-deep section.content-grid>div>.title,:host .smaller>::v-deep section.content-grid>div>.title{background-color:#fff}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}:host{width:inherit}.content-user{min-width:350px;height:100%;font-size:14px}.content-user.small,.content-user.smaller{min-width:initial;width:100%;height:100%;min-height:150px;background-position:center;background-repeat:no-repeat;background-size:cover}.content-user.small>div>.org-img,.content-user.smaller>div>.org-img{display:none}.content-user.small>div>.user-info,.content-user.smaller>div>.user-info{padding:15px 0}.content-user.small>div>.user-info>div,.content-user.smaller>div>.user-info>div{border-top-right-radius:0;border-bottom-right-radius:0}.content-user>div{display:flex;flex-direction:column;height:100%;justify-content:flex-end}.content-user>div>.org-img{display:flex;align-items:center;justify-content:center;flex:1;margin-top:15px}.content-user>div>.org-img img{width:270px;height:auto;border-radius:10px}.content-user>div>.user-info{padding:25px 0}.content-user>div>.user-info>div{display:flex;align-items:center;border-top-right-radius:27px;border-bottom-right-radius:27px;height:54px;background-color:rgba(0,0,0,.7)}.content-user>div>.user-info>div :only-child:not(.user-avatar){display:inline-block;max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.content-user>div>.user-info>div span{color:#fff}.content-user>div>.user-info>div .user-avatar{float:left;margin:0 15px}.content-user>div>.user-info>div .user-avatar img,.content-user>div>.user-info>div .user-avatar svg{width:68px;height:68px;border-radius:50%}.content-user>div>.user-info>div .user-avatar svg{color:#fff;background-color:#b7b7b7}.content-user>div>.user-info>div .wrapper-info :only-child{display:block}.content-user>div>.user-info>div .wrapper-info .user-name{font-weight:bold}.content-user>div>.user-info>div .other-orgs{flex:1}.content-user>div>.user-info>div .other-orgs>a{float:right;color:#fff;margin-right:15px}.content-user>div>.user-info>div .other-orgs>a>svg{width:24px;height:24px}.content-user>div>.user-info>div .other-orgs>button{float:right;color:#fff;margin-right:15px;border:none;background:none;cursor:pointer}.content-user>div>.user-info>div .other-orgs>button>svg{width:24px;height:24px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.hamburger-menu{display:flex}.hamburger-menu>.content-menu-toggle{color:#fff;text-decoration:none;cursor:pointer;padding:5px 0;background-color:rgba(0,0,0,0);border-style:none}.hamburger-menu>.content-menu-toggle:hover>.menu-wrapper>.hm-line{opacity:.7}.hamburger-menu>.content-menu-toggle .menu-icon{display:flex;flex-wrap:wrap;align-content:center;justify-content:center;width:28px;height:28px;margin:0 var(--content-menu-icon-spaces, 10px)}.hamburger-menu>.content-menu-toggle .menu-icon.hamburger-icon{flex-direction:column;flex-wrap:nowrap}.hamburger-menu>.content-menu-toggle .menu-icon.hamburger-icon .icon-elem{flex:0 1 2px;width:100%;margin:2.5px 0px;content:\" \";background-color:var(--content-menu-icon-font-color, #fff);border-radius:1px}.hamburger-menu>.content-menu-toggle .menu-icon.four-square-icon .icon-elem,.hamburger-menu>.content-menu-toggle .menu-icon.four-circle-icon .icon-elem{flex:0 1 10px;width:10px;height:10px;margin:2px;content:\" \";background-color:var(--content-menu-icon-font-color, #fff);border-radius:1px}.hamburger-menu>.content-menu-toggle .menu-icon.nine-square-icon .icon-elem,.hamburger-menu>.content-menu-toggle .menu-icon.nine-circle-icon .icon-elem{flex:0 1 6px;width:6px;height:6px;margin:1px;content:\" \";background-color:var(--content-menu-icon-font-color, #fff);border-radius:1px}.hamburger-menu>.content-menu-toggle .menu-icon.four-circle-icon .icon-elem,.hamburger-menu>.content-menu-toggle .menu-icon.nine-circle-icon .icon-elem{border-radius:50%}.hamburger-menu>.content-menu-toggle .menu-icon.empty-icon .icon-elem{box-sizing:border-box;background-color:rgba(0,0,0,0);border:1.5px solid var(--content-menu-icon-font-color, #fff)}.hamburger-menu .toggler-menu,.hamburger-menu slot esco-content-menu{position:fixed;width:100%;height:100%;top:0;left:0;overflow-y:scroll;visibility:hidden;opacity:0;transition:opacity 600ms,visibility 600ms;animation:fade 600ms}.hamburger-menu .active-menu,.hamburger-menu slot .active-menu{visibility:visible;opacity:1}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.content-menu-header-buttons{display:flex;flex-flow:row nowrap;justify-content:space-between}.content-menu-header-buttons>*{margin-top:1em}.content-menu-header-buttons>:first-child{margin-left:1em}.content-menu-header-buttons>:last-child{margin-right:1em}.content-menu-header-buttons>button>svg,.content-menu-header-buttons>a>svg{width:32px;height:32px;color:#fff}.content-menu-header-buttons button{text-decoration:none;border:none;background-color:rgba(0,0,0,0);box-shadow:none;cursor:pointer}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.portlet-card{width:255px;height:170px;padding:5px;line-height:20px;background-color:#fff;text-align:center;border-radius:5px;position:relative;display:flex;flex-flow:column nowrap;box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2);transition:box-shadow .25s}.portlet-card:hover{cursor:pointer;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.portlet-card>.portlet-card-icon,.portlet-card>.portlet-card-title,.portlet-card>.portlet-card-description{display:block;text-align:center;color:rgba(0,0,0,.8)}.portlet-card>.portlet-card-action{color:rgba(0,0,0,.34);position:absolute;top:0;right:0;margin:5px}.portlet-card>.portlet-card-icon{display:var(--content-gridcard-icon-display)}.portlet-card>.portlet-card-icon>div{display:inline-flex;align-items:center;justify-content:center;height:83px;width:83px;margin-top:-30px;border-radius:10px}.portlet-card>.portlet-card-icon>div img{height:100%;width:auto;border-radius:10px}.portlet-card>.portlet-card-icon>div .defaultIcon{width:100%;height:100%;background-color:#5b686d;border-radius:10px}.portlet-card>.portlet-card-icon>div .defaultIcon p{display:inline-block;vertical-align:middle;text-align:center;font-weight:bold;color:#fff;font-size:1.6em}.portlet-card>.portlet-card-title{display:var(--content-gridcard-title-display);padding-top:1em;font-size:16px;font-weight:bold;overflow:hidden;text-overflow:ellipsis}.portlet-card>.portlet-card-description{display:var(--content-gridcard-description-display);padding-top:.3em;flex:1;font-size:14px}.portlet-card.custom-card{padding:5px;padding:var(--content-gridcard-padding, 5px);border:none;border:var(--content-gridcard-border, none);background-color:#fff;background-color:var(--content-gridcard-bg-color, white);border-radius:5px;border-radius:var(--content-gridcard-border-radius, 5px);box-shadow:none;box-shadow:var(--content-gridcard-shadow, none);transition:box-shadow .25s;width:180px;width:var(--content-gridcard-size-w, 180px);height:180px;height:var(--content-gridcard-size-h, 180px)}.portlet-card.custom-card:hover{box-shadow:none;box-shadow:var(--content-gridcard-shadow-hover, none)}.portlet-card.custom-card>.portlet-card-icon>div{height:75px;height:var(--content-gridcard-icon-size, 75px);width:75px;width:var(--content-gridcard-icon-size, 75px);margin-top:0}.portlet-card.custom-card>.portlet-card-title{overflow-x:hidden;overflow-y:visible;text-overflow:ellipsis;font-size:var(--content-gridcard-title-fontsize, 16px)}.portlet-card.custom-card>.portlet-card-description{font-size:var(--content-gridcard-description-fontsize, 16px)}.portlet-card.medium-card,.portlet-card.small-card,.portlet-card.smaller-card{height:160px}.portlet-card.medium-card>.portlet-card-icon>div,.portlet-card.small-card>.portlet-card-icon>div,.portlet-card.smaller-card>.portlet-card-icon>div{height:75px;width:75px}.portlet-card.small-card,.portlet-card.smaller-card{height:auto;background-color:rgba(0,0,0,0);border:none;box-shadow:none;padding:0}.portlet-card.small-card.background-dark>.portlet-card-title,.portlet-card.small-card.background-dark>.portlet-card-description,.portlet-card.smaller-card.background-dark>.portlet-card-title,.portlet-card.smaller-card.background-dark>.portlet-card-description{color:#fff}.portlet-card.small-card>.portlet-card-description,.portlet-card.smaller-card>.portlet-card-description{display:none}.portlet-card.small-card>.portlet-card-icon>div,.portlet-card.smaller-card>.portlet-card-icon>div{margin:0}.portlet-card.small-card>.portlet-card-title,.portlet-card.smaller-card>.portlet-card-title{padding-top:.8em;font-weight:500}.portlet-card.small-card>.portlet-card-action,.portlet-card.smaller-card>.portlet-card-action{margin:0}.portlet-card.small-card:not(.hide-action),.portlet-card.smaller-card:not(.hide-action){margin-top:22px}.portlet-card.small-card:not(.hide-action)>.portlet-card-action,.portlet-card.smaller-card:not(.hide-action)>.portlet-card-action{top:-22px}.portlet-card.medium-card{width:205px}.portlet-card.small-card{width:120px}.portlet-card.smaller-card{width:100px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3645:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";

      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }

      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }

      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }

      content += cssWithMappingToString(item);

      if (needLayer) {
        content += "}";
      }

      if (item[2]) {
        content += "}";
      }

      if (item[4]) {
        content += "}";
      }

      return content;
    }).join("");
  }; // import a list of modules into the list


  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }

      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }

      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }

      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ 1667:
/***/ (function(module) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    options = {};
  }

  if (!url) {
    return url;
  }

  url = String(url.__esModule ? url.default : url); // If url is already wrapped in quotes, remove them

  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  }

  if (options.hash) {
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
  }

  return url;
};

/***/ }),

/***/ 8081:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 8552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(1789),
    hashDelete = __webpack_require__(401),
    hashGet = __webpack_require__(7667),
    hashHas = __webpack_require__(1327),
    hashSet = __webpack_require__(1866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 8407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(7040),
    listCacheDelete = __webpack_require__(4125),
    listCacheGet = __webpack_require__(2117),
    listCacheHas = __webpack_require__(7518),
    listCacheSet = __webpack_require__(3399);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 7071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 3369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(4785),
    mapCacheDelete = __webpack_require__(1285),
    mapCacheGet = __webpack_require__(6000),
    mapCacheHas = __webpack_require__(9916),
    mapCacheSet = __webpack_require__(5265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 8525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 8668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369),
    setCacheAdd = __webpack_require__(619),
    setCacheHas = __webpack_require__(2385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 6384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    stackClear = __webpack_require__(7465),
    stackDelete = __webpack_require__(3779),
    stackGet = __webpack_require__(7599),
    stackHas = __webpack_require__(6783),
    stackSet = __webpack_require__(4309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 2705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 4963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 7443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 4636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(2545),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isIndex = __webpack_require__(5776),
    isTypedArray = __webpack_require__(6719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 9932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 2488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 2908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 8470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(7813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 1848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 7786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    toKey = __webpack_require__(327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 8866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(2488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 4239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    getRawTag = __webpack_require__(9607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 2118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1848),
    baseIsNaN = __webpack_require__(2722),
    strictIndexOf = __webpack_require__(2351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(7005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    equalArrays = __webpack_require__(7114),
    equalByTag = __webpack_require__(8351),
    equalObjects = __webpack_require__(6096),
    getTag = __webpack_require__(4160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isTypedArray = __webpack_require__(6719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    baseIsEqual = __webpack_require__(939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 2722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 8458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isMasked = __webpack_require__(5346),
    isObject = __webpack_require__(3218),
    toSource = __webpack_require__(346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 8749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isLength = __webpack_require__(1780),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 7206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(1573),
    baseMatchesProperty = __webpack_require__(6432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(9601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5726),
    nativeKeys = __webpack_require__(9850);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 1573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(2634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 6432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(939),
    get = __webpack_require__(7361),
    hasIn = __webpack_require__(9095),
    isKey = __webpack_require__(5403),
    isStrictComparable = __webpack_require__(9162),
    matchesStrictComparable = __webpack_require__(2634),
    toKey = __webpack_require__(327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 9152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 2545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    arrayMap = __webpack_require__(9932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(7990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 1717:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 5652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8668),
    arrayIncludes = __webpack_require__(7443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(4757),
    createSet = __webpack_require__(3593),
    setToArray = __webpack_require__(1814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 4757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 1811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(5403),
    stringToPath = __webpack_require__(5514),
    toString = __webpack_require__(9833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 4429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 3593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(8525),
    noop = __webpack_require__(308),
    setToArray = __webpack_require__(1814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 7114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8668),
    arraySome = __webpack_require__(2908),
    cacheHas = __webpack_require__(4757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 8351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    Uint8Array = __webpack_require__(1149),
    eq = __webpack_require__(7813),
    equalArrays = __webpack_require__(7114),
    mapToArray = __webpack_require__(8776),
    setToArray = __webpack_require__(1814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 6096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(8234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 1957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 8234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(8866),
    getSymbols = __webpack_require__(9551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 5050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(7019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(9162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(8458),
    getValue = __webpack_require__(7801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 9607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 9551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(4963),
    stubArray = __webpack_require__(479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(8552),
    Map = __webpack_require__(7071),
    Promise = __webpack_require__(3818),
    Set = __webpack_require__(8525),
    WeakMap = __webpack_require__(577),
    baseGetTag = __webpack_require__(4239),
    toSource = __webpack_require__(346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 7801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(5776),
    isLength = __webpack_require__(1780),
    toKey = __webpack_require__(327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 1789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 7667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 1327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 1866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 5403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 7019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 5346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(4429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 5726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 9162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 7040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 4125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 2117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 7518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 4785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 1285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 6000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 9916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 5265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 8776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 2634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 4523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(8306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 4536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 9850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(1957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 5639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 2385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 7465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 3779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 7599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 6783:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 4309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071),
    MapCache = __webpack_require__(3369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 2351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 5514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(4523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 3279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(4841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 7813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 7361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 9095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 5694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(7005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 8612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isLength = __webpack_require__(1780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(5639),
    stubFalse = __webpack_require__(5062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObject = __webpack_require__(3218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 3218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 7005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 7037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 3448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 6719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(8749),
    baseUnary = __webpack_require__(1717),
    nodeUtil = __webpack_require__(1167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(4636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(8612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 8306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 9601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(371),
    basePropertyDeep = __webpack_require__(9152),
    isKey = __webpack_require__(5403),
    toKey = __webpack_require__(327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 5062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 4841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(7561),
    isObject = __webpack_require__(3218),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 9833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 5578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(7206),
    baseUniq = __webpack_require__(5652);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 4044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "defaultBaseSortFn": function() { return /* binding */ defaultBaseSortFn; },
  "matchSorter": function() { return /* binding */ matchSorter; },
  "rankings": function() { return /* binding */ rankings; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/remove-accents/index.js
var remove_accents = __webpack_require__(6826);
var remove_accents_default = /*#__PURE__*/__webpack_require__.n(remove_accents);
;// CONCATENATED MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js



var rankings = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
matchSorter.rankings = rankings;

var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
  return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */


function matchSorter(items, value, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      keys = _options.keys,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold,
      _options$baseSort = _options.baseSort,
      baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort,
      _options$sorter = _options.sorter,
      sorter = _options$sorter === void 0 ? function (matchedItems) {
    return matchedItems.sort(function (a, b) {
      return sortRankedValues(a, b, baseSort);
    });
  } : _options$sorter;
  var matchedItems = items.reduce(reduceItemsToRanked, []);
  return sorter(matchedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });

  function reduceItemsToRanked(matches, item, index) {
    var rankingInfo = getHighestRanking(item, keys, value, options);
    var rank = rankingInfo.rank,
        _rankingInfo$keyThres = rankingInfo.keyThreshold,
        keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;

    if (rank >= keyThreshold) {
      matches.push(_extends({}, rankingInfo, {
        item: item,
        index: index
      }));
    }

    return matches;
  }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */


function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    // if keys is not specified, then we assume the item given is ready to be matched
    var stringItem = item;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: stringItem,
      rank: getMatchRanking(stringItem, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }

  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        rankedValue = _ref2.rankedValue,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;
    var newRank = getMatchRanking(itemValue, value, options);
    var newRankedValue = rankedValue;
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }

    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
      newRankedValue = itemValue;
    }

    return {
      rankedValue: newRankedValue,
      rank: rank,
      keyIndex: keyIndex,
      keyThreshold: keyThreshold
    };
  }, {
    rankedValue: item,
    rank: rankings.NO_MATCH,
    keyIndex: -1,
    keyThreshold: options.threshold
  });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */


function getMatchRanking(testString, stringToRank, options) {
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options); // too long

  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  } // case sensitive equals


  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  } // Lower casing before further comparison


  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase(); // case insensitive equals

  if (testString === stringToRank) {
    return rankings.EQUAL;
  } // starts with


  if (testString.startsWith(stringToRank)) {
    return rankings.STARTS_WITH;
  } // word starts with


  if (testString.includes(" " + stringToRank)) {
    return rankings.WORD_STARTS_WITH;
  } // contains


  if (testString.includes(stringToRank)) {
    return rankings.CONTAINS;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  } // acronym


  if (getAcronym(testString).includes(stringToRank)) {
    return rankings.ACRONYM;
  } // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.


  return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */


function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */


function getClosenessRanking(testString, stringToRank) {
  var matchingInOrderCharCount = 0;
  var charNumber = 0;

  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index, J = string.length; j < J; j++) {
      var stringChar = string[j];

      if (stringChar === matchChar) {
        matchingInOrderCharCount += 1;
        return j + 1;
      }
    }

    return -1;
  }

  function getRanking(spread) {
    var spreadPercentage = 1 / spread;
    var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
    var ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
    return ranking;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);

  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }

  charNumber = firstIndex;

  for (var i = 1, I = stringToRank.length; i < I; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;

    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */


function sortRankedValues(a, b, baseSort) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bKeyIndex = b.keyIndex;
  var same = aRank === bRank;

  if (same) {
    if (aKeyIndex === bKeyIndex) {
      // use the base sort function as a tie-breaker
      return baseSort(a, b);
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */


function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;
  // value might not actually be a string at this point (we don't get to choose)
  // so part of preparing the value for comparison is ensure that it is a string
  value = "" + value; // toString

  if (!keepDiacritics) {
    value = remove_accents_default()(value);
  }

  return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */


function getItemValues(item, key) {
  if (typeof key === 'object') {
    key = key.key;
  }

  var value;

  if (typeof key === 'function') {
    value = key(item);
  } else if (item == null) {
    value = null;
  } else if (Object.hasOwnProperty.call(item, key)) {
    value = item[key];
  } else if (key.includes('.')) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return getNestedValues(key, item);
  } else {
    value = null;
  } // because `value` can also be undefined


  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [String(value)];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */


function getNestedValues(path, item) {
  var keys = path.split('.');
  var values = [item];

  for (var i = 0, I = keys.length; i < I; i++) {
    var nestedKey = keys[i];
    var nestedValues = [];

    for (var j = 0, J = values.length; j < J; j++) {
      var nestedItem = values[j];
      if (nestedItem == null) continue;

      if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
        var nestedValue = nestedItem[nestedKey];

        if (nestedValue != null) {
          nestedValues.push(nestedValue);
        }
      } else if (nestedKey === '*') {
        // ensure that values is an array
        nestedValues = nestedValues.concat(nestedItem);
      }
    }

    values = nestedValues;
  }

  if (Array.isArray(values[0])) {
    // keep allowing the implicit wildcard for an array of strings at the end of
    // the path; don't use `.flat()` because that's not available in node.js v10
    var result = [];
    return result.concat.apply(result, values);
  } // Based on our logic it should be an array of strings by now...
  // assuming the user's path terminated in strings


  return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */


function getAllValuesToRank(item, keys) {
  var allValues = [];

  for (var j = 0, J = keys.length; j < J; j++) {
    var key = keys[j];
    var attributes = getKeyAttributes(key);
    var itemValues = getItemValues(item, key);

    for (var i = 0, I = itemValues.length; i < I; i++) {
      allValues.push({
        itemValue: itemValues[i],
        attributes: attributes
      });
    }
  }

  return allValues;
}

var defaultKeyAttributes = {
  maxRanking: Infinity,
  minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */

function getKeyAttributes(key) {
  if (typeof key === 'string') {
    return defaultKeyAttributes;
  }

  return _extends({}, defaultKeyAttributes, key);
}
/*
eslint
  no-continue: "off",
*/




/***/ }),

/***/ 6826:
/***/ (function(module) {

var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

module.exports = removeAccents;
module.exports.has = hasAccents;
module.exports.remove = removeAccents;


/***/ }),

/***/ 4972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./fr.ts": 2258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4972;

/***/ }),

/***/ 9954:
/***/ (function(module) {

"use strict";
module.exports = "data:application/font-woff;charset=utf-8;base64, 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";

/***/ }),

/***/ 1417:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var Gf = { exports: {} };
(function(e) {
  var t = function(n) {
    var r = Object.prototype, s = r.hasOwnProperty, o = Object.defineProperty || function(L, k, U) {
      L[k] = U.value;
    }, i, a = typeof Symbol == "function" ? Symbol : {}, l = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", u = a.toStringTag || "@@toStringTag";
    function d(L, k, U) {
      return Object.defineProperty(L, k, {
        value: U,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), L[k];
    }
    try {
      d({}, "");
    } catch {
      d = function(k, U, B) {
        return k[U] = B;
      };
    }
    function h(L, k, U, B) {
      var z = k && k.prototype instanceof I ? k : I, Q = Object.create(z.prototype), Ie = new he(B || []);
      return o(Q, "_invoke", { value: ce(L, U, Ie) }), Q;
    }
    n.wrap = h;
    function T(L, k, U) {
      try {
        return { type: "normal", arg: L.call(k, U) };
      } catch (B) {
        return { type: "throw", arg: B };
      }
    }
    var O = "suspendedStart", A = "suspendedYield", v = "executing", m = "completed", g = {};
    function I() {
    }
    function S() {
    }
    function D() {
    }
    var G = {};
    d(G, l, function() {
      return this;
    });
    var w = Object.getPrototypeOf, Y = w && w(w(re([])));
    Y && Y !== r && s.call(Y, l) && (G = Y);
    var J = D.prototype = I.prototype = Object.create(G);
    S.prototype = D, o(J, "constructor", { value: D, configurable: !0 }), o(
      D,
      "constructor",
      { value: S, configurable: !0 }
    ), S.displayName = d(
      D,
      u,
      "GeneratorFunction"
    );
    function fe(L) {
      ["next", "throw", "return"].forEach(function(k) {
        d(L, k, function(U) {
          return this._invoke(k, U);
        });
      });
    }
    n.isGeneratorFunction = function(L) {
      var k = typeof L == "function" && L.constructor;
      return k ? k === S || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (k.displayName || k.name) === "GeneratorFunction" : !1;
    }, n.mark = function(L) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(L, D) : (L.__proto__ = D, d(L, u, "GeneratorFunction")), L.prototype = Object.create(J), L;
    }, n.awrap = function(L) {
      return { __await: L };
    };
    function ge(L, k) {
      function U(Q, Ie, de, Ee) {
        var _e = T(L[Q], L, Ie);
        if (_e.type === "throw")
          Ee(_e.arg);
        else {
          var _t = _e.arg, Le = _t.value;
          return Le && typeof Le == "object" && s.call(Le, "__await") ? k.resolve(Le.__await).then(function(je) {
            U("next", je, de, Ee);
          }, function(je) {
            U("throw", je, de, Ee);
          }) : k.resolve(Le).then(function(je) {
            _t.value = je, de(_t);
          }, function(je) {
            return U("throw", je, de, Ee);
          });
        }
      }
      var B;
      function z(Q, Ie) {
        function de() {
          return new k(function(Ee, _e) {
            U(Q, Ie, Ee, _e);
          });
        }
        return B = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        B ? B.then(
          de,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          de
        ) : de();
      }
      o(this, "_invoke", { value: z });
    }
    fe(ge.prototype), d(ge.prototype, c, function() {
      return this;
    }), n.AsyncIterator = ge, n.async = function(L, k, U, B, z) {
      z === void 0 && (z = Promise);
      var Q = new ge(
        h(L, k, U, B),
        z
      );
      return n.isGeneratorFunction(k) ? Q : Q.next().then(function(Ie) {
        return Ie.done ? Ie.value : Q.next();
      });
    };
    function ce(L, k, U) {
      var B = O;
      return function(Q, Ie) {
        if (B === v)
          throw new Error("Generator is already running");
        if (B === m) {
          if (Q === "throw")
            throw Ie;
          return te();
        }
        for (U.method = Q, U.arg = Ie; ; ) {
          var de = U.delegate;
          if (de) {
            var Ee = Ge(de, U);
            if (Ee) {
              if (Ee === g) continue;
              return Ee;
            }
          }
          if (U.method === "next")
            U.sent = U._sent = U.arg;
          else if (U.method === "throw") {
            if (B === O)
              throw B = m, U.arg;
            U.dispatchException(U.arg);
          } else U.method === "return" && U.abrupt("return", U.arg);
          B = v;
          var _e = T(L, k, U);
          if (_e.type === "normal") {
            if (B = U.done ? m : A, _e.arg === g)
              continue;
            return {
              value: _e.arg,
              done: U.done
            };
          } else _e.type === "throw" && (B = m, U.method = "throw", U.arg = _e.arg);
        }
      };
    }
    function Ge(L, k) {
      var U = k.method, B = L.iterator[U];
      if (B === i)
        return k.delegate = null, U === "throw" && L.iterator.return && (k.method = "return", k.arg = i, Ge(L, k), k.method === "throw") || U !== "return" && (k.method = "throw", k.arg = new TypeError(
          "The iterator does not provide a '" + U + "' method"
        )), g;
      var z = T(B, L.iterator, k.arg);
      if (z.type === "throw")
        return k.method = "throw", k.arg = z.arg, k.delegate = null, g;
      var Q = z.arg;
      if (!Q)
        return k.method = "throw", k.arg = new TypeError("iterator result is not an object"), k.delegate = null, g;
      if (Q.done)
        k[L.resultName] = Q.value, k.next = L.nextLoc, k.method !== "return" && (k.method = "next", k.arg = i);
      else
        return Q;
      return k.delegate = null, g;
    }
    fe(J), d(J, u, "Generator"), d(J, l, function() {
      return this;
    }), d(J, "toString", function() {
      return "[object Generator]";
    });
    function Rt(L) {
      var k = { tryLoc: L[0] };
      1 in L && (k.catchLoc = L[1]), 2 in L && (k.finallyLoc = L[2], k.afterLoc = L[3]), this.tryEntries.push(k);
    }
    function ht(L) {
      var k = L.completion || {};
      k.type = "normal", delete k.arg, L.completion = k;
    }
    function he(L) {
      this.tryEntries = [{ tryLoc: "root" }], L.forEach(Rt, this), this.reset(!0);
    }
    n.keys = function(L) {
      var k = Object(L), U = [];
      for (var B in k)
        U.push(B);
      return U.reverse(), function z() {
        for (; U.length; ) {
          var Q = U.pop();
          if (Q in k)
            return z.value = Q, z.done = !1, z;
        }
        return z.done = !0, z;
      };
    };
    function re(L) {
      if (L != null) {
        var k = L[l];
        if (k)
          return k.call(L);
        if (typeof L.next == "function")
          return L;
        if (!isNaN(L.length)) {
          var U = -1, B = function z() {
            for (; ++U < L.length; )
              if (s.call(L, U))
                return z.value = L[U], z.done = !1, z;
            return z.value = i, z.done = !0, z;
          };
          return B.next = B;
        }
      }
      throw new TypeError(typeof L + " is not iterable");
    }
    n.values = re;
    function te() {
      return { value: i, done: !0 };
    }
    return he.prototype = {
      constructor: he,
      reset: function(L) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(ht), !L)
          for (var k in this)
            k.charAt(0) === "t" && s.call(this, k) && !isNaN(+k.slice(1)) && (this[k] = i);
      },
      stop: function() {
        this.done = !0;
        var L = this.tryEntries[0], k = L.completion;
        if (k.type === "throw")
          throw k.arg;
        return this.rval;
      },
      dispatchException: function(L) {
        if (this.done)
          throw L;
        var k = this;
        function U(Ee, _e) {
          return Q.type = "throw", Q.arg = L, k.next = Ee, _e && (k.method = "next", k.arg = i), !!_e;
        }
        for (var B = this.tryEntries.length - 1; B >= 0; --B) {
          var z = this.tryEntries[B], Q = z.completion;
          if (z.tryLoc === "root")
            return U("end");
          if (z.tryLoc <= this.prev) {
            var Ie = s.call(z, "catchLoc"), de = s.call(z, "finallyLoc");
            if (Ie && de) {
              if (this.prev < z.catchLoc)
                return U(z.catchLoc, !0);
              if (this.prev < z.finallyLoc)
                return U(z.finallyLoc);
            } else if (Ie) {
              if (this.prev < z.catchLoc)
                return U(z.catchLoc, !0);
            } else if (de) {
              if (this.prev < z.finallyLoc)
                return U(z.finallyLoc);
            } else
              throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function(L, k) {
        for (var U = this.tryEntries.length - 1; U >= 0; --U) {
          var B = this.tryEntries[U];
          if (B.tryLoc <= this.prev && s.call(B, "finallyLoc") && this.prev < B.finallyLoc) {
            var z = B;
            break;
          }
        }
        z && (L === "break" || L === "continue") && z.tryLoc <= k && k <= z.finallyLoc && (z = null);
        var Q = z ? z.completion : {};
        return Q.type = L, Q.arg = k, z ? (this.method = "next", this.next = z.finallyLoc, g) : this.complete(Q);
      },
      complete: function(L, k) {
        if (L.type === "throw")
          throw L.arg;
        return L.type === "break" || L.type === "continue" ? this.next = L.arg : L.type === "return" ? (this.rval = this.arg = L.arg, this.method = "return", this.next = "end") : L.type === "normal" && k && (this.next = k), g;
      },
      finish: function(L) {
        for (var k = this.tryEntries.length - 1; k >= 0; --k) {
          var U = this.tryEntries[k];
          if (U.finallyLoc === L)
            return this.complete(U.completion, U.afterLoc), ht(U), g;
        }
      },
      catch: function(L) {
        for (var k = this.tryEntries.length - 1; k >= 0; --k) {
          var U = this.tryEntries[k];
          if (U.tryLoc === L) {
            var B = U.completion;
            if (B.type === "throw") {
              var z = B.arg;
              ht(U);
            }
            return z;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(L, k, U) {
        return this.delegate = {
          iterator: re(L),
          resultName: k,
          nextLoc: U
        }, this.method === "next" && (this.arg = i), g;
      }
    }, n;
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    e.exports
  );
  try {
    regeneratorRuntime = t;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
})(Gf);
/**
* @vue/shared v3.5.11
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Qo(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const ie = {}, Pn = [], ut = () => {
}, jf = () => !1, fs = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Zo = (e) => e.startsWith("onUpdate:"), ve = Object.assign, ei = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Uf = Object.prototype.hasOwnProperty, se = (e, t) => Uf.call(e, t), $ = Array.isArray, Dn = (e) => yr(e) === "[object Map]", Ql = (e) => yr(e) === "[object Set]", $i = (e) => yr(e) === "[object Date]", X = (e) => typeof e == "function", be = (e) => typeof e == "string", Tt = (e) => typeof e == "symbol", le = (e) => e !== null && typeof e == "object", Zl = (e) => (le(e) || X(e)) && X(e.then) && X(e.catch), ec = Object.prototype.toString, yr = (e) => ec.call(e), Hf = (e) => yr(e).slice(8, -1), ds = (e) => yr(e) === "[object Object]", ti = (e) => be(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, er = /* @__PURE__ */ Qo(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), ps = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, Vf = /-(\w)/g, ft = ps(
  (e) => e.replace(Vf, (t, n) => n ? n.toUpperCase() : "")
), zf = /\B([A-Z])/g, it = ps(
  (e) => e.replace(zf, "-$1").toLowerCase()
), tc = ps((e) => e.charAt(0).toUpperCase() + e.slice(1)), ks = ps(
  (e) => e ? `on${tc(e)}` : ""
), nn = (e, t) => !Object.is(e, t), jr = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, nc = (e, t, n, r = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: r,
    value: n
  });
}, Kf = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Wi = (e) => {
  const t = be(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Xi;
const rc = () => Xi || (Xi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function ni(e) {
  if ($(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], s = be(r) ? Xf(r) : ni(r);
      if (s)
        for (const o in s)
          t[o] = s[o];
    }
    return t;
  } else if (be(e) || le(e))
    return e;
}
const Bf = /;(?![^(]*\))/g, $f = /:([^]+)/, Wf = /\/\*[^]*?\*\//g;
function Xf(e) {
  const t = {};
  return e.replace(Wf, "").split(Bf).forEach((n) => {
    if (n) {
      const r = n.split($f);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function ri(e) {
  let t = "";
  if (be(e))
    t = e;
  else if ($(e))
    for (let n = 0; n < e.length; n++) {
      const r = ri(e[n]);
      r && (t += r + " ");
    }
  else if (le(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const Yf = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", qf = /* @__PURE__ */ Qo(Yf);
function sc(e) {
  return !!e || e === "";
}
function Jf(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let r = 0; n && r < e.length; r++)
    n = Xr(e[r], t[r]);
  return n;
}
function Xr(e, t) {
  if (e === t) return !0;
  let n = $i(e), r = $i(t);
  if (n || r)
    return n && r ? e.getTime() === t.getTime() : !1;
  if (n = Tt(e), r = Tt(t), n || r)
    return e === t;
  if (n = $(e), r = $(t), n || r)
    return n && r ? Jf(e, t) : !1;
  if (n = le(e), r = le(t), n || r) {
    if (!n || !r)
      return !1;
    const s = Object.keys(e).length, o = Object.keys(t).length;
    if (s !== o)
      return !1;
    for (const i in e) {
      const a = e.hasOwnProperty(i), l = t.hasOwnProperty(i);
      if (a && !l || !a && l || !Xr(e[i], t[i]))
        return !1;
    }
  }
  return String(e) === String(t);
}
const oc = (e) => !!(e && e.__v_isRef === !0), wt = (e) => be(e) ? e : e == null ? "" : $(e) || le(e) && (e.toString === ec || !X(e.toString)) ? oc(e) ? wt(e.value) : JSON.stringify(e, ic, 2) : String(e), ic = (e, t) => oc(t) ? ic(e, t.value) : Dn(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [r, s], o) => (n[Ms(r, o) + " =>"] = s, n),
    {}
  )
} : Ql(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => Ms(n))
} : Tt(t) ? Ms(t) : le(t) && !$(t) && !ds(t) ? String(t) : t, Ms = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    Tt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
var Qf = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
let We;
class ac {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = We, !t && We && (this.index = (We.scopes || (We.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = We;
      try {
        return We = this, t();
      } finally {
        We = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    We = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    We = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, r;
      for (n = 0, r = this.effects.length; n < r; n++)
        this.effects[n].stop();
      for (n = 0, r = this.cleanups.length; n < r; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, r = this.scopes.length; n < r; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function Zf(e) {
  return new ac(e);
}
function ed() {
  return We;
}
let ae;
const Fs = /* @__PURE__ */ new WeakSet();
class lc {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, We && We.active && We.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Fs.has(this) && (Fs.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || uc(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Yi(this), fc(this);
    const t = ae, n = dt;
    ae = this, dt = !0;
    try {
      return this.fn();
    } finally {
      dc(this), ae = t, dt = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        ii(t);
      this.deps = this.depsTail = void 0, Yi(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Fs.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    io(this) && this.run();
  }
  get dirty() {
    return io(this);
  }
}
let cc = 0, tr, nr;
function uc(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = nr, nr = e;
    return;
  }
  e.next = tr, tr = e;
}
function si() {
  cc++;
}
function oi() {
  if (--cc > 0)
    return;
  if (nr) {
    let t = nr;
    for (nr = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; tr; ) {
    let t = tr;
    for (tr = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (r) {
          e || (e = r);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function fc(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function dc(e) {
  let t, n = e.depsTail, r = n;
  for (; r; ) {
    const s = r.prevDep;
    r.version === -1 ? (r === n && (n = s), ii(r), td(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = s;
  }
  e.deps = t, e.depsTail = n;
}
function io(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (pc(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function pc(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === fr))
    return;
  e.globalVersion = fr;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !io(e)) {
    e.flags &= -3;
    return;
  }
  const n = ae, r = dt;
  ae = e, dt = !0;
  try {
    fc(e);
    const s = e.fn(e._value);
    (t.version === 0 || nn(s, e._value)) && (e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    ae = n, dt = r, dc(e), e.flags &= -3;
  }
}
function ii(e, t = !1) {
  const { dep: n, prevSub: r, nextSub: s } = e;
  if (r && (r.nextSub = s, e.prevSub = void 0), s && (s.prevSub = r, e.nextSub = void 0), n.subs === e && (n.subs = r), !n.subs && n.computed) {
    n.computed.flags &= -5;
    for (let o = n.computed.deps; o; o = o.nextDep)
      ii(o, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function td(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let dt = !0;
const mc = [];
function zt() {
  mc.push(dt), dt = !1;
}
function Kt() {
  const e = mc.pop();
  dt = e === void 0 ? !0 : e;
}
function Yi(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = ae;
    ae = void 0;
    try {
      t();
    } finally {
      ae = n;
    }
  }
}
let fr = 0;
class nd {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class ai {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0;
  }
  track(t) {
    if (!ae || !dt || ae === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== ae)
      n = this.activeLink = new nd(ae, this), ae.deps ? (n.prevDep = ae.depsTail, ae.depsTail.nextDep = n, ae.depsTail = n) : ae.deps = ae.depsTail = n, hc(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const r = n.nextDep;
      r.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = r), n.prevDep = ae.depsTail, n.nextDep = void 0, ae.depsTail.nextDep = n, ae.depsTail = n, ae.deps === n && (ae.deps = r);
    }
    return n;
  }
  trigger(t) {
    this.version++, fr++, this.notify(t);
  }
  notify(t) {
    si();
    try {
      Qf.NODE_ENV;
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      oi();
    }
  }
}
function hc(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let r = t.deps; r; r = r.nextDep)
        hc(r);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), e.dep.subs = e;
  }
}
const ao = /* @__PURE__ */ new WeakMap(), hn = Symbol(
  ""
), lo = Symbol(
  ""
), dr = Symbol(
  ""
);
function xe(e, t, n) {
  if (dt && ae) {
    let r = ao.get(e);
    r || ao.set(e, r = /* @__PURE__ */ new Map());
    let s = r.get(n);
    s || (r.set(n, s = new ai()), s.map = r, s.key = n), s.track();
  }
}
function Ut(e, t, n, r, s, o) {
  const i = ao.get(e);
  if (!i) {
    fr++;
    return;
  }
  const a = (l) => {
    l && l.trigger();
  };
  if (si(), t === "clear")
    i.forEach(a);
  else {
    const l = $(e), c = l && ti(n);
    if (l && n === "length") {
      const u = Number(r);
      i.forEach((d, h) => {
        (h === "length" || h === dr || !Tt(h) && h >= u) && a(d);
      });
    } else
      switch (n !== void 0 && a(i.get(n)), c && a(i.get(dr)), t) {
        case "add":
          l ? c && a(i.get("length")) : (a(i.get(hn)), Dn(e) && a(i.get(lo)));
          break;
        case "delete":
          l || (a(i.get(hn)), Dn(e) && a(i.get(lo)));
          break;
        case "set":
          Dn(e) && a(i.get(hn));
          break;
      }
  }
  oi();
}
function Tn(e) {
  const t = ne(e);
  return t === e ? t : (xe(t, "iterate", dr), at(e) ? t : t.map(De));
}
function ms(e) {
  return xe(e = ne(e), "iterate", dr), e;
}
const rd = {
  __proto__: null,
  [Symbol.iterator]() {
    return Gs(this, Symbol.iterator, De);
  },
  concat(...e) {
    return Tn(this).concat(
      ...e.map((t) => $(t) ? Tn(t) : t)
    );
  },
  entries() {
    return Gs(this, "entries", (e) => (e[1] = De(e[1]), e));
  },
  every(e, t) {
    return Pt(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return Pt(this, "filter", e, t, (n) => n.map(De), arguments);
  },
  find(e, t) {
    return Pt(this, "find", e, t, De, arguments);
  },
  findIndex(e, t) {
    return Pt(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return Pt(this, "findLast", e, t, De, arguments);
  },
  findLastIndex(e, t) {
    return Pt(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return Pt(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return js(this, "includes", e);
  },
  indexOf(...e) {
    return js(this, "indexOf", e);
  },
  join(e) {
    return Tn(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return js(this, "lastIndexOf", e);
  },
  map(e, t) {
    return Pt(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Wn(this, "pop");
  },
  push(...e) {
    return Wn(this, "push", e);
  },
  reduce(e, ...t) {
    return qi(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return qi(this, "reduceRight", e, t);
  },
  shift() {
    return Wn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return Pt(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Wn(this, "splice", e);
  },
  toReversed() {
    return Tn(this).toReversed();
  },
  toSorted(e) {
    return Tn(this).toSorted(e);
  },
  toSpliced(...e) {
    return Tn(this).toSpliced(...e);
  },
  unshift(...e) {
    return Wn(this, "unshift", e);
  },
  values() {
    return Gs(this, "values", De);
  }
};
function Gs(e, t, n) {
  const r = ms(e), s = r[t]();
  return r !== e && !at(e) && (s._next = s.next, s.next = () => {
    const o = s._next();
    return o.value && (o.value = n(o.value)), o;
  }), s;
}
const sd = Array.prototype;
function Pt(e, t, n, r, s, o) {
  const i = ms(e), a = i !== e && !at(e), l = i[t];
  if (l !== sd[t]) {
    const d = l.apply(e, o);
    return a ? De(d) : d;
  }
  let c = n;
  i !== e && (a ? c = function(d, h) {
    return n.call(this, De(d), h, e);
  } : n.length > 2 && (c = function(d, h) {
    return n.call(this, d, h, e);
  }));
  const u = l.call(i, c, r);
  return a && s ? s(u) : u;
}
function qi(e, t, n, r) {
  const s = ms(e);
  let o = n;
  return s !== e && (at(e) ? n.length > 3 && (o = function(i, a, l) {
    return n.call(this, i, a, l, e);
  }) : o = function(i, a, l) {
    return n.call(this, i, De(a), l, e);
  }), s[t](o, ...r);
}
function js(e, t, n) {
  const r = ne(e);
  xe(r, "iterate", dr);
  const s = r[t](...n);
  return (s === -1 || s === !1) && ui(n[0]) ? (n[0] = ne(n[0]), r[t](...n)) : s;
}
function Wn(e, t, n = []) {
  zt(), si();
  const r = ne(e)[t].apply(e, n);
  return oi(), Kt(), r;
}
const od = /* @__PURE__ */ Qo("__proto__,__v_isRef,__isVue"), _c = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(Tt)
);
function id(e) {
  Tt(e) || (e = String(e));
  const t = ne(this);
  return xe(t, "has", e), t.hasOwnProperty(e);
}
class gc {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    const s = this._isReadonly, o = this._isShallow;
    if (n === "__v_isReactive")
      return !s;
    if (n === "__v_isReadonly")
      return s;
    if (n === "__v_isShallow")
      return o;
    if (n === "__v_raw")
      return r === (s ? o ? vc : Oc : o ? yc : Sc).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const i = $(t);
    if (!s) {
      let l;
      if (i && (l = rd[n]))
        return l;
      if (n === "hasOwnProperty")
        return id;
    }
    const a = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Pe(t) ? t : r
    );
    return (Tt(n) ? _c.has(n) : od(n)) || (s || xe(t, "get", n), o) ? a : Pe(a) ? i && ti(n) ? a : a.value : le(a) ? s ? Ic(a) : ci(a) : a;
  }
}
class bc extends gc {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, s) {
    let o = t[n];
    if (!this._isShallow) {
      const l = En(o);
      if (!at(r) && !En(r) && (o = ne(o), r = ne(r)), !$(t) && Pe(o) && !Pe(r))
        return l ? !1 : (o.value = r, !0);
    }
    const i = $(t) && ti(n) ? Number(n) < t.length : se(t, n), a = Reflect.set(
      t,
      n,
      r,
      Pe(t) ? t : s
    );
    return t === ne(s) && (i ? nn(r, o) && Ut(t, "set", n, r) : Ut(t, "add", n, r)), a;
  }
  deleteProperty(t, n) {
    const r = se(t, n);
    t[n];
    const s = Reflect.deleteProperty(t, n);
    return s && r && Ut(t, "delete", n, void 0), s;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!Tt(n) || !_c.has(n)) && xe(t, "has", n), r;
  }
  ownKeys(t) {
    return xe(
      t,
      "iterate",
      $(t) ? "length" : hn
    ), Reflect.ownKeys(t);
  }
}
class Ec extends gc {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const ad = /* @__PURE__ */ new bc(), ld = /* @__PURE__ */ new Ec(), cd = /* @__PURE__ */ new bc(!0), ud = /* @__PURE__ */ new Ec(!0), li = (e) => e, hs = (e) => Reflect.getPrototypeOf(e);
function Cr(e, t, n = !1, r = !1) {
  e = e.__v_raw;
  const s = ne(e), o = ne(t);
  n || (nn(t, o) && xe(s, "get", t), xe(s, "get", o));
  const { has: i } = hs(s), a = r ? li : n ? fi : De;
  if (i.call(s, t))
    return a(e.get(t));
  if (i.call(s, o))
    return a(e.get(o));
  e !== s && e.get(t);
}
function Rr(e, t = !1) {
  const n = this.__v_raw, r = ne(n), s = ne(e);
  return t || (nn(e, s) && xe(r, "has", e), xe(r, "has", s)), e === s ? n.has(e) : n.has(e) || n.has(s);
}
function Pr(e, t = !1) {
  return e = e.__v_raw, !t && xe(ne(e), "iterate", hn), Reflect.get(e, "size", e);
}
function Ji(e, t = !1) {
  !t && !at(e) && !En(e) && (e = ne(e));
  const n = ne(this);
  return hs(n).has.call(n, e) || (n.add(e), Ut(n, "add", e, e)), this;
}
function Qi(e, t, n = !1) {
  !n && !at(t) && !En(t) && (t = ne(t));
  const r = ne(this), { has: s, get: o } = hs(r);
  let i = s.call(r, e);
  i || (e = ne(e), i = s.call(r, e));
  const a = o.call(r, e);
  return r.set(e, t), i ? nn(t, a) && Ut(r, "set", e, t) : Ut(r, "add", e, t), this;
}
function Zi(e) {
  const t = ne(this), { has: n, get: r } = hs(t);
  let s = n.call(t, e);
  s || (e = ne(e), s = n.call(t, e)), r && r.call(t, e);
  const o = t.delete(e);
  return s && Ut(t, "delete", e, void 0), o;
}
function ea() {
  const e = ne(this), t = e.size !== 0, n = e.clear();
  return t && Ut(e, "clear", void 0, void 0), n;
}
function Dr(e, t) {
  return function(r, s) {
    const o = this, i = o.__v_raw, a = ne(i), l = t ? li : e ? fi : De;
    return !e && xe(a, "iterate", hn), i.forEach((c, u) => r.call(s, l(c), l(u), o));
  };
}
function wr(e, t, n) {
  return function(...r) {
    const s = this.__v_raw, o = ne(s), i = Dn(o), a = e === "entries" || e === Symbol.iterator && i, l = e === "keys" && i, c = s[e](...r), u = n ? li : t ? fi : De;
    return !t && xe(
      o,
      "iterate",
      l ? lo : hn
    ), {
      // iterator protocol
      next() {
        const { value: d, done: h } = c.next();
        return h ? { value: d, done: h } : {
          value: a ? [u(d[0]), u(d[1])] : u(d),
          done: h
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Wt(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function fd() {
  const e = {
    get(o) {
      return Cr(this, o);
    },
    get size() {
      return Pr(this);
    },
    has: Rr,
    add: Ji,
    set: Qi,
    delete: Zi,
    clear: ea,
    forEach: Dr(!1, !1)
  }, t = {
    get(o) {
      return Cr(this, o, !1, !0);
    },
    get size() {
      return Pr(this);
    },
    has: Rr,
    add(o) {
      return Ji.call(this, o, !0);
    },
    set(o, i) {
      return Qi.call(this, o, i, !0);
    },
    delete: Zi,
    clear: ea,
    forEach: Dr(!1, !0)
  }, n = {
    get(o) {
      return Cr(this, o, !0);
    },
    get size() {
      return Pr(this, !0);
    },
    has(o) {
      return Rr.call(this, o, !0);
    },
    add: Wt("add"),
    set: Wt("set"),
    delete: Wt("delete"),
    clear: Wt("clear"),
    forEach: Dr(!0, !1)
  }, r = {
    get(o) {
      return Cr(this, o, !0, !0);
    },
    get size() {
      return Pr(this, !0);
    },
    has(o) {
      return Rr.call(this, o, !0);
    },
    add: Wt("add"),
    set: Wt("set"),
    delete: Wt("delete"),
    clear: Wt("clear"),
    forEach: Dr(!0, !0)
  };
  return [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((o) => {
    e[o] = wr(o, !1, !1), n[o] = wr(o, !0, !1), t[o] = wr(o, !1, !0), r[o] = wr(
      o,
      !0,
      !0
    );
  }), [
    e,
    n,
    t,
    r
  ];
}
const [
  dd,
  pd,
  md,
  hd
] = /* @__PURE__ */ fd();
function _s(e, t) {
  const n = t ? e ? hd : md : e ? pd : dd;
  return (r, s, o) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? r : Reflect.get(
    se(n, s) && s in r ? n : r,
    s,
    o
  );
}
const _d = {
  get: /* @__PURE__ */ _s(!1, !1)
}, gd = {
  get: /* @__PURE__ */ _s(!1, !0)
}, bd = {
  get: /* @__PURE__ */ _s(!0, !1)
}, Ed = {
  get: /* @__PURE__ */ _s(!0, !0)
}, Sc = /* @__PURE__ */ new WeakMap(), yc = /* @__PURE__ */ new WeakMap(), Oc = /* @__PURE__ */ new WeakMap(), vc = /* @__PURE__ */ new WeakMap();
function Sd(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function yd(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Sd(Hf(e));
}
function ci(e) {
  return En(e) ? e : gs(
    e,
    !1,
    ad,
    _d,
    Sc
  );
}
function Od(e) {
  return gs(
    e,
    !1,
    cd,
    gd,
    yc
  );
}
function Ic(e) {
  return gs(
    e,
    !0,
    ld,
    bd,
    Oc
  );
}
function xr(e) {
  return gs(
    e,
    !0,
    ud,
    Ed,
    vc
  );
}
function gs(e, t, n, r, s) {
  if (!le(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const o = s.get(e);
  if (o)
    return o;
  const i = yd(e);
  if (i === 0)
    return e;
  const a = new Proxy(
    e,
    i === 2 ? r : n
  );
  return s.set(e, a), a;
}
function wn(e) {
  return En(e) ? wn(e.__v_raw) : !!(e && e.__v_isReactive);
}
function En(e) {
  return !!(e && e.__v_isReadonly);
}
function at(e) {
  return !!(e && e.__v_isShallow);
}
function ui(e) {
  return e ? !!e.__v_raw : !1;
}
function ne(e) {
  const t = e && e.__v_raw;
  return t ? ne(t) : e;
}
function vd(e) {
  return !se(e, "__v_skip") && Object.isExtensible(e) && nc(e, "__v_skip", !0), e;
}
const De = (e) => le(e) ? ci(e) : e, fi = (e) => le(e) ? Ic(e) : e;
function Pe(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Ur(e) {
  return Ac(e, !1);
}
function Id(e) {
  return Ac(e, !0);
}
function Ac(e, t) {
  return Pe(e) ? e : new Ad(e, t);
}
class Ad {
  constructor(t, n) {
    this.dep = new ai(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : ne(t), this._value = n ? t : De(t), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, r = this.__v_isShallow || at(t) || En(t);
    t = r ? t : ne(t), nn(t, n) && (this._rawValue = t, this._value = r ? t : De(t), this.dep.trigger());
  }
}
function Yr(e) {
  return Pe(e) ? e.value : e;
}
const Td = {
  get: (e, t, n) => t === "__v_raw" ? e : Yr(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const s = e[t];
    return Pe(s) && !Pe(n) ? (s.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function Tc(e) {
  return wn(e) ? e : new Proxy(e, Td);
}
class Nd {
  constructor(t, n, r) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new ai(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = fr - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = r;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    ae !== this)
      return uc(this, !0), !0;
  }
  get value() {
    const t = this.dep.track();
    return pc(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter && this.setter(t);
  }
}
function Cd(e, t, n = !1) {
  let r, s;
  return X(e) ? r = e : (r = e.get, s = e.set), new Nd(r, s, n);
}
const Lr = {}, qr = /* @__PURE__ */ new WeakMap();
let dn;
function Rd(e, t = !1, n = dn) {
  if (n) {
    let r = qr.get(n);
    r || qr.set(n, r = []), r.push(e);
  }
}
function Pd(e, t, n = ie) {
  const { immediate: r, deep: s, once: o, scheduler: i, augmentJob: a, call: l } = n, c = (S) => s ? S : at(S) || s === !1 || s === 0 ? kt(S, 1) : kt(S);
  let u, d, h, T, O = !1, A = !1;
  if (Pe(e) ? (d = () => e.value, O = at(e)) : wn(e) ? (d = () => c(e), O = !0) : $(e) ? (A = !0, O = e.some((S) => wn(S) || at(S)), d = () => e.map((S) => {
    if (Pe(S))
      return S.value;
    if (wn(S))
      return c(S);
    if (X(S))
      return l ? l(S, 2) : S();
  })) : X(e) ? t ? d = l ? () => l(e, 2) : e : d = () => {
    if (h) {
      zt();
      try {
        h();
      } finally {
        Kt();
      }
    }
    const S = dn;
    dn = u;
    try {
      return l ? l(e, 3, [T]) : e(T);
    } finally {
      dn = S;
    }
  } : d = ut, t && s) {
    const S = d, D = s === !0 ? 1 / 0 : s;
    d = () => kt(S(), D);
  }
  const v = ed(), m = () => {
    u.stop(), v && ei(v.effects, u);
  };
  if (o && t) {
    const S = t;
    t = (...D) => {
      S(...D), m();
    };
  }
  let g = A ? new Array(e.length).fill(Lr) : Lr;
  const I = (S) => {
    if (!(!(u.flags & 1) || !u.dirty && !S))
      if (t) {
        const D = u.run();
        if (s || O || (A ? D.some((G, w) => nn(G, g[w])) : nn(D, g))) {
          h && h();
          const G = dn;
          dn = u;
          try {
            const w = [
              D,
              // pass undefined as the old value when it's changed for the first time
              g === Lr ? void 0 : A && g[0] === Lr ? [] : g,
              T
            ];
            l ? l(t, 3, w) : (
              // @ts-expect-error
              t(...w)
            ), g = D;
          } finally {
            dn = G;
          }
        }
      } else
        u.run();
  };
  return a && a(I), u = new lc(d), u.scheduler = i ? () => i(I, !1) : I, T = (S) => Rd(S, !1, u), h = u.onStop = () => {
    const S = qr.get(u);
    if (S) {
      if (l)
        l(S, 4);
      else
        for (const D of S) D();
      qr.delete(u);
    }
  }, t ? r ? I(!0) : g = u.run() : i ? i(I.bind(null, !0), !0) : u.run(), m.pause = u.pause.bind(u), m.resume = u.resume.bind(u), m.stop = m, m;
}
function kt(e, t = 1 / 0, n) {
  if (t <= 0 || !le(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, Pe(e))
    kt(e.value, t, n);
  else if ($(e))
    for (let r = 0; r < e.length; r++)
      kt(e[r], t, n);
  else if (Ql(e) || Dn(e))
    e.forEach((r) => {
      kt(r, t, n);
    });
  else if (ds(e)) {
    for (const r in e)
      kt(e[r], t, n);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && kt(e[r], t, n);
  }
  return e;
}
var Jt = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
const rr = [];
let Us = !1;
function Dd(e, ...t) {
  if (Us) return;
  Us = !0, zt();
  const n = rr.length ? rr[rr.length - 1].component : null, r = n && n.appContext.config.warnHandler, s = wd();
  if (r)
    Vn(
      r,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((o) => {
          var i, a;
          return (a = (i = o.toString) == null ? void 0 : i.call(o)) != null ? a : JSON.stringify(o);
        }).join(""),
        n && n.proxy,
        s.map(
          ({ vnode: o }) => `at <${iu(n, o.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const o = [`[Vue warn]: ${e}`, ...t];
    s.length && o.push(`
`, ...xd(s)), console.warn(...o);
  }
  Kt(), Us = !1;
}
function wd() {
  let e = rr[rr.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function xd(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...Ld(n));
  }), t;
}
function Ld({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, s = ` at <${iu(
    e.component,
    e.type,
    r
  )}`, o = ">" + n;
  return e.props ? [s, ...kd(e.props), o] : [s + o];
}
function kd(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...Nc(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Nc(e, t, n) {
  return be(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : Pe(t) ? (t = Nc(e, ne(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : X(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = ne(t), n ? t : [`${e}=`, t]);
}
function Vn(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (s) {
    bs(s, t, n);
  }
}
function Nt(e, t, n, r) {
  if (X(e)) {
    const s = Vn(e, t, n, r);
    return s && Zl(s) && s.catch((o) => {
      bs(o, t, n);
    }), s;
  }
  if ($(e)) {
    const s = [];
    for (let o = 0; o < e.length; o++)
      s.push(Nt(e[o], t, n, r));
    return s;
  }
}
function bs(e, t, n, r = !0) {
  const s = t ? t.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: i } = t && t.appContext.config || ie;
  if (t) {
    let a = t.parent;
    const l = t.proxy, c = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; a; ) {
      const u = a.ec;
      if (u) {
        for (let d = 0; d < u.length; d++)
          if (u[d](e, l, c) === !1)
            return;
      }
      a = a.parent;
    }
    if (o) {
      zt(), Vn(o, null, 10, [
        e,
        l,
        c
      ]), Kt();
      return;
    }
  }
  Md(e, n, s, r, i);
}
function Md(e, t, n, r = !0, s = !1) {
  if (s)
    throw e;
  console.error(e);
}
const Fe = [];
let St = -1;
const xn = [];
let Qt = null, Nn = 0;
const Cc = /* @__PURE__ */ Promise.resolve();
let Jr = null;
function Rc(e) {
  const t = Jr || Cc;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Fd(e) {
  let t = St + 1, n = Fe.length;
  for (; t < n; ) {
    const r = t + n >>> 1, s = Fe[r], o = pr(s);
    o < e || o === e && s.flags & 2 ? t = r + 1 : n = r;
  }
  return t;
}
function di(e) {
  if (!(e.flags & 1)) {
    const t = pr(e), n = Fe[Fe.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= pr(n) ? Fe.push(e) : Fe.splice(Fd(t), 0, e), e.flags |= 1, Pc();
  }
}
function Pc() {
  Jr || (Jr = Cc.then(wc));
}
function Gd(e) {
  $(e) ? xn.push(...e) : Qt && e.id === -1 ? Qt.splice(Nn + 1, 0, e) : e.flags & 1 || (xn.push(e), e.flags |= 1), Pc();
}
function ta(e, t, n = St + 1) {
  for (; n < Fe.length; n++) {
    const r = Fe[n];
    if (r && r.flags & 2) {
      if (e && r.id !== e.uid)
        continue;
      Fe.splice(n, 1), n--, r.flags & 4 && (r.flags &= -2), r(), r.flags & 4 || (r.flags &= -2);
    }
  }
}
function Dc(e) {
  if (xn.length) {
    const t = [...new Set(xn)].sort(
      (n, r) => pr(n) - pr(r)
    );
    if (xn.length = 0, Qt) {
      Qt.push(...t);
      return;
    }
    for (Qt = t, Nn = 0; Nn < Qt.length; Nn++) {
      const n = Qt[Nn];
      n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2;
    }
    Qt = null, Nn = 0;
  }
}
const pr = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function wc(e) {
  const t = ut;
  try {
    for (St = 0; St < Fe.length; St++) {
      const n = Fe[St];
      n && !(n.flags & 8) && (Jt.NODE_ENV !== "production" && t(n), n.flags & 4 && (n.flags &= -2), Vn(
        n,
        n.i,
        n.i ? 15 : 14
      ), n.flags & 4 || (n.flags &= -2));
    }
  } finally {
    for (; St < Fe.length; St++) {
      const n = Fe[St];
      n && (n.flags &= -2);
    }
    St = -1, Fe.length = 0, Dc(), Jr = null, (Fe.length || xn.length) && wc();
  }
}
let qe = null, xc = null;
function Qr(e) {
  const t = qe;
  return qe = e, xc = e && e.type.__scopeId || null, t;
}
function jd(e, t = qe, n) {
  if (!t || e._n)
    return e;
  const r = (...s) => {
    r._d && ca(-1);
    const o = Qr(t);
    let i;
    try {
      i = e(...s);
    } finally {
      Qr(o), r._d && ca(1);
    }
    return i;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
function Ud(e, t) {
  if (qe === null)
    return e;
  const n = Os(qe), r = e.dirs || (e.dirs = []);
  for (let s = 0; s < t.length; s++) {
    let [o, i, a, l = ie] = t[s];
    o && (X(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && kt(i), r.push({
      dir: o,
      instance: n,
      value: i,
      oldValue: void 0,
      arg: a,
      modifiers: l
    }));
  }
  return e;
}
function un(e, t, n, r) {
  const s = e.dirs, o = t && t.dirs;
  for (let i = 0; i < s.length; i++) {
    const a = s[i];
    o && (a.oldValue = o[i].value);
    let l = a.dir[r];
    l && (zt(), Nt(l, n, 8, [
      e.el,
      a,
      e,
      t
    ]), Kt());
  }
}
const Hd = Symbol("_vte"), Vd = (e) => e.__isTeleport;
function pi(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, pi(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function In(e, t) {
  return X(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    ve({ name: e.name }, t, { setup: e })
  ) : e;
}
function Lc(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
function co(e, t, n, r, s = !1) {
  if ($(e)) {
    e.forEach(
      (O, A) => co(
        O,
        t && ($(t) ? t[A] : t),
        n,
        r,
        s
      )
    );
    return;
  }
  if (sr(r) && !s)
    return;
  const o = r.shapeFlag & 4 ? Os(r.component) : r.el, i = s ? null : o, { i: a, r: l } = e, c = t && t.r, u = a.refs === ie ? a.refs = {} : a.refs, d = a.setupState, h = ne(d), T = d === ie ? () => !1 : (O) => se(h, O);
  if (c != null && c !== l && (be(c) ? (u[c] = null, T(c) && (d[c] = null)) : Pe(c) && (c.value = null)), X(l))
    Vn(l, a, 12, [i, u]);
  else {
    const O = be(l), A = Pe(l);
    if (O || A) {
      const v = () => {
        if (e.f) {
          const m = O ? T(l) ? d[l] : u[l] : l.value;
          s ? $(m) && ei(m, o) : $(m) ? m.includes(o) || m.push(o) : O ? (u[l] = [o], T(l) && (d[l] = u[l])) : (l.value = [o], e.k && (u[e.k] = l.value));
        } else O ? (u[l] = i, T(l) && (d[l] = i)) : A && (l.value = i, e.k && (u[e.k] = i));
      };
      i ? (v.id = -1, $e(v, n)) : v();
    }
  }
}
const sr = (e) => !!e.type.__asyncLoader, kc = (e) => e.type.__isKeepAlive;
function zd(e, t) {
  Mc(e, "a", t);
}
function Kd(e, t) {
  Mc(e, "da", t);
}
function Mc(e, t, n = Ce) {
  const r = e.__wdc || (e.__wdc = () => {
    let s = n;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (Es(t, r, n), n) {
    let s = n.parent;
    for (; s && s.parent; )
      kc(s.parent.vnode) && Bd(r, t, n, s), s = s.parent;
  }
}
function Bd(e, t, n, r) {
  const s = Es(
    t,
    e,
    r,
    !0
    /* prepend */
  );
  hi(() => {
    ei(r[t], s);
  }, n);
}
function Es(e, t, n = Ce, r = !1) {
  if (n) {
    const s = n[e] || (n[e] = []), o = t.__weh || (t.__weh = (...i) => {
      zt();
      const a = vr(n), l = Nt(t, n, e, i);
      return a(), Kt(), l;
    });
    return r ? s.unshift(o) : s.push(o), o;
  }
}
const Bt = (e) => (t, n = Ce) => {
  (!ys || e === "sp") && Es(e, (...r) => t(...r), n);
}, $d = Bt("bm"), mi = Bt("m"), Wd = Bt(
  "bu"
), Xd = Bt("u"), Fc = Bt(
  "bum"
), hi = Bt("um"), Yd = Bt(
  "sp"
), qd = Bt("rtg"), Jd = Bt("rtc");
function Qd(e, t = Ce) {
  Es("ec", e, t);
}
const Zd = Symbol.for("v-ndc");
function ep(e, t, n, r) {
  let s;
  const o = n, i = $(e);
  if (i || be(e)) {
    const a = i && wn(e);
    let l = !1;
    a && (l = !at(e), e = ms(e)), s = new Array(e.length);
    for (let c = 0, u = e.length; c < u; c++)
      s[c] = t(
        l ? De(e[c]) : e[c],
        c,
        void 0,
        o
      );
  } else if (typeof e == "number") {
    s = new Array(e);
    for (let a = 0; a < e; a++)
      s[a] = t(a + 1, a, void 0, o);
  } else if (le(e))
    if (e[Symbol.iterator])
      s = Array.from(
        e,
        (a, l) => t(a, l, void 0, o)
      );
    else {
      const a = Object.keys(e);
      s = new Array(a.length);
      for (let l = 0, c = a.length; l < c; l++) {
        const u = a[l];
        s[l] = t(e[u], u, l, o);
      }
    }
  else
    s = [];
  return s;
}
const uo = (e) => e ? su(e) ? Os(e) : uo(e.parent) : null, or = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ve(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => uo(e.parent),
    $root: (e) => uo(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => _i(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      di(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Rc.bind(e.proxy)),
    $watch: (e) => yp.bind(e)
  })
), Hs = (e, t) => e !== ie && !e.__isScriptSetup && se(e, t), tp = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: r, data: s, props: o, accessCache: i, type: a, appContext: l } = e;
    let c;
    if (t[0] !== "$") {
      const T = i[t];
      if (T !== void 0)
        switch (T) {
          case 1:
            return r[t];
          case 2:
            return s[t];
          case 4:
            return n[t];
          case 3:
            return o[t];
        }
      else {
        if (Hs(r, t))
          return i[t] = 1, r[t];
        if (s !== ie && se(s, t))
          return i[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = e.propsOptions[0]) && se(c, t)
        )
          return i[t] = 3, o[t];
        if (n !== ie && se(n, t))
          return i[t] = 4, n[t];
        fo && (i[t] = 0);
      }
    }
    const u = or[t];
    let d, h;
    if (u)
      return t === "$attrs" && xe(e.attrs, "get", ""), u(e);
    if (
      // css module (injected by vue-loader)
      (d = a.__cssModules) && (d = d[t])
    )
      return d;
    if (n !== ie && se(n, t))
      return i[t] = 4, n[t];
    if (
      // global properties
      h = l.config.globalProperties, se(h, t)
    )
      return h[t];
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: s, ctx: o } = e;
    return Hs(s, t) ? (s[t] = n, !0) : r !== ie && se(r, t) ? (r[t] = n, !0) : se(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (o[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: s, propsOptions: o }
  }, i) {
    let a;
    return !!n[i] || e !== ie && se(e, i) || Hs(t, i) || (a = o[0]) && se(a, i) || se(r, i) || se(or, i) || se(s.config.globalProperties, i);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : se(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function na(e) {
  return $(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
let fo = !0;
function np(e) {
  const t = _i(e), n = e.proxy, r = e.ctx;
  fo = !1, t.beforeCreate && ra(t.beforeCreate, e, "bc");
  const {
    // state
    data: s,
    computed: o,
    methods: i,
    watch: a,
    provide: l,
    inject: c,
    // lifecycle
    created: u,
    beforeMount: d,
    mounted: h,
    beforeUpdate: T,
    updated: O,
    activated: A,
    deactivated: v,
    beforeDestroy: m,
    beforeUnmount: g,
    destroyed: I,
    unmounted: S,
    render: D,
    renderTracked: G,
    renderTriggered: w,
    errorCaptured: Y,
    serverPrefetch: J,
    // public API
    expose: fe,
    inheritAttrs: ge,
    // assets
    components: ce,
    directives: Ge,
    filters: Rt
  } = t;
  if (c && rp(c, r, null), i)
    for (const re in i) {
      const te = i[re];
      X(te) && (r[re] = te.bind(n));
    }
  if (s) {
    const re = s.call(n, n);
    le(re) && (e.data = ci(re));
  }
  if (fo = !0, o)
    for (const re in o) {
      const te = o[re], L = X(te) ? te.bind(n, n) : X(te.get) ? te.get.bind(n, n) : ut, k = !X(te) && X(te.set) ? te.set.bind(n) : ut, U = Xe({
        get: L,
        set: k
      });
      Object.defineProperty(r, re, {
        enumerable: !0,
        configurable: !0,
        get: () => U.value,
        set: (B) => U.value = B
      });
    }
  if (a)
    for (const re in a)
      Gc(a[re], r, n, re);
  if (l) {
    const re = X(l) ? l.call(n) : l;
    Reflect.ownKeys(re).forEach((te) => {
      Uc(te, re[te]);
    });
  }
  u && ra(u, e, "c");
  function he(re, te) {
    $(te) ? te.forEach((L) => re(L.bind(n))) : te && re(te.bind(n));
  }
  if (he($d, d), he(mi, h), he(Wd, T), he(Xd, O), he(zd, A), he(Kd, v), he(Qd, Y), he(Jd, G), he(qd, w), he(Fc, g), he(hi, S), he(Yd, J), $(fe))
    if (fe.length) {
      const re = e.exposed || (e.exposed = {});
      fe.forEach((te) => {
        Object.defineProperty(re, te, {
          get: () => n[te],
          set: (L) => n[te] = L
        });
      });
    } else e.exposed || (e.exposed = {});
  D && e.render === ut && (e.render = D), ge != null && (e.inheritAttrs = ge), ce && (e.components = ce), Ge && (e.directives = Ge), J && Lc(e);
}
function rp(e, t, n = ut) {
  $(e) && (e = po(e));
  for (const r in e) {
    const s = e[r];
    let o;
    le(s) ? "default" in s ? o = ir(
      s.from || r,
      s.default,
      !0
    ) : o = ir(s.from || r) : o = ir(s), Pe(o) ? Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => o.value,
      set: (i) => o.value = i
    }) : t[r] = o;
  }
}
function ra(e, t, n) {
  Nt(
    $(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Gc(e, t, n, r) {
  let s = r.includes(".") ? Zc(n, r) : () => n[r];
  if (be(e)) {
    const o = t[e];
    X(o) && tn(s, o);
  } else if (X(e))
    tn(s, e.bind(n));
  else if (le(e))
    if ($(e))
      e.forEach((o) => Gc(o, t, n, r));
    else {
      const o = X(e.handler) ? e.handler.bind(n) : t[e.handler];
      X(o) && tn(s, o, e);
    }
}
function _i(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: s,
    optionsCache: o,
    config: { optionMergeStrategies: i }
  } = e.appContext, a = o.get(t);
  let l;
  return a ? l = a : !s.length && !n && !r ? l = t : (l = {}, s.length && s.forEach(
    (c) => Zr(l, c, i, !0)
  ), Zr(l, t, i)), le(t) && o.set(t, l), l;
}
function Zr(e, t, n, r = !1) {
  const { mixins: s, extends: o } = t;
  o && Zr(e, o, n, !0), s && s.forEach(
    (i) => Zr(e, i, n, !0)
  );
  for (const i in t)
    if (!(r && i === "expose")) {
      const a = sp[i] || n && n[i];
      e[i] = a ? a(e[i], t[i]) : t[i];
    }
  return e;
}
const sp = {
  data: sa,
  props: oa,
  emits: oa,
  // objects
  methods: Jn,
  computed: Jn,
  // lifecycle
  beforeCreate: ke,
  created: ke,
  beforeMount: ke,
  mounted: ke,
  beforeUpdate: ke,
  updated: ke,
  beforeDestroy: ke,
  beforeUnmount: ke,
  destroyed: ke,
  unmounted: ke,
  activated: ke,
  deactivated: ke,
  errorCaptured: ke,
  serverPrefetch: ke,
  // assets
  components: Jn,
  directives: Jn,
  // watch
  watch: ip,
  // provide / inject
  provide: sa,
  inject: op
};
function sa(e, t) {
  return t ? e ? function() {
    return ve(
      X(e) ? e.call(this, this) : e,
      X(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function op(e, t) {
  return Jn(po(e), po(t));
}
function po(e) {
  if ($(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function ke(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Jn(e, t) {
  return e ? ve(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function oa(e, t) {
  return e ? $(e) && $(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ve(
    /* @__PURE__ */ Object.create(null),
    na(e),
    na(t ?? {})
  ) : t;
}
function ip(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = ve(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = ke(e[r], t[r]);
  return n;
}
function jc() {
  return {
    app: null,
    config: {
      isNativeTag: jf,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let ap = 0;
function lp(e, t) {
  return function(r, s = null) {
    X(r) || (r = ve({}, r)), s != null && !le(s) && (s = null);
    const o = jc(), i = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const c = o.app = {
      _uid: ap++,
      _component: r,
      _props: s,
      _container: null,
      _context: o,
      _instance: null,
      version: $p,
      get config() {
        return o.config;
      },
      set config(u) {
      },
      use(u, ...d) {
        return i.has(u) || (u && X(u.install) ? (i.add(u), u.install(c, ...d)) : X(u) && (i.add(u), u(c, ...d))), c;
      },
      mixin(u) {
        return o.mixins.includes(u) || o.mixins.push(u), c;
      },
      component(u, d) {
        return d ? (o.components[u] = d, c) : o.components[u];
      },
      directive(u, d) {
        return d ? (o.directives[u] = d, c) : o.directives[u];
      },
      mount(u, d, h) {
        if (!l) {
          const T = c._ceVNode || we(r, s);
          return T.appContext = o, h === !0 ? h = "svg" : h === !1 && (h = void 0), d && t ? t(T, u) : e(T, u, h), l = !0, c._container = u, u.__vue_app__ = c, Os(T.component);
        }
      },
      onUnmount(u) {
        a.push(u);
      },
      unmount() {
        l && (Nt(
          a,
          c._instance,
          16
        ), e(null, c._container), delete c._container.__vue_app__);
      },
      provide(u, d) {
        return o.provides[u] = d, c;
      },
      runWithContext(u) {
        const d = Ln;
        Ln = c;
        try {
          return u();
        } finally {
          Ln = d;
        }
      }
    };
    return c;
  };
}
let Ln = null;
function Uc(e, t) {
  if (Ce) {
    let n = Ce.provides;
    const r = Ce.parent && Ce.parent.provides;
    r === n && (n = Ce.provides = Object.create(r)), n[e] = t;
  }
}
function ir(e, t, n = !1) {
  const r = Ce || qe;
  if (r || Ln) {
    const s = Ln ? Ln._context.provides : r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return n && X(t) ? t.call(r && r.proxy) : t;
  }
}
const Hc = {}, Vc = () => Object.create(Hc), zc = (e) => Object.getPrototypeOf(e) === Hc;
function cp(e, t, n, r = !1) {
  const s = {}, o = Vc();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Kc(e, t, s, o);
  for (const i in e.propsOptions[0])
    i in s || (s[i] = void 0);
  n ? e.props = r ? s : Od(s) : e.type.props ? e.props = s : e.props = o, e.attrs = o;
}
function up(e, t, n, r) {
  const {
    props: s,
    attrs: o,
    vnode: { patchFlag: i }
  } = e, a = ne(s), [l] = e.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (r || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const u = e.vnode.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        let h = u[d];
        if (Ss(e.emitsOptions, h))
          continue;
        const T = t[h];
        if (l)
          if (se(o, h))
            T !== o[h] && (o[h] = T, c = !0);
          else {
            const O = ft(h);
            s[O] = mo(
              l,
              a,
              O,
              T,
              e,
              !1
            );
          }
        else
          T !== o[h] && (o[h] = T, c = !0);
      }
    }
  } else {
    Kc(e, t, s, o) && (c = !0);
    let u;
    for (const d in a)
      (!t || // for camelCase
      !se(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((u = it(d)) === d || !se(t, u))) && (l ? n && // for camelCase
      (n[d] !== void 0 || // for kebab-case
      n[u] !== void 0) && (s[d] = mo(
        l,
        a,
        d,
        void 0,
        e,
        !0
      )) : delete s[d]);
    if (o !== a)
      for (const d in o)
        (!t || !se(t, d)) && (delete o[d], c = !0);
  }
  c && Ut(e.attrs, "set", "");
}
function Kc(e, t, n, r) {
  const [s, o] = e.propsOptions;
  let i = !1, a;
  if (t)
    for (let l in t) {
      if (er(l))
        continue;
      const c = t[l];
      let u;
      s && se(s, u = ft(l)) ? !o || !o.includes(u) ? n[u] = c : (a || (a = {}))[u] = c : Ss(e.emitsOptions, l) || (!(l in r) || c !== r[l]) && (r[l] = c, i = !0);
    }
  if (o) {
    const l = ne(n), c = a || ie;
    for (let u = 0; u < o.length; u++) {
      const d = o[u];
      n[d] = mo(
        s,
        l,
        d,
        c[d],
        e,
        !se(c, d)
      );
    }
  }
  return i;
}
function mo(e, t, n, r, s, o) {
  const i = e[n];
  if (i != null) {
    const a = se(i, "default");
    if (a && r === void 0) {
      const l = i.default;
      if (i.type !== Function && !i.skipFactory && X(l)) {
        const { propsDefaults: c } = s;
        if (n in c)
          r = c[n];
        else {
          const u = vr(s);
          r = c[n] = l.call(
            null,
            t
          ), u();
        }
      } else
        r = l;
      s.ce && s.ce._setProp(n, r);
    }
    i[
      0
      /* shouldCast */
    ] && (o && !a ? r = !1 : i[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === it(n)) && (r = !0));
  }
  return r;
}
const fp = /* @__PURE__ */ new WeakMap();
function Bc(e, t, n = !1) {
  const r = n ? fp : t.propsCache, s = r.get(e);
  if (s)
    return s;
  const o = e.props, i = {}, a = [];
  let l = !1;
  if (!X(e)) {
    const u = (d) => {
      l = !0;
      const [h, T] = Bc(d, t, !0);
      ve(i, h), T && a.push(...T);
    };
    !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  if (!o && !l)
    return le(e) && r.set(e, Pn), Pn;
  if ($(o))
    for (let u = 0; u < o.length; u++) {
      const d = ft(o[u]);
      ia(d) && (i[d] = ie);
    }
  else if (o)
    for (const u in o) {
      const d = ft(u);
      if (ia(d)) {
        const h = o[u], T = i[d] = $(h) || X(h) ? { type: h } : ve({}, h), O = T.type;
        let A = !1, v = !0;
        if ($(O))
          for (let m = 0; m < O.length; ++m) {
            const g = O[m], I = X(g) && g.name;
            if (I === "Boolean") {
              A = !0;
              break;
            } else I === "String" && (v = !1);
          }
        else
          A = X(O) && O.name === "Boolean";
        T[
          0
          /* shouldCast */
        ] = A, T[
          1
          /* shouldCastTrue */
        ] = v, (A || se(T, "default")) && a.push(d);
      }
    }
  const c = [i, a];
  return le(e) && r.set(e, c), c;
}
function ia(e) {
  return e[0] !== "$" && !er(e);
}
const $c = (e) => e[0] === "_" || e === "$stable", gi = (e) => $(e) ? e.map(yt) : [yt(e)], dp = (e, t, n) => {
  if (t._n)
    return t;
  const r = jd((...s) => (Jt.NODE_ENV !== "production" && Ce && (!n || (n.root, Ce.root)), gi(t(...s))), n);
  return r._c = !1, r;
}, Wc = (e, t, n) => {
  const r = e._ctx;
  for (const s in e) {
    if ($c(s)) continue;
    const o = e[s];
    if (X(o))
      t[s] = dp(s, o, r);
    else if (o != null) {
      const i = gi(o);
      t[s] = () => i;
    }
  }
}, Xc = (e, t) => {
  const n = gi(t);
  e.slots.default = () => n;
}, Yc = (e, t, n) => {
  for (const r in t)
    (n || r !== "_") && (e[r] = t[r]);
}, pp = (e, t, n) => {
  const r = e.slots = Vc();
  if (e.vnode.shapeFlag & 32) {
    const s = t._;
    s ? (Yc(r, t, n), n && nc(r, "_", s, !0)) : Wc(t, r);
  } else t && Xc(e, t);
}, mp = (e, t, n) => {
  const { vnode: r, slots: s } = e;
  let o = !0, i = ie;
  if (r.shapeFlag & 32) {
    const a = t._;
    a ? n && a === 1 ? o = !1 : Yc(s, t, n) : (o = !t.$stable, Wc(t, s)), i = t;
  } else t && (Xc(e, t), i = { default: 1 });
  if (o)
    for (const a in s)
      !$c(a) && i[a] == null && delete s[a];
}, $e = Cp;
function hp(e) {
  return _p(e);
}
function _p(e, t) {
  const n = rc();
  n.__VUE__ = !0;
  const {
    insert: r,
    remove: s,
    patchProp: o,
    createElement: i,
    createText: a,
    createComment: l,
    setText: c,
    setElementText: u,
    parentNode: d,
    nextSibling: h,
    setScopeId: T = ut,
    insertStaticContent: O
  } = e, A = (_, b, P, F = null, M = null, f = null, p = void 0, y = null, C = !!b.dynamicChildren) => {
    if (_ === b)
      return;
    _ && !Xn(_, b) && (F = Ee(_), B(_, M, f, !0), _ = null), b.patchFlag === -2 && (C = !1, b.dynamicChildren = null);
    const { type: x, ref: j, shapeFlag: E } = b;
    switch (x) {
      case Or:
        v(_, b, P, F);
        break;
      case Sn:
        m(_, b, P, F);
        break;
      case Ks:
        _ == null && g(b, P, F, p);
        break;
      case st:
        ce(
          _,
          b,
          P,
          F,
          M,
          f,
          p,
          y,
          C
        );
        break;
      default:
        E & 1 ? D(
          _,
          b,
          P,
          F,
          M,
          f,
          p,
          y,
          C
        ) : E & 6 ? Ge(
          _,
          b,
          P,
          F,
          M,
          f,
          p,
          y,
          C
        ) : (E & 64 || E & 128) && x.process(
          _,
          b,
          P,
          F,
          M,
          f,
          p,
          y,
          C,
          Le
        );
    }
    j != null && M && co(j, _ && _.ref, f, b || _, !b);
  }, v = (_, b, P, F) => {
    if (_ == null)
      r(
        b.el = a(b.children),
        P,
        F
      );
    else {
      const M = b.el = _.el;
      b.children !== _.children && c(M, b.children);
    }
  }, m = (_, b, P, F) => {
    _ == null ? r(
      b.el = l(b.children || ""),
      P,
      F
    ) : b.el = _.el;
  }, g = (_, b, P, F) => {
    [_.el, _.anchor] = O(
      _.children,
      b,
      P,
      F,
      _.el,
      _.anchor
    );
  }, I = ({ el: _, anchor: b }, P, F) => {
    let M;
    for (; _ && _ !== b; )
      M = h(_), r(_, P, F), _ = M;
    r(b, P, F);
  }, S = ({ el: _, anchor: b }) => {
    let P;
    for (; _ && _ !== b; )
      P = h(_), s(_), _ = P;
    s(b);
  }, D = (_, b, P, F, M, f, p, y, C) => {
    b.type === "svg" ? p = "svg" : b.type === "math" && (p = "mathml"), _ == null ? G(
      b,
      P,
      F,
      M,
      f,
      p,
      y,
      C
    ) : J(
      _,
      b,
      M,
      f,
      p,
      y,
      C
    );
  }, G = (_, b, P, F, M, f, p, y) => {
    let C, x;
    const { props: j, shapeFlag: E, transition: N, dirs: H } = _;
    if (C = _.el = i(
      _.type,
      f,
      j && j.is,
      j
    ), E & 8 ? u(C, _.children) : E & 16 && Y(
      _.children,
      C,
      null,
      F,
      M,
      Vs(_, f),
      p,
      y
    ), H && un(_, null, F, "created"), w(C, _, _.scopeId, p, F), j) {
      for (const Z in j)
        Z !== "value" && !er(Z) && o(C, Z, null, j[Z], f, F);
      "value" in j && o(C, "value", null, j.value, f), (x = j.onVnodeBeforeMount) && bt(x, F, _);
    }
    H && un(_, null, F, "beforeMount");
    const K = gp(M, N);
    K && N.beforeEnter(C), r(C, b, P), ((x = j && j.onVnodeMounted) || K || H) && $e(() => {
      x && bt(x, F, _), K && N.enter(C), H && un(_, null, F, "mounted");
    }, M);
  }, w = (_, b, P, F, M) => {
    if (P && T(_, P), F)
      for (let f = 0; f < F.length; f++)
        T(_, F[f]);
    if (M) {
      let f = M.subTree;
      if (b === f || tu(f.type) && (f.ssContent === b || f.ssFallback === b)) {
        const p = M.vnode;
        w(
          _,
          p,
          p.scopeId,
          p.slotScopeIds,
          M.parent
        );
      }
    }
  }, Y = (_, b, P, F, M, f, p, y, C = 0) => {
    for (let x = C; x < _.length; x++) {
      const j = _[x] = y ? Zt(_[x]) : yt(_[x]);
      A(
        null,
        j,
        b,
        P,
        F,
        M,
        f,
        p,
        y
      );
    }
  }, J = (_, b, P, F, M, f, p) => {
    const y = b.el = _.el;
    let { patchFlag: C, dynamicChildren: x, dirs: j } = b;
    C |= _.patchFlag & 16;
    const E = _.props || ie, N = b.props || ie;
    let H;
    if (P && fn(P, !1), (H = N.onVnodeBeforeUpdate) && bt(H, P, b, _), j && un(b, _, P, "beforeUpdate"), P && fn(P, !0), (E.innerHTML && N.innerHTML == null || E.textContent && N.textContent == null) && u(y, ""), x ? fe(
      _.dynamicChildren,
      x,
      y,
      P,
      F,
      Vs(b, M),
      f
    ) : p || te(
      _,
      b,
      y,
      null,
      P,
      F,
      Vs(b, M),
      f,
      !1
    ), C > 0) {
      if (C & 16)
        ge(y, E, N, P, M);
      else if (C & 2 && E.class !== N.class && o(y, "class", null, N.class, M), C & 4 && o(y, "style", E.style, N.style, M), C & 8) {
        const K = b.dynamicProps;
        for (let Z = 0; Z < K.length; Z++) {
          const ee = K[Z], ye = E[ee], Te = N[ee];
          (Te !== ye || ee === "value") && o(y, ee, ye, Te, M, P);
        }
      }
      C & 1 && _.children !== b.children && u(y, b.children);
    } else !p && x == null && ge(y, E, N, P, M);
    ((H = N.onVnodeUpdated) || j) && $e(() => {
      H && bt(H, P, b, _), j && un(b, _, P, "updated");
    }, F);
  }, fe = (_, b, P, F, M, f, p) => {
    for (let y = 0; y < b.length; y++) {
      const C = _[y], x = b[y], j = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        C.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (C.type === st || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Xn(C, x) || // - In the case of a component, it could contain anything.
        C.shapeFlag & 70) ? d(C.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          P
        )
      );
      A(
        C,
        x,
        j,
        null,
        F,
        M,
        f,
        p,
        !0
      );
    }
  }, ge = (_, b, P, F, M) => {
    if (b !== P) {
      if (b !== ie)
        for (const f in b)
          !er(f) && !(f in P) && o(
            _,
            f,
            b[f],
            null,
            M,
            F
          );
      for (const f in P) {
        if (er(f)) continue;
        const p = P[f], y = b[f];
        p !== y && f !== "value" && o(_, f, y, p, M, F);
      }
      "value" in P && o(_, "value", b.value, P.value, M);
    }
  }, ce = (_, b, P, F, M, f, p, y, C) => {
    const x = b.el = _ ? _.el : a(""), j = b.anchor = _ ? _.anchor : a("");
    let { patchFlag: E, dynamicChildren: N, slotScopeIds: H } = b;
    H && (y = y ? y.concat(H) : H), _ == null ? (r(x, P, F), r(j, P, F), Y(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      b.children || [],
      P,
      j,
      M,
      f,
      p,
      y,
      C
    )) : E > 0 && E & 64 && N && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    _.dynamicChildren ? (fe(
      _.dynamicChildren,
      N,
      P,
      M,
      f,
      p,
      y
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (b.key != null || M && b === M.subTree) && qc(
      _,
      b,
      !0
      /* shallow */
    )) : te(
      _,
      b,
      P,
      j,
      M,
      f,
      p,
      y,
      C
    );
  }, Ge = (_, b, P, F, M, f, p, y, C) => {
    b.slotScopeIds = y, _ == null ? b.shapeFlag & 512 ? M.ctx.activate(
      b,
      P,
      F,
      p,
      C
    ) : Rt(
      b,
      P,
      F,
      M,
      f,
      p,
      C
    ) : ht(_, b, C);
  }, Rt = (_, b, P, F, M, f, p) => {
    const y = _.component = Fp(
      _,
      F,
      M
    );
    if (kc(_) && (y.ctx.renderer = Le), Gp(y, !1, p), y.asyncDep) {
      if (M && M.registerDep(y, he, p), !_.el) {
        const C = y.subTree = we(Sn);
        m(null, C, b, P);
      }
    } else
      he(
        y,
        _,
        b,
        P,
        M,
        f,
        p
      );
  }, ht = (_, b, P) => {
    const F = b.component = _.component;
    if (Tp(_, b, P))
      if (F.asyncDep && !F.asyncResolved) {
        re(F, b, P);
        return;
      } else
        F.next = b, F.update();
    else
      b.el = _.el, F.vnode = b;
  }, he = (_, b, P, F, M, f, p) => {
    const y = () => {
      if (_.isMounted) {
        let { next: E, bu: N, u: H, parent: K, vnode: Z } = _;
        {
          const Ke = Jc(_);
          if (Ke) {
            E && (E.el = Z.el, re(_, E, p)), Ke.asyncDep.then(() => {
              _.isUnmounted || y();
            });
            return;
          }
        }
        let ee = E, ye;
        fn(_, !1), E ? (E.el = Z.el, re(_, E, p)) : E = Z, N && jr(N), (ye = E.props && E.props.onVnodeBeforeUpdate) && bt(ye, K, E, Z), fn(_, !0);
        const Te = zs(_), rt = _.subTree;
        _.subTree = Te, A(
          rt,
          Te,
          // parent may have changed if it's in a teleport
          d(rt.el),
          // anchor may have changed if it's in a fragment
          Ee(rt),
          _,
          M,
          f
        ), E.el = Te.el, ee === null && Np(_, Te.el), H && $e(H, M), (ye = E.props && E.props.onVnodeUpdated) && $e(
          () => bt(ye, K, E, Z),
          M
        );
      } else {
        let E;
        const { el: N, props: H } = b, { bm: K, m: Z, parent: ee, root: ye, type: Te } = _, rt = sr(b);
        if (fn(_, !1), K && jr(K), !rt && (E = H && H.onVnodeBeforeMount) && bt(E, ee, b), fn(_, !0), N && An) {
          const Ke = () => {
            _.subTree = zs(_), An(
              N,
              _.subTree,
              _,
              M,
              null
            );
          };
          rt && Te.__asyncHydrate ? Te.__asyncHydrate(
            N,
            _,
            Ke
          ) : Ke();
        } else {
          ye.ce && ye.ce._injectChildStyle(Te);
          const Ke = _.subTree = zs(_);
          A(
            null,
            Ke,
            P,
            F,
            _,
            M,
            f
          ), b.el = Ke.el;
        }
        if (Z && $e(Z, M), !rt && (E = H && H.onVnodeMounted)) {
          const Ke = b;
          $e(
            () => bt(E, ee, Ke),
            M
          );
        }
        (b.shapeFlag & 256 || ee && sr(ee.vnode) && ee.vnode.shapeFlag & 256) && _.a && $e(_.a, M), _.isMounted = !0, b = P = F = null;
      }
    };
    _.scope.on();
    const C = _.effect = new lc(y);
    _.scope.off();
    const x = _.update = C.run.bind(C), j = _.job = C.runIfDirty.bind(C);
    j.i = _, j.id = _.uid, C.scheduler = () => di(j), fn(_, !0), x();
  }, re = (_, b, P) => {
    b.component = _;
    const F = _.vnode.props;
    _.vnode = b, _.next = null, up(_, b.props, F, P), mp(_, b.children, P), zt(), ta(_), Kt();
  }, te = (_, b, P, F, M, f, p, y, C = !1) => {
    const x = _ && _.children, j = _ ? _.shapeFlag : 0, E = b.children, { patchFlag: N, shapeFlag: H } = b;
    if (N > 0) {
      if (N & 128) {
        k(
          x,
          E,
          P,
          F,
          M,
          f,
          p,
          y,
          C
        );
        return;
      } else if (N & 256) {
        L(
          x,
          E,
          P,
          F,
          M,
          f,
          p,
          y,
          C
        );
        return;
      }
    }
    H & 8 ? (j & 16 && de(x, M, f), E !== x && u(P, E)) : j & 16 ? H & 16 ? k(
      x,
      E,
      P,
      F,
      M,
      f,
      p,
      y,
      C
    ) : de(x, M, f, !0) : (j & 8 && u(P, ""), H & 16 && Y(
      E,
      P,
      F,
      M,
      f,
      p,
      y,
      C
    ));
  }, L = (_, b, P, F, M, f, p, y, C) => {
    _ = _ || Pn, b = b || Pn;
    const x = _.length, j = b.length, E = Math.min(x, j);
    let N;
    for (N = 0; N < E; N++) {
      const H = b[N] = C ? Zt(b[N]) : yt(b[N]);
      A(
        _[N],
        H,
        P,
        null,
        M,
        f,
        p,
        y,
        C
      );
    }
    x > j ? de(
      _,
      M,
      f,
      !0,
      !1,
      E
    ) : Y(
      b,
      P,
      F,
      M,
      f,
      p,
      y,
      C,
      E
    );
  }, k = (_, b, P, F, M, f, p, y, C) => {
    let x = 0;
    const j = b.length;
    let E = _.length - 1, N = j - 1;
    for (; x <= E && x <= N; ) {
      const H = _[x], K = b[x] = C ? Zt(b[x]) : yt(b[x]);
      if (Xn(H, K))
        A(
          H,
          K,
          P,
          null,
          M,
          f,
          p,
          y,
          C
        );
      else
        break;
      x++;
    }
    for (; x <= E && x <= N; ) {
      const H = _[E], K = b[N] = C ? Zt(b[N]) : yt(b[N]);
      if (Xn(H, K))
        A(
          H,
          K,
          P,
          null,
          M,
          f,
          p,
          y,
          C
        );
      else
        break;
      E--, N--;
    }
    if (x > E) {
      if (x <= N) {
        const H = N + 1, K = H < j ? b[H].el : F;
        for (; x <= N; )
          A(
            null,
            b[x] = C ? Zt(b[x]) : yt(b[x]),
            P,
            K,
            M,
            f,
            p,
            y,
            C
          ), x++;
      }
    } else if (x > N)
      for (; x <= E; )
        B(_[x], M, f, !0), x++;
    else {
      const H = x, K = x, Z = /* @__PURE__ */ new Map();
      for (x = K; x <= N; x++) {
        const Be = b[x] = C ? Zt(b[x]) : yt(b[x]);
        Be.key != null && Z.set(Be.key, x);
      }
      let ee, ye = 0;
      const Te = N - K + 1;
      let rt = !1, Ke = 0;
      const $n = new Array(Te);
      for (x = 0; x < Te; x++) $n[x] = 0;
      for (x = H; x <= E; x++) {
        const Be = _[x];
        if (ye >= Te) {
          B(Be, M, f, !0);
          continue;
        }
        let gt;
        if (Be.key != null)
          gt = Z.get(Be.key);
        else
          for (ee = K; ee <= N; ee++)
            if ($n[ee - K] === 0 && Xn(Be, b[ee])) {
              gt = ee;
              break;
            }
        gt === void 0 ? B(Be, M, f, !0) : ($n[gt - K] = x + 1, gt >= Ke ? Ke = gt : rt = !0, A(
          Be,
          b[gt],
          P,
          null,
          M,
          f,
          p,
          y,
          C
        ), ye++);
      }
      const Ki = rt ? bp($n) : Pn;
      for (ee = Ki.length - 1, x = Te - 1; x >= 0; x--) {
        const Be = K + x, gt = b[Be], Bi = Be + 1 < j ? b[Be + 1].el : F;
        $n[x] === 0 ? A(
          null,
          gt,
          P,
          Bi,
          M,
          f,
          p,
          y,
          C
        ) : rt && (ee < 0 || x !== Ki[ee] ? U(gt, P, Bi, 2) : ee--);
      }
    }
  }, U = (_, b, P, F, M = null) => {
    const { el: f, type: p, transition: y, children: C, shapeFlag: x } = _;
    if (x & 6) {
      U(_.component.subTree, b, P, F);
      return;
    }
    if (x & 128) {
      _.suspense.move(b, P, F);
      return;
    }
    if (x & 64) {
      p.move(_, b, P, Le);
      return;
    }
    if (p === st) {
      r(f, b, P);
      for (let E = 0; E < C.length; E++)
        U(C[E], b, P, F);
      r(_.anchor, b, P);
      return;
    }
    if (p === Ks) {
      I(_, b, P);
      return;
    }
    if (F !== 2 && x & 1 && y)
      if (F === 0)
        y.beforeEnter(f), r(f, b, P), $e(() => y.enter(f), M);
      else {
        const { leave: E, delayLeave: N, afterLeave: H } = y, K = () => r(f, b, P), Z = () => {
          E(f, () => {
            K(), H && H();
          });
        };
        N ? N(f, K, Z) : Z();
      }
    else
      r(f, b, P);
  }, B = (_, b, P, F = !1, M = !1) => {
    const {
      type: f,
      props: p,
      ref: y,
      children: C,
      dynamicChildren: x,
      shapeFlag: j,
      patchFlag: E,
      dirs: N,
      cacheIndex: H
    } = _;
    if (E === -2 && (M = !1), y != null && co(y, null, P, _, !0), H != null && (b.renderCache[H] = void 0), j & 256) {
      b.ctx.deactivate(_);
      return;
    }
    const K = j & 1 && N, Z = !sr(_);
    let ee;
    if (Z && (ee = p && p.onVnodeBeforeUnmount) && bt(ee, b, _), j & 6)
      Ie(_.component, P, F);
    else {
      if (j & 128) {
        _.suspense.unmount(P, F);
        return;
      }
      K && un(_, null, b, "beforeUnmount"), j & 64 ? _.type.remove(
        _,
        b,
        P,
        Le,
        F
      ) : x && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !x.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (f !== st || E > 0 && E & 64) ? de(
        x,
        b,
        P,
        !1,
        !0
      ) : (f === st && E & 384 || !M && j & 16) && de(C, b, P), F && z(_);
    }
    (Z && (ee = p && p.onVnodeUnmounted) || K) && $e(() => {
      ee && bt(ee, b, _), K && un(_, null, b, "unmounted");
    }, P);
  }, z = (_) => {
    const { type: b, el: P, anchor: F, transition: M } = _;
    if (b === st) {
      Q(P, F);
      return;
    }
    if (b === Ks) {
      S(_);
      return;
    }
    const f = () => {
      s(P), M && !M.persisted && M.afterLeave && M.afterLeave();
    };
    if (_.shapeFlag & 1 && M && !M.persisted) {
      const { leave: p, delayLeave: y } = M, C = () => p(P, f);
      y ? y(_.el, f, C) : C();
    } else
      f();
  }, Q = (_, b) => {
    let P;
    for (; _ !== b; )
      P = h(_), s(_), _ = P;
    s(b);
  }, Ie = (_, b, P) => {
    const { bum: F, scope: M, job: f, subTree: p, um: y, m: C, a: x } = _;
    aa(C), aa(x), F && jr(F), M.stop(), f && (f.flags |= 8, B(p, _, b, P)), y && $e(y, b), $e(() => {
      _.isUnmounted = !0;
    }, b), b && b.pendingBranch && !b.isUnmounted && _.asyncDep && !_.asyncResolved && _.suspenseId === b.pendingId && (b.deps--, b.deps === 0 && b.resolve());
  }, de = (_, b, P, F = !1, M = !1, f = 0) => {
    for (let p = f; p < _.length; p++)
      B(_[p], b, P, F, M);
  }, Ee = (_) => {
    if (_.shapeFlag & 6)
      return Ee(_.component.subTree);
    if (_.shapeFlag & 128)
      return _.suspense.next();
    const b = h(_.anchor || _.el), P = b && b[Hd];
    return P ? h(P) : b;
  };
  let _e = !1;
  const _t = (_, b, P) => {
    _ == null ? b._vnode && B(b._vnode, null, null, !0) : A(
      b._vnode || null,
      _,
      b,
      null,
      null,
      null,
      P
    ), b._vnode = _, _e || (_e = !0, ta(), Dc(), _e = !1);
  }, Le = {
    p: A,
    um: B,
    m: U,
    r: z,
    mt: Rt,
    mc: Y,
    pc: te,
    pbc: fe,
    n: Ee,
    o: e
  };
  let je, An;
  return {
    render: _t,
    hydrate: je,
    createApp: lp(_t, je)
  };
}
function Vs({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function fn({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function gp(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function qc(e, t, n = !1) {
  const r = e.children, s = t.children;
  if ($(r) && $(s))
    for (let o = 0; o < r.length; o++) {
      const i = r[o];
      let a = s[o];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[o] = Zt(s[o]), a.el = i.el), !n && a.patchFlag !== -2 && qc(i, a)), a.type === Or && (a.el = i.el);
    }
}
function bp(e) {
  const t = e.slice(), n = [0];
  let r, s, o, i, a;
  const l = e.length;
  for (r = 0; r < l; r++) {
    const c = e[r];
    if (c !== 0) {
      if (s = n[n.length - 1], e[s] < c) {
        t[r] = s, n.push(r);
        continue;
      }
      for (o = 0, i = n.length - 1; o < i; )
        a = o + i >> 1, e[n[a]] < c ? o = a + 1 : i = a;
      c < e[n[o]] && (o > 0 && (t[r] = n[o - 1]), n[o] = r);
    }
  }
  for (o = n.length, i = n[o - 1]; o-- > 0; )
    n[o] = i, i = t[i];
  return n;
}
function Jc(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Jc(t);
}
function aa(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const Ep = Symbol.for("v-scx"), Sp = () => ir(Ep);
function tn(e, t, n) {
  return Qc(e, t, n);
}
function Qc(e, t, n = ie) {
  const { immediate: r, deep: s, flush: o, once: i } = n, a = ve({}, n);
  let l;
  if (ys)
    if (o === "sync") {
      const h = Sp();
      l = h.__watcherHandles || (h.__watcherHandles = []);
    } else if (!t || r)
      a.once = !0;
    else {
      const h = () => {
      };
      return h.stop = ut, h.resume = ut, h.pause = ut, h;
    }
  const c = Ce;
  a.call = (h, T, O) => Nt(h, c, T, O);
  let u = !1;
  o === "post" ? a.scheduler = (h) => {
    $e(h, c && c.suspense);
  } : o !== "sync" && (u = !0, a.scheduler = (h, T) => {
    T ? h() : di(h);
  }), a.augmentJob = (h) => {
    t && (h.flags |= 4), u && (h.flags |= 2, c && (h.id = c.uid, h.i = c));
  };
  const d = Pd(e, t, a);
  return l && l.push(d), d;
}
function yp(e, t, n) {
  const r = this.proxy, s = be(e) ? e.includes(".") ? Zc(r, e) : () => r[e] : e.bind(r, r);
  let o;
  X(t) ? o = t : (o = t.handler, n = t);
  const i = vr(this), a = Qc(s, o.bind(r), n);
  return i(), a;
}
function Zc(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let s = 0; s < n.length && r; s++)
      r = r[n[s]];
    return r;
  };
}
const Op = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${ft(t)}Modifiers`] || e[`${it(t)}Modifiers`];
function vp(e, t, ...n) {
  if (e.isUnmounted) return;
  const r = e.vnode.props || ie;
  let s = n;
  const o = t.startsWith("update:"), i = o && Op(r, t.slice(7));
  i && (i.trim && (s = n.map((u) => be(u) ? u.trim() : u)), i.number && (s = n.map(Kf)));
  let a, l = r[a = ks(t)] || // also try camelCase event handler (#2249)
  r[a = ks(ft(t))];
  !l && o && (l = r[a = ks(it(t))]), l && Nt(
    l,
    e,
    6,
    s
  );
  const c = r[a + "Once"];
  if (c) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Nt(
      c,
      e,
      6,
      s
    );
  }
}
function eu(e, t, n = !1) {
  const r = t.emitsCache, s = r.get(e);
  if (s !== void 0)
    return s;
  const o = e.emits;
  let i = {}, a = !1;
  if (!X(e)) {
    const l = (c) => {
      const u = eu(c, t, !0);
      u && (a = !0, ve(i, u));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !o && !a ? (le(e) && r.set(e, null), null) : ($(o) ? o.forEach((l) => i[l] = null) : ve(i, o), le(e) && r.set(e, i), i);
}
function Ss(e, t) {
  return !e || !fs(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), se(e, t[0].toLowerCase() + t.slice(1)) || se(e, it(t)) || se(e, t));
}
function zs(e) {
  const {
    type: t,
    vnode: n,
    proxy: r,
    withProxy: s,
    propsOptions: [o],
    slots: i,
    attrs: a,
    emit: l,
    render: c,
    renderCache: u,
    props: d,
    data: h,
    setupState: T,
    ctx: O,
    inheritAttrs: A
  } = e, v = Qr(e);
  let m, g;
  try {
    if (n.shapeFlag & 4) {
      const S = s || r, D = Jt.NODE_ENV !== "production" && T.__isScriptSetup ? new Proxy(S, {
        get(G, w, Y) {
          return Dd(
            `Property '${String(
              w
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(G, w, Y);
        }
      }) : S;
      m = yt(
        c.call(
          D,
          S,
          u,
          Jt.NODE_ENV !== "production" ? xr(d) : d,
          T,
          h,
          O
        )
      ), g = a;
    } else {
      const S = t;
      Jt.NODE_ENV, m = yt(
        S.length > 1 ? S(
          Jt.NODE_ENV !== "production" ? xr(d) : d,
          Jt.NODE_ENV !== "production" ? {
            get attrs() {
              return xr(a);
            },
            slots: i,
            emit: l
          } : { attrs: a, slots: i, emit: l }
        ) : S(
          Jt.NODE_ENV !== "production" ? xr(d) : d,
          null
        )
      ), g = t.props ? a : Ip(a);
    }
  } catch (S) {
    ar.length = 0, bs(S, e, 1), m = we(Sn);
  }
  let I = m;
  if (g && A !== !1) {
    const S = Object.keys(g), { shapeFlag: D } = I;
    S.length && D & 7 && (o && S.some(Zo) && (g = Ap(
      g,
      o
    )), I = Fn(I, g, !1, !0));
  }
  return n.dirs && (I = Fn(I, null, !1, !0), I.dirs = I.dirs ? I.dirs.concat(n.dirs) : n.dirs), n.transition && pi(I, n.transition), m = I, Qr(v), m;
}
const Ip = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || fs(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, Ap = (e, t) => {
  const n = {};
  for (const r in e)
    (!Zo(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
  return n;
};
function Tp(e, t, n) {
  const { props: r, children: s, component: o } = e, { props: i, children: a, patchFlag: l } = t, c = o.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return r ? la(r, i, c) : !!i;
    if (l & 8) {
      const u = t.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        const h = u[d];
        if (i[h] !== r[h] && !Ss(c, h))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : r === i ? !1 : r ? i ? la(r, i, c) : !0 : !!i;
  return !1;
}
function la(e, t, n) {
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < r.length; s++) {
    const o = r[s];
    if (t[o] !== e[o] && !Ss(n, o))
      return !0;
  }
  return !1;
}
function Np({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const r = t.subTree;
    if (r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const tu = (e) => e.__isSuspense;
function Cp(e, t) {
  t && t.pendingBranch ? $(e) ? t.effects.push(...e) : t.effects.push(e) : Gd(e);
}
const st = Symbol.for("v-fgt"), Or = Symbol.for("v-txt"), Sn = Symbol.for("v-cmt"), Ks = Symbol.for("v-stc"), ar = [];
let Je = null;
function kn(e = !1) {
  ar.push(Je = e ? null : []);
}
function Rp() {
  ar.pop(), Je = ar[ar.length - 1] || null;
}
let mr = 1;
function ca(e) {
  mr += e, e < 0 && Je && (Je.hasOnce = !0);
}
function nu(e) {
  return e.dynamicChildren = mr > 0 ? Je || Pn : null, Rp(), mr > 0 && Je && Je.push(e), e;
}
function lr(e, t, n, r, s, o) {
  return nu(
    Ne(
      e,
      t,
      n,
      r,
      s,
      o,
      !0
    )
  );
}
function Pp(e, t, n, r, s) {
  return nu(
    we(
      e,
      t,
      n,
      r,
      s,
      !0
    )
  );
}
function es(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Xn(e, t) {
  return e.type === t.type && e.key === t.key;
}
const ru = ({ key: e }) => e ?? null, Hr = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? be(e) || Pe(e) || X(e) ? { i: qe, r: e, k: t, f: !!n } : e : null);
function Ne(e, t = null, n = null, r = 0, s = null, o = e === st ? 0 : 1, i = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && ru(t),
    ref: t && Hr(t),
    scopeId: xc,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: r,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: qe
  };
  return a ? (bi(l, n), o & 128 && e.normalize(l)) : n && (l.shapeFlag |= be(n) ? 8 : 16), mr > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  Je && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Je.push(l), l;
}
const we = Dp;
function Dp(e, t = null, n = null, r = 0, s = null, o = !1) {
  if ((!e || e === Zd) && (e = Sn), es(e)) {
    const a = Fn(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && bi(a, n), mr > 0 && !o && Je && (a.shapeFlag & 6 ? Je[Je.indexOf(e)] = a : Je.push(a)), a.patchFlag = -2, a;
  }
  if (Bp(e) && (e = e.__vccOpts), t) {
    t = wp(t);
    let { class: a, style: l } = t;
    a && !be(a) && (t.class = ri(a)), le(l) && (ui(l) && !$(l) && (l = ve({}, l)), t.style = ni(l));
  }
  const i = be(e) ? 1 : tu(e) ? 128 : Vd(e) ? 64 : le(e) ? 4 : X(e) ? 2 : 0;
  return Ne(
    e,
    t,
    n,
    r,
    s,
    i,
    o,
    !0
  );
}
function wp(e) {
  return e ? ui(e) || zc(e) ? ve({}, e) : e : null;
}
function Fn(e, t, n = !1, r = !1) {
  const { props: s, ref: o, patchFlag: i, children: a, transition: l } = e, c = t ? Lp(s || {}, t) : s, u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: c,
    key: c && ru(c),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? $(o) ? o.concat(Hr(t)) : [o, Hr(t)] : Hr(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== st ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Fn(e.ssContent),
    ssFallback: e.ssFallback && Fn(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && r && pi(
    u,
    l.clone(u)
  ), u;
}
function ho(e = " ", t = 0) {
  return we(Or, null, e, t);
}
function xp(e = "", t = !1) {
  return t ? (kn(), Pp(Sn, null, e)) : we(Sn, null, e);
}
function yt(e) {
  return e == null || typeof e == "boolean" ? we(Sn) : $(e) ? we(
    st,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : es(e) ? Zt(e) : we(Or, null, String(e));
}
function Zt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Fn(e);
}
function bi(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if ($(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), bi(e, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = t._;
      !s && !zc(t) ? t._ctx = qe : s === 3 && qe && (qe.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else X(t) ? (t = { default: t, _ctx: qe }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [ho(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Lp(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const s in r)
      if (s === "class")
        t.class !== r.class && (t.class = ri([t.class, r.class]));
      else if (s === "style")
        t.style = ni([t.style, r.style]);
      else if (fs(s)) {
        const o = t[s], i = r[s];
        i && o !== i && !($(o) && o.includes(i)) && (t[s] = o ? [].concat(o, i) : i);
      } else s !== "" && (t[s] = r[s]);
  }
  return t;
}
function bt(e, t, n, r = null) {
  Nt(e, t, 7, [
    n,
    r
  ]);
}
const kp = jc();
let Mp = 0;
function Fp(e, t, n) {
  const r = e.type, s = (t ? t.appContext : e.appContext) || kp, o = {
    uid: Mp++,
    vnode: e,
    type: r,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new ac(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Bc(r, s),
    emitsOptions: eu(r, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: ie,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: ie,
    data: ie,
    props: ie,
    attrs: ie,
    slots: ie,
    refs: ie,
    setupState: ie,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = t ? t.root : o, o.emit = vp.bind(null, o), e.ce && e.ce(o), o;
}
let Ce = null;
const Ei = () => Ce || qe;
let ts, _o;
{
  const e = rc(), t = (n, r) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(r), (o) => {
      s.length > 1 ? s.forEach((i) => i(o)) : s[0](o);
    };
  };
  ts = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Ce = n
  ), _o = t(
    "__VUE_SSR_SETTERS__",
    (n) => ys = n
  );
}
const vr = (e) => {
  const t = Ce;
  return ts(e), e.scope.on(), () => {
    e.scope.off(), ts(t);
  };
}, ua = () => {
  Ce && Ce.scope.off(), ts(null);
};
function su(e) {
  return e.vnode.shapeFlag & 4;
}
let ys = !1;
function Gp(e, t = !1, n = !1) {
  t && _o(t);
  const { props: r, children: s } = e.vnode, o = su(e);
  cp(e, r, o, t), pp(e, s, n);
  const i = o ? jp(e, t) : void 0;
  return t && _o(!1), i;
}
function jp(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, tp);
  const { setup: r } = n;
  if (r) {
    const s = e.setupContext = r.length > 1 ? Hp(e) : null, o = vr(e);
    zt();
    const i = Vn(
      r,
      e,
      0,
      [
        e.props,
        s
      ]
    );
    if (Kt(), o(), Zl(i)) {
      if (sr(e) || Lc(e), i.then(ua, ua), t)
        return i.then((a) => {
          fa(e, a, t);
        }).catch((a) => {
          bs(a, e, 0);
        });
      e.asyncDep = i;
    } else
      fa(e, i, t);
  } else
    ou(e, t);
}
function fa(e, t, n) {
  X(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : le(t) && (e.setupState = Tc(t)), ou(e, n);
}
let da;
function ou(e, t, n) {
  const r = e.type;
  if (!e.render) {
    if (!t && da && !r.render) {
      const s = r.template || _i(e).template;
      if (s) {
        const { isCustomElement: o, compilerOptions: i } = e.appContext.config, { delimiters: a, compilerOptions: l } = r, c = ve(
          ve(
            {
              isCustomElement: o,
              delimiters: a
            },
            i
          ),
          l
        );
        r.render = da(s, c);
      }
    }
    e.render = r.render || ut;
  }
  {
    const s = vr(e);
    zt();
    try {
      np(e);
    } finally {
      Kt(), s();
    }
  }
}
const Up = {
  get(e, t) {
    return xe(e, "get", ""), e[t];
  }
};
function Hp(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    attrs: new Proxy(e.attrs, Up),
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function Os(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Tc(vd(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in or)
        return or[n](e);
    },
    has(t, n) {
      return n in t || n in or;
    }
  })) : e.proxy;
}
const Vp = /(?:^|[-_])(\w)/g, zp = (e) => e.replace(Vp, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Kp(e, t = !0) {
  return X(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function iu(e, t, n = !1) {
  let r = Kp(t);
  if (!r && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (r = s[1]);
  }
  if (!r && e && e.parent) {
    const s = (o) => {
      for (const i in o)
        if (o[i] === t)
          return i;
    };
    r = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return r ? zp(r) : n ? "App" : "Anonymous";
}
function Bp(e) {
  return X(e) && "__vccOpts" in e;
}
const Xe = (e, t) => Cd(e, t, ys);
function Si(e, t, n) {
  const r = arguments.length;
  return r === 2 ? le(t) && !$(t) ? es(t) ? we(e, null, [t]) : we(e, t) : we(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && es(n) && (n = [n]), we(e, t, n));
}
const $p = "3.5.11";
let go;
const pa = typeof window < "u" && window.trustedTypes;
if (pa)
  try {
    go = /* @__PURE__ */ pa.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch {
  }
const au = go ? (e) => go.createHTML(e) : (e) => e, Wp = "http://www.w3.org/2000/svg", Xp = "http://www.w3.org/1998/Math/MathML", xt = typeof document < "u" ? document : null, ma = xt && /* @__PURE__ */ xt.createElement("template"), Yp = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, r) => {
    const s = t === "svg" ? xt.createElementNS(Wp, e) : t === "mathml" ? xt.createElementNS(Xp, e) : n ? xt.createElement(e, { is: n }) : xt.createElement(e);
    return e === "select" && r && r.multiple != null && s.setAttribute("multiple", r.multiple), s;
  },
  createText: (e) => xt.createTextNode(e),
  createComment: (e) => xt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => xt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, r, s, o) {
    const i = n ? n.previousSibling : t.lastChild;
    if (s && (s === o || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), n), !(s === o || !(s = s.nextSibling)); )
        ;
    else {
      ma.innerHTML = au(
        r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e
      );
      const a = ma.content;
      if (r === "svg" || r === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, n);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, qp = Symbol("_vtc");
function Jp(e, t, n) {
  const r = e[qp];
  r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const ha = Symbol("_vod"), Qp = Symbol("_vsh"), Zp = Symbol(""), em = /(^|;)\s*display\s*:/;
function tm(e, t, n) {
  const r = e.style, s = be(n);
  let o = !1;
  if (n && !s) {
    if (t)
      if (be(t))
        for (const i of t.split(";")) {
          const a = i.slice(0, i.indexOf(":")).trim();
          n[a] == null && Vr(r, a, "");
        }
      else
        for (const i in t)
          n[i] == null && Vr(r, i, "");
    for (const i in n)
      i === "display" && (o = !0), Vr(r, i, n[i]);
  } else if (s) {
    if (t !== n) {
      const i = r[Zp];
      i && (n += ";" + i), r.cssText = n, o = em.test(n);
    }
  } else t && e.removeAttribute("style");
  ha in e && (e[ha] = o ? r.display : "", e[Qp] && (r.display = "none"));
}
const _a = /\s*!important$/;
function Vr(e, t, n) {
  if ($(n))
    n.forEach((r) => Vr(e, t, r));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const r = nm(e, t);
    _a.test(n) ? e.setProperty(
      it(r),
      n.replace(_a, ""),
      "important"
    ) : e[r] = n;
  }
}
const ga = ["Webkit", "Moz", "ms"], Bs = {};
function nm(e, t) {
  const n = Bs[t];
  if (n)
    return n;
  let r = ft(t);
  if (r !== "filter" && r in e)
    return Bs[t] = r;
  r = tc(r);
  for (let s = 0; s < ga.length; s++) {
    const o = ga[s] + r;
    if (o in e)
      return Bs[t] = o;
  }
  return t;
}
const ba = "http://www.w3.org/1999/xlink";
function Ea(e, t, n, r, s, o = qf(t)) {
  r && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(ba, t.slice(6, t.length)) : e.setAttributeNS(ba, t, n) : n == null || o && !sc(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    o ? "" : Tt(n) ? String(n) : n
  );
}
function Sa(e, t, n, r) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? au(n) : n);
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    const i = s === "OPTION" ? e.getAttribute("value") || "" : e.value, a = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (i !== a || !("_value" in e)) && (e.value = a), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let o = !1;
  if (n === "" || n == null) {
    const i = typeof e[t];
    i === "boolean" ? n = sc(n) : n == null && i === "string" ? (n = "", o = !0) : i === "number" && (n = 0, o = !0);
  }
  try {
    e[t] = n;
  } catch {
  }
  o && e.removeAttribute(t);
}
function lu(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function rm(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
const ya = Symbol("_vei");
function sm(e, t, n, r, s = null) {
  const o = e[ya] || (e[ya] = {}), i = o[t];
  if (r && i)
    i.value = r;
  else {
    const [a, l] = om(t);
    if (r) {
      const c = o[t] = lm(
        r,
        s
      );
      lu(e, a, c, l);
    } else i && (rm(e, a, i, l), o[t] = void 0);
  }
}
const Oa = /(?:Once|Passive|Capture)$/;
function om(e) {
  let t;
  if (Oa.test(e)) {
    t = {};
    let r;
    for (; r = e.match(Oa); )
      e = e.slice(0, e.length - r[0].length), t[r[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : it(e.slice(2)), t];
}
let $s = 0;
const im = /* @__PURE__ */ Promise.resolve(), am = () => $s || (im.then(() => $s = 0), $s = Date.now());
function lm(e, t) {
  const n = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= n.attached)
      return;
    Nt(
      cm(r, n.value),
      t,
      5,
      [r]
    );
  };
  return n.value = e, n.attached = am(), n;
}
function cm(e, t) {
  if ($(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (r) => (s) => !s._stopped && r && r(s)
    );
  } else
    return t;
}
const va = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, um = (e, t, n, r, s, o) => {
  const i = s === "svg";
  t === "class" ? Jp(e, r, i) : t === "style" ? tm(e, n, r) : fs(t) ? Zo(t) || sm(e, t, n, r, o) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : fm(e, t, r, i)) ? (Sa(e, t, r), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Ea(e, t, r, i, o, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !be(r)) ? Sa(e, ft(t), r) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), Ea(e, t, r, i));
};
function fm(e, t, n, r) {
  if (r)
    return !!(t === "innerHTML" || t === "textContent" || t in e && va(t) && X(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const s = e.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return va(t) && be(n) ? !1 : t in e;
}
const Ia = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function cu(e, t, n) {
  const r = /* @__PURE__ */ In(e, t);
  ds(r) && ve(r, t);
  class s extends yi {
    constructor(i) {
      super(r, i, n);
    }
  }
  return s.def = r, s;
}
const dm = typeof HTMLElement < "u" ? HTMLElement : class {
};
class yi extends dm {
  constructor(t, n = {}, r = bo) {
    super(), this._def = t, this._props = n, this._createApp = r, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && r !== bo ? this._root = this.shadowRoot : t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this, this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof yi) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, Rc(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let r = 0; r < this.attributes.length; r++)
      this._setAttr(this.attributes[r].name);
    this._ob = new MutationObserver((r) => {
      for (const s of r)
        this._setAttr(s.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (r, s = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: o, styles: i } = r;
      let a;
      if (o && !$(o))
        for (const l in o) {
          const c = o[l];
          (c === Number || c && c.type === Number) && (l in this._props && (this._props[l] = Wi(this._props[l])), (a || (a = /* @__PURE__ */ Object.create(null)))[ft(l)] = !0);
        }
      this._numberProps = a, s && this._resolveProps(r), this.shadowRoot && this._applyStyles(i), this._mount(r);
    }, n = this._def.__asyncLoader;
    n ? this._pendingResolve = n().then(
      (r) => t(this._def = r, !0)
    ) : t(this._def);
  }
  _mount(t) {
    this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const n = this._instance && this._instance.exposed;
    if (n)
      for (const r in n)
        se(this, r) || Object.defineProperty(this, r, {
          // unwrap ref to be consistent with public instance behavior
          get: () => Yr(n[r])
        });
  }
  _resolveProps(t) {
    const { props: n } = t, r = $(n) ? n : Object.keys(n || {});
    for (const s of Object.keys(this))
      s[0] !== "_" && r.includes(s) && this._setProp(s, this[s]);
    for (const s of r.map(ft))
      Object.defineProperty(this, s, {
        get() {
          return this._getProp(s);
        },
        set(o) {
          this._setProp(s, o, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const n = this.hasAttribute(t);
    let r = n ? this.getAttribute(t) : Ia;
    const s = ft(t);
    n && this._numberProps && this._numberProps[s] && (r = Wi(r)), this._setProp(s, r, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, r = !0, s = !1) {
    n !== this._props[t] && (n === Ia ? delete this._props[t] : (this._props[t] = n, t === "key" && this._app && (this._app._ceVNode.key = n)), s && this._instance && this._update(), r && (n === !0 ? this.setAttribute(it(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(it(t), n + "") : n || this.removeAttribute(it(t))));
  }
  _update() {
    Em(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const n = we(this._def, ve(t, this._props));
    return this._instance || (n.ce = (r) => {
      this._instance = r, r.ce = this, r.isCE = !0;
      const s = (o, i) => {
        this.dispatchEvent(
          new CustomEvent(
            o,
            ds(i[0]) ? ve({ detail: i }, i[0]) : { detail: i }
          )
        );
      };
      r.emit = (o, ...i) => {
        s(o, i), it(o) !== o && s(it(o), i);
      }, this._setParent();
    }), n;
  }
  _applyStyles(t, n) {
    if (!t) return;
    if (n) {
      if (n === this._def || this._styleChildren.has(n))
        return;
      this._styleChildren.add(n);
    }
    const r = this._nonce;
    for (let s = t.length - 1; s >= 0; s--) {
      const o = document.createElement("style");
      r && o.setAttribute("nonce", r), o.textContent = t[s], this.shadowRoot.prepend(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let n;
    for (; n = this.firstChild; ) {
      const r = n.nodeType === 1 && n.getAttribute("slot") || "default";
      (t[r] || (t[r] = [])).push(n), this.removeChild(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), n = this._instance.type.__scopeId;
    for (let r = 0; r < t.length; r++) {
      const s = t[r], o = s.getAttribute("name") || "default", i = this._slots[o], a = s.parentNode;
      if (i)
        for (const l of i) {
          if (n && l.nodeType === 1) {
            const c = n + "-s", u = document.createTreeWalker(l, 1);
            l.setAttribute(c, "");
            let d;
            for (; d = u.nextNode(); )
              d.setAttribute(c, "");
          }
          a.insertBefore(l, s);
        }
      else
        for (; s.firstChild; ) a.insertBefore(s.firstChild, s);
      a.removeChild(s);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
  }
}
const Aa = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return $(t) ? (n) => jr(t, n) : t;
}, Ws = Symbol("_assign"), pm = {
  created(e, { value: t }, n) {
    e.checked = Xr(t, n.props.value), e[Ws] = Aa(n), lu(e, "change", () => {
      e[Ws](mm(e));
    });
  },
  beforeUpdate(e, { value: t, oldValue: n }, r) {
    e[Ws] = Aa(r), t !== n && (e.checked = Xr(t, r.props.value));
  }
};
function mm(e) {
  return "_value" in e ? e._value : e.value;
}
const hm = ["ctrl", "shift", "alt", "meta"], _m = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => hm.some((n) => e[`${n}Key`] && !t.includes(n))
}, gm = (e, t) => {
  const n = e._withMods || (e._withMods = {}), r = t.join(".");
  return n[r] || (n[r] = (s, ...o) => {
    for (let i = 0; i < t.length; i++) {
      const a = _m[t[i]];
      if (a && a(s, t)) return;
    }
    return e(s, ...o);
  });
}, bm = /* @__PURE__ */ ve({ patchProp: um }, Yp);
let Ta;
function uu() {
  return Ta || (Ta = hp(bm));
}
const Em = (...e) => {
  uu().render(...e);
}, bo = (...e) => {
  const t = uu().createApp(...e), { mount: n } = t;
  return t.mount = (r) => {
    const s = ym(r);
    if (!s) return;
    const o = t._component;
    !X(o) && !o.render && !o.template && (o.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const i = n(s, !1, Sm(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), i;
  }, t;
};
function Sm(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function ym(e) {
  return be(e) ? document.querySelector(e) : e;
}
const Na = {
  "change-etab": {
    title: "Change structure",
    "struct-current": "Current structure : ",
    legend: "Select another structure to reconnect to :",
    "valid-button": "Change structure",
    "change-confirm": `In order for the structure change to take effect, you must log out.

Do you agree to log out now?`
  }
}, Ca = {
  "change-etab": {
    title: "Changer de structure",
    "struct-current": "Structure courante : ",
    legend: "Sélectionnez une autre structure à laquelle vous reconnecter :",
    "valid-button": "Changer de structure",
    "change-confirm": `Afin que le changement de structure soit effectif, vous devez vous déonnecter.

Acceptez-vous de vous déconnecter maintenant ?`
  }
};
/*!
  * shared v10.0.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const ns = typeof window < "u", an = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), hr = (e) => typeof e == "number" && isFinite(e), Ra = (e) => Am(e) === "[object RegExp]", Om = (e) => ct(e) && Object.keys(e).length === 0, It = Object.assign;
let Pa;
const fu = () => Pa || (Pa = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), vm = Object.prototype.hasOwnProperty;
function rs(e, t) {
  return vm.call(e, t);
}
const Ft = Array.isArray, kr = (e) => typeof e == "function", Oe = (e) => typeof e == "string", Lt = (e) => typeof e == "boolean", Qe = (e) => e !== null && typeof e == "object", Im = Object.prototype.toString, Am = (e) => Im.call(e), ct = (e) => {
  if (!Qe(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, Mr = (e) => !Qe(e) || Ft(e);
function zr(e, t) {
  if (Mr(e) || Mr(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: s } = n.pop();
    Object.keys(r).forEach((o) => {
      Mr(r[o]) || Mr(s[o]) ? s[o] = r[o] : n.push({ src: r[o], des: s[o] });
    });
  }
}
const Tm = (e, t, n) => Nm({ l: e, k: t, s: n }), Nm = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ye = (e) => typeof e == "number" && isFinite(e), Cm = (e) => pu(e) === "[object Date]", Da = (e) => pu(e) === "[object RegExp]", Oi = (e) => pe(e) && Object.keys(e).length === 0, ln = Object.assign;
let wa;
const Rm = () => wa || (wa = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function xa(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const At = Array.isArray, Ae = (e) => typeof e == "function", W = (e) => typeof e == "string", He = (e) => typeof e == "boolean", Re = (e) => e !== null && typeof e == "object", Pm = (e) => Re(e) && Ae(e.then) && Ae(e.catch), du = Object.prototype.toString, pu = (e) => du.call(e), pe = (e) => {
  if (!Re(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, Dm = (e) => e == null ? "" : At(e) || pe(e) && e.toString === du ? JSON.stringify(e, null, 2) : String(e);
function vi(e, t = "") {
  return e.reduce((n, r, s) => s === 0 ? n + r : n + t + r, "");
}
function wm(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
function xm(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Eo(e, t, n) {
  return { start: e, end: t };
}
const oe = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Lm = 17;
function vs(e, t, n = {}) {
  const { domain: r, messages: s, args: o } = n, i = e, a = new SyntaxError(String(i));
  return a.code = e, t && (a.location = t), a.domain = r, a;
}
function km(e) {
  throw e;
}
const Dt = " ", Mm = "\r", Me = `
`, Fm = "\u2028", Gm = "\u2029";
function jm(e) {
  const t = e;
  let n = 0, r = 1, s = 1, o = 0;
  const i = (w) => t[w] === Mm && t[w + 1] === Me, a = (w) => t[w] === Me, l = (w) => t[w] === Gm, c = (w) => t[w] === Fm, u = (w) => i(w) || a(w) || l(w) || c(w), d = () => n, h = () => r, T = () => s, O = () => o, A = (w) => i(w) || l(w) || c(w) ? Me : t[w], v = () => A(n), m = () => A(n + o);
  function g() {
    return o = 0, u(n) && (r++, s = 0), i(n) && n++, n++, s++, t[n];
  }
  function I() {
    return i(n + o) && o++, o++, t[n + o];
  }
  function S() {
    n = 0, r = 1, s = 1, o = 0;
  }
  function D(w = 0) {
    o = w;
  }
  function G() {
    const w = n + o;
    for (; w !== n; )
      g();
    o = 0;
  }
  return {
    index: d,
    line: h,
    column: T,
    peekOffset: O,
    charAt: A,
    currentChar: v,
    currentPeek: m,
    next: g,
    peek: I,
    reset: S,
    resetPeek: D,
    skipToPeek: G
  };
}
const Xt = void 0, Um = ".", La = "'", Hm = "tokenizer";
function Vm(e, t = {}) {
  const n = t.location !== !1, r = jm(e), s = () => r.index(), o = () => xm(r.line(), r.column(), r.index()), i = o(), a = s(), l = {
    currentType: 13,
    offset: a,
    startLoc: i,
    endLoc: i,
    lastType: 13,
    lastOffset: a,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = t;
  function d(f, p, y, ...C) {
    const x = c();
    if (p.column += y, p.offset += y, u) {
      const j = n ? Eo(x.startLoc, p) : null, E = vs(f, j, {
        domain: Hm,
        args: C
      });
      u(E);
    }
  }
  function h(f, p, y) {
    f.endLoc = o(), f.currentType = p;
    const C = { type: p };
    return n && (C.loc = Eo(f.startLoc, f.endLoc)), y != null && (C.value = y), C;
  }
  const T = (f) => h(
    f,
    13
    /* TokenTypes.EOF */
  );
  function O(f, p) {
    return f.currentChar() === p ? (f.next(), p) : (d(oe.EXPECTED_TOKEN, o(), 0, p), "");
  }
  function A(f) {
    let p = "";
    for (; f.currentPeek() === Dt || f.currentPeek() === Me; )
      p += f.currentPeek(), f.peek();
    return p;
  }
  function v(f) {
    const p = A(f);
    return f.skipToPeek(), p;
  }
  function m(f) {
    if (f === Xt)
      return !1;
    const p = f.charCodeAt(0);
    return p >= 97 && p <= 122 || // a-z
    p >= 65 && p <= 90 || // A-Z
    p === 95;
  }
  function g(f) {
    if (f === Xt)
      return !1;
    const p = f.charCodeAt(0);
    return p >= 48 && p <= 57;
  }
  function I(f, p) {
    const { currentType: y } = p;
    if (y !== 2)
      return !1;
    A(f);
    const C = m(f.currentPeek());
    return f.resetPeek(), C;
  }
  function S(f, p) {
    const { currentType: y } = p;
    if (y !== 2)
      return !1;
    A(f);
    const C = f.currentPeek() === "-" ? f.peek() : f.currentPeek(), x = g(C);
    return f.resetPeek(), x;
  }
  function D(f, p) {
    const { currentType: y } = p;
    if (y !== 2)
      return !1;
    A(f);
    const C = f.currentPeek() === La;
    return f.resetPeek(), C;
  }
  function G(f, p) {
    const { currentType: y } = p;
    if (y !== 7)
      return !1;
    A(f);
    const C = f.currentPeek() === ".";
    return f.resetPeek(), C;
  }
  function w(f, p) {
    const { currentType: y } = p;
    if (y !== 8)
      return !1;
    A(f);
    const C = m(f.currentPeek());
    return f.resetPeek(), C;
  }
  function Y(f, p) {
    const { currentType: y } = p;
    if (!(y === 7 || y === 11))
      return !1;
    A(f);
    const C = f.currentPeek() === ":";
    return f.resetPeek(), C;
  }
  function J(f, p) {
    const { currentType: y } = p;
    if (y !== 9)
      return !1;
    const C = () => {
      const j = f.currentPeek();
      return j === "{" ? m(f.peek()) : j === "@" || j === "|" || j === ":" || j === "." || j === Dt || !j ? !1 : j === Me ? (f.peek(), C()) : ge(f, !1);
    }, x = C();
    return f.resetPeek(), x;
  }
  function fe(f) {
    A(f);
    const p = f.currentPeek() === "|";
    return f.resetPeek(), p;
  }
  function ge(f, p = !0) {
    const y = (x = !1, j = "") => {
      const E = f.currentPeek();
      return E === "{" || E === "@" || !E ? x : E === "|" ? !(j === Dt || j === Me) : E === Dt ? (f.peek(), y(!0, Dt)) : E === Me ? (f.peek(), y(!0, Me)) : !0;
    }, C = y();
    return p && f.resetPeek(), C;
  }
  function ce(f, p) {
    const y = f.currentChar();
    return y === Xt ? Xt : p(y) ? (f.next(), y) : null;
  }
  function Ge(f) {
    const p = f.charCodeAt(0);
    return p >= 97 && p <= 122 || // a-z
    p >= 65 && p <= 90 || // A-Z
    p >= 48 && p <= 57 || // 0-9
    p === 95 || // _
    p === 36;
  }
  function Rt(f) {
    return ce(f, Ge);
  }
  function ht(f) {
    const p = f.charCodeAt(0);
    return p >= 97 && p <= 122 || // a-z
    p >= 65 && p <= 90 || // A-Z
    p >= 48 && p <= 57 || // 0-9
    p === 95 || // _
    p === 36 || // $
    p === 45;
  }
  function he(f) {
    return ce(f, ht);
  }
  function re(f) {
    const p = f.charCodeAt(0);
    return p >= 48 && p <= 57;
  }
  function te(f) {
    return ce(f, re);
  }
  function L(f) {
    const p = f.charCodeAt(0);
    return p >= 48 && p <= 57 || // 0-9
    p >= 65 && p <= 70 || // A-F
    p >= 97 && p <= 102;
  }
  function k(f) {
    return ce(f, L);
  }
  function U(f) {
    let p = "", y = "";
    for (; p = te(f); )
      y += p;
    return y;
  }
  function B(f) {
    let p = "";
    for (; ; ) {
      const y = f.currentChar();
      if (y === "{" || y === "}" || y === "@" || y === "|" || !y)
        break;
      if (y === Dt || y === Me)
        if (ge(f))
          p += y, f.next();
        else {
          if (fe(f))
            break;
          p += y, f.next();
        }
      else
        p += y, f.next();
    }
    return p;
  }
  function z(f) {
    v(f);
    let p = "", y = "";
    for (; p = he(f); )
      y += p;
    return f.currentChar() === Xt && d(oe.UNTERMINATED_CLOSING_BRACE, o(), 0), y;
  }
  function Q(f) {
    v(f);
    let p = "";
    return f.currentChar() === "-" ? (f.next(), p += `-${U(f)}`) : p += U(f), f.currentChar() === Xt && d(oe.UNTERMINATED_CLOSING_BRACE, o(), 0), p;
  }
  function Ie(f) {
    return f !== La && f !== Me;
  }
  function de(f) {
    v(f), O(f, "'");
    let p = "", y = "";
    for (; p = ce(f, Ie); )
      p === "\\" ? y += Ee(f) : y += p;
    const C = f.currentChar();
    return C === Me || C === Xt ? (d(oe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), C === Me && (f.next(), O(f, "'")), y) : (O(f, "'"), y);
  }
  function Ee(f) {
    const p = f.currentChar();
    switch (p) {
      case "\\":
      case "'":
        return f.next(), `\\${p}`;
      case "u":
        return _e(f, p, 4);
      case "U":
        return _e(f, p, 6);
      default:
        return d(oe.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, p), "";
    }
  }
  function _e(f, p, y) {
    O(f, p);
    let C = "";
    for (let x = 0; x < y; x++) {
      const j = k(f);
      if (!j) {
        d(oe.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${p}${C}${f.currentChar()}`);
        break;
      }
      C += j;
    }
    return `\\${p}${C}`;
  }
  function _t(f) {
    return f !== "{" && f !== "}" && f !== Dt && f !== Me;
  }
  function Le(f) {
    v(f);
    let p = "", y = "";
    for (; p = ce(f, _t); )
      y += p;
    return y;
  }
  function je(f) {
    let p = "", y = "";
    for (; p = Rt(f); )
      y += p;
    return y;
  }
  function An(f) {
    const p = (y) => {
      const C = f.currentChar();
      return C === "{" || C === "@" || C === "|" || C === "(" || C === ")" || !C || C === Dt ? y : (y += C, f.next(), p(y));
    };
    return p("");
  }
  function _(f) {
    v(f);
    const p = O(
      f,
      "|"
      /* TokenChars.Pipe */
    );
    return v(f), p;
  }
  function b(f, p) {
    let y = null;
    switch (f.currentChar()) {
      case "{":
        return p.braceNest >= 1 && d(oe.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), f.next(), y = h(
          p,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), v(f), p.braceNest++, y;
      case "}":
        return p.braceNest > 0 && p.currentType === 2 && d(oe.EMPTY_PLACEHOLDER, o(), 0), f.next(), y = h(
          p,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), p.braceNest--, p.braceNest > 0 && v(f), p.inLinked && p.braceNest === 0 && (p.inLinked = !1), y;
      case "@":
        return p.braceNest > 0 && d(oe.UNTERMINATED_CLOSING_BRACE, o(), 0), y = P(f, p) || T(p), p.braceNest = 0, y;
      default: {
        let x = !0, j = !0, E = !0;
        if (fe(f))
          return p.braceNest > 0 && d(oe.UNTERMINATED_CLOSING_BRACE, o(), 0), y = h(p, 1, _(f)), p.braceNest = 0, p.inLinked = !1, y;
        if (p.braceNest > 0 && (p.currentType === 4 || p.currentType === 5 || p.currentType === 6))
          return d(oe.UNTERMINATED_CLOSING_BRACE, o(), 0), p.braceNest = 0, F(f, p);
        if (x = I(f, p))
          return y = h(p, 4, z(f)), v(f), y;
        if (j = S(f, p))
          return y = h(p, 5, Q(f)), v(f), y;
        if (E = D(f, p))
          return y = h(p, 6, de(f)), v(f), y;
        if (!x && !j && !E)
          return y = h(p, 12, Le(f)), d(oe.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, y.value), v(f), y;
        break;
      }
    }
    return y;
  }
  function P(f, p) {
    const { currentType: y } = p;
    let C = null;
    const x = f.currentChar();
    switch ((y === 7 || y === 8 || y === 11 || y === 9) && (x === Me || x === Dt) && d(oe.INVALID_LINKED_FORMAT, o(), 0), x) {
      case "@":
        return f.next(), C = h(
          p,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), p.inLinked = !0, C;
      case ".":
        return v(f), f.next(), h(
          p,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return v(f), f.next(), h(
          p,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return fe(f) ? (C = h(p, 1, _(f)), p.braceNest = 0, p.inLinked = !1, C) : G(f, p) || Y(f, p) ? (v(f), P(f, p)) : w(f, p) ? (v(f), h(p, 11, je(f))) : J(f, p) ? (v(f), x === "{" ? b(f, p) || C : h(p, 10, An(f))) : (y === 7 && d(oe.INVALID_LINKED_FORMAT, o(), 0), p.braceNest = 0, p.inLinked = !1, F(f, p));
    }
  }
  function F(f, p) {
    let y = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (p.braceNest > 0)
      return b(f, p) || T(p);
    if (p.inLinked)
      return P(f, p) || T(p);
    switch (f.currentChar()) {
      case "{":
        return b(f, p) || T(p);
      case "}":
        return d(oe.UNBALANCED_CLOSING_BRACE, o(), 0), f.next(), h(
          p,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return P(f, p) || T(p);
      default: {
        if (fe(f))
          return y = h(p, 1, _(f)), p.braceNest = 0, p.inLinked = !1, y;
        if (ge(f))
          return h(p, 0, B(f));
        break;
      }
    }
    return y;
  }
  function M() {
    const { currentType: f, offset: p, startLoc: y, endLoc: C } = l;
    return l.lastType = f, l.lastOffset = p, l.lastStartLoc = y, l.lastEndLoc = C, l.offset = s(), l.startLoc = o(), r.currentChar() === Xt ? h(
      l,
      13
      /* TokenTypes.EOF */
    ) : F(r, l);
  }
  return {
    nextToken: M,
    currentOffset: s,
    currentPosition: o,
    context: c
  };
}
const zm = "parser", Km = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Bm(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function $m(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function r(m, g, I, S, ...D) {
    const G = m.currentPosition();
    if (G.offset += S, G.column += S, n) {
      const w = t ? Eo(I, G) : null, Y = vs(g, w, {
        domain: zm,
        args: D
      });
      n(Y);
    }
  }
  function s(m, g, I) {
    const S = { type: m };
    return t && (S.start = g, S.end = g, S.loc = { start: I, end: I }), S;
  }
  function o(m, g, I, S) {
    t && (m.end = g, m.loc && (m.loc.end = I));
  }
  function i(m, g) {
    const I = m.context(), S = s(3, I.offset, I.startLoc);
    return S.value = g, o(S, m.currentOffset(), m.currentPosition()), S;
  }
  function a(m, g) {
    const I = m.context(), { lastOffset: S, lastStartLoc: D } = I, G = s(5, S, D);
    return G.index = parseInt(g, 10), m.nextToken(), o(G, m.currentOffset(), m.currentPosition()), G;
  }
  function l(m, g) {
    const I = m.context(), { lastOffset: S, lastStartLoc: D } = I, G = s(4, S, D);
    return G.key = g, m.nextToken(), o(G, m.currentOffset(), m.currentPosition()), G;
  }
  function c(m, g) {
    const I = m.context(), { lastOffset: S, lastStartLoc: D } = I, G = s(9, S, D);
    return G.value = g.replace(Km, Bm), m.nextToken(), o(G, m.currentOffset(), m.currentPosition()), G;
  }
  function u(m) {
    const g = m.nextToken(), I = m.context(), { lastOffset: S, lastStartLoc: D } = I, G = s(8, S, D);
    return g.type !== 11 ? (r(m, oe.UNEXPECTED_EMPTY_LINKED_MODIFIER, I.lastStartLoc, 0), G.value = "", o(G, S, D), {
      nextConsumeToken: g,
      node: G
    }) : (g.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, Et(g)), G.value = g.value || "", o(G, m.currentOffset(), m.currentPosition()), {
      node: G
    });
  }
  function d(m, g) {
    const I = m.context(), S = s(7, I.offset, I.startLoc);
    return S.value = g, o(S, m.currentOffset(), m.currentPosition()), S;
  }
  function h(m) {
    const g = m.context(), I = s(6, g.offset, g.startLoc);
    let S = m.nextToken();
    if (S.type === 8) {
      const D = u(m);
      I.modifier = D.node, S = D.nextConsumeToken || m.nextToken();
    }
    switch (S.type !== 9 && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(S)), S = m.nextToken(), S.type === 2 && (S = m.nextToken()), S.type) {
      case 10:
        S.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(S)), I.key = d(m, S.value || "");
        break;
      case 4:
        S.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(S)), I.key = l(m, S.value || "");
        break;
      case 5:
        S.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(S)), I.key = a(m, S.value || "");
        break;
      case 6:
        S.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(S)), I.key = c(m, S.value || "");
        break;
      default: {
        r(m, oe.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const D = m.context(), G = s(7, D.offset, D.startLoc);
        return G.value = "", o(G, D.offset, D.startLoc), I.key = G, o(I, D.offset, D.startLoc), {
          nextConsumeToken: S,
          node: I
        };
      }
    }
    return o(I, m.currentOffset(), m.currentPosition()), {
      node: I
    };
  }
  function T(m) {
    const g = m.context(), I = g.currentType === 1 ? m.currentOffset() : g.offset, S = g.currentType === 1 ? g.endLoc : g.startLoc, D = s(2, I, S);
    D.items = [];
    let G = null;
    do {
      const J = G || m.nextToken();
      switch (G = null, J.type) {
        case 0:
          J.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(J)), D.items.push(i(m, J.value || ""));
          break;
        case 5:
          J.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(J)), D.items.push(a(m, J.value || ""));
          break;
        case 4:
          J.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(J)), D.items.push(l(m, J.value || ""));
          break;
        case 6:
          J.value == null && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Et(J)), D.items.push(c(m, J.value || ""));
          break;
        case 7: {
          const fe = h(m);
          D.items.push(fe.node), G = fe.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const w = g.currentType === 1 ? g.lastOffset : m.currentOffset(), Y = g.currentType === 1 ? g.lastEndLoc : m.currentPosition();
    return o(D, w, Y), D;
  }
  function O(m, g, I, S) {
    const D = m.context();
    let G = S.items.length === 0;
    const w = s(1, g, I);
    w.cases = [], w.cases.push(S);
    do {
      const Y = T(m);
      G || (G = Y.items.length === 0), w.cases.push(Y);
    } while (D.currentType !== 13);
    return G && r(m, oe.MUST_HAVE_MESSAGES_IN_PLURAL, I, 0), o(w, m.currentOffset(), m.currentPosition()), w;
  }
  function A(m) {
    const g = m.context(), { offset: I, startLoc: S } = g, D = T(m);
    return g.currentType === 13 ? D : O(m, I, S, D);
  }
  function v(m) {
    const g = Vm(m, ln({}, e)), I = g.context(), S = s(0, I.offset, I.startLoc);
    return t && S.loc && (S.loc.source = m), S.body = A(g), e.onCacheKey && (S.cacheKey = e.onCacheKey(m)), I.currentType !== 13 && r(g, oe.UNEXPECTED_LEXICAL_ANALYSIS, I.lastStartLoc, 0, m[I.offset] || ""), o(S, g.currentOffset(), g.currentPosition()), S;
  }
  return { parse: v };
}
function Et(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Wm(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (o) => (n.helpers.add(o), o) };
}
function ka(e, t) {
  for (let n = 0; n < e.length; n++)
    Ii(e[n], t);
}
function Ii(e, t) {
  switch (e.type) {
    case 1:
      ka(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      ka(e.items, t);
      break;
    case 6: {
      Ii(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Xm(e, t = {}) {
  const n = Wm(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Ii(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function Ym(e) {
  const t = e.body;
  return t.type === 2 ? Ma(t) : t.cases.forEach((n) => Ma(n)), e;
}
function Ma(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = vi(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
function Cn(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Cn(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        Cn(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        Cn(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Cn(t.key), t.k = t.key, delete t.key, t.modifier && (Cn(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
  }
  delete e.type;
}
function qm(e, t) {
  const { sourceMap: n, filename: r, breakLineCode: s, needIndent: o } = t, i = t.location !== !1, a = {
    filename: r,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: s,
    needIndent: o,
    indentLevel: 0
  };
  i && e.loc && (a.source = e.loc.source);
  const l = () => a;
  function c(v, m) {
    a.code += v;
  }
  function u(v, m = !0) {
    const g = m ? s : "";
    c(o ? g + "  ".repeat(v) : g);
  }
  function d(v = !0) {
    const m = ++a.indentLevel;
    v && u(m);
  }
  function h(v = !0) {
    const m = --a.indentLevel;
    v && u(m);
  }
  function T() {
    u(a.indentLevel);
  }
  return {
    context: l,
    push: c,
    indent: d,
    deindent: h,
    newline: T,
    helper: (v) => `_${v}`,
    needIndent: () => a.needIndent
  };
}
function Jm(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Gn(e, t.key), t.modifier ? (e.push(", "), Gn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Qm(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const s = t.items.length;
  for (let o = 0; o < s && (Gn(e, t.items[o]), o !== s - 1); o++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function Zm(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const s = t.cases.length;
    for (let o = 0; o < s && (Gn(e, t.cases[o]), o !== s - 1); o++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function eh(e, t) {
  t.body ? Gn(e, t.body) : e.push("null");
}
function Gn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      eh(e, t);
      break;
    case 1:
      Zm(e, t);
      break;
    case 2:
      Qm(e, t);
      break;
    case 6:
      Jm(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
  }
}
const th = (e, t = {}) => {
  const n = W(t.mode) ? t.mode : "normal", r = W(t.filename) ? t.filename : "message.intl", s = !!t.sourceMap, o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, i = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], l = qm(e, {
    mode: n,
    filename: r,
    sourceMap: s,
    breakLineCode: o,
    needIndent: i
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(i), a.length > 0 && (l.push(`const { ${vi(a.map((d) => `${d}: _${d}`), ", ")} } = ctx`), l.newline()), l.push("return "), Gn(l, e), l.deindent(i), l.push("}"), delete e.helpers;
  const { code: c, map: u } = l.context();
  return {
    ast: e,
    code: c,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function nh(e, t = {}) {
  const n = ln({}, t), r = !!n.jit, s = !!n.minify, o = n.optimize == null ? !0 : n.optimize, a = $m(n).parse(e);
  return r ? (o && Ym(a), s && Cn(a), { ast: a, code: "" }) : (Xm(a, n), th(a, n));
}
var rh = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
function sh() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Rm().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
function Xs(e) {
  return (n) => oh(n, e);
}
function oh(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const r = n, s = r.c || r.cases;
    return e.plural(s.reduce((o, i) => [
      ...o,
      Fa(e, i)
    ], []));
  } else
    return Fa(e, n);
}
function Fa(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = (t.i || t.items).reduce((s, o) => [...s, So(e, o)], []);
    return e.normalize(r);
  }
}
function So(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3: {
      const r = t;
      return r.v || r.value;
    }
    case 9: {
      const r = t;
      return r.v || r.value;
    }
    case 4: {
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    }
    case 5: {
      const r = t;
      return e.interpolate(e.list(r.i != null ? r.i : r.index));
    }
    case 6: {
      const r = t, s = r.m || r.modifier;
      return e.linked(So(e, r.k || r.key), s ? So(e, s) : void 0, e.type);
    }
    case 7: {
      const r = t;
      return r.v || r.value;
    }
    case 8: {
      const r = t;
      return r.v || r.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const ih = (e) => e;
let Fr = /* @__PURE__ */ Object.create(null);
const jn = (e) => Re(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function ah(e, t = {}) {
  let n = !1;
  const r = t.onError || km;
  return t.onError = (s) => {
    n = !0, r(s);
  }, { ...nh(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function lh(e, t) {
  if (W(e)) {
    He(t.warnHtmlMessage) && t.warnHtmlMessage;
    const r = (t.onCacheKey || ih)(e), s = Fr[r];
    if (s)
      return s;
    const { ast: o, detectError: i } = ah(e, {
      ...t,
      location: rh.NODE_ENV !== "production",
      jit: !0
    }), a = Xs(o);
    return i ? a : Fr[r] = a;
  } else {
    const n = e.cacheKey;
    if (n) {
      const r = Fr[n];
      return r || (Fr[n] = Xs(e));
    } else
      return Xs(e);
  }
}
let _r = null;
function ch(e) {
  _r = e;
}
function uh(e, t, n) {
  _r && _r.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const fh = /* @__PURE__ */ dh("function:translate");
function dh(e) {
  return (t) => _r && _r.emit(e, t);
}
const Gt = {
  INVALID_ARGUMENT: Lm,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, ph = 24;
function jt(e) {
  return vs(e, null, void 0);
}
function Ai(e, t) {
  return t.locale != null ? Ga(t.locale) : Ga(e.locale);
}
let Ys;
function Ga(e) {
  if (W(e))
    return e;
  if (Ae(e)) {
    if (e.resolvedOnce && Ys != null)
      return Ys;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Pm(t))
        throw jt(Gt.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ys = t;
    } else
      throw jt(Gt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw jt(Gt.NOT_SUPPORT_LOCALE_TYPE);
}
function mh(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...At(t) ? t : Re(t) ? Object.keys(t) : W(t) ? [t] : [n]
  ])];
}
function mu(e, t, n) {
  const r = W(n) ? n : ss, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let o = s.__localeChainCache.get(r);
  if (!o) {
    o = [];
    let i = [n];
    for (; At(i); )
      i = ja(o, i, t);
    const a = At(t) || !pe(t) ? t : t.default ? t.default : null;
    i = W(a) ? [a] : a, At(i) && ja(o, i, !1), s.__localeChainCache.set(r, o);
  }
  return o;
}
function ja(e, t, n) {
  let r = !0;
  for (let s = 0; s < t.length && He(r); s++) {
    const o = t[s];
    W(o) && (r = hh(e, t[s], n));
  }
  return r;
}
function hh(e, t, n) {
  let r;
  const s = t.split("-");
  do {
    const o = s.join("-");
    r = _h(e, o, n), s.splice(-1, 1);
  } while (s.length && r === !0);
  return r;
}
function _h(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (At(n) || pe(n)) && n[s] && (r = n[s]);
  }
  return r;
}
const cn = [];
cn[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
cn[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
cn[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
cn[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
cn[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
cn[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
cn[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const gh = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function bh(e) {
  return gh.test(e);
}
function Eh(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Sh(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function yh(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : bh(t) ? Eh(t) : "*" + t;
}
function Oh(e) {
  const t = [];
  let n = -1, r = 0, s = 0, o, i, a, l, c, u, d;
  const h = [];
  h[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = a : i += a;
  }, h[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, h[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    h[
      0
      /* Actions.APPEND */
    ](), s++;
  }, h[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, r = 4, h[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, i === void 0 || (i = yh(i), i === !1))
        return !1;
      h[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function T() {
    const O = e[n + 1];
    if (r === 5 && O === "'" || r === 6 && O === '"')
      return n++, a = "\\" + O, h[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, o = e[n], !(o === "\\" && T())) {
      if (l = Sh(o), d = cn[r], c = d[l] || d.l || 8, c === 8 || (r = c[0], c[1] !== void 0 && (u = h[c[1]], u && (a = o, u() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const Ua = /* @__PURE__ */ new Map();
function vh(e, t) {
  return Re(e) ? e[t] : null;
}
function Ih(e, t) {
  if (!Re(e))
    return null;
  let n = Ua.get(t);
  if (n || (n = Oh(t), n && Ua.set(t, n)), !n)
    return null;
  const r = n.length;
  let s = e, o = 0;
  for (; o < r; ) {
    const i = s[n[o]];
    if (i === void 0 || Ae(s))
      return null;
    s = i, o++;
  }
  return s;
}
const Ah = "10.0.1", Is = -1, ss = "en-US", Ha = "", Va = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Th() {
  return {
    upper: (e, t) => t === "text" && W(e) ? e.toUpperCase() : t === "vnode" && Re(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && W(e) ? e.toLowerCase() : t === "vnode" && Re(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && W(e) ? Va(e) : t === "vnode" && Re(e) && "__v_isVNode" in e ? Va(e.children) : e
  };
}
let hu;
function Nh(e) {
  hu = e;
}
let _u;
function Ch(e) {
  _u = e;
}
let gu;
function Rh(e) {
  gu = e;
}
let bu = null;
const Ph = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  bu = e;
}, Dh = /* @__NO_SIDE_EFFECTS__ */ () => bu;
let Eu = null;
const za = (e) => {
  Eu = e;
}, wh = () => Eu;
let Ka = 0;
function xh(e = {}) {
  const t = Ae(e.onWarn) ? e.onWarn : wm, n = W(e.version) ? e.version : Ah, r = W(e.locale) || Ae(e.locale) ? e.locale : ss, s = Ae(r) ? ss : r, o = At(e.fallbackLocale) || pe(e.fallbackLocale) || W(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, i = pe(e.messages) ? e.messages : { [s]: {} }, a = pe(e.datetimeFormats) ? e.datetimeFormats : { [s]: {} }, l = pe(e.numberFormats) ? e.numberFormats : { [s]: {} }, c = ln({}, e.modifiers || {}, Th()), u = e.pluralRules || {}, d = Ae(e.missing) ? e.missing : null, h = He(e.missingWarn) || Da(e.missingWarn) ? e.missingWarn : !0, T = He(e.fallbackWarn) || Da(e.fallbackWarn) ? e.fallbackWarn : !0, O = !!e.fallbackFormat, A = !!e.unresolving, v = Ae(e.postTranslation) ? e.postTranslation : null, m = pe(e.processor) ? e.processor : null, g = He(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, I = !!e.escapeParameter, S = Ae(e.messageCompiler) ? e.messageCompiler : hu, D = Ae(e.messageResolver) ? e.messageResolver : _u || vh, G = Ae(e.localeFallbacker) ? e.localeFallbacker : gu || mh, w = Re(e.fallbackContext) ? e.fallbackContext : void 0, Y = e, J = Re(Y.__datetimeFormatters) ? Y.__datetimeFormatters : /* @__PURE__ */ new Map(), fe = Re(Y.__numberFormatters) ? Y.__numberFormatters : /* @__PURE__ */ new Map(), ge = Re(Y.__meta) ? Y.__meta : {};
  Ka++;
  const ce = {
    version: n,
    cid: Ka,
    locale: r,
    fallbackLocale: o,
    messages: i,
    modifiers: c,
    pluralRules: u,
    missing: d,
    missingWarn: h,
    fallbackWarn: T,
    fallbackFormat: O,
    unresolving: A,
    postTranslation: v,
    processor: m,
    warnHtmlMessage: g,
    escapeParameter: I,
    messageCompiler: S,
    messageResolver: D,
    localeFallbacker: G,
    fallbackContext: w,
    onWarn: t,
    __meta: ge
  };
  return ce.datetimeFormats = a, ce.numberFormats = l, ce.__datetimeFormatters = J, ce.__numberFormatters = fe, __INTLIFY_PROD_DEVTOOLS__ && uh(ce, n, ge), ce;
}
function Ti(e, t, n, r, s) {
  const { missing: o, onWarn: i } = e;
  if (o !== null) {
    const a = o(e, n, t, s);
    return W(a) ? a : t;
  } else
    return t;
}
function Yn(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Lh(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function kh(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (Lh(e, t[r]))
      return !0;
  return !1;
}
function Ba(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __datetimeFormatters: a } = e, [l, c, u, d] = yo(...t), h = He(u.missingWarn) ? u.missingWarn : e.missingWarn;
  He(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn;
  const T = !!u.part, O = Ai(e, u), A = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    O
  );
  if (!W(l) || l === "")
    return new Intl.DateTimeFormat(O, d).format(c);
  let v = {}, m, g = null;
  const I = "datetime format";
  for (let G = 0; G < A.length && (m = A[G], v = n[m] || {}, g = v[l], !pe(g)); G++)
    Ti(e, l, m, h, I);
  if (!pe(g) || !W(m))
    return r ? Is : l;
  let S = `${m}__${l}`;
  Oi(d) || (S = `${S}__${JSON.stringify(d)}`);
  let D = a.get(S);
  return D || (D = new Intl.DateTimeFormat(m, ln({}, g, d)), a.set(S, D)), T ? D.formatToParts(c) : D.format(c);
}
const Su = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function yo(...e) {
  const [t, n, r, s] = e, o = {};
  let i = {}, a;
  if (W(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw jt(Gt.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    a = new Date(c);
    try {
      a.toISOString();
    } catch {
      throw jt(Gt.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Cm(t)) {
    if (isNaN(t.getTime()))
      throw jt(Gt.INVALID_DATE_ARGUMENT);
    a = t;
  } else if (Ye(t))
    a = t;
  else
    throw jt(Gt.INVALID_ARGUMENT);
  return W(n) ? o.key = n : pe(n) && Object.keys(n).forEach((l) => {
    Su.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), W(r) ? o.locale = r : pe(r) && (i = r), pe(s) && (i = s), [o.key || "", a, o, i];
}
function $a(e, t, n) {
  const r = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    r.__datetimeFormatters.has(o) && r.__datetimeFormatters.delete(o);
  }
}
function Wa(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __numberFormatters: a } = e, [l, c, u, d] = Oo(...t), h = He(u.missingWarn) ? u.missingWarn : e.missingWarn;
  He(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn;
  const T = !!u.part, O = Ai(e, u), A = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    O
  );
  if (!W(l) || l === "")
    return new Intl.NumberFormat(O, d).format(c);
  let v = {}, m, g = null;
  const I = "number format";
  for (let G = 0; G < A.length && (m = A[G], v = n[m] || {}, g = v[l], !pe(g)); G++)
    Ti(e, l, m, h, I);
  if (!pe(g) || !W(m))
    return r ? Is : l;
  let S = `${m}__${l}`;
  Oi(d) || (S = `${S}__${JSON.stringify(d)}`);
  let D = a.get(S);
  return D || (D = new Intl.NumberFormat(m, ln({}, g, d)), a.set(S, D)), T ? D.formatToParts(c) : D.format(c);
}
const yu = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Oo(...e) {
  const [t, n, r, s] = e, o = {};
  let i = {};
  if (!Ye(t))
    throw jt(Gt.INVALID_ARGUMENT);
  const a = t;
  return W(n) ? o.key = n : pe(n) && Object.keys(n).forEach((l) => {
    yu.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), W(r) ? o.locale = r : pe(r) && (i = r), pe(s) && (i = s), [o.key || "", a, o, i];
}
function Xa(e, t, n) {
  const r = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    r.__numberFormatters.has(o) && r.__numberFormatters.delete(o);
  }
}
const Mh = (e) => e, Fh = (e) => "", Gh = "text", jh = (e) => e.length === 0 ? "" : vi(e), Uh = Dm;
function Ya(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Hh(e) {
  const t = Ye(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ye(e.named.count) || Ye(e.named.n)) ? Ye(e.named.count) ? e.named.count : Ye(e.named.n) ? e.named.n : t : t;
}
function Vh(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function zh(e = {}) {
  const t = e.locale, n = Hh(e), r = Re(e.pluralRules) && W(t) && Ae(e.pluralRules[t]) ? e.pluralRules[t] : Ya, s = Re(e.pluralRules) && W(t) && Ae(e.pluralRules[t]) ? Ya : void 0, o = (m) => m[r(n, m.length, s)], i = e.list || [], a = (m) => i[m], l = e.named || {};
  Ye(e.pluralIndex) && Vh(n, l);
  const c = (m) => l[m];
  function u(m, g) {
    const I = Ae(e.messages) ? e.messages(m, !!g) : Re(e.messages) ? e.messages[m] : !1;
    return I || (e.parent ? e.parent.message(m) : Fh);
  }
  const d = (m) => e.modifiers ? e.modifiers[m] : Mh, h = pe(e.processor) && Ae(e.processor.normalize) ? e.processor.normalize : jh, T = pe(e.processor) && Ae(e.processor.interpolate) ? e.processor.interpolate : Uh, O = pe(e.processor) && W(e.processor.type) ? e.processor.type : Gh, v = {
    list: a,
    named: c,
    plural: o,
    linked: (m, ...g) => {
      const [I, S] = g;
      let D = "text", G = "";
      g.length === 1 ? Re(I) ? (G = I.modifier || G, D = I.type || D) : W(I) && (G = I || G) : g.length === 2 && (W(I) && (G = I || G), W(S) && (D = S || D));
      const w = u(m, !0)(v), Y = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        D === "vnode" && At(w) && G ? w[0] : w
      );
      return G ? d(G)(Y, D) : Y;
    },
    message: u,
    type: O,
    interpolate: T,
    normalize: h,
    values: ln({}, i, l)
  };
  return v;
}
const qa = () => "", ot = (e) => Ae(e);
function Ja(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: s, messageCompiler: o, fallbackLocale: i, messages: a } = e, [l, c] = vo(...t), u = He(c.missingWarn) ? c.missingWarn : e.missingWarn, d = He(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, h = He(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, T = !!c.resolvedMessage, O = W(c.default) || He(c.default) ? He(c.default) ? o ? l : () => l : c.default : n ? o ? l : () => l : null, A = n || O != null && (W(O) || Ae(O)), v = Ai(e, c);
  h && Kh(c);
  let [m, g, I] = T ? [
    l,
    v,
    a[v] || {}
  ] : Ou(e, l, v, i, d, u), S = m, D = l;
  if (!T && !(W(S) || jn(S) || ot(S)) && A && (S = O, D = S), !T && (!(W(S) || jn(S) || ot(S)) || !W(g)))
    return s ? Is : l;
  let G = !1;
  const w = () => {
    G = !0;
  }, Y = ot(S) ? S : vu(e, l, g, S, D, w);
  if (G)
    return S;
  const J = Wh(e, g, I, c), fe = zh(J), ge = Bh(e, Y, fe), ce = r ? r(ge, l) : ge;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const Ge = {
      timestamp: Date.now(),
      key: W(l) ? l : ot(S) ? S.key : "",
      locale: g || (ot(S) ? S.locale : ""),
      format: W(S) ? S : ot(S) ? S.source : "",
      message: ce
    };
    Ge.meta = ln({}, e.__meta, /* @__PURE__ */ Dh() || {}), fh(Ge);
  }
  return ce;
}
function Kh(e) {
  At(e.list) ? e.list = e.list.map((t) => W(t) ? xa(t) : t) : Re(e.named) && Object.keys(e.named).forEach((t) => {
    W(e.named[t]) && (e.named[t] = xa(e.named[t]));
  });
}
function Ou(e, t, n, r, s, o) {
  const { messages: i, onWarn: a, messageResolver: l, localeFallbacker: c } = e, u = c(e, r, n);
  let d = {}, h, T = null;
  const O = "translate";
  for (let A = 0; A < u.length && (h = u[A], d = i[h] || {}, (T = l(d, t)) === null && (T = d[t]), !(W(T) || jn(T) || ot(T))); A++)
    if (!kh(h, u)) {
      const v = Ti(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        h,
        o,
        O
      );
      v !== t && (T = v);
    }
  return [T, h, d];
}
function vu(e, t, n, r, s, o) {
  const { messageCompiler: i, warnHtmlMessage: a } = e;
  if (ot(r)) {
    const c = r;
    return c.locale = c.locale || n, c.key = c.key || t, c;
  }
  if (i == null) {
    const c = () => r;
    return c.locale = n, c.key = t, c;
  }
  const l = i(r, $h(e, n, s, r, a, o));
  return l.locale = n, l.key = t, l.source = r, l;
}
function Bh(e, t, n) {
  return t(n);
}
function vo(...e) {
  const [t, n, r] = e, s = {};
  if (!W(t) && !Ye(t) && !ot(t) && !jn(t))
    throw jt(Gt.INVALID_ARGUMENT);
  const o = Ye(t) ? String(t) : (ot(t), t);
  return Ye(n) ? s.plural = n : W(n) ? s.default = n : pe(n) && !Oi(n) ? s.named = n : At(n) && (s.list = n), Ye(r) ? s.plural = r : W(r) ? s.default = r : pe(r) && ln(s, r), [o, s];
}
function $h(e, t, n, r, s, o) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (i) => {
      throw o && o(i), i;
    },
    onCacheKey: (i) => Tm(t, n, i)
  };
}
function Wh(e, t, n, r) {
  const { modifiers: s, pluralRules: o, messageResolver: i, fallbackLocale: a, fallbackWarn: l, missingWarn: c, fallbackContext: u } = e, h = {
    locale: t,
    modifiers: s,
    pluralRules: o,
    messages: (T, O) => {
      let A = i(n, T);
      if (A == null && (u || O)) {
        const [, , v] = Ou(
          u || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          T,
          t,
          a,
          l,
          c
        );
        A = i(v, T);
      }
      if (W(A) || jn(A)) {
        let v = !1;
        const g = vu(e, T, t, A, T, () => {
          v = !0;
        });
        return v ? qa : g;
      } else return ot(A) ? A : qa;
    }
  };
  return e.processor && (h.processor = e.processor), r.list && (h.list = r.list), r.named && (h.named = r.named), Ye(r.plural) && (h.pluralIndex = r.plural), h;
}
sh();
var Xh = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
const Yh = "10.0.1";
function qh() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fu().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const lt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ph,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function pt(e, ...t) {
  return vs(e, null, void 0);
}
const Io = /* @__PURE__ */ an("__translateVNode"), Ao = /* @__PURE__ */ an("__datetimeParts"), To = /* @__PURE__ */ an("__numberParts"), Jh = an("__setPluralRules"), Qh = /* @__PURE__ */ an("__injectWithOption"), No = /* @__PURE__ */ an("__dispose");
function gr(e) {
  if (!Qe(e))
    return e;
  for (const t in e)
    if (rs(e, t))
      if (!t.includes("."))
        Qe(e[t]) && gr(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let s = e, o = !1;
        for (let i = 0; i < r; i++) {
          if (n[i] in s || (s[n[i]] = {}), !Qe(s[n[i]])) {
            o = !0;
            break;
          }
          s = s[n[i]];
        }
        o || (s[n[r]] = e[t], delete e[t]), Qe(s[n[r]]) && gr(s[n[r]]);
      }
  return e;
}
function Iu(e, t) {
  const { messages: n, __i18n: r, messageResolver: s, flatJson: o } = t, i = ct(n) ? n : Ft(r) ? {} : { [e]: {} };
  if (Ft(r) && r.forEach((a) => {
    if ("locale" in a && "resource" in a) {
      const { locale: l, resource: c } = a;
      l ? (i[l] = i[l] || {}, zr(c, i[l])) : zr(c, i);
    } else
      Oe(a) && zr(JSON.parse(a), i);
  }), s == null && o)
    for (const a in i)
      rs(i, a) && gr(i[a]);
  return i;
}
function Au(e) {
  return e.type;
}
function Zh(e, t, n) {
  let r = Qe(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (r = Iu(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(r);
  s.length && s.forEach((o) => {
    e.mergeLocaleMessage(o, r[o]);
  });
  {
    if (Qe(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (Qe(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function Qa(e) {
  return we(Or, null, e, 0);
}
const Za = "__INTLIFY_META__", el = () => [], e_ = () => !1;
let tl = 0;
function nl(e) {
  return (t, n, r, s) => e(n, r, Ei() || void 0, s);
}
const t_ = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Ei();
  let t = null;
  return e && (t = Au(e)[Za]) ? { [Za]: t } : null;
};
function Tu(e = {}) {
  const { __root: t, __injectWithOption: n } = e, r = t === void 0, s = e.flatJson, o = ns ? Ur : Id;
  let i = Lt(e.inheritLocale) ? e.inheritLocale : !0;
  const a = o(
    // prettier-ignore
    t && i ? t.locale.value : Oe(e.locale) ? e.locale : ss
  ), l = o(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : Oe(e.fallbackLocale) || Ft(e.fallbackLocale) || ct(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a.value
  ), c = o(Iu(a.value, e)), u = o(ct(e.datetimeFormats) ? e.datetimeFormats : { [a.value]: {} }), d = o(ct(e.numberFormats) ? e.numberFormats : { [a.value]: {} });
  let h = t ? t.missingWarn : Lt(e.missingWarn) || Ra(e.missingWarn) ? e.missingWarn : !0, T = t ? t.fallbackWarn : Lt(e.fallbackWarn) || Ra(e.fallbackWarn) ? e.fallbackWarn : !0, O = t ? t.fallbackRoot : Lt(e.fallbackRoot) ? e.fallbackRoot : !0, A = !!e.fallbackFormat, v = kr(e.missing) ? e.missing : null, m = kr(e.missing) ? nl(e.missing) : null, g = kr(e.postTranslation) ? e.postTranslation : null, I = t ? t.warnHtmlMessage : Lt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, S = !!e.escapeParameter;
  const D = t ? t.modifiers : ct(e.modifiers) ? e.modifiers : {};
  let G = e.pluralRules || t && t.pluralRules, w;
  w = (() => {
    r && za(null);
    const E = {
      version: Yh,
      locale: a.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: D,
      pluralRules: G,
      missing: m === null ? void 0 : m,
      missingWarn: h,
      fallbackWarn: T,
      fallbackFormat: A,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: I,
      escapeParameter: S,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    E.datetimeFormats = u.value, E.numberFormats = d.value, E.__datetimeFormatters = ct(w) ? w.__datetimeFormatters : void 0, E.__numberFormatters = ct(w) ? w.__numberFormatters : void 0;
    const N = xh(E);
    return r && za(N), N;
  })(), Yn(w, a.value, l.value);
  function J() {
    return [
      a.value,
      l.value,
      c.value,
      u.value,
      d.value
    ];
  }
  const fe = Xe({
    get: () => a.value,
    set: (E) => {
      a.value = E, w.locale = a.value;
    }
  }), ge = Xe({
    get: () => l.value,
    set: (E) => {
      l.value = E, w.fallbackLocale = l.value, Yn(w, a.value, E);
    }
  }), ce = Xe(() => c.value), Ge = /* @__PURE__ */ Xe(() => u.value), Rt = /* @__PURE__ */ Xe(() => d.value);
  function ht() {
    return kr(g) ? g : null;
  }
  function he(E) {
    g = E, w.postTranslation = E;
  }
  function re() {
    return v;
  }
  function te(E) {
    E !== null && (m = nl(E)), v = E, w.missing = m;
  }
  const L = (E, N, H, K, Z, ee) => {
    J();
    let ye;
    try {
      Xh.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (w.fallbackContext = t ? wh() : void 0), ye = E(w);
    } finally {
      __INTLIFY_PROD_DEVTOOLS__, r || (w.fallbackContext = void 0);
    }
    if (H !== "translate exists" && // for not `te` (e.g `t`)
    hr(ye) && ye === Is || H === "translate exists" && !ye) {
      const [Te, rt] = N();
      return t && O ? K(t) : Z(Te);
    } else {
      if (ee(ye))
        return ye;
      throw pt(lt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function k(...E) {
    return L((N) => Reflect.apply(Ja, null, [N, ...E]), () => vo(...E), "translate", (N) => Reflect.apply(N.t, N, [...E]), (N) => N, (N) => Oe(N));
  }
  function U(...E) {
    const [N, H, K] = E;
    if (K && !Qe(K))
      throw pt(lt.INVALID_ARGUMENT);
    return k(N, H, It({ resolvedMessage: !0 }, K || {}));
  }
  function B(...E) {
    return L((N) => Reflect.apply(Ba, null, [N, ...E]), () => yo(...E), "datetime format", (N) => Reflect.apply(N.d, N, [...E]), () => Ha, (N) => Oe(N));
  }
  function z(...E) {
    return L((N) => Reflect.apply(Wa, null, [N, ...E]), () => Oo(...E), "number format", (N) => Reflect.apply(N.n, N, [...E]), () => Ha, (N) => Oe(N));
  }
  function Q(E) {
    return E.map((N) => Oe(N) || hr(N) || Lt(N) ? Qa(String(N)) : N);
  }
  const de = {
    normalize: Q,
    interpolate: (E) => E,
    type: "vnode"
  };
  function Ee(...E) {
    return L((N) => {
      let H;
      const K = N;
      try {
        K.processor = de, H = Reflect.apply(Ja, null, [K, ...E]);
      } finally {
        K.processor = null;
      }
      return H;
    }, () => vo(...E), "translate", (N) => N[Io](...E), (N) => [Qa(N)], (N) => Ft(N));
  }
  function _e(...E) {
    return L((N) => Reflect.apply(Wa, null, [N, ...E]), () => Oo(...E), "number format", (N) => N[To](...E), el, (N) => Oe(N) || Ft(N));
  }
  function _t(...E) {
    return L((N) => Reflect.apply(Ba, null, [N, ...E]), () => yo(...E), "datetime format", (N) => N[Ao](...E), el, (N) => Oe(N) || Ft(N));
  }
  function Le(E) {
    G = E, w.pluralRules = G;
  }
  function je(E, N) {
    return L(() => {
      if (!E)
        return !1;
      const H = Oe(N) ? N : a.value, K = b(H), Z = w.messageResolver(K, E);
      return jn(Z) || ot(Z) || Oe(Z);
    }, () => [E], "translate exists", (H) => Reflect.apply(H.te, H, [E, N]), e_, (H) => Lt(H));
  }
  function An(E) {
    let N = null;
    const H = mu(w, l.value, a.value);
    for (let K = 0; K < H.length; K++) {
      const Z = c.value[H[K]] || {}, ee = w.messageResolver(Z, E);
      if (ee != null) {
        N = ee;
        break;
      }
    }
    return N;
  }
  function _(E) {
    const N = An(E);
    return N ?? (t ? t.tm(E) || {} : {});
  }
  function b(E) {
    return c.value[E] || {};
  }
  function P(E, N) {
    if (s) {
      const H = { [E]: N };
      for (const K in H)
        rs(H, K) && gr(H[K]);
      N = H[E];
    }
    c.value[E] = N, w.messages = c.value;
  }
  function F(E, N) {
    c.value[E] = c.value[E] || {};
    const H = { [E]: N };
    if (s)
      for (const K in H)
        rs(H, K) && gr(H[K]);
    N = H[E], zr(N, c.value[E]), w.messages = c.value;
  }
  function M(E) {
    return u.value[E] || {};
  }
  function f(E, N) {
    u.value[E] = N, w.datetimeFormats = u.value, $a(w, E, N);
  }
  function p(E, N) {
    u.value[E] = It(u.value[E] || {}, N), w.datetimeFormats = u.value, $a(w, E, N);
  }
  function y(E) {
    return d.value[E] || {};
  }
  function C(E, N) {
    d.value[E] = N, w.numberFormats = d.value, Xa(w, E, N);
  }
  function x(E, N) {
    d.value[E] = It(d.value[E] || {}, N), w.numberFormats = d.value, Xa(w, E, N);
  }
  tl++, t && ns && (tn(t.locale, (E) => {
    i && (a.value = E, w.locale = E, Yn(w, a.value, l.value));
  }), tn(t.fallbackLocale, (E) => {
    i && (l.value = E, w.fallbackLocale = E, Yn(w, a.value, l.value));
  }));
  const j = {
    id: tl,
    locale: fe,
    fallbackLocale: ge,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(E) {
      i = E, E && t && (a.value = t.locale.value, l.value = t.fallbackLocale.value, Yn(w, a.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: ce,
    get modifiers() {
      return D;
    },
    get pluralRules() {
      return G || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(E) {
      h = E, w.missingWarn = h;
    },
    get fallbackWarn() {
      return T;
    },
    set fallbackWarn(E) {
      T = E, w.fallbackWarn = T;
    },
    get fallbackRoot() {
      return O;
    },
    set fallbackRoot(E) {
      O = E;
    },
    get fallbackFormat() {
      return A;
    },
    set fallbackFormat(E) {
      A = E, w.fallbackFormat = A;
    },
    get warnHtmlMessage() {
      return I;
    },
    set warnHtmlMessage(E) {
      I = E, w.warnHtmlMessage = E;
    },
    get escapeParameter() {
      return S;
    },
    set escapeParameter(E) {
      S = E, w.escapeParameter = E;
    },
    t: k,
    getLocaleMessage: b,
    setLocaleMessage: P,
    mergeLocaleMessage: F,
    getPostTranslationHandler: ht,
    setPostTranslationHandler: he,
    getMissingHandler: re,
    setMissingHandler: te,
    [Jh]: Le
  };
  return j.datetimeFormats = Ge, j.numberFormats = Rt, j.rt = U, j.te = je, j.tm = _, j.d = B, j.n = z, j.getDateTimeFormat = M, j.setDateTimeFormat = f, j.mergeDateTimeFormat = p, j.getNumberFormat = y, j.setNumberFormat = C, j.mergeNumberFormat = x, j[Qh] = n, j[Io] = Ee, j[Ao] = _t, j[To] = _e, j;
}
const Ni = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function n_({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, s) => [
    ...r,
    // prettier-ignore
    ...s.type === st ? s.children : [s]
  ], []) : t.reduce((n, r) => {
    const s = e[r];
    return s && (n[r] = s()), n;
  }, {});
}
function Nu() {
  return st;
}
const r_ = /* @__PURE__ */ In({
  /* eslint-disable */
  name: "i18n-t",
  props: It({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      validator: (e) => hr(e) || !isNaN(e)
    }
  }, Ni),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, s = e.i18n || As({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const o = Object.keys(n).filter((d) => d !== "_"), i = {};
      e.locale && (i.locale = e.locale), e.plural !== void 0 && (i.plural = Oe(e.plural) ? +e.plural : e.plural);
      const a = n_(t, o), l = s[Io](e.keypath, a, i), c = It({}, r), u = Oe(e.tag) || Qe(e.tag) ? e.tag : Nu();
      return Si(u, c, l);
    };
  }
}), rl = r_;
function s_(e) {
  return Ft(e) && !Oe(e[0]);
}
function Cu(e, t, n, r) {
  const { slots: s, attrs: o } = t;
  return () => {
    const i = { part: !0 };
    let a = {};
    e.locale && (i.locale = e.locale), Oe(e.format) ? i.key = e.format : Qe(e.format) && (Oe(e.format.key) && (i.key = e.format.key), a = Object.keys(e.format).reduce((h, T) => n.includes(T) ? It({}, h, { [T]: e.format[T] }) : h, {}));
    const l = r(e.value, i, a);
    let c = [i.key];
    Ft(l) ? c = l.map((h, T) => {
      const O = s[h.type], A = O ? O({ [h.type]: h.value, index: T, parts: l }) : [h.value];
      return s_(A) && (A[0].key = `${h.type}-${T}`), A;
    }) : Oe(l) && (c = [l]);
    const u = It({}, o), d = Oe(e.tag) || Qe(e.tag) ? e.tag : Nu();
    return Si(d, u, c);
  };
}
const o_ = /* @__PURE__ */ In({
  /* eslint-disable */
  name: "i18n-n",
  props: It({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Ni),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || As({
      useScope: e.scope,
      __useComponent: !0
    });
    return Cu(e, t, yu, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[To](...r)
    ));
  }
}), sl = o_, i_ = /* @__PURE__ */ In({
  /* eslint-disable */
  name: "i18n-d",
  props: It({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Ni),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || As({
      useScope: e.scope,
      __useComponent: !0
    });
    return Cu(e, t, Su, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[Ao](...r)
    ));
  }
}), ol = i_;
function a_(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function l_(e) {
  const t = (i) => {
    const { instance: a, value: l } = i;
    if (!a || !a.$)
      throw pt(lt.UNEXPECTED_ERROR);
    const c = a_(e, a.$), u = il(l);
    return [
      Reflect.apply(c.t, c, [...al(u)]),
      c
    ];
  };
  return {
    created: (i, a) => {
      const [l, c] = t(a);
      ns && e.global === c && (i.__i18nWatcher = tn(c.locale, () => {
        a.instance && a.instance.$forceUpdate();
      })), i.__composer = c, i.textContent = l;
    },
    unmounted: (i) => {
      ns && i.__i18nWatcher && (i.__i18nWatcher(), i.__i18nWatcher = void 0, delete i.__i18nWatcher), i.__composer && (i.__composer = void 0, delete i.__composer);
    },
    beforeUpdate: (i, { value: a }) => {
      if (i.__composer) {
        const l = i.__composer, c = il(a);
        i.textContent = Reflect.apply(l.t, l, [
          ...al(c)
        ]);
      }
    },
    getSSRProps: (i) => {
      const [a] = t(i);
      return { textContent: a };
    }
  };
}
function il(e) {
  if (Oe(e))
    return { path: e };
  if (ct(e)) {
    if (!("path" in e))
      throw pt(lt.REQUIRED_VALUE, "path");
    return e;
  } else
    throw pt(lt.INVALID_VALUE);
}
function al(e) {
  const { path: t, locale: n, args: r, choice: s, plural: o } = e, i = {}, a = r || {};
  return Oe(n) && (i.locale = n), hr(s) && (i.plural = s), hr(o) && (i.plural = o), [t, a, i];
}
function c_(e, t, ...n) {
  const r = ct(n[0]) ? n[0] : {};
  (Lt(r.globalInstall) ? r.globalInstall : !0) && ([rl.name, "I18nT"].forEach((o) => e.component(o, rl)), [sl.name, "I18nN"].forEach((o) => e.component(o, sl)), [ol.name, "I18nD"].forEach((o) => e.component(o, ol))), e.directive("t", l_(t));
}
const Ru = /* @__PURE__ */ an("global-vue-i18n");
function u_(e = {}, t) {
  const n = Lt(e.globalInjection) ? e.globalInjection : !0, r = /* @__PURE__ */ new Map(), [s, o] = f_(e), i = /* @__PURE__ */ an("");
  function a(d) {
    return r.get(d) || null;
  }
  function l(d, h) {
    r.set(d, h);
  }
  function c(d) {
    r.delete(d);
  }
  const u = {
    // mode
    get mode() {
      return "composition";
    },
    // install plugin
    async install(d, ...h) {
      if (d.__VUE_I18N_SYMBOL__ = i, d.provide(d.__VUE_I18N_SYMBOL__, u), ct(h[0])) {
        const A = h[0];
        u.__composerExtend = A.__composerExtend, u.__vueI18nExtend = A.__vueI18nExtend;
      }
      let T = null;
      n && (T = E_(d, u.global)), c_(d, u, ...h);
      const O = d.unmount;
      d.unmount = () => {
        T && T(), u.dispose(), O();
      };
    },
    // global accessor
    get global() {
      return o;
    },
    dispose() {
      s.stop();
    },
    // @internal
    __instances: r,
    // @internal
    __getInstance: a,
    // @internal
    __setInstance: l,
    // @internal
    __deleteInstance: c
  };
  return u;
}
function As(e = {}) {
  const t = Ei();
  if (t == null)
    throw pt(lt.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw pt(lt.NOT_INSTALLED);
  const n = d_(t), r = m_(n), s = Au(t), o = p_(e, s);
  if (o === "global")
    return Zh(r, e, s), r;
  if (o === "parent") {
    let l = h_(n, t, e.__useComponent);
    return l == null && (l = r), l;
  }
  const i = n;
  let a = i.__getInstance(t);
  if (a == null) {
    const l = It({}, e);
    "__i18n" in s && (l.__i18n = s.__i18n), r && (l.__root = r), a = Tu(l), i.__composerExtend && (a[No] = i.__composerExtend(a)), g_(i, t, a), i.__setInstance(t, a);
  }
  return a;
}
function f_(e, t, n) {
  const r = Zf(), s = r.run(() => Tu(e));
  if (s == null)
    throw pt(lt.UNEXPECTED_ERROR);
  return [r, s];
}
function d_(e) {
  const t = ir(e.isCE ? Ru : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw pt(e.isCE ? lt.NOT_INSTALLED_WITH_PROVIDE : lt.UNEXPECTED_ERROR);
  return t;
}
function p_(e, t) {
  return Om(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function m_(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function h_(e, t, n = !1) {
  let r = null;
  const s = t.root;
  let o = __(t, n);
  for (; o != null; ) {
    const i = e;
    if (e.mode === "composition" && (r = i.__getInstance(o)), r != null || s === o)
      break;
    o = o.parent;
  }
  return r;
}
function __(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function g_(e, t, n) {
  mi(() => {
  }, t), hi(() => {
    const r = n;
    e.__deleteInstance(t);
    const s = r[No];
    s && (s(), delete r[No]);
  }, t);
}
const b_ = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], ll = ["t", "rt", "d", "n", "tm", "te"];
function E_(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return b_.forEach((s) => {
    const o = Object.getOwnPropertyDescriptor(t, s);
    if (!o)
      throw pt(lt.UNEXPECTED_ERROR);
    const i = Pe(o.value) ? {
      get() {
        return o.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(a) {
        o.value.value = a;
      }
    } : {
      get() {
        return o.get && o.get();
      }
    };
    Object.defineProperty(n, s, i);
  }), e.config.globalProperties.$i18n = n, ll.forEach((s) => {
    const o = Object.getOwnPropertyDescriptor(t, s);
    if (!o || !o.value)
      throw pt(lt.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${s}`, o);
  }), () => {
    delete e.config.globalProperties.$i18n, ll.forEach((s) => {
      delete e.config.globalProperties[`$${s}`];
    });
  };
}
qh();
Nh(lh);
Ch(Ih);
Rh(mu);
if (__INTLIFY_PROD_DEVTOOLS__) {
  const e = fu();
  e.__INTLIFY__ = !0, ch(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
const Pu = u_({
  legacy: !1,
  locale: window.navigator.language,
  fallbackLocale: "en",
  messages: {
    en: Na,
    "en-US": Na,
    fr: Ca,
    "fr-FR": Ca
  }
}), S_ = ["show", "change-etab-api", "user-info-api-url"], y_ = /* @__PURE__ */ In({
  __name: "I18nHost.ce",
  props: {
    show: { type: Boolean },
    changeEtabApi: { type: String },
    userInfoApiUrl: { type: String }
  },
  setup(e) {
    return Uc(Ru, Pu), (t, n) => (kn(), lr("page-change-etab", {
      show: t.show,
      "change-etab-api": t.changeEtabApi,
      "user-info-api-url": t.userInfoApiUrl
    }, null, 8, S_));
  }
});
function Co(e) {
  this.message = e;
}
Co.prototype = new Error(), Co.prototype.name = "InvalidCharacterError";
var cl = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new Co("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n, r, s = 0, o = 0, i = ""; r = t.charAt(o++); ~r && (n = s % 4 ? 64 * n + r : r, s++ % 4) ? i += String.fromCharCode(255 & n >> (-2 * s & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
  return i;
};
function O_(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(n) {
      return decodeURIComponent(cl(n).replace(/(.)/g, function(r, s) {
        var o = s.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      }));
    }(t);
  } catch {
    return cl(t);
  }
}
function os(e) {
  this.message = e;
}
function v_(e, t) {
  if (typeof e != "string") throw new os("Invalid token specified");
  var n = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(O_(e.split(".")[n]));
  } catch (r) {
    throw new os("Invalid token specified: " + r.message);
  }
}
os.prototype = new Error(), os.prototype.name = "InvalidTokenError";
function ul(e, t, n, r, s, o, i) {
  try {
    var a = e[o](i), l = a.value;
  } catch (c) {
    n(c);
    return;
  }
  a.done ? t(l) : Promise.resolve(l).then(r, s);
}
function I_(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, s) {
      var o = e.apply(t, n);
      function i(l) {
        ul(o, r, s, i, a, "next", l);
      }
      function a(l) {
        ul(o, r, s, i, a, "throw", l);
      }
      i(void 0);
    });
  };
}
function A_(e, t) {
  return T_(e) || N_(e, t) || C_(e, t) || R_();
}
function T_(e) {
  if (Array.isArray(e)) return e;
}
function N_(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], s = !0, o = !1, i, a;
    try {
      for (n = n.call(e); !(s = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); s = !0)
        ;
    } catch (l) {
      o = !0, a = l;
    } finally {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (o) throw a;
      }
    }
    return r;
  }
}
function C_(e, t) {
  if (e) {
    if (typeof e == "string") return fl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fl(e, t);
  }
}
function fl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function R_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function P_() {
  return Ro.apply(this, arguments);
}
function Ro() {
  return Ro = I_(/* @__PURE__ */ regeneratorRuntime.mark(function e() {
    var t, n, r, s, o, i, a, l, c, u = arguments;
    return regeneratorRuntime.wrap(function(h) {
      for (; ; )
        switch (h.prev = h.next) {
          case 0:
            return t = u.length > 0 && u[0] !== void 0 ? u[0] : {}, n = t.userInfoApiUrl, r = n === void 0 ? "/uPortal/api/v5-1/userinfo" : n, s = t.propertyTransforms, o = s === void 0 ? {} : s, i = u.length > 1 ? u[1] : void 0, h.prev = 2, h.next = 5, fetch(r, {
              method: "GET",
              credentials: "include"
            });
          case 5:
            if (a = h.sent, a.ok) {
              h.next = 8;
              break;
            }
            throw new Error(a.statusText);
          case 8:
            return h.next = 10, a.text();
          case 10:
            if (l = h.sent, c = D_(l), Object.entries(o).forEach(function(T) {
              var O = A_(T, 2), A = O[0], v = O[1];
              c.decoded[A] = v(c.decoded[A]);
            }), !i) {
              h.next = 15;
              break;
            }
            return h.abrupt("return", i(null, c));
          case 15:
            return h.abrupt("return", c);
          case 18:
            if (h.prev = 18, h.t0 = h.catch(2), console.error(h.t0), !i) {
              h.next = 23;
              break;
            }
            return h.abrupt("return", i(h.t0));
          case 23:
            throw h.t0;
          case 24:
          case "end":
            return h.stop();
        }
    }, e, null, [[2, 18]]);
  })), Ro.apply(this, arguments);
}
function D_(e) {
  return {
    encoded: e,
    decoded: v_(e)
  };
}
function Du(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: w_ } = Object.prototype, { getPrototypeOf: Ci } = Object, Ts = /* @__PURE__ */ ((e) => (t) => {
  const n = w_.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), mt = (e) => (e = e.toLowerCase(), (t) => Ts(t) === e), Ns = (e) => (t) => typeof t === e, { isArray: zn } = Array, br = Ns("undefined");
function x_(e) {
  return e !== null && !br(e) && e.constructor !== null && !br(e.constructor) && Ze(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const wu = mt("ArrayBuffer");
function L_(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && wu(e.buffer), t;
}
const k_ = Ns("string"), Ze = Ns("function"), xu = Ns("number"), Cs = (e) => e !== null && typeof e == "object", M_ = (e) => e === !0 || e === !1, Kr = (e) => {
  if (Ts(e) !== "object")
    return !1;
  const t = Ci(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, F_ = mt("Date"), G_ = mt("File"), j_ = mt("Blob"), U_ = mt("FileList"), H_ = (e) => Cs(e) && Ze(e.pipe), V_ = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ze(e.append) && ((t = Ts(e)) === "formdata" || // detect form-data instance
  t === "object" && Ze(e.toString) && e.toString() === "[object FormData]"));
}, z_ = mt("URLSearchParams"), [K_, B_, $_, W_] = ["ReadableStream", "Request", "Response", "Headers"].map(mt), X_ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ir(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), zn(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let a;
    for (r = 0; r < i; r++)
      a = o[r], t.call(null, e[a], a, e);
  }
}
function Lu(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const mn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ku = (e) => !br(e) && e !== mn;
function Po() {
  const { caseless: e } = ku(this) && this || {}, t = {}, n = (r, s) => {
    const o = e && Lu(t, s) || s;
    Kr(t[o]) && Kr(r) ? t[o] = Po(t[o], r) : Kr(r) ? t[o] = Po({}, r) : zn(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Ir(arguments[r], n);
  return t;
}
const Y_ = (e, t, n, { allOwnKeys: r } = {}) => (Ir(t, (s, o) => {
  n && Ze(s) ? e[o] = Du(s, n) : e[o] = s;
}, { allOwnKeys: r }), e), q_ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), J_ = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Q_ = (e, t, n, r) => {
  let s, o, i;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      i = s[o], (!r || r(i, e, t)) && !a[i] && (t[i] = e[i], a[i] = !0);
    e = n !== !1 && Ci(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Z_ = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, eg = (e) => {
  if (!e) return null;
  if (zn(e)) return e;
  let t = e.length;
  if (!xu(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, tg = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Ci(Uint8Array)), ng = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, rg = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, sg = mt("HTMLFormElement"), og = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), dl = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), ig = mt("RegExp"), Mu = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Ir(n, (s, o) => {
    let i;
    (i = t(s, o, e)) !== !1 && (r[o] = i || s);
  }), Object.defineProperties(e, r);
}, ag = (e) => {
  Mu(e, (t, n) => {
    if (Ze(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Ze(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, lg = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((o) => {
      n[o] = !0;
    });
  };
  return zn(e) ? r(e) : r(String(e).split(t)), n;
}, cg = () => {
}, ug = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, qs = "abcdefghijklmnopqrstuvwxyz", pl = "0123456789", Fu = {
  DIGIT: pl,
  ALPHA: qs,
  ALPHA_DIGIT: qs + qs.toUpperCase() + pl
}, fg = (e = 16, t = Fu.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function dg(e) {
  return !!(e && Ze(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const pg = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (Cs(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const o = zn(r) ? [] : {};
        return Ir(r, (i, a) => {
          const l = n(i, s + 1);
          !br(l) && (o[a] = l);
        }), t[s] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, mg = mt("AsyncFunction"), hg = (e) => e && (Cs(e) || Ze(e)) && Ze(e.then) && Ze(e.catch), Gu = ((e, t) => e ? setImmediate : t ? ((n, r) => (mn.addEventListener("message", ({ source: s, data: o }) => {
  s === mn && o === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), mn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Ze(mn.postMessage)
), _g = typeof queueMicrotask < "u" ? queueMicrotask.bind(mn) : typeof process < "u" && process.nextTick || Gu, R = {
  isArray: zn,
  isArrayBuffer: wu,
  isBuffer: x_,
  isFormData: V_,
  isArrayBufferView: L_,
  isString: k_,
  isNumber: xu,
  isBoolean: M_,
  isObject: Cs,
  isPlainObject: Kr,
  isReadableStream: K_,
  isRequest: B_,
  isResponse: $_,
  isHeaders: W_,
  isUndefined: br,
  isDate: F_,
  isFile: G_,
  isBlob: j_,
  isRegExp: ig,
  isFunction: Ze,
  isStream: H_,
  isURLSearchParams: z_,
  isTypedArray: tg,
  isFileList: U_,
  forEach: Ir,
  merge: Po,
  extend: Y_,
  trim: X_,
  stripBOM: q_,
  inherits: J_,
  toFlatObject: Q_,
  kindOf: Ts,
  kindOfTest: mt,
  endsWith: Z_,
  toArray: eg,
  forEachEntry: ng,
  matchAll: rg,
  isHTMLForm: sg,
  hasOwnProperty: dl,
  hasOwnProp: dl,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Mu,
  freezeMethods: ag,
  toObjectSet: lg,
  toCamelCase: og,
  noop: cg,
  toFiniteNumber: ug,
  findKey: Lu,
  global: mn,
  isContextDefined: ku,
  ALPHABET: Fu,
  generateString: fg,
  isSpecCompliantForm: dg,
  toJSONObject: pg,
  isAsyncFn: mg,
  isThenable: hg,
  setImmediate: Gu,
  asap: _g
};
function q(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
R.inherits(q, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: R.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const ju = q.prototype, Uu = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Uu[e] = { value: e };
});
Object.defineProperties(q, Uu);
Object.defineProperty(ju, "isAxiosError", { value: !0 });
q.from = (e, t, n, r, s, o) => {
  const i = Object.create(ju);
  return R.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), q.call(i, e.message, t, n, r, s), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
};
const gg = null;
function Do(e) {
  return R.isPlainObject(e) || R.isArray(e);
}
function Hu(e) {
  return R.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ml(e, t, n) {
  return e ? e.concat(t).map(function(s, o) {
    return s = Hu(s), !n && o ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function bg(e) {
  return R.isArray(e) && !e.some(Do);
}
const Eg = R.toFlatObject(R, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Rs(e, t, n) {
  if (!R.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = R.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(A, v) {
    return !R.isUndefined(v[A]);
  });
  const r = n.metaTokens, s = n.visitor || u, o = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && R.isSpecCompliantForm(t);
  if (!R.isFunction(s))
    throw new TypeError("visitor must be a function");
  function c(O) {
    if (O === null) return "";
    if (R.isDate(O))
      return O.toISOString();
    if (!l && R.isBlob(O))
      throw new q("Blob is not supported. Use a Buffer instead.");
    return R.isArrayBuffer(O) || R.isTypedArray(O) ? l && typeof Blob == "function" ? new Blob([O]) : Buffer.from(O) : O;
  }
  function u(O, A, v) {
    let m = O;
    if (O && !v && typeof O == "object") {
      if (R.endsWith(A, "{}"))
        A = r ? A : A.slice(0, -2), O = JSON.stringify(O);
      else if (R.isArray(O) && bg(O) || (R.isFileList(O) || R.endsWith(A, "[]")) && (m = R.toArray(O)))
        return A = Hu(A), m.forEach(function(I, S) {
          !(R.isUndefined(I) || I === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? ml([A], S, o) : i === null ? A : A + "[]",
            c(I)
          );
        }), !1;
    }
    return Do(O) ? !0 : (t.append(ml(v, A, o), c(O)), !1);
  }
  const d = [], h = Object.assign(Eg, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Do
  });
  function T(O, A) {
    if (!R.isUndefined(O)) {
      if (d.indexOf(O) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      d.push(O), R.forEach(O, function(m, g) {
        (!(R.isUndefined(m) || m === null) && s.call(
          t,
          m,
          R.isString(g) ? g.trim() : g,
          A,
          h
        )) === !0 && T(m, A ? A.concat(g) : [g]);
      }), d.pop();
    }
  }
  if (!R.isObject(e))
    throw new TypeError("data must be an object");
  return T(e), t;
}
function hl(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Ri(e, t) {
  this._pairs = [], e && Rs(e, this, t);
}
const Vu = Ri.prototype;
Vu.append = function(t, n) {
  this._pairs.push([t, n]);
};
Vu.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, hl);
  } : hl;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function Sg(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function zu(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Sg, s = n && n.serialize;
  let o;
  if (s ? o = s(t, n) : o = R.isURLSearchParams(t) ? t.toString() : new Ri(t, n).toString(r), o) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class _l {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    R.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Ku = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, yg = typeof URLSearchParams < "u" ? URLSearchParams : Ri, Og = typeof FormData < "u" ? FormData : null, vg = typeof Blob < "u" ? Blob : null, Ig = {
  isBrowser: !0,
  classes: {
    URLSearchParams: yg,
    FormData: Og,
    Blob: vg
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Pi = typeof window < "u" && typeof document < "u", wo = typeof navigator == "object" && navigator || void 0, Ag = Pi && (!wo || ["ReactNative", "NativeScript", "NS"].indexOf(wo.product) < 0), Tg = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Ng = Pi && window.location.href || "http://localhost", Cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Pi,
  hasStandardBrowserEnv: Ag,
  hasStandardBrowserWebWorkerEnv: Tg,
  navigator: wo,
  origin: Ng
}, Symbol.toStringTag, { value: "Module" })), Ve = {
  ...Cg,
  ...Ig
};
function Rg(e, t) {
  return Rs(e, new Ve.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, o) {
      return Ve.isNode && R.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Pg(e) {
  return R.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Dg(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let o;
  for (r = 0; r < s; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function Bu(e) {
  function t(n, r, s, o) {
    let i = n[o++];
    if (i === "__proto__") return !0;
    const a = Number.isFinite(+i), l = o >= n.length;
    return i = !i && R.isArray(s) ? s.length : i, l ? (R.hasOwnProp(s, i) ? s[i] = [s[i], r] : s[i] = r, !a) : ((!s[i] || !R.isObject(s[i])) && (s[i] = []), t(n, r, s[i], o) && R.isArray(s[i]) && (s[i] = Dg(s[i])), !a);
  }
  if (R.isFormData(e) && R.isFunction(e.entries)) {
    const n = {};
    return R.forEachEntry(e, (r, s) => {
      t(Pg(r), s, n, 0);
    }), n;
  }
  return null;
}
function wg(e, t, n) {
  if (R.isString(e))
    try {
      return (t || JSON.parse)(e), R.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const Ar = {
  transitional: Ku,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, o = R.isObject(t);
    if (o && R.isHTMLForm(t) && (t = new FormData(t)), R.isFormData(t))
      return s ? JSON.stringify(Bu(t)) : t;
    if (R.isArrayBuffer(t) || R.isBuffer(t) || R.isStream(t) || R.isFile(t) || R.isBlob(t) || R.isReadableStream(t))
      return t;
    if (R.isArrayBufferView(t))
      return t.buffer;
    if (R.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Rg(t, this.formSerializer).toString();
      if ((a = R.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Rs(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || s ? (n.setContentType("application/json", !1), wg(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ar.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (R.isResponse(t) || R.isReadableStream(t))
      return t;
    if (t && R.isString(t) && (r && !this.responseType || s)) {
      const i = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (i)
          throw a.name === "SyntaxError" ? q.from(a, q.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ve.classes.FormData,
    Blob: Ve.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
R.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ar.headers[e] = {};
});
const xg = R.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Lg = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(i) {
    s = i.indexOf(":"), n = i.substring(0, s).trim().toLowerCase(), r = i.substring(s + 1).trim(), !(!n || t[n] && xg[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, gl = Symbol("internals");
function qn(e) {
  return e && String(e).trim().toLowerCase();
}
function Br(e) {
  return e === !1 || e == null ? e : R.isArray(e) ? e.map(Br) : String(e);
}
function kg(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Mg = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Js(e, t, n, r, s) {
  if (R.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!R.isString(t)) {
    if (R.isString(r))
      return t.indexOf(r) !== -1;
    if (R.isRegExp(r))
      return r.test(t);
  }
}
function Fg(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Gg(e, t) {
  const n = R.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, o, i) {
        return this[r].call(this, t, s, o, i);
      },
      configurable: !0
    });
  });
}
class ze {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function o(a, l, c) {
      const u = qn(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = R.findKey(s, u);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || l] = Br(a));
    }
    const i = (a, l) => R.forEach(a, (c, u) => o(c, u, l));
    if (R.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (R.isString(t) && (t = t.trim()) && !Mg(t))
      i(Lg(t), n);
    else if (R.isHeaders(t))
      for (const [a, l] of t.entries())
        o(l, a, r);
    else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = qn(t), t) {
      const r = R.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return kg(s);
        if (R.isFunction(n))
          return n.call(this, s, r);
        if (R.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = qn(t), t) {
      const r = R.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Js(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function o(i) {
      if (i = qn(i), i) {
        const a = R.findKey(r, i);
        a && (!n || Js(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return R.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Js(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return R.forEach(this, (s, o) => {
      const i = R.findKey(r, o);
      if (i) {
        n[i] = Br(s), delete n[o];
        return;
      }
      const a = t ? Fg(o) : String(o).trim();
      a !== o && delete n[o], n[a] = Br(s), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return R.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && R.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[gl] = this[gl] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(i) {
      const a = qn(i);
      r[a] || (Gg(s, i), r[a] = !0);
    }
    return R.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
R.reduceDescriptors(ze.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
R.freezeMethods(ze);
function Qs(e, t) {
  const n = this || Ar, r = t || n, s = ze.from(r.headers);
  let o = r.data;
  return R.forEach(e, function(a) {
    o = a.call(n, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function $u(e) {
  return !!(e && e.__CANCEL__);
}
function Kn(e, t, n) {
  q.call(this, e ?? "canceled", q.ERR_CANCELED, t, n), this.name = "CanceledError";
}
R.inherits(Kn, q, {
  __CANCEL__: !0
});
function Wu(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new q(
    "Request failed with status code " + n.status,
    [q.ERR_BAD_REQUEST, q.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function jg(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Ug(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[o];
    i || (i = c), n[s] = l, r[s] = c;
    let d = o, h = 0;
    for (; d !== s; )
      h += n[d++], d = d % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), c - i < t)
      return;
    const T = u && c - u;
    return T ? Math.round(h * 1e3 / T) : void 0;
  };
}
function Hg(e, t) {
  let n = 0, r = 1e3 / t, s, o;
  const i = (c, u = Date.now()) => {
    n = u, s = null, o && (clearTimeout(o), o = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? i(c, u) : (s = c, o || (o = setTimeout(() => {
      o = null, i(s);
    }, r - d)));
  }, () => s && i(s)];
}
const is = (e, t, n = 3) => {
  let r = 0;
  const s = Ug(50, 250);
  return Hg((o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, l = i - r, c = s(l), u = i <= a;
    r = i;
    const d = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && a && u ? (a - i) / c : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, bl = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, El = (e) => (...t) => R.asap(() => e(...t)), Vg = Ve.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = Ve.navigator && /(msie|trident)/i.test(Ve.navigator.userAgent), n = document.createElement("a");
    let r;
    function s(o) {
      let i = o;
      return t && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = s(window.location.href), function(i) {
      const a = R.isString(i) ? s(i) : i;
      return a.protocol === r.protocol && a.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), zg = Ve.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, o) {
      const i = [e + "=" + encodeURIComponent(t)];
      R.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), R.isString(r) && i.push("path=" + r), R.isString(s) && i.push("domain=" + s), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Kg(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Bg(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Xu(e, t) {
  return e && !Kg(t) ? Bg(e, t) : t;
}
const Sl = (e) => e instanceof ze ? { ...e } : e;
function yn(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return R.isPlainObject(c) && R.isPlainObject(u) ? R.merge.call({ caseless: d }, c, u) : R.isPlainObject(u) ? R.merge({}, u) : R.isArray(u) ? u.slice() : u;
  }
  function s(c, u, d) {
    if (R.isUndefined(u)) {
      if (!R.isUndefined(c))
        return r(void 0, c, d);
    } else return r(c, u, d);
  }
  function o(c, u) {
    if (!R.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (R.isUndefined(u)) {
      if (!R.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function a(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: a,
    headers: (c, u) => s(Sl(c), Sl(u), !0)
  };
  return R.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || s, h = d(e[u], t[u], u);
    R.isUndefined(h) && d !== a || (n[u] = h);
  }), n;
}
const Yu = (e) => {
  const t = yn({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: a } = t;
  t.headers = i = ze.from(i), t.url = zu(Xu(t.baseURL, t.url), e.params, e.paramsSerializer), a && i.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (R.isFormData(n)) {
    if (Ve.hasStandardBrowserEnv || Ve.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Ve.hasStandardBrowserEnv && (r && R.isFunction(r) && (r = r(t)), r || r !== !1 && Vg(t.url))) {
    const c = s && o && zg.read(o);
    c && i.set(s, c);
  }
  return t;
}, $g = typeof XMLHttpRequest < "u", Wg = $g && function(e) {
  return new Promise(function(n, r) {
    const s = Yu(e);
    let o = s.data;
    const i = ze.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: c } = s, u, d, h, T, O;
    function A() {
      T && T(), O && O(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let v = new XMLHttpRequest();
    v.open(s.method.toUpperCase(), s.url, !0), v.timeout = s.timeout;
    function m() {
      if (!v)
        return;
      const I = ze.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), D = {
        data: !a || a === "text" || a === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: I,
        config: e,
        request: v
      };
      Wu(function(w) {
        n(w), A();
      }, function(w) {
        r(w), A();
      }, D), v = null;
    }
    "onloadend" in v ? v.onloadend = m : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(m);
    }, v.onabort = function() {
      v && (r(new q("Request aborted", q.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function() {
      r(new q("Network Error", q.ERR_NETWORK, e, v)), v = null;
    }, v.ontimeout = function() {
      let S = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const D = s.transitional || Ku;
      s.timeoutErrorMessage && (S = s.timeoutErrorMessage), r(new q(
        S,
        D.clarifyTimeoutError ? q.ETIMEDOUT : q.ECONNABORTED,
        e,
        v
      )), v = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in v && R.forEach(i.toJSON(), function(S, D) {
      v.setRequestHeader(D, S);
    }), R.isUndefined(s.withCredentials) || (v.withCredentials = !!s.withCredentials), a && a !== "json" && (v.responseType = s.responseType), c && ([h, O] = is(c, !0), v.addEventListener("progress", h)), l && v.upload && ([d, T] = is(l), v.upload.addEventListener("progress", d), v.upload.addEventListener("loadend", T)), (s.cancelToken || s.signal) && (u = (I) => {
      v && (r(!I || I.type ? new Kn(null, e, v) : I), v.abort(), v = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const g = jg(s.url);
    if (g && Ve.protocols.indexOf(g) === -1) {
      r(new q("Unsupported protocol " + g + ":", q.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, Xg = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const o = function(c) {
      if (!s) {
        s = !0, a();
        const u = c instanceof Error ? c : this.reason;
        r.abort(u instanceof q ? u : new Kn(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, o(new q(`timeout ${t} of ms exceeded`, q.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", o));
    const { signal: l } = r;
    return l.unsubscribe = () => R.asap(a), l;
  }
}, Yg = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, qg = async function* (e, t) {
  for await (const n of Jg(e))
    yield* Yg(n, t);
}, Jg = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, yl = (e, t, n, r) => {
  const s = qg(e, t);
  let o = 0, i, a = (l) => {
    i || (i = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await s.next();
        if (c) {
          a(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let h = o += d;
          n(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(l) {
      return a(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ps = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", qu = Ps && typeof ReadableStream == "function", Qg = Ps && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Ju = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Zg = qu && Ju(() => {
  let e = !1;
  const t = new Request(Ve.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Ol = 64 * 1024, xo = qu && Ju(() => R.isReadableStream(new Response("").body)), as = {
  stream: xo && ((e) => e.body)
};
Ps && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !as[t] && (as[t] = R.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new q(`Response type '${t}' is not supported`, q.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const e0 = async (e) => {
  if (e == null)
    return 0;
  if (R.isBlob(e))
    return e.size;
  if (R.isSpecCompliantForm(e))
    return (await new Request(Ve.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (R.isArrayBufferView(e) || R.isArrayBuffer(e))
    return e.byteLength;
  if (R.isURLSearchParams(e) && (e = e + ""), R.isString(e))
    return (await Qg(e)).byteLength;
}, t0 = async (e, t) => {
  const n = R.toFiniteNumber(e.getContentLength());
  return n ?? e0(t);
}, n0 = Ps && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: s,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: h
  } = Yu(e);
  c = c ? (c + "").toLowerCase() : "text";
  let T = Xg([s, o && o.toAbortSignal()], i), O;
  const A = T && T.unsubscribe && (() => {
    T.unsubscribe();
  });
  let v;
  try {
    if (l && Zg && n !== "get" && n !== "head" && (v = await t0(u, r)) !== 0) {
      let D = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), G;
      if (R.isFormData(r) && (G = D.headers.get("content-type")) && u.setContentType(G), D.body) {
        const [w, Y] = bl(
          v,
          is(El(l))
        );
        r = yl(D.body, Ol, w, Y);
      }
    }
    R.isString(d) || (d = d ? "include" : "omit");
    const m = "credentials" in Request.prototype;
    O = new Request(t, {
      ...h,
      signal: T,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: m ? d : void 0
    });
    let g = await fetch(O);
    const I = xo && (c === "stream" || c === "response");
    if (xo && (a || I && A)) {
      const D = {};
      ["status", "statusText", "headers"].forEach((J) => {
        D[J] = g[J];
      });
      const G = R.toFiniteNumber(g.headers.get("content-length")), [w, Y] = a && bl(
        G,
        is(El(a), !0)
      ) || [];
      g = new Response(
        yl(g.body, Ol, w, () => {
          Y && Y(), A && A();
        }),
        D
      );
    }
    c = c || "text";
    let S = await as[R.findKey(as, c) || "text"](g, e);
    return !I && A && A(), await new Promise((D, G) => {
      Wu(D, G, {
        data: S,
        headers: ze.from(g.headers),
        status: g.status,
        statusText: g.statusText,
        config: e,
        request: O
      });
    });
  } catch (m) {
    throw A && A(), m && m.name === "TypeError" && /fetch/i.test(m.message) ? Object.assign(
      new q("Network Error", q.ERR_NETWORK, e, O),
      {
        cause: m.cause || m
      }
    ) : q.from(m, m && m.code, e, O);
  }
}), Lo = {
  http: gg,
  xhr: Wg,
  fetch: n0
};
R.forEach(Lo, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const vl = (e) => `- ${e}`, r0 = (e) => R.isFunction(e) || e === null || e === !1, Qu = {
  getAdapter: (e) => {
    e = R.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let o = 0; o < t; o++) {
      n = e[o];
      let i;
      if (r = n, !r0(n) && (r = Lo[(i = String(n)).toLowerCase()], r === void 0))
        throw new q(`Unknown adapter '${i}'`);
      if (r)
        break;
      s[i || "#" + o] = r;
    }
    if (!r) {
      const o = Object.entries(s).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? o.length > 1 ? `since :
` + o.map(vl).join(`
`) : " " + vl(o[0]) : "as no adapter specified";
      throw new q(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Lo
};
function Zs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Kn(null, e);
}
function Il(e) {
  return Zs(e), e.headers = ze.from(e.headers), e.data = Qs.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Qu.getAdapter(e.adapter || Ar.adapter)(e).then(function(r) {
    return Zs(e), r.data = Qs.call(
      e,
      e.transformResponse,
      r
    ), r.headers = ze.from(r.headers), r;
  }, function(r) {
    return $u(r) || (Zs(e), r && r.response && (r.response.data = Qs.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = ze.from(r.response.headers))), Promise.reject(r);
  });
}
const Zu = "1.7.7", Di = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Di[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Al = {};
Di.transitional = function(t, n, r) {
  function s(o, i) {
    return "[Axios v" + Zu + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (t === !1)
      throw new q(
        s(i, " has been removed" + (n ? " in " + n : "")),
        q.ERR_DEPRECATED
      );
    return n && !Al[i] && (Al[i] = !0, console.warn(
      s(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, i, a) : !0;
  };
};
function s0(e, t, n) {
  if (typeof e != "object")
    throw new q("options must be an object", q.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const o = r[s], i = t[o];
    if (i) {
      const a = e[o], l = a === void 0 || i(a, o, e);
      if (l !== !0)
        throw new q("option " + o + " must be " + l, q.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new q("Unknown option " + o, q.ERR_BAD_OPTION);
  }
}
const ko = {
  assertOptions: s0,
  validators: Di
}, Yt = ko.validators;
class _n {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new _l(),
      response: new _l()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = yn(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: o } = n;
    r !== void 0 && ko.assertOptions(r, {
      silentJSONParsing: Yt.transitional(Yt.boolean),
      forcedJSONParsing: Yt.transitional(Yt.boolean),
      clarifyTimeoutError: Yt.transitional(Yt.boolean)
    }, !1), s != null && (R.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : ko.assertOptions(s, {
      encode: Yt.function,
      serialize: Yt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && R.merge(
      o.common,
      o[n.method]
    );
    o && R.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (O) => {
        delete o[O];
      }
    ), n.headers = ze.concat(i, o);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(A) {
      typeof A.runWhen == "function" && A.runWhen(n) === !1 || (l = l && A.synchronous, a.unshift(A.fulfilled, A.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(A) {
      c.push(A.fulfilled, A.rejected);
    });
    let u, d = 0, h;
    if (!l) {
      const O = [Il.bind(this), void 0];
      for (O.unshift.apply(O, a), O.push.apply(O, c), h = O.length, u = Promise.resolve(n); d < h; )
        u = u.then(O[d++], O[d++]);
      return u;
    }
    h = a.length;
    let T = n;
    for (d = 0; d < h; ) {
      const O = a[d++], A = a[d++];
      try {
        T = O(T);
      } catch (v) {
        A.call(this, v);
        break;
      }
    }
    try {
      u = Il.call(this, T);
    } catch (O) {
      return Promise.reject(O);
    }
    for (d = 0, h = c.length; d < h; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = yn(this.defaults, t);
    const n = Xu(t.baseURL, t.url);
    return zu(n, t.params, t.paramsSerializer);
  }
}
R.forEach(["delete", "get", "head", "options"], function(t) {
  _n.prototype[t] = function(n, r) {
    return this.request(yn(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
R.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, i, a) {
      return this.request(yn(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  _n.prototype[t] = n(), _n.prototype[t + "Form"] = n(!0);
});
class wi {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const i = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(s);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, a) {
      r.reason || (r.reason = new Kn(o, i, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new wi(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
function o0(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function i0(e) {
  return R.isObject(e) && e.isAxiosError === !0;
}
const Mo = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Mo).forEach(([e, t]) => {
  Mo[t] = e;
});
function ef(e) {
  const t = new _n(e), n = Du(_n.prototype.request, t);
  return R.extend(n, _n.prototype, t, { allOwnKeys: !0 }), R.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return ef(yn(e, s));
  }, n;
}
const Se = ef(Ar);
Se.Axios = _n;
Se.CanceledError = Kn;
Se.CancelToken = wi;
Se.isCancel = $u;
Se.VERSION = Zu;
Se.toFormData = Rs;
Se.AxiosError = q;
Se.Cancel = Se.CanceledError;
Se.all = function(t) {
  return Promise.all(t);
};
Se.spread = o0;
Se.isAxiosError = i0;
Se.mergeConfig = yn;
Se.AxiosHeaders = ze;
Se.formToJSON = (e) => Bu(R.isHTMLForm(e) ? new FormData(e) : e);
Se.getAdapter = Qu.getAdapter;
Se.HttpStatusCode = Mo;
Se.default = Se;
const tf = async (e) => {
  try {
    const { encoded: t } = await P_({
      userInfoApiUrl: e
    });
    return t;
  } catch (t) {
    console.error("error: ", t);
  }
}, a0 = async (e, t) => await Se.get(`${e}`, {
  headers: {
    Authorization: `Bearer ${await tf(t)}`,
    "content-type": "application/jwt"
  }
}), l0 = async (e, t) => await Se.put(`${e}`, null, {
  headers: {
    Authorization: `Bearer ${await tf(t)}`,
    "content-type": "application/jwt"
  }
});
var c0 = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
const Tl = () => {
};
let xi = {}, nf = {}, rf = null, sf = {
  mark: Tl,
  measure: Tl
};
try {
  typeof window < "u" && (xi = window), typeof document < "u" && (nf = document), typeof MutationObserver < "u" && (rf = MutationObserver), typeof performance < "u" && (sf = performance);
} catch {
}
const {
  userAgent: Nl = ""
} = xi.navigator || {}, rn = xi, ue = nf, Cl = rf, Gr = sf;
rn.document;
const $t = !!ue.documentElement && !!ue.head && typeof ue.addEventListener == "function" && typeof ue.createElement == "function", of = ~Nl.indexOf("MSIE") || ~Nl.indexOf("Trident/");
var me = "classic", af = "duotone", et = "sharp", tt = "sharp-duotone", u0 = [me, af, et, tt], f0 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds"
  }
}, Rl = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, d0 = ["kit"], p0 = /fa(s|r|l|t|d|b|k|kd|ss|sr|sl|st|sds)?[\-\ ]/, m0 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, h0 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
}, _0 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds"
  }
}, g0 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds"
  }
}, b0 = {
  classic: ["fas", "far", "fal", "fat"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds"]
}, E0 = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid"
  }
}, S0 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds"
  }
}, lf = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fad: "duotone",
    "fa-duotone": "duotone",
    fab: "brands",
    "fa-brands": "brands"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid"
  }
}, y0 = ["solid", "regular", "light", "thin", "duotone", "brands"], cf = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], O0 = cf.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Qn = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, v0 = [...Object.keys(b0), ...y0, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Qn.GROUP, Qn.SWAP_OPACITY, Qn.PRIMARY, Qn.SECONDARY].concat(cf.map((e) => "".concat(e, "x"))).concat(O0.map((e) => "w-".concat(e))), I0 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, A0 = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, T0 = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, Pl = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
};
const Ht = "___FONT_AWESOME___", Fo = 16, uf = "fa", ff = "svg-inline--fa", On = "data-fa-i2svg", Go = "data-fa-pseudo-element", N0 = "data-fa-pseudo-element-pending", Li = "data-prefix", ki = "data-icon", Dl = "fontawesome-i2svg", C0 = "async", R0 = ["HTML", "HEAD", "STYLE", "SCRIPT"], df = (() => {
  try {
    return c0.NODE_ENV === "production";
  } catch {
    return !1;
  }
})(), pf = [me, et, tt];
function Tr(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[me];
    }
  });
}
const mf = {
  ...lf
};
mf[me] = {
  ...lf[me],
  ...Rl.kit,
  ...Rl["kit-duotone"]
};
const gn = Tr(mf), jo = {
  ...S0
};
jo[me] = {
  ...jo[me],
  ...Pl.kit,
  ...Pl["kit-duotone"]
};
const Er = Tr(jo), Uo = {
  ...E0
};
Uo[me] = {
  ...Uo[me],
  ...T0.kit
};
const bn = Tr(Uo), Ho = {
  ...g0
};
Ho[me] = {
  ...Ho[me],
  ...A0.kit
};
const P0 = Tr(Ho), D0 = p0, hf = "fa-layers-text", w0 = m0, x0 = {
  ...f0
};
Tr(x0);
const L0 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], eo = Qn, Un = /* @__PURE__ */ new Set();
Object.keys(Er[me]).map(Un.add.bind(Un));
Object.keys(Er[et]).map(Un.add.bind(Un));
Object.keys(Er[tt]).map(Un.add.bind(Un));
const k0 = [...d0, ...v0], cr = rn.FontAwesomeConfig || {};
function M0(e) {
  var t = ue.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function F0(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
ue && typeof ue.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const s = F0(M0(n));
  s != null && (cr[r] = s);
});
const _f = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: uf,
  replacementClass: ff,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
cr.familyPrefix && (cr.cssPrefix = cr.familyPrefix);
const Hn = {
  ..._f,
  ...cr
};
Hn.autoReplaceSvg || (Hn.observeMutations = !1);
const V = {};
Object.keys(_f).forEach((e) => {
  Object.defineProperty(V, e, {
    enumerable: !0,
    set: function(t) {
      Hn[e] = t, ur.forEach((n) => n(V));
    },
    get: function() {
      return Hn[e];
    }
  });
});
Object.defineProperty(V, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Hn.cssPrefix = e, ur.forEach((t) => t(V));
  },
  get: function() {
    return Hn.cssPrefix;
  }
});
rn.FontAwesomeConfig = V;
const ur = [];
function G0(e) {
  return ur.push(e), () => {
    ur.splice(ur.indexOf(e), 1);
  };
}
const qt = Fo, Ot = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function j0(e) {
  if (!e || !$t)
    return;
  const t = ue.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = ue.head.childNodes;
  let r = null;
  for (let s = n.length - 1; s > -1; s--) {
    const o = n[s], i = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(i) > -1 && (r = o);
  }
  return ue.head.insertBefore(t, r), e;
}
const U0 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Sr() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += U0[Math.random() * 62 | 0];
  return t;
}
function Bn(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Mi(e) {
  return e.classList ? Bn(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function gf(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function H0(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(gf(e[n]), '" '), "").trim();
}
function Ds(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Fi(e) {
  return e.size !== Ot.size || e.x !== Ot.x || e.y !== Ot.y || e.rotate !== Ot.rotate || e.flipX || e.flipY;
}
function V0(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const s = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), a = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(i, " ").concat(a)
  }, c = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: l,
    path: c
  };
}
function z0(e) {
  let {
    transform: t,
    width: n = Fo,
    height: r = Fo,
    startCentered: s = !1
  } = e, o = "";
  return s && of ? o += "translate(".concat(t.x / qt - n / 2, "em, ").concat(t.y / qt - r / 2, "em) ") : s ? o += "translate(calc(-50% + ".concat(t.x / qt, "em), calc(-50% + ").concat(t.y / qt, "em)) ") : o += "translate(".concat(t.x / qt, "em, ").concat(t.y / qt, "em) "), o += "scale(".concat(t.size / qt * (t.flipX ? -1 : 1), ", ").concat(t.size / qt * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var K0 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function bf() {
  const e = uf, t = ff, n = V.cssPrefix, r = V.replacementClass;
  let s = K0;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), i = new RegExp("\\--".concat(e, "\\-"), "g"), a = new RegExp("\\.".concat(t), "g");
    s = s.replace(o, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(a, ".".concat(r));
  }
  return s;
}
let wl = !1;
function to() {
  V.autoAddCss && !wl && (j0(bf()), wl = !0);
}
var B0 = {
  mixout() {
    return {
      dom: {
        css: bf,
        insertCss: to
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        to();
      },
      beforeI2svg() {
        to();
      }
    };
  }
};
const Vt = rn || {};
Vt[Ht] || (Vt[Ht] = {});
Vt[Ht].styles || (Vt[Ht].styles = {});
Vt[Ht].hooks || (Vt[Ht].hooks = {});
Vt[Ht].shims || (Vt[Ht].shims = []);
var vt = Vt[Ht];
const Ef = [], Sf = function() {
  ue.removeEventListener("DOMContentLoaded", Sf), ls = 1, Ef.map((e) => e());
};
let ls = !1;
$t && (ls = (ue.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(ue.readyState), ls || ue.addEventListener("DOMContentLoaded", Sf));
function $0(e) {
  $t && (ls ? setTimeout(e, 0) : Ef.push(e));
}
function Nr(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? gf(e) : "<".concat(t, " ").concat(H0(n), ">").concat(r.map(Nr).join(""), "</").concat(t, ">");
}
function xl(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var no = function(t, n, r, s) {
  var o = Object.keys(t), i = o.length, a = n, l, c, u;
  for (r === void 0 ? (l = 1, u = t[o[0]]) : (l = 0, u = r); l < i; l++)
    c = o[l], u = a(u, t[c], c, t);
  return u;
};
function W0(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const s = e.charCodeAt(n++);
    if (s >= 55296 && s <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((s & 1023) << 10) + (o & 1023) + 65536) : (t.push(s), n--);
    } else
      t.push(s);
  }
  return t;
}
function Vo(e) {
  const t = W0(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function X0(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), s;
  return r >= 55296 && r <= 56319 && n > t + 1 && (s = e.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (r - 55296) * 1024 + s - 56320 + 65536 : r;
}
function Ll(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function zo(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, s = Ll(t);
  typeof vt.hooks.addPack == "function" && !r ? vt.hooks.addPack(e, Ll(t)) : vt.styles[e] = {
    ...vt.styles[e] || {},
    ...s
  }, e === "fas" && zo("fa", t);
}
const {
  styles: pn,
  shims: Y0
} = vt, q0 = {
  [me]: Object.values(bn[me]),
  [et]: Object.values(bn[et]),
  [tt]: Object.values(bn[tt])
};
let Gi = null, yf = {}, Of = {}, vf = {}, If = {}, Af = {};
const J0 = {
  [me]: Object.keys(gn[me]),
  [et]: Object.keys(gn[et]),
  [tt]: Object.keys(gn[tt])
};
function Q0(e) {
  return ~k0.indexOf(e);
}
function Z0(e, t) {
  const n = t.split("-"), r = n[0], s = n.slice(1).join("-");
  return r === e && s !== "" && !Q0(s) ? s : null;
}
const Tf = () => {
  const e = (r) => no(pn, (s, o, i) => (s[i] = no(o, r, {}), s), {});
  yf = e((r, s, o) => (s[3] && (r[s[3]] = o), s[2] && s[2].filter((a) => typeof a == "number").forEach((a) => {
    r[a.toString(16)] = o;
  }), r)), Of = e((r, s, o) => (r[o] = o, s[2] && s[2].filter((a) => typeof a == "string").forEach((a) => {
    r[a] = o;
  }), r)), Af = e((r, s, o) => {
    const i = s[2];
    return r[o] = o, i.forEach((a) => {
      r[a] = o;
    }), r;
  });
  const t = "far" in pn || V.autoFetchSvg, n = no(Y0, (r, s) => {
    const o = s[0];
    let i = s[1];
    const a = s[2];
    return i === "far" && !t && (i = "fas"), typeof o == "string" && (r.names[o] = {
      prefix: i,
      iconName: a
    }), typeof o == "number" && (r.unicodes[o.toString(16)] = {
      prefix: i,
      iconName: a
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  vf = n.names, If = n.unicodes, Gi = ws(V.styleDefault, {
    family: V.familyDefault
  });
};
G0((e) => {
  Gi = ws(e.styleDefault, {
    family: V.familyDefault
  });
});
Tf();
function ji(e, t) {
  return (yf[e] || {})[t];
}
function e1(e, t) {
  return (Of[e] || {})[t];
}
function en(e, t) {
  return (Af[e] || {})[t];
}
function Nf(e) {
  return vf[e] || {
    prefix: null,
    iconName: null
  };
}
function t1(e) {
  const t = If[e], n = ji("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function sn() {
  return Gi;
}
const Ui = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function ws(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = me
  } = t, r = gn[n][e], s = Er[n][e] || Er[n][r], o = e in vt.styles ? e : null;
  return s || o || null;
}
const n1 = {
  [me]: Object.keys(bn[me]),
  [et]: Object.keys(bn[et]),
  [tt]: Object.keys(bn[tt])
};
function xs(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t, r = {
    [me]: "".concat(V.cssPrefix, "-").concat(me),
    [et]: "".concat(V.cssPrefix, "-").concat(et),
    [tt]: "".concat(V.cssPrefix, "-").concat(tt)
  };
  let s = null, o = me;
  const i = u0.filter((l) => l !== af);
  i.forEach((l) => {
    (e.includes(r[l]) || e.some((c) => n1[l].includes(c))) && (o = l);
  });
  const a = e.reduce((l, c) => {
    const u = Z0(V.cssPrefix, c);
    if (pn[c] ? (c = q0[o].includes(c) ? P0[o][c] : c, s = c, l.prefix = c) : J0[o].indexOf(c) > -1 ? (s = c, l.prefix = ws(c, {
      family: o
    })) : u ? l.iconName = u : c !== V.replacementClass && !i.some((d) => c === r[d]) && l.rest.push(c), !n && l.prefix && l.iconName) {
      const d = s === "fa" ? Nf(l.iconName) : {}, h = en(l.prefix, l.iconName);
      d.prefix && (s = null), l.iconName = d.iconName || h || l.iconName, l.prefix = d.prefix || l.prefix, l.prefix === "far" && !pn.far && pn.fas && !V.autoFetchSvg && (l.prefix = "fas");
    }
    return l;
  }, Ui());
  return (e.includes("fa-brands") || e.includes("fab")) && (a.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (a.prefix = "fad"), !a.prefix && o === et && (pn.fass || V.autoFetchSvg) && (a.prefix = "fass", a.iconName = en(a.prefix, a.iconName) || a.iconName), !a.prefix && o === tt && (pn.fasds || V.autoFetchSvg) && (a.prefix = "fasds", a.iconName = en(a.prefix, a.iconName) || a.iconName), (a.prefix === "fa" || s === "fa") && (a.prefix = sn() || "fas"), a;
}
class r1 {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const s = n.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((o) => {
      this.definitions[o] = {
        ...this.definitions[o] || {},
        ...s[o]
      }, zo(o, s[o]);
      const i = bn[me][o];
      i && zo(i, s[o]), Tf();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((s) => {
      const {
        prefix: o,
        iconName: i,
        icon: a
      } = r[s], l = a[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (t[o][c] = a);
      }), t[o][i] = a;
    }), t;
  }
}
let kl = [], Rn = {};
const Mn = {}, s1 = Object.keys(Mn);
function o1(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return kl = e, Rn = {}, Object.keys(Mn).forEach((r) => {
    s1.indexOf(r) === -1 && delete Mn[r];
  }), kl.forEach((r) => {
    const s = r.mixout ? r.mixout() : {};
    if (Object.keys(s).forEach((o) => {
      typeof s[o] == "function" && (n[o] = s[o]), typeof s[o] == "object" && Object.keys(s[o]).forEach((i) => {
        n[o] || (n[o] = {}), n[o][i] = s[o][i];
      });
    }), r.hooks) {
      const o = r.hooks();
      Object.keys(o).forEach((i) => {
        Rn[i] || (Rn[i] = []), Rn[i].push(o[i]);
      });
    }
    r.provides && r.provides(Mn);
  }), n;
}
function Ko(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    r[s - 2] = arguments[s];
  return (Rn[e] || []).forEach((i) => {
    t = i.apply(null, [t, ...r]);
  }), t;
}
function vn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (Rn[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function on() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Mn[e] ? Mn[e].apply(null, t) : void 0;
}
function Bo(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || sn();
  if (t)
    return t = en(n, t) || t, xl(Cf.definitions, n, t) || xl(vt.styles, n, t);
}
const Cf = new r1(), i1 = () => {
  V.autoReplaceSvg = !1, V.observeMutations = !1, vn("noAuto");
}, a1 = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $t ? (vn("beforeI2svg", e), on("pseudoElements2svg", e), on("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    V.autoReplaceSvg === !1 && (V.autoReplaceSvg = !0), V.observeMutations = !0, $0(() => {
      c1({
        autoReplaceSvgRoot: t
      }), vn("watch", e);
    });
  }
}, l1 = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: en(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = ws(e[0]);
      return {
        prefix: n,
        iconName: en(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(V.cssPrefix, "-")) > -1 || e.match(D0))) {
      const t = xs(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || sn(),
        iconName: en(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = sn();
      return {
        prefix: t,
        iconName: en(t, e) || e
      };
    }
  }
}, nt = {
  noAuto: i1,
  config: V,
  dom: a1,
  parse: l1,
  library: Cf,
  findIconDefinition: Bo,
  toHtml: Nr
}, c1 = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = ue
  } = e;
  (Object.keys(vt.styles).length > 0 || V.autoFetchSvg) && $t && V.autoReplaceSvg && nt.dom.i2svg({
    node: t
  });
};
function Ls(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Nr(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!$t) return;
      const n = ue.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function u1(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: s,
    styles: o,
    transform: i
  } = e;
  if (Fi(i) && n.found && !r.found) {
    const {
      width: a,
      height: l
    } = n, c = {
      x: a / l / 2,
      y: 0.5
    };
    s.style = Ds({
      ...o,
      "transform-origin": "".concat(c.x + i.x / 16, "em ").concat(c.y + i.y / 16, "em")
    });
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function f1(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: s,
    symbol: o
  } = e;
  const i = o === !0 ? "".concat(t, "-").concat(V.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: {
        ...s,
        id: i
      },
      children: r
    }]
  }];
}
function Hi(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: s,
    transform: o,
    symbol: i,
    title: a,
    maskId: l,
    titleId: c,
    extra: u,
    watchable: d = !1
  } = e, {
    width: h,
    height: T
  } = n.found ? n : t, O = r === "fak", A = [V.replacementClass, s ? "".concat(V.cssPrefix, "-").concat(s) : ""].filter((D) => u.classes.indexOf(D) === -1).filter((D) => D !== "" || !!D).concat(u.classes).join(" ");
  let v = {
    children: [],
    attributes: {
      ...u.attributes,
      "data-prefix": r,
      "data-icon": s,
      class: A,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(h, " ").concat(T)
    }
  };
  const m = O && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(h / T * 16 * 0.0625, "em")
  } : {};
  d && (v.attributes[On] = ""), a && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(c || Sr())
    },
    children: [a]
  }), delete v.attributes.title);
  const g = {
    ...v,
    prefix: r,
    iconName: s,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: i,
    styles: {
      ...m,
      ...u.styles
    }
  }, {
    children: I,
    attributes: S
  } = n.found && t.found ? on("generateAbstractMask", g) || {
    children: [],
    attributes: {}
  } : on("generateAbstractIcon", g) || {
    children: [],
    attributes: {}
  };
  return g.children = I, g.attributes = S, i ? f1(g) : u1(g);
}
function Ml(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: s,
    title: o,
    extra: i,
    watchable: a = !1
  } = e, l = {
    ...i.attributes,
    ...o ? {
      title: o
    } : {},
    class: i.classes.join(" ")
  };
  a && (l[On] = "");
  const c = {
    ...i.styles
  };
  Fi(s) && (c.transform = z0({
    transform: s,
    startCentered: !0,
    width: n,
    height: r
  }), c["-webkit-transform"] = c.transform);
  const u = Ds(c);
  u.length > 0 && (l.style = u);
  const d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), d;
}
function d1(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, s = {
    ...r.attributes,
    ...n ? {
      title: n
    } : {},
    class: r.classes.join(" ")
  }, o = Ds(r.styles);
  o.length > 0 && (s.style = o);
  const i = [];
  return i.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), n && i.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), i;
}
const {
  styles: ro
} = vt;
function $o(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let s = null;
  return Array.isArray(r) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(V.cssPrefix, "-").concat(eo.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(V.cssPrefix, "-").concat(eo.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(V.cssPrefix, "-").concat(eo.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: s
  };
}
const p1 = {
  found: !1,
  width: 512,
  height: 512
};
function m1(e, t) {
  !df && !V.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Wo(e, t) {
  let n = t;
  return t === "fa" && V.styleDefault !== null && (t = sn()), new Promise((r, s) => {
    if (n === "fa") {
      const o = Nf(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && ro[t] && ro[t][e]) {
      const o = ro[t][e];
      return r($o(o));
    }
    m1(e, t), r({
      ...p1,
      icon: V.showMissingIcons && e ? on("missingIconAbstract") || {} : {}
    });
  });
}
const Fl = () => {
}, Xo = V.measurePerformance && Gr && Gr.mark && Gr.measure ? Gr : {
  mark: Fl,
  measure: Fl
}, Zn = 'FA "6.6.0"', h1 = (e) => (Xo.mark("".concat(Zn, " ").concat(e, " begins")), () => Rf(e)), Rf = (e) => {
  Xo.mark("".concat(Zn, " ").concat(e, " ends")), Xo.measure("".concat(Zn, " ").concat(e), "".concat(Zn, " ").concat(e, " begins"), "".concat(Zn, " ").concat(e, " ends"));
};
var Vi = {
  begin: h1,
  end: Rf
};
const $r = () => {
};
function Gl(e) {
  return typeof (e.getAttribute ? e.getAttribute(On) : null) == "string";
}
function _1(e) {
  const t = e.getAttribute ? e.getAttribute(Li) : null, n = e.getAttribute ? e.getAttribute(ki) : null;
  return t && n;
}
function g1(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(V.replacementClass);
}
function b1() {
  return V.autoReplaceSvg === !0 ? Wr.replace : Wr[V.autoReplaceSvg] || Wr.replace;
}
function E1(e) {
  return ue.createElementNS("http://www.w3.org/2000/svg", e);
}
function S1(e) {
  return ue.createElement(e);
}
function Pf(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? E1 : S1
  } = t;
  if (typeof e == "string")
    return ue.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    r.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    r.appendChild(Pf(o, {
      ceFn: n
    }));
  }), r;
}
function y1(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const Wr = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(Pf(n), t);
      }), t.getAttribute(On) === null && V.keepOriginalSource) {
        let n = ue.createComment(y1(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Mi(t).indexOf(V.replacementClass))
      return Wr.replace(e);
    const r = new RegExp("".concat(V.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((i, a) => (a === V.replacementClass || a.match(r) ? i.toSvg.push(a) : i.toNode.push(a), i), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const s = n.map((o) => Nr(o)).join(`
`);
    t.setAttribute(On, ""), t.innerHTML = s;
  }
};
function jl(e) {
  e();
}
function Df(e, t) {
  const n = typeof t == "function" ? t : $r;
  if (e.length === 0)
    n();
  else {
    let r = jl;
    V.mutateApproach === C0 && (r = rn.requestAnimationFrame || jl), r(() => {
      const s = b1(), o = Vi.begin("mutate");
      e.map(s), o(), n();
    });
  }
}
let zi = !1;
function wf() {
  zi = !0;
}
function Yo() {
  zi = !1;
}
let cs = null;
function Ul(e) {
  if (!Cl || !V.observeMutations)
    return;
  const {
    treeCallback: t = $r,
    nodeCallback: n = $r,
    pseudoElementsCallback: r = $r,
    observeMutationsRoot: s = ue
  } = e;
  cs = new Cl((o) => {
    if (zi) return;
    const i = sn();
    Bn(o).forEach((a) => {
      if (a.type === "childList" && a.addedNodes.length > 0 && !Gl(a.addedNodes[0]) && (V.searchPseudoElements && r(a.target), t(a.target)), a.type === "attributes" && a.target.parentNode && V.searchPseudoElements && r(a.target.parentNode), a.type === "attributes" && Gl(a.target) && ~L0.indexOf(a.attributeName))
        if (a.attributeName === "class" && _1(a.target)) {
          const {
            prefix: l,
            iconName: c
          } = xs(Mi(a.target));
          a.target.setAttribute(Li, l || i), c && a.target.setAttribute(ki, c);
        } else g1(a.target) && n(a.target);
    });
  }), $t && cs.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function O1() {
  cs && cs.disconnect();
}
function v1(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, s) => {
    const o = s.split(":"), i = o[0], a = o.slice(1);
    return i && a.length > 0 && (r[i] = a.join(":").trim()), r;
  }, {})), n;
}
function I1(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = xs(Mi(e));
  return s.prefix || (s.prefix = sn()), t && n && (s.prefix = t, s.iconName = n), s.iconName && s.prefix || (s.prefix && r.length > 0 && (s.iconName = e1(s.prefix, e.innerText) || ji(s.prefix, Vo(e.innerText))), !s.iconName && V.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function A1(e) {
  const t = Bn(e.attributes).reduce((s, o) => (s.name !== "class" && s.name !== "style" && (s[o.name] = o.value), s), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return V.autoA11y && (n ? t["aria-labelledby"] = "".concat(V.replacementClass, "-title-").concat(r || Sr()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function T1() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ot,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Hl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: s
  } = I1(e), o = A1(e), i = Ko("parseNodeAttributes", {}, e);
  let a = t.styleParser ? v1(e) : [];
  return {
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: Ot,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: a,
      attributes: o
    },
    ...i
  };
}
const {
  styles: N1
} = vt;
function xf(e) {
  const t = V.autoReplaceSvg === "nest" ? Hl(e, {
    styleParser: !1
  }) : Hl(e);
  return ~t.extra.classes.indexOf(hf) ? on("generateLayersText", e, t) : on("generateSvgReplacementMutation", e, t);
}
let Ct = /* @__PURE__ */ new Set();
pf.map((e) => {
  Ct.add("fa-".concat(e));
});
Object.keys(gn[me]).map(Ct.add.bind(Ct));
Object.keys(gn[et]).map(Ct.add.bind(Ct));
Object.keys(gn[tt]).map(Ct.add.bind(Ct));
Ct = [...Ct];
function Vl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!$t) return Promise.resolve();
  const n = ue.documentElement.classList, r = (u) => n.add("".concat(Dl, "-").concat(u)), s = (u) => n.remove("".concat(Dl, "-").concat(u)), o = V.autoFetchSvg ? Ct : pf.map((u) => "fa-".concat(u)).concat(Object.keys(N1));
  o.includes("fa") || o.push("fa");
  const i = [".".concat(hf, ":not([").concat(On, "])")].concat(o.map((u) => ".".concat(u, ":not([").concat(On, "])"))).join(", ");
  if (i.length === 0)
    return Promise.resolve();
  let a = [];
  try {
    a = Bn(e.querySelectorAll(i));
  } catch {
  }
  if (a.length > 0)
    r("pending"), s("complete");
  else
    return Promise.resolve();
  const l = Vi.begin("onTree"), c = a.reduce((u, d) => {
    try {
      const h = xf(d);
      h && u.push(h);
    } catch (h) {
      df || h.name === "MissingIcon" && console.error(h);
    }
    return u;
  }, []);
  return new Promise((u, d) => {
    Promise.all(c).then((h) => {
      Df(h, () => {
        r("active"), r("complete"), s("pending"), typeof t == "function" && t(), l(), u();
      });
    }).catch((h) => {
      l(), d(h);
    });
  });
}
function C1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  xf(e).then((n) => {
    n && Df([n], t);
  });
}
function R1(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : Bo(t || {});
    let {
      mask: s
    } = n;
    return s && (s = (s || {}).icon ? s : Bo(s || {})), e(r, {
      ...n,
      mask: s
    });
  };
}
const P1 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Ot,
    symbol: r = !1,
    mask: s = null,
    maskId: o = null,
    title: i = null,
    titleId: a = null,
    classes: l = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!e) return;
  const {
    prefix: d,
    iconName: h,
    icon: T
  } = e;
  return Ls({
    type: "icon",
    ...e
  }, () => (vn("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), V.autoA11y && (i ? c["aria-labelledby"] = "".concat(V.replacementClass, "-title-").concat(a || Sr()) : (c["aria-hidden"] = "true", c.focusable = "false")), Hi({
    icons: {
      main: $o(T),
      mask: s ? $o(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: d,
    iconName: h,
    transform: {
      ...Ot,
      ...n
    },
    symbol: r,
    title: i,
    maskId: o,
    titleId: a,
    extra: {
      attributes: c,
      styles: u,
      classes: l
    }
  })));
};
var D1 = {
  mixout() {
    return {
      icon: R1(P1)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = Vl, e.nodeCallback = C1, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = ue,
        callback: r = () => {
        }
      } = t;
      return Vl(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: s,
        titleId: o,
        prefix: i,
        transform: a,
        symbol: l,
        mask: c,
        maskId: u,
        extra: d
      } = n;
      return new Promise((h, T) => {
        Promise.all([Wo(r, i), c.iconName ? Wo(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((O) => {
          let [A, v] = O;
          h([t, Hi({
            icons: {
              main: A,
              mask: v
            },
            prefix: i,
            iconName: r,
            transform: a,
            symbol: l,
            maskId: u,
            title: s,
            titleId: o,
            extra: d,
            watchable: !0
          })]);
        }).catch(T);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: s,
        transform: o,
        styles: i
      } = t;
      const a = Ds(i);
      a.length > 0 && (r.style = a);
      let l;
      return Fi(o) && (l = on("generateAbstractTransformGrouping", {
        main: s,
        transform: o,
        containerWidth: s.width,
        iconWidth: s.width
      })), n.push(l || s.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, w1 = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Ls({
          type: "layer"
        }, () => {
          vn("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((s) => {
            Array.isArray(s) ? s.map((o) => {
              r = r.concat(o.abstract);
            }) : r = r.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(V.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, x1 = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: s = {},
          styles: o = {}
        } = t;
        return Ls({
          type: "counter",
          content: e
        }, () => (vn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), d1({
          content: e.toString(),
          title: n,
          extra: {
            attributes: s,
            styles: o,
            classes: ["".concat(V.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, L1 = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Ot,
          title: r = null,
          classes: s = [],
          attributes: o = {},
          styles: i = {}
        } = t;
        return Ls({
          type: "text",
          content: e
        }, () => (vn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Ml({
          content: e,
          transform: {
            ...Ot,
            ...n
          },
          title: r,
          extra: {
            attributes: o,
            styles: i,
            classes: ["".concat(V.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: s,
        extra: o
      } = n;
      let i = null, a = null;
      if (of) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        i = c.width / l, a = c.height / l;
      }
      return V.autoA11y && !r && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, Ml({
        content: t.innerHTML,
        width: i,
        height: a,
        transform: s,
        title: r,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const k1 = new RegExp('"', "ug"), zl = [1105920, 1112319], Kl = {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  },
  ..._0,
  ...h0,
  ...I0
}, qo = Object.keys(Kl).reduce((e, t) => (e[t.toLowerCase()] = Kl[t], e), {}), M1 = Object.keys(qo).reduce((e, t) => {
  const n = qo[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function F1(e) {
  const t = e.replace(k1, ""), n = X0(t, 0), r = n >= zl[0] && n <= zl[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Vo(s ? t[0] : t),
    isSecondary: r || s
  };
}
function G1(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), s = isNaN(r) ? "normal" : r;
  return (qo[n] || {})[s] || M1[n];
}
function Bl(e, t) {
  const n = "".concat(N0).concat(t.replace(":", "-"));
  return new Promise((r, s) => {
    if (e.getAttribute(n) !== null)
      return r();
    const i = Bn(e.children).filter((h) => h.getAttribute(Go) === t)[0], a = rn.getComputedStyle(e, t), l = a.getPropertyValue("font-family"), c = l.match(w0), u = a.getPropertyValue("font-weight"), d = a.getPropertyValue("content");
    if (i && !c)
      return e.removeChild(i), r();
    if (c && d !== "none" && d !== "") {
      const h = a.getPropertyValue("content");
      let T = G1(l, u);
      const {
        value: O,
        isSecondary: A
      } = F1(h), v = c[0].startsWith("FontAwesome");
      let m = ji(T, O), g = m;
      if (v) {
        const I = t1(O);
        I.iconName && I.prefix && (m = I.iconName, T = I.prefix);
      }
      if (m && !A && (!i || i.getAttribute(Li) !== T || i.getAttribute(ki) !== g)) {
        e.setAttribute(n, g), i && e.removeChild(i);
        const I = T1(), {
          extra: S
        } = I;
        S.attributes[Go] = t, Wo(m, T).then((D) => {
          const G = Hi({
            ...I,
            icons: {
              main: D,
              mask: Ui()
            },
            prefix: T,
            iconName: g,
            extra: S,
            watchable: !0
          }), w = ue.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(w, e.firstChild) : e.appendChild(w), w.outerHTML = G.map((Y) => Nr(Y)).join(`
`), e.removeAttribute(n), r();
        }).catch(s);
      } else
        r();
    } else
      r();
  });
}
function j1(e) {
  return Promise.all([Bl(e, "::before"), Bl(e, "::after")]);
}
function U1(e) {
  return e.parentNode !== document.head && !~R0.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Go) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function $l(e) {
  if ($t)
    return new Promise((t, n) => {
      const r = Bn(e.querySelectorAll("*")).filter(U1).map(j1), s = Vi.begin("searchPseudoElements");
      wf(), Promise.all(r).then(() => {
        s(), Yo(), t();
      }).catch(() => {
        s(), Yo(), n();
      });
    });
}
var H1 = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = $l, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = ue
      } = t;
      V.searchPseudoElements && $l(n);
    };
  }
};
let Wl = !1;
var V1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          wf(), Wl = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        Ul(Ko("mutationObserverCallbacks", {}));
      },
      noAuto() {
        O1();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        Wl ? Yo() : Ul(Ko("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const Xl = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const s = r.toLowerCase().split("-"), o = s[0];
    let i = s.slice(1).join("-");
    if (o && i === "h")
      return n.flipX = !0, n;
    if (o && i === "v")
      return n.flipY = !0, n;
    if (i = parseFloat(i), isNaN(i))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + i;
        break;
      case "shrink":
        n.size = n.size - i;
        break;
      case "left":
        n.x = n.x - i;
        break;
      case "right":
        n.x = n.x + i;
        break;
      case "up":
        n.y = n.y - i;
        break;
      case "down":
        n.y = n.y + i;
        break;
      case "rotate":
        n.rotate = n.rotate + i;
        break;
    }
    return n;
  }, t);
};
var z1 = {
  mixout() {
    return {
      parse: {
        transform: (e) => Xl(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = Xl(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: s,
        iconWidth: o
      } = t;
      const i = {
        transform: "translate(".concat(s / 2, " 256)")
      }, a = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), c = "rotate(".concat(r.rotate, " 0 0)"), u = {
        transform: "".concat(a, " ").concat(l, " ").concat(c)
      }, d = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, h = {
        outer: i,
        inner: u,
        path: d
      };
      return {
        tag: "g",
        attributes: {
          ...h.outer
        },
        children: [{
          tag: "g",
          attributes: {
            ...h.inner
          },
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: {
              ...n.icon.attributes,
              ...h.path
            }
          }]
        }]
      };
    };
  }
};
const so = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Yl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function K1(e) {
  return e.tag === "g" ? e.children : [e];
}
var B1 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? xs(n.split(" ").map((s) => s.trim())) : Ui();
        return r.prefix || (r.prefix = sn()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: s,
        mask: o,
        maskId: i,
        transform: a
      } = t;
      const {
        width: l,
        icon: c
      } = s, {
        width: u,
        icon: d
      } = o, h = V0({
        transform: a,
        containerWidth: u,
        iconWidth: l
      }), T = {
        tag: "rect",
        attributes: {
          ...so,
          fill: "white"
        }
      }, O = c.children ? {
        children: c.children.map(Yl)
      } : {}, A = {
        tag: "g",
        attributes: {
          ...h.inner
        },
        children: [Yl({
          tag: c.tag,
          attributes: {
            ...c.attributes,
            ...h.path
          },
          ...O
        })]
      }, v = {
        tag: "g",
        attributes: {
          ...h.outer
        },
        children: [A]
      }, m = "mask-".concat(i || Sr()), g = "clip-".concat(i || Sr()), I = {
        tag: "mask",
        attributes: {
          ...so,
          id: m,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        },
        children: [T, v]
      }, S = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: g
          },
          children: K1(d)
        }, I]
      };
      return n.push(S, {
        tag: "rect",
        attributes: {
          fill: "currentColor",
          "clip-path": "url(#".concat(g, ")"),
          mask: "url(#".concat(m, ")"),
          ...so
        }
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, $1 = {
  provides(e) {
    let t = !1;
    rn.matchMedia && (t = rn.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: {
          ...r,
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        }
      });
      const o = {
        ...s,
        attributeName: "opacity"
      }, i = {
        tag: "circle",
        attributes: {
          ...r,
          cx: "256",
          cy: "364",
          r: "28"
        },
        children: []
      };
      return t || i.children.push({
        tag: "animate",
        attributes: {
          ...s,
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        }
      }, {
        tag: "animate",
        attributes: {
          ...o,
          values: "1;0;1;1;0;1;"
        }
      }), n.push(i), n.push({
        tag: "path",
        attributes: {
          ...r,
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        },
        children: t ? [] : [{
          tag: "animate",
          attributes: {
            ...o,
            values: "1;0;0;0;0;1;"
          }
        }]
      }), t || n.push({
        tag: "path",
        attributes: {
          ...r,
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        },
        children: [{
          tag: "animate",
          attributes: {
            ...o,
            values: "0;0;1;1;0;0;"
          }
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, W1 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, X1 = [B0, D1, w1, x1, L1, H1, V1, z1, B1, $1, W1];
o1(X1, {
  mixoutsTo: nt
});
nt.noAuto;
nt.config;
const Y1 = nt.library;
nt.dom;
const Jo = nt.parse;
nt.findIconDefinition;
nt.toHtml;
const q1 = nt.icon;
nt.layer;
nt.text;
nt.counter;
var J1 = { GJS_DEBUG_TOPICS: "JS ERROR;JS LOG", LESSOPEN: "| /usr/bin/lesspipe %s", USER: "indahj", npm_config_user_agent: "yarn/4.5.0 npm/? node/v20.10.0 linux x64", GIO_MODULE_DIR: "/home/indahj/snap/code/common/.cache/gio-modules", XDG_SESSION_TYPE: "wayland", GIT_ASKPASS: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass.sh", GTK_EXE_PREFIX_VSCODE_SNAP_ORIG: "", npm_node_execpath: "/tmp/xfs-e69a95c4/node", GDK_BACKEND_VSCODE_SNAP_ORIG: "", SHLVL: "1", HOME: "/home/indahj", CHROME_DESKTOP: "code-url-handler.desktop", LOCPATH_VSCODE_SNAP_ORIG: "", OLDPWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/dist", TERM_PROGRAM_VERSION: "1.94.2", DESKTOP_SESSION: "ubuntu", GTK_PATH: "/snap/code/172/usr/lib/x86_64-linux-gnu/gtk-3.0", NVM_BIN: "/home/indahj/.nvm/versions/node/v20.10.0/bin", npm_package_json: "/home/indahj/Projects/recia-webcomponents/packages/change-etab/package.json", NVM_INC: "/home/indahj/.nvm/versions/node/v20.10.0/include/node", GTK_IM_MODULE_FILE: "/home/indahj/snap/code/common/.cache/immodules/immodules.cache", GIO_LAUNCHED_DESKTOP_FILE: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SHELL_SESSION_MODE: "ubuntu", GTK_MODULES: "gail:atk-bridge", GSETTINGS_SCHEMA_DIR_VSCODE_SNAP_ORIG: "", VSCODE_GIT_ASKPASS_MAIN: "/snap/code/172/usr/share/code/resources/app/extensions/git/dist/askpass-main.js", VSCODE_GIT_ASKPASS_NODE: "/snap/code/172/usr/share/code/code", MANAGERPID: "2763", SYSTEMD_EXEC_PID: "2989", IM_CONFIG_CHECK_ENV: "1", DBUS_SESSION_BUS_ADDRESS: "unix:path=/run/user/1000/bus", COLORTERM: "truecolor", GIO_LAUNCHED_DESKTOP_FILE_PID: "6415", NVM_DIR: "/home/indahj/.nvm", IM_CONFIG_PHASE: "1", WAYLAND_DISPLAY: "wayland-0", LOGNAME: "indahj", JOURNAL_STREAM: "8:43272", _: "/home/indahj/.nvm/versions/node/v20.10.0/bin/yarn", XDG_CONFIG_DIRS_VSCODE_SNAP_ORIG: "/etc/xdg/xdg-ubuntu:/etc/xdg", XDG_SESSION_CLASS: "user", XDG_DATA_DIRS_VSCODE_SNAP_ORIG: "/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", USERNAME: "indahj", TERM: "xterm-256color", GNOME_DESKTOP_SESSION_ID: "this-is-deprecated", PATH: "/tmp/xfs-e69a95c4:/tmp/xfs-5449b6ac:/home/indahj/.nvm/versions/node/v20.10.0/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin:/snap/bin", SESSION_MANAGER: "local/indahj-Precision-3561:@/tmp/.ICE-unix/2971,unix/indahj-Precision-3561:/tmp/.ICE-unix/2971", GTK_EXE_PREFIX: "/snap/code/172/usr", INVOCATION_ID: "1d9c3bb553834bd19dfff01c0455193d", npm_package_name: "@gip-recia/change-etab", XDG_MENU_PREFIX: "gnome-", BAMF_DESKTOP_FILE_HINT: "/var/lib/snapd/desktop/applications/code_code.desktop", GNOME_SETUP_DISPLAY: ":1", XDG_RUNTIME_DIR: "/run/user/1000", GDK_BACKEND: "x11", DISPLAY: ":0", LOCPATH: "/snap/code/172/usr/lib/locale", LANG: "fr_FR.UTF-8", XDG_CURRENT_DESKTOP: "Unity", GIO_MODULE_DIR_VSCODE_SNAP_ORIG: "", XMODIFIERS: "@im=ibus", XDG_SESSION_DESKTOP: "ubuntu", XAUTHORITY: "/run/user/1000/.mutter-Xwaylandauth.CRUWV2", LS_COLORS: "rs=0:di=01;34:ln=01;36:mh=00:pi=40;33:so=01;35:do=01;35:bd=40;33;01:cd=40;33;01:or=40;31;01:mi=00:su=37;41:sg=30;43:ca=30;41:tw=30;42:ow=34;42:st=37;44:ex=01;32:*.tar=01;31:*.tgz=01;31:*.arc=01;31:*.arj=01;31:*.taz=01;31:*.lha=01;31:*.lz4=01;31:*.lzh=01;31:*.lzma=01;31:*.tlz=01;31:*.txz=01;31:*.tzo=01;31:*.t7z=01;31:*.zip=01;31:*.z=01;31:*.dz=01;31:*.gz=01;31:*.lrz=01;31:*.lz=01;31:*.lzo=01;31:*.xz=01;31:*.zst=01;31:*.tzst=01;31:*.bz2=01;31:*.bz=01;31:*.tbz=01;31:*.tbz2=01;31:*.tz=01;31:*.deb=01;31:*.rpm=01;31:*.jar=01;31:*.war=01;31:*.ear=01;31:*.sar=01;31:*.rar=01;31:*.alz=01;31:*.ace=01;31:*.zoo=01;31:*.cpio=01;31:*.7z=01;31:*.rz=01;31:*.cab=01;31:*.wim=01;31:*.swm=01;31:*.dwm=01;31:*.esd=01;31:*.jpg=01;35:*.jpeg=01;35:*.mjpg=01;35:*.mjpeg=01;35:*.gif=01;35:*.bmp=01;35:*.pbm=01;35:*.pgm=01;35:*.ppm=01;35:*.tga=01;35:*.xbm=01;35:*.xpm=01;35:*.tif=01;35:*.tiff=01;35:*.png=01;35:*.svg=01;35:*.svgz=01;35:*.mng=01;35:*.pcx=01;35:*.mov=01;35:*.mpg=01;35:*.mpeg=01;35:*.m2v=01;35:*.mkv=01;35:*.webm=01;35:*.webp=01;35:*.ogm=01;35:*.mp4=01;35:*.m4v=01;35:*.mp4v=01;35:*.vob=01;35:*.qt=01;35:*.nuv=01;35:*.wmv=01;35:*.asf=01;35:*.rm=01;35:*.rmvb=01;35:*.flc=01;35:*.avi=01;35:*.fli=01;35:*.flv=01;35:*.gl=01;35:*.dl=01;35:*.xcf=01;35:*.xwd=01;35:*.yuv=01;35:*.cgm=01;35:*.emf=01;35:*.ogv=01;35:*.ogx=01;35:*.aac=00;36:*.au=00;36:*.flac=00;36:*.m4a=00;36:*.mid=00;36:*.midi=00;36:*.mka=00;36:*.mp3=00;36:*.mpc=00;36:*.ogg=00;36:*.ra=00;36:*.wav=00;36:*.oga=00;36:*.opus=00;36:*.spx=00;36:*.xspf=00;36:", VSCODE_GIT_IPC_HANDLE: "/run/user/1000/vscode-git-a8befda9a5.sock", TERM_PROGRAM: "vscode", SSH_AGENT_LAUNCHER: "gnome-keyring", SSH_AUTH_SOCK: "/run/user/1000/keyring/ssh", GSETTINGS_SCHEMA_DIR: "/home/indahj/snap/code/172/.local/share/glib-2.0/schemas", ORIGINAL_XDG_CURRENT_DESKTOP: "ubuntu:GNOME", PROJECT_CWD: "/home/indahj/Projects/recia-webcomponents", SHELL: "/bin/bash", npm_package_version: "1.0.0", npm_lifecycle_event: "build-only", QT_ACCESSIBILITY: "1", GDMSESSION: "ubuntu", LESSCLOSE: "/usr/bin/lesspipe %s %s", GTK_PATH_VSCODE_SNAP_ORIG: "", GTK_IM_MODULE_FILE_VSCODE_SNAP_ORIG: "", GJS_DEBUG_OUTPUT: "stderr", VSCODE_GIT_ASKPASS_EXTRA_ARGS: "", QT_IM_MODULE: "ibus", PWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", BERRY_BIN_FOLDER: "/tmp/xfs-e69a95c4", npm_execpath: "/tmp/xfs-e69a95c4/yarn", XDG_CONFIG_DIRS: "/etc/xdg/xdg-ubuntu:/etc/xdg", NVM_CD_FLAGS: "", XDG_DATA_DIRS: "/home/indahj/snap/code/172/.local/share:/home/indahj/snap/code/172:/snap/code/172/usr/share:/usr/share/ubuntu:/usr/local/share/:/usr/share/:/var/lib/snapd/desktop", INIT_CWD: "/home/indahj/Projects/recia-webcomponents/packages/change-etab", NODE_ENV: "production", VITE_BASE_URI: "/indah/ui", VITE_CHANGEETAB_API_URI: "/indah/changeetab/api/", VITE_USER_INFO_API_URI: "/portail/api/v5-1/userinfo?claims=private,ESCOSIREN,ESCOSIRENCourant,&groups=" };
function ql(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ql(Object(n), !0).forEach(function(r) {
      Ue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ql(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Q1(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Z1(e) {
  var t = Q1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
function Ue(e, t, n) {
  return t = Z1(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function eb(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function tb(e, t) {
  if (e == null) return {};
  var n = eb(e, t), r, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (s = 0; s < o.length; s++)
      r = o[s], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var nb = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Lf = { exports: {} };
(function(e) {
  (function(t) {
    var n = function(m, g, I) {
      if (!c(g) || d(g) || h(g) || T(g) || l(g))
        return g;
      var S, D = 0, G = 0;
      if (u(g))
        for (S = [], G = g.length; D < G; D++)
          S.push(n(m, g[D], I));
      else {
        S = {};
        for (var w in g)
          Object.prototype.hasOwnProperty.call(g, w) && (S[m(w, I)] = n(m, g[w], I));
      }
      return S;
    }, r = function(m, g) {
      g = g || {};
      var I = g.separator || "_", S = g.split || /(?=[A-Z])/;
      return m.split(S).join(I);
    }, s = function(m) {
      return O(m) ? m : (m = m.replace(/[\-_\s]+(.)?/g, function(g, I) {
        return I ? I.toUpperCase() : "";
      }), m.substr(0, 1).toLowerCase() + m.substr(1));
    }, o = function(m) {
      var g = s(m);
      return g.substr(0, 1).toUpperCase() + g.substr(1);
    }, i = function(m, g) {
      return r(m, g).toLowerCase();
    }, a = Object.prototype.toString, l = function(m) {
      return typeof m == "function";
    }, c = function(m) {
      return m === Object(m);
    }, u = function(m) {
      return a.call(m) == "[object Array]";
    }, d = function(m) {
      return a.call(m) == "[object Date]";
    }, h = function(m) {
      return a.call(m) == "[object RegExp]";
    }, T = function(m) {
      return a.call(m) == "[object Boolean]";
    }, O = function(m) {
      return m = m - 0, m === m;
    }, A = function(m, g) {
      var I = g && "process" in g ? g.process : g;
      return typeof I != "function" ? m : function(S, D) {
        return I(S, m, D);
      };
    }, v = {
      camelize: s,
      decamelize: i,
      pascalize: o,
      depascalize: i,
      camelizeKeys: function(m, g) {
        return n(A(s, g), m);
      },
      decamelizeKeys: function(m, g) {
        return n(A(i, g), m, g);
      },
      pascalizeKeys: function(m, g) {
        return n(A(o, g), m);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = v : t.humps = v;
  })(nb);
})(Lf);
var rb = Lf.exports, sb = ["class", "style"];
function ob(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), s = rb.camelize(n.slice(0, r)), o = n.slice(r + 1).trim();
    return t[s] = o, t;
  }, {});
}
function ib(e) {
  return e.split(/\s+/).reduce(function(t, n) {
    return t[n] = !0, t;
  }, {});
}
function kf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var r = (e.children || []).map(function(l) {
    return kf(l);
  }), s = Object.keys(e.attributes || {}).reduce(function(l, c) {
    var u = e.attributes[c];
    switch (c) {
      case "class":
        l.class = ib(u);
        break;
      case "style":
        l.style = ob(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var o = n.style, i = o === void 0 ? {} : o, a = tb(n, sb);
  return Si(e.tag, Mt(Mt(Mt({}, t), {}, {
    class: s.class,
    style: Mt(Mt({}, s.style), i)
  }, s.attrs), a), r);
}
var Mf = !1;
try {
  Mf = J1.NODE_ENV === "production";
} catch {
}
function ab() {
  if (!Mf && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function oo(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Ue({}, e, t) : {};
}
function lb(e) {
  var t, n = (t = {
    "fa-spin": e.spin,
    "fa-pulse": e.pulse,
    "fa-fw": e.fixedWidth,
    "fa-border": e.border,
    "fa-li": e.listItem,
    "fa-inverse": e.inverse,
    "fa-flip": e.flip === !0,
    "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
    "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
  }, Ue(Ue(Ue(Ue(Ue(Ue(Ue(Ue(Ue(Ue(t, "fa-".concat(e.size), e.size !== null), "fa-rotate-".concat(e.rotation), e.rotation !== null), "fa-pull-".concat(e.pull), e.pull !== null), "fa-swap-opacity", e.swapOpacity), "fa-bounce", e.bounce), "fa-shake", e.shake), "fa-beat", e.beat), "fa-fade", e.fade), "fa-beat-fade", e.beatFade), "fa-flash", e.flash), Ue(Ue(t, "fa-spin-pulse", e.spinPulse), "fa-spin-reverse", e.spinReverse));
  return Object.keys(n).map(function(r) {
    return n[r] ? r : null;
  }).filter(function(r) {
    return r;
  });
}
function Jl(e) {
  if (e && us(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (Jo.icon)
    return Jo.icon(e);
  if (e === null)
    return null;
  if (us(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
var cb = /* @__PURE__ */ In({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(t) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(t) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(t) {
        return ["right", "left"].indexOf(t) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(t) {
        return [90, 180, 270].indexOf(Number.parseInt(t, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(t) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var r = n.attrs, s = Xe(function() {
      return Jl(t.icon);
    }), o = Xe(function() {
      return oo("classes", lb(t));
    }), i = Xe(function() {
      return oo("transform", typeof t.transform == "string" ? Jo.transform(t.transform) : t.transform);
    }), a = Xe(function() {
      return oo("mask", Jl(t.mask));
    }), l = Xe(function() {
      return q1(s.value, Mt(Mt(Mt(Mt({}, o.value), i.value), a.value), {}, {
        symbol: t.symbol,
        title: t.title,
        titleId: t.titleId,
        maskId: t.maskId
      }));
    });
    tn(l, function(u) {
      if (!u)
        return ab("Could not find one or more icon(s)", s.value, a.value);
    }, {
      immediate: !0
    });
    var c = Xe(function() {
      return l.value ? kf(l.value.abstract[0], {}, r) : null;
    });
    return function() {
      return c.value;
    };
  }
});
const ub = { class: "modal-title" }, fb = { class: "current" }, db = { class: "form-change" }, pb = { class: "list-struct" }, mb = ["id", "value"], hb = ["for"], _b = ["disabled"], gb = /* @__PURE__ */ In({
  __name: "PageChangeEtab.ce",
  props: {
    show: { type: Boolean },
    changeEtabApi: { type: String },
    userInfoApiUrl: { type: String }
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, { t: r } = As(), s = (O) => r(`change-etab.${O}`), o = t;
    let i = Ur(!1);
    const a = Ur(""), l = Ur(), c = () => {
      i.value = !1, o("update:show", !1);
    };
    tn(
      () => n.show,
      (O) => {
        i.value = O, O && u();
      }
    );
    const u = async () => {
      try {
        const O = await a0(n.changeEtabApi, n.userInfoApiUrl);
        l.value = O.data;
      } catch (O) {
        console.error("error : ", O.res.data);
      }
    };
    async function d() {
      try {
        if (confirm(s("change-confirm"))) {
          const A = await l0(n.changeEtabApi + a.value, n.userInfoApiUrl);
          location.replace(A.data.redirectUrl + "/Logout");
        }
      } catch (O) {
        console.error("error: ", O);
      }
    }
    const h = Xe(() => a.value === ""), T = (O) => {
      O.key === "Escape" && i.value && c();
    };
    return mi(() => {
      window.addEventListener("keydown", T);
    }), Fc(() => {
      window.removeEventListener("keydown", T);
    }), (O, A) => {
      var v, m, g;
      return Yr(i) ? (kn(), lr("div", {
        key: 0,
        class: "modal-mask",
        onClick: c
      }, [
        Ne("div", {
          class: "modal-component",
          onClick: A[1] || (A[1] = gm(() => {
          }, ["stop"]))
        }, [
          Ne("header", null, [
            Ne("h1", ub, wt(s("title")), 1),
            Ne("button", {
              class: "btn-close",
              onClick: c
            }, [
              we(Yr(cb), { icon: ["fa", "xmark"] })
            ])
          ]),
          Ne("main", null, [
            Ne("span", fb, [
              ho(wt(s("struct-current")) + " " + wt((v = l.value) == null ? void 0 : v.structCurrent.displayName) + " ", 1),
              Ne("small", null, "(" + wt((m = l.value) == null ? void 0 : m.structCurrent.code) + ")", 1)
            ]),
            Ne("div", db, [
              Ne("fieldset", null, [
                Ne("legend", null, wt(s("legend")), 1),
                Ne("ul", pb, [
                  (kn(!0), lr(st, null, ep((g = l.value) == null ? void 0 : g.sirenStructures, (I) => (kn(), lr("li", {
                    key: I.id
                  }, [
                    Ud(Ne("input", {
                      type: "radio",
                      name: "",
                      id: I.id,
                      value: I.id,
                      "onUpdate:modelValue": A[0] || (A[0] = (S) => a.value = S)
                    }, null, 8, mb), [
                      [pm, a.value]
                    ]),
                    Ne("label", {
                      for: I.id
                    }, [
                      ho(wt(I.displayName) + " ", 1),
                      Ne("small", null, " (" + wt(I.code) + ") ", 1)
                    ], 8, hb)
                  ]))), 128))
                ])
              ])
            ])
          ]),
          Ne("footer", null, [
            Ne("button", {
              disabled: h.value,
              class: "btn-submit",
              onClick: d
            }, wt(s("valid-button")), 9, _b)
          ])
        ])
      ])) : xp("", !0);
    };
  }
}), bb = "label{font-size:14px}.modal-mask{position:fixed;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:var(--change-etab-modal-z-index, 1055);height:100%;width:100%;transition:opacity .2s ease-in-out,visibility .2s ease-in-out;background-color:var(--change-etab-background-modal-overlay-color, rgba(160, 160, 160, .4196078431))}.modal-mask .modal-component{position:absolute;min-width:600px;width:fit-content;height:fit-content;padding:0;margin:auto;overflow:hidden;background-color:var(--change-etab-background-modal-component-color, #ffffff);border-radius:28px;border:none;display:flex;flex-direction:column;flex-grow:0;flex-shrink:0;justify-content:center;color:var(--change-etab-font-text-color, #333)}@media (width < 600px){.modal-mask .modal-component{min-width:0}}.modal-mask .modal-component header{padding:16px;display:flex;justify-content:space-between;align-items:center}.modal-mask .modal-component header .modal-title{padding:0;margin:0;word-wrap:unset;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:22px}.modal-mask .modal-component header .btn-close{opacity:.4;font-weight:700;line-height:1;cursor:pointer;margin-left:auto;width:25px;display:flex;justify-content:center;align-items:center;background-color:transparent;border:none}.modal-mask .modal-component main{padding:0 15px}.modal-mask .modal-component main .current{display:block;font-size:15px;margin-bottom:10px}.modal-mask .modal-component main .form-change{align-self:flex-start}.modal-mask .modal-component main fieldset{padding:0;margin:0;border:0}.modal-mask .modal-component main legend{padding:0;font-size:18px;border-bottom:1px solid #e5e5e5;width:100%}.modal-mask .modal-component main .list-struct{max-height:50%;overflow-y:scroll;list-style:none;margin:10px 0;padding:0;display:flex;flex-direction:column;gap:10px}.modal-mask .modal-component footer{display:flex;padding:15px;flex-direction:row-reverse}.modal-mask .modal-component footer .btn-submit{padding:7px;border-radius:28px;background-color:var(--change-etab-button-background-color, #25b2f3);color:var(--change-etab-button-text-color, #ffffff);cursor:pointer;border:transparent;font-size:15px}.modal-mask .modal-component footer .btn-submit:disabled{color:#757575;background-color:#d6d6d6;cursor:not-allowed}", Ff = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, Eb = /* @__PURE__ */ Ff(gb, [["styles", [bb]]]), Sb = /* @__PURE__ */ cu(y_), yb = /* @__PURE__ */ cu(Eb), Ob = () => {
  customElements.define("change-etab", Sb), customElements.define("page-change-etab", yb);
}, vb = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, Ib = () => {
  Y1.add(vb);
}, Ab = {};
function Tb(e, t) {
  return kn(), lr("div");
}
const Nb = /* @__PURE__ */ Ff(Ab, [["render", Tb]]), Cb = bo(Nb);
Ob();
Ib();
Cb.use(Pu);


/***/ }),

/***/ 1799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LOCALE_STATUS_EVENT": function() { return /* reexport */ LOCALE_STATUS_EVENT; },
  "_installMsgImplementation": function() { return /* binding */ _installMsgImplementation; },
  "configureLocalization": function() { return /* reexport */ configureLocalization; },
  "configureTransformLocalization": function() { return /* reexport */ configureTransformLocalization; },
  "isStrTagged": function() { return /* reexport */ isStrTagged; },
  "joinStringsAndValues": function() { return /* reexport */ joinStringsAndValues; },
  "localized": function() { return /* reexport */ localized; },
  "msg": function() { return /* binding */ msg; },
  "str": function() { return /* reexport */ str; },
  "updateWhenLocaleChanges": function() { return /* reexport */ updateWhenLocaleChanges; }
});

;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/str-tag.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * Tag that allows expressions to be used in localized non-HTML template
 * strings.
 *
 * Example: msg(str`Hello ${this.user}!`);
 *
 * The Lit html tag can also be used for this purpose, but HTML will need to be
 * escaped, and there is a small overhead for HTML parsing.
 *
 * Untagged template strings with expressions aren't supported by lit-localize
 * because they don't allow for values to be captured at runtime.
 */
const _str = (strings, ...values) => ({
    strTag: true,
    strings,
    values,
});
const str = _str;
const isStrTagged = (val) => typeof val !== 'string' && 'strTag' in val;
/**
 * Render the result of a `str` tagged template to a string. Note we don't need
 * to do this for Lit templates, since Lit itself handles rendering.
 */
const joinStringsAndValues = (strings, values, valueOrder) => {
    let concat = strings[0];
    for (let i = 1; i < strings.length; i++) {
        concat += values[valueOrder ? valueOrder[i - 1] : i - 1];
        concat += strings[i];
    }
    return concat;
};
//# sourceMappingURL=str-tag.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/default-msg.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * Default identity msg implementation. Simply returns the input template with
 * no awareness of translations. If the template is str-tagged, returns it in
 * string form.
 */
const defaultMsg = ((template) => isStrTagged(template)
    ? joinStringsAndValues(template.strings, template.values)
    : template);
//# sourceMappingURL=default-msg.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/locale-status-event.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * Name of the event dispatched to `window` whenever a locale change starts,
 * finishes successfully, or fails. Only relevant to runtime mode.
 *
 * The `detail` of this event is an object with a `status` string that can be:
 * "loading", "ready", or "error", along with the relevant locale code, and
 * error message if applicable.
 *
 * You can listen for this event to know when your application should be
 * re-rendered following a locale change. See also the Localized mixin, which
 * automatically re-renders LitElement classes using this event.
 */
const LOCALE_STATUS_EVENT = 'lit-localize-status';
//# sourceMappingURL=locale-status-event.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/localized-controller.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

class LocalizeController {
    constructor(host) {
        this.__litLocalizeEventHandler = (event) => {
            if (event.detail.status === 'ready') {
                this.host.requestUpdate();
            }
        };
        this.host = host;
    }
    hostConnected() {
        window.addEventListener(LOCALE_STATUS_EVENT, this.__litLocalizeEventHandler);
    }
    hostDisconnected() {
        window.removeEventListener(LOCALE_STATUS_EVENT, this.__litLocalizeEventHandler);
    }
}
/**
 * Re-render the given LitElement whenever a new active locale has loaded.
 *
 * See also {@link localized} for the same functionality as a decorator.
 *
 * When using lit-localize in transform mode, calls to this function are
 * replaced with undefined.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {msg, updateWhenLocaleChanges} from '@lit/localize';
 *
 *   class MyElement extends LitElement {
 *     constructor() {
 *       super();
 *       updateWhenLocaleChanges(this);
 *     }
 *
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */
const _updateWhenLocaleChanges = (host) => host.addController(new LocalizeController(host));
const updateWhenLocaleChanges = _updateWhenLocaleChanges;
//# sourceMappingURL=localized-controller.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/localized-decorator.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * Class decorator to enable re-rendering the given LitElement whenever a new
 * active locale has loaded.
 *
 * See also {@link updateWhenLocaleChanges} for the same functionality without
 * the use of decorators.
 *
 * When using lit-localize in transform mode, applications of this decorator are
 * removed.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {customElement} from 'lit/decorators.js';
 *   import {msg, localized} from '@lit/localize';
 *
 *   @localized()
 *   @customElement('my-element')
 *   class MyElement extends LitElement {
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */
const _localized = () => (classOrDescriptor) => typeof classOrDescriptor === 'function'
    ? legacyLocalized(classOrDescriptor)
    : standardLocalized(classOrDescriptor);
const localized = _localized;
const standardLocalized = ({ kind, elements }) => {
    return {
        kind,
        elements,
        finisher(clazz) {
            clazz.addInitializer(updateWhenLocaleChanges);
        },
    };
};
const legacyLocalized = (clazz) => {
    clazz.addInitializer(updateWhenLocaleChanges);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return clazz;
};
//# sourceMappingURL=localized-decorator.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/deferred.js
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Deferred {
    constructor() {
        this.settled = false;
        this.promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    resolve(value) {
        this.settled = true;
        this._resolve(value);
    }
    reject(error) {
        this.settled = true;
        this._reject(error);
    }
}
//# sourceMappingURL=deferred.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/fnv1a64.js
/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */
// This module is derived from the file:
// https://github.com/tjwebb/fnv-plus/blob/1e2ce68a07cb7dd4c3c85364f3d8d96c95919474/index.js#L309
//
// Changes:
// - Only the _hash64_1a_fast function is included.
// - Removed loop unrolling.
// - Converted to TypeScript ES module.
// - var -> let/const
//
// TODO(aomarks) Upstream improvements to https://github.com/tjwebb/fnv-plus/.
const hl = [];
for (let i = 0; i < 256; i++) {
    hl[i] = ((i >> 4) & 15).toString(16) + (i & 15).toString(16);
}
/**
 * Perform a FNV-1A 64-bit hash of the given string (as UTF-16 code units), and
 * return a hexadecimal digest (left zero padded to 16 characters).
 *
 * @see {@link http://tools.ietf.org/html/draft-eastlake-fnv-06}
 */
function fnv1a64(str) {
    let t0 = 0, v0 = 0x2325, t1 = 0, v1 = 0x8422, t2 = 0, v2 = 0x9ce4, t3 = 0, v3 = 0xcbf2;
    for (let i = 0; i < str.length; i++) {
        v0 ^= str.charCodeAt(i);
        t0 = v0 * 435;
        t1 = v1 * 435;
        t2 = v2 * 435;
        t3 = v3 * 435;
        t2 += v0 << 8;
        t3 += v1 << 8;
        t1 += t0 >>> 16;
        v0 = t0 & 65535;
        t2 += t1 >>> 16;
        v1 = t1 & 65535;
        v3 = (t3 + (t2 >>> 16)) & 65535;
        v2 = t2 & 65535;
    }
    return (hl[v3 >> 8] +
        hl[v3 & 255] +
        hl[v2 >> 8] +
        hl[v2 & 255] +
        hl[v1 >> 8] +
        hl[v1 & 255] +
        hl[v0 >> 8] +
        hl[v0 & 255]);
}
//# sourceMappingURL=fnv1a64.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/id-generation.js
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * Delimiter used between each template string component before hashing. Used to
 * prevent e.g. "foobar" and "foo${baz}bar" from sharing a hash.
 *
 * This is the "record separator" ASCII character.
 */
const HASH_DELIMITER = '\x1e';
/**
 * Id prefix on html-tagged templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */
const HTML_PREFIX = 'h';
/**
 * Id prefix on plain string templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */
const STRING_PREFIX = 's';
/**
 * Generate a unique ID for a lit-localize message.
 *
 * Example:
 *   Template: html`Hello <b>${who}</b>!`
 *     Params: ["Hello <b>", "</b>!"], true
 *     Output: h82ccc38d4d46eaa9
 *
 * The ID is constructed as:
 *
 *   [0]    Kind of template: [h]tml or [s]tring.
 *   [1,16] 64-bit FNV-1a hash hex digest of the template strings, as UTF-16
 *          code points, delineated by an ASCII "record separator" character.
 *
 * We choose FNV-1a because:
 *
 *   1. It's pretty fast (e.g. much faster than SHA-1).
 *   2. It's pretty small (0.25 KiB minified + brotli).
 *   3. We don't require cryptographic security, and 64 bits should give
 *      sufficient collision resistance for any one application. Worst
 *      case, we will always detect collisions during analysis.
 *   4. We can't use Web Crypto API (e.g. SHA-1), because it's asynchronous.
 *   5. It's a well known non-cryptographic hash with implementations in many
 *      languages.
 *   6. There was an existing JavaScript implementation that doesn't require
 *      BigInt, for IE11 compatibility.
 */
function generateMsgId(strings, isHtmlTagged) {
    return ((isHtmlTagged ? HTML_PREFIX : STRING_PREFIX) +
        fnv1a64(typeof strings === 'string' ? strings : strings.join(HASH_DELIMITER)));
}
//# sourceMappingURL=id-generation.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/internal/runtime-msg.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */



const expressionOrders = new WeakMap();
const hashCache = new Map();
function runtimeMsg(templates, template, options) {
    var _a;
    if (templates) {
        const id = (_a = options === null || options === void 0 ? void 0 : options.id) !== null && _a !== void 0 ? _a : generateId(template);
        const localized = templates[id];
        if (localized) {
            if (typeof localized === 'string') {
                // E.g. "Hello World!"
                return localized;
            }
            else if ('strTag' in localized) {
                // E.g. str`Hello ${name}!`
                //
                // Localized templates have ${number} in place of real template
                // expressions. They can't have real template values, because the
                // variable scope would be wrong. The number tells us the index of the
                // source value to substitute in its place, because expressions can be
                // moved to a different position during translation.
                return joinStringsAndValues(localized.strings, 
                // Cast `template` because its type wasn't automatically narrowed (but
                // we know it must be the same type as `localized`).
                template.values, localized.values);
            }
            else {
                // E.g. html`Hello <b>${name}</b>!`
                //
                // We have to keep our own mapping of expression ordering because we do
                // an in-place update of `values`, and otherwise we'd lose ordering for
                // subsequent renders.
                let order = expressionOrders.get(localized);
                if (order === undefined) {
                    order = localized.values;
                    expressionOrders.set(localized, order);
                }
                // Cast `localized.values` because it's readonly.
                localized.values = order.map((i) => template.values[i]);
                return localized;
            }
        }
    }
    return defaultMsg(template);
}
function generateId(template) {
    const strings = typeof template === 'string' ? template : template.strings;
    let id = hashCache.get(strings);
    if (id === undefined) {
        id = generateMsgId(strings, typeof template !== 'string' && !('strTag' in template));
        hashCache.set(strings, id);
    }
    return id;
}
//# sourceMappingURL=runtime-msg.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/init/runtime.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */




/**
 * Dispatch a "lit-localize-status" event to `window` with the given detail.
 */
function dispatchStatusEvent(detail) {
    window.dispatchEvent(new CustomEvent(LOCALE_STATUS_EVENT, { detail }));
}
let activeLocale = '';
let loadingLocale;
let sourceLocale;
let validLocales;
let loadLocale;
let templates;
let loading = new Deferred();
// The loading promise must be initially resolved, because that's what we should
// return if the user immediately calls setLocale(sourceLocale).
loading.resolve();
let requestId = 0;
/**
 * Set configuration parameters for lit-localize when in runtime mode. Returns
 * an object with functions:
 *
 * - `getLocale`: Return the active locale code.
 * - `setLocale`: Set the active locale code.
 *
 * Throws if called more than once.
 */
const configureLocalization = (config) => {
    _installMsgImplementation(((template, options) => runtimeMsg(templates, template, options)));
    activeLocale = sourceLocale = config.sourceLocale;
    validLocales = new Set(config.targetLocales);
    validLocales.add(config.sourceLocale);
    loadLocale = config.loadLocale;
    return { getLocale, setLocale };
};
/**
 * Return the active locale code.
 */
const getLocale = () => {
    return activeLocale;
};
/**
 * Set the active locale code, and begin loading templates for that locale using
 * the `loadLocale` function that was passed to `configureLocalization`. Returns
 * a promise that resolves when the next locale is ready to be rendered.
 *
 * Note that if a second call to `setLocale` is made while the first requested
 * locale is still loading, then the second call takes precedence, and the
 * promise returned from the first call will resolve when second locale is
 * ready. If you need to know whether a particular locale was loaded, check
 * `getLocale` after the promise resolves.
 *
 * Throws if the given locale is not contained by the configured `sourceLocale`
 * or `targetLocales`.
 */
const setLocale = (newLocale) => {
    if (newLocale === (loadingLocale !== null && loadingLocale !== void 0 ? loadingLocale : activeLocale)) {
        return loading.promise;
    }
    if (!validLocales || !loadLocale) {
        throw new Error('Internal error');
    }
    if (!validLocales.has(newLocale)) {
        throw new Error('Invalid locale code');
    }
    requestId++;
    const thisRequestId = requestId;
    loadingLocale = newLocale;
    if (loading.settled) {
        loading = new Deferred();
    }
    dispatchStatusEvent({ status: 'loading', loadingLocale: newLocale });
    const localePromise = newLocale === sourceLocale
        ? // We could switch to the source locale synchronously, but we prefer to
            // queue it on a microtask so that switching locales is consistently
            // asynchronous.
            Promise.resolve({ templates: undefined })
        : loadLocale(newLocale);
    localePromise.then((mod) => {
        if (requestId === thisRequestId) {
            activeLocale = newLocale;
            loadingLocale = undefined;
            templates = mod.templates;
            dispatchStatusEvent({ status: 'ready', readyLocale: newLocale });
            loading.resolve();
        }
        // Else another locale was requested in the meantime. Don't resolve or
        // reject, because the newer load call is going to use the same promise.
        // Note the user can call getLocale() after the promise resolves if they
        // need to check if the locale is still the one they expected to load.
    }, (err) => {
        if (requestId === thisRequestId) {
            dispatchStatusEvent({
                status: 'error',
                errorLocale: newLocale,
                errorMessage: err.toString(),
            });
            loading.reject(err);
        }
    });
    return loading.promise;
};
//# sourceMappingURL=runtime.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/init/transform.js
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */


/**
 * Set configuration parameters for lit-localize when in transform mode. Returns
 * an object with function:
 *
 * - `getLocale`: Return the active locale code.
 *
 * Throws if called more than once.
 */
const configureTransformLocalization = (config) => {
    _installMsgImplementation(defaultMsg);
    const sourceLocale = config.sourceLocale;
    return {
        getLocale: () => sourceLocale,
    };
};
//# sourceMappingURL=transform.js.map
;// CONCATENATED MODULE: ./node_modules/@lit/localize/lit-localize.js
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */




// TODO(aomarks) In a future breaking version, remove these imports so that the
// bulk of the code isn't included in bundles by default. In particular imagine
// the component library use-case where msg() calls are made, but there is no
// need to actually initialize any of the localization runtime.




/**
 * Make a string or lit-html template localizable.
 *
 * @param template A string, a lit-html template, or a function that returns
 * either a string or lit-html template.
 * @param options Optional configuration object with the following properties:
 *   - id: Optional project-wide unique identifier for this template. If
 *     omitted, an id will be automatically generated from the template strings.
 *   - desc: Optional description
 */
let msg = defaultMsg;
let installed = false;
/**
 * Internal only. Do not use this function.
 *
 * Installs an implementation of the msg function to replace the default
 * identity function. Throws if called more than once.
 *
 * @internal
 */
function _installMsgImplementation(impl) {
    if (installed) {
        throw new Error('lit-localize can only be configured once');
    }
    msg = impl;
    installed = true;
}
//# sourceMappingURL=lit-localize.js.map

/***/ }),

/***/ 875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XM": function() { return /* binding */ e; },
/* harmony export */   "Xe": function() { return /* binding */ i; },
/* harmony export */   "pX": function() { return /* binding */ t; }
/* harmony export */ });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e=t=>(...e)=>({_$litDirective$:t,values:e});class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}
//# sourceMappingURL=directive.js.map


/***/ }),

/***/ 1943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UnsafeHTMLDirective": function() { return /* binding */ e; },
/* harmony export */   "unsafeHTML": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var _lit_html_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3692);
/* harmony import */ var _directive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875);

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class e extends _directive_js__WEBPACK_IMPORTED_MODULE_1__/* .Directive */ .Xe{constructor(i){if(super(i),this.it=_lit_html_js__WEBPACK_IMPORTED_MODULE_0__/* .nothing */ .Ld,i.type!==_directive_js__WEBPACK_IMPORTED_MODULE_1__/* .PartType.CHILD */ .pX.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(r){if(r===_lit_html_js__WEBPACK_IMPORTED_MODULE_0__/* .nothing */ .Ld||null==r)return this.ft=void 0,this.it=r;if(r===_lit_html_js__WEBPACK_IMPORTED_MODULE_0__/* .noChange */ .Jb)return r;if("string"!=typeof r)throw Error(this.constructor.directiveName+"() called with a non-string value");if(r===this.it)return this.ft;this.it=r;const s=[r];return s.raw=s,this.ft={_$litType$:this.constructor.resultType,strings:s,values:[]}}}e.directiveName="unsafeHTML",e.resultType=1;const o=(0,_directive_js__WEBPACK_IMPORTED_MODULE_1__/* .directive */ .XM)(e);
//# sourceMappingURL=unsafe-html.js.map


/***/ }),

/***/ 3692:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ R; },
/* harmony export */   "Jb": function() { return /* binding */ b; },
/* harmony export */   "Ld": function() { return /* binding */ w; },
/* harmony export */   "YP": function() { return /* binding */ y; },
/* harmony export */   "dy": function() { return /* binding */ $; },
/* harmony export */   "sY": function() { return /* binding */ x; }
/* harmony export */ });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;const i=globalThis.trustedTypes,s=i?i.createPolicy("lit-html",{createHTML:t=>t}):void 0,e=`lit$${(Math.random()+"").slice(9)}$`,o="?"+e,n=`<${o}>`,l=document,h=(t="")=>l.createComment(t),r=t=>null===t||"object"!=typeof t&&"function"!=typeof t,d=Array.isArray,u=t=>{var i;return d(t)||"function"==typeof(null===(i=t)||void 0===i?void 0:i[Symbol.iterator])},c=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,v=/-->/g,a=/>/g,f=/>|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,_=/'/g,m=/"/g,g=/^(?:script|style|textarea|title)$/i,p=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),$=p(1),y=p(2),b=Symbol.for("lit-noChange"),w=Symbol.for("lit-nothing"),T=new WeakMap,x=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new N(i.insertBefore(h(),t),t,void 0,null!=s?s:{})}return l._$AI(t),l},A=l.createTreeWalker(l,129,null,!1),C=(t,i)=>{const o=t.length-1,l=[];let h,r=2===i?"<svg>":"",d=c;for(let i=0;i<o;i++){const s=t[i];let o,u,p=-1,$=0;for(;$<s.length&&(d.lastIndex=$,u=d.exec(s),null!==u);)$=d.lastIndex,d===c?"!--"===u[1]?d=v:void 0!==u[1]?d=a:void 0!==u[2]?(g.test(u[2])&&(h=RegExp("</"+u[2],"g")),d=f):void 0!==u[3]&&(d=f):d===f?">"===u[0]?(d=null!=h?h:c,p=-1):void 0===u[1]?p=-2:(p=d.lastIndex-u[2].length,o=u[1],d=void 0===u[3]?f:'"'===u[3]?m:_):d===m||d===_?d=f:d===v||d===a?d=c:(d=f,h=void 0);const y=d===f&&t[i+1].startsWith("/>")?" ":"";r+=d===c?s+n:p>=0?(l.push(o),s.slice(0,p)+"$lit$"+s.slice(p)+e+y):s+e+(-2===p?(l.push(void 0),i):y)}const u=r+(t[o]||"<?>")+(2===i?"</svg>":"");if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return[void 0!==s?s.createHTML(u):u,l]};class E{constructor({strings:t,_$litType$:s},n){let l;this.parts=[];let r=0,d=0;const u=t.length-1,c=this.parts,[v,a]=C(t,s);if(this.el=E.createElement(v,n),A.currentNode=this.el.content,2===s){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes)}for(;null!==(l=A.nextNode())&&c.length<u;){if(1===l.nodeType){if(l.hasAttributes()){const t=[];for(const i of l.getAttributeNames())if(i.endsWith("$lit$")||i.startsWith(e)){const s=a[d++];if(t.push(i),void 0!==s){const t=l.getAttribute(s.toLowerCase()+"$lit$").split(e),i=/([.?@])?(.*)/.exec(s);c.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?M:"?"===i[1]?H:"@"===i[1]?I:S})}else c.push({type:6,index:r})}for(const i of t)l.removeAttribute(i)}if(g.test(l.tagName)){const t=l.textContent.split(e),s=t.length-1;if(s>0){l.textContent=i?i.emptyScript:"";for(let i=0;i<s;i++)l.append(t[i],h()),A.nextNode(),c.push({type:2,index:++r});l.append(t[s],h())}}}else if(8===l.nodeType)if(l.data===o)c.push({type:2,index:r});else{let t=-1;for(;-1!==(t=l.data.indexOf(e,t+1));)c.push({type:7,index:r}),t+=e.length-1}r++}}static createElement(t,i){const s=l.createElement("template");return s.innerHTML=t,s}}function P(t,i,s=t,e){var o,n,l,h;if(i===b)return i;let d=void 0!==e?null===(o=s._$Cl)||void 0===o?void 0:o[e]:s._$Cu;const u=r(i)?void 0:i._$litDirective$;return(null==d?void 0:d.constructor)!==u&&(null===(n=null==d?void 0:d._$AO)||void 0===n||n.call(d,!1),void 0===u?d=void 0:(d=new u(t),d._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Cl)&&void 0!==l?l:h._$Cl=[])[e]=d:s._$Cu=d),void 0!==d&&(i=P(t,d._$AS(t,i.values),d,e)),i}class V{constructor(t,i){this.v=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}p(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:l).importNode(s,!0);A.currentNode=o;let n=A.nextNode(),h=0,r=0,d=e[0];for(;void 0!==d;){if(h===d.index){let i;2===d.type?i=new N(n,n.nextSibling,this,t):1===d.type?i=new d.ctor(n,d.name,d.strings,this,t):6===d.type&&(i=new L(n,this,t)),this.v.push(i),d=e[++r]}h!==(null==d?void 0:d.index)&&(n=A.nextNode(),h++)}return o}m(t){let i=0;for(const s of this.v)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++}}class N{constructor(t,i,s,e){var o;this.type=2,this._$AH=w,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cg=null===(o=null==e?void 0:e.isConnected)||void 0===o||o}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cg}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=P(this,t,i),r(t)?t===w||null==t||""===t?(this._$AH!==w&&this._$AR(),this._$AH=w):t!==this._$AH&&t!==b&&this.$(t):void 0!==t._$litType$?this.T(t):void 0!==t.nodeType?this.k(t):u(t)?this.S(t):this.$(t)}M(t,i=this._$AB){return this._$AA.parentNode.insertBefore(t,i)}k(t){this._$AH!==t&&(this._$AR(),this._$AH=this.M(t))}$(t){this._$AH!==w&&r(this._$AH)?this._$AA.nextSibling.data=t:this.k(l.createTextNode(t)),this._$AH=t}T(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=E.createElement(e.h,this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.m(s);else{const t=new V(o,this),i=t.p(this.options);t.m(s),this.k(i),this._$AH=t}}_$AC(t){let i=T.get(t.strings);return void 0===i&&T.set(t.strings,i=new E(t)),i}S(t){d(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new N(this.M(h()),this.M(h()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e)}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i}}setConnected(t){var i;void 0===this._$AM&&(this._$Cg=t,null===(i=this._$AP)||void 0===i||i.call(this,t))}}class S{constructor(t,i,s,e,o){this.type=1,this._$AH=w,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=w}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=P(this,t,i,0),n=!r(t)||t!==this._$AH&&t!==b,n&&(this._$AH=t);else{const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=P(this,e[s+l],i,l),h===b&&(h=this._$AH[l]),n||(n=!r(h)||h!==this._$AH[l]),h===w?t=w:t!==w&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h}n&&!e&&this.C(t)}C(t){t===w?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"")}}class M extends S{constructor(){super(...arguments),this.type=3}C(t){this.element[this.name]=t===w?void 0:t}}const k=i?i.emptyScript:"";class H extends S{constructor(){super(...arguments),this.type=4}C(t){t&&t!==w?this.element.setAttribute(this.name,k):this.element.removeAttribute(this.name)}}class I extends S{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5}_$AI(t,i=this){var s;if((t=null!==(s=P(this,t,i,0))&&void 0!==s?s:w)===b)return;const e=this._$AH,o=t===w&&e!==w||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==w&&(e===w||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t)}}class L{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s}get _$AU(){return this._$AM._$AU}_$AI(t){P(this,t)}}const R={L:"$lit$",P:e,V:o,I:1,N:C,R:V,j:u,D:P,H:N,F:S,O:H,W:I,B:M,Z:L},z=window.litHtmlPolyfillSupport;null==z||z(E,N),(null!==(t=globalThis.litHtmlVersions)&&void 0!==t?t:globalThis.litHtmlVersions=[]).push("2.2.5");
//# sourceMappingURL=lit-html.js.map


/***/ }),

/***/ 5595:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "customElement": function() { return /* reexport */ n; },
  "eventOptions": function() { return /* reexport */ event_options_e; },
  "property": function() { return /* reexport */ e; },
  "query": function() { return /* reexport */ query_i; },
  "queryAll": function() { return /* reexport */ query_all_e; },
  "queryAssignedElements": function() { return /* reexport */ query_assigned_elements_l; },
  "queryAssignedNodes": function() { return /* reexport */ o; },
  "queryAsync": function() { return /* reexport */ query_async_e; },
  "state": function() { return /* reexport */ t; }
});

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/custom-element.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const n=n=>e=>"function"==typeof e?((n,e)=>(window.customElements.define(n,e),e))(n,e):((n,e)=>{const{kind:t,elements:i}=e;return{kind:t,elements:i,finisher(e){window.customElements.define(n,e)}}})(n,e);
//# sourceMappingURL=custom-element.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/property.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i=(i,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(n){n.createProperty(e.key,i)}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this))},finisher(n){n.createProperty(e.key,i)}};function e(e){return(n,t)=>void 0!==t?((i,e,n)=>{e.constructor.createProperty(n,i)})(e,n,t):i(e,n)}
//# sourceMappingURL=property.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/state.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function t(t){return e({...t,state:!0})}
//# sourceMappingURL=state.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/base.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const base_e=(e,t,o)=>{Object.defineProperty(t,o,e)},base_t=(e,t)=>({kind:"method",placement:"prototype",key:t.key,descriptor:e}),base_o=({finisher:e,descriptor:t})=>(o,n)=>{var r;if(void 0===n){const n=null!==(r=o.originalKey)&&void 0!==r?r:o.key,i=null!=t?{kind:"method",placement:"prototype",key:n,descriptor:t(o.key)}:{...o,key:n};return null!=e&&(i.finisher=function(t){e(t,n)}),i}{const r=o.constructor;void 0!==t&&Object.defineProperty(o,n,t(n)),null==e||e(r,n)}};
//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/event-options.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function event_options_e(e){return base_o({finisher:(r,t)=>{Object.assign(r.prototype[t],e)}})}
//# sourceMappingURL=event-options.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/query.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function query_i(i,n){return base_o({descriptor:o=>{const t={get(){var o,n;return null!==(n=null===(o=this.renderRoot)||void 0===o?void 0:o.querySelector(i))&&void 0!==n?n:null},enumerable:!0,configurable:!0};if(n){const n="symbol"==typeof o?Symbol():"__"+o;t.get=function(){var o,t;return void 0===this[n]&&(this[n]=null!==(t=null===(o=this.renderRoot)||void 0===o?void 0:o.querySelector(i))&&void 0!==t?t:null),this[n]}}return t}})}
//# sourceMappingURL=query.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/query-all.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function query_all_e(e){return base_o({descriptor:r=>({get(){var r,o;return null!==(o=null===(r=this.renderRoot)||void 0===r?void 0:r.querySelectorAll(e))&&void 0!==o?o:[]},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-all.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/query-async.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function query_async_e(e){return base_o({descriptor:r=>({async get(){var r;return await this.updateComplete,null===(r=this.renderRoot)||void 0===r?void 0:r.querySelector(e)},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-async.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/query-assigned-elements.js

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var query_assigned_elements_n;const query_assigned_elements_e=null!=(null===(query_assigned_elements_n=window.HTMLSlotElement)||void 0===query_assigned_elements_n?void 0:query_assigned_elements_n.prototype.assignedElements)?(o,n)=>o.assignedElements(n):(o,n)=>o.assignedNodes(n).filter((o=>o.nodeType===Node.ELEMENT_NODE));function query_assigned_elements_l(n){const{slot:l,selector:t}=null!=n?n:{};return base_o({descriptor:o=>({get(){var o;const r="slot"+(l?`[name=${l}]`:":not([name])"),i=null===(o=this.renderRoot)||void 0===o?void 0:o.querySelector(r),s=null!=i?query_assigned_elements_e(i,n):[];return t?s.filter((o=>o.matches(t))):s},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-assigned-elements.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/decorators/query-assigned-nodes.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function o(o,n,r){let l,s=o;return"object"==typeof o?(s=o.slot,l=o):l={flatten:n},r?query_assigned_elements_l({slot:s,flatten:n,selector:r}):base_o({descriptor:e=>({get(){var e,t;const o="slot"+(s?`[name=${s}]`:":not([name])"),n=null===(e=this.renderRoot)||void 0===e?void 0:e.querySelector(o);return null!==(t=null==n?void 0:n.assignedNodes(l))&&void 0!==t?t:[]},enumerable:!0,configurable:!0})})}
//# sourceMappingURL=query-assigned-nodes.js.map

;// CONCATENATED MODULE: ./node_modules/lit/decorators.js

//# sourceMappingURL=decorators.js.map


/***/ }),

/***/ 9455:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "classMap": function() { return /* reexport */ o; }
});

// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(3692);
// EXTERNAL MODULE: ./node_modules/lit-html/directive.js
var directive = __webpack_require__(875);
;// CONCATENATED MODULE: ./node_modules/lit-html/directives/class-map.js

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o=(0,directive/* directive */.XM)(class extends directive/* Directive */.Xe{constructor(t){var i;if(super(t),t.type!==directive/* PartType.ATTRIBUTE */.pX.ATTRIBUTE||"class"!==t.name||(null===(i=t.strings)||void 0===i?void 0:i.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return" "+Object.keys(t).filter((i=>t[i])).join(" ")+" "}update(i,[s]){var r,o;if(void 0===this.et){this.et=new Set,void 0!==i.strings&&(this.st=new Set(i.strings.join(" ").split(/\s/).filter((t=>""!==t))));for(const t in s)s[t]&&!(null===(r=this.st)||void 0===r?void 0:r.has(t))&&this.et.add(t);return this.render(s)}const e=i.element.classList;this.et.forEach((t=>{t in s||(e.remove(t),this.et.delete(t))}));for(const t in s){const i=!!s[t];i===this.et.has(t)||(null===(o=this.st)||void 0===o?void 0:o.has(t))||(i?(e.add(t),this.et.add(t)):(e.remove(t),this.et.delete(t)))}return lit_html/* noChange */.Jb}});
//# sourceMappingURL=class-map.js.map

;// CONCATENATED MODULE: ./node_modules/lit/directives/class-map.js

//# sourceMappingURL=class-map.js.map


/***/ }),

/***/ 2386:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "repeat": function() { return /* reexport */ c; }
});

// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(3692);
// EXTERNAL MODULE: ./node_modules/lit-html/directive.js
var directive = __webpack_require__(875);
;// CONCATENATED MODULE: ./node_modules/lit-html/directive-helpers.js

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{H:i}=lit_html/* _$LH */.Al,t=o=>null===o||"object"!=typeof o&&"function"!=typeof o,n={HTML:1,SVG:2},v=(o,i)=>{var t,n;return void 0===i?void 0!==(null===(t=o)||void 0===t?void 0:t._$litType$):(null===(n=o)||void 0===n?void 0:n._$litType$)===i},l=o=>{var i;return void 0!==(null===(i=o)||void 0===i?void 0:i._$litDirective$)},d=o=>{var i;return null===(i=o)||void 0===i?void 0:i._$litDirective$},r=o=>void 0===o.strings,e=()=>document.createComment(""),u=(o,t,n)=>{var v;const l=o._$AA.parentNode,d=void 0===t?o._$AB:t._$AA;if(void 0===n){const t=l.insertBefore(e(),d),v=l.insertBefore(e(),d);n=new i(t,v,o,o.options)}else{const i=n._$AB.nextSibling,t=n._$AM,r=t!==o;if(r){let i;null===(v=n._$AQ)||void 0===v||v.call(n,o),n._$AM=o,void 0!==n._$AP&&(i=o._$AU)!==t._$AU&&n._$AP(i)}if(i!==d||r){let o=n._$AA;for(;o!==i;){const i=o.nextSibling;l.insertBefore(o,d),o=i}}}return n},directive_helpers_c=(o,i,t=o)=>(o._$AI(i,t),o),f={},directive_helpers_s=(o,i=f)=>o._$AH=i,directive_helpers_a=o=>o._$AH,directive_helpers_m=o=>{var i;null===(i=o._$AP)||void 0===i||i.call(o,!1,!0);let t=o._$AA;const n=o._$AB.nextSibling;for(;t!==n;){const o=t.nextSibling;t.remove(),t=o}},p=o=>{o._$AR()};
//# sourceMappingURL=directive-helpers.js.map

;// CONCATENATED MODULE: ./node_modules/lit-html/directives/repeat.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const repeat_u=(e,s,t)=>{const r=new Map;for(let l=s;l<=t;l++)r.set(e[l],l);return r},c=(0,directive/* directive */.XM)(class extends directive/* Directive */.Xe{constructor(e){if(super(e),e.type!==directive/* PartType.CHILD */.pX.CHILD)throw Error("repeat() can only be used in text expressions")}dt(e,s,t){let r;void 0===t?t=s:void 0!==s&&(r=s);const l=[],o=[];let i=0;for(const s of e)l[i]=r?r(s,i):i,o[i]=t(s,i),i++;return{values:o,keys:l}}render(e,s,t){return this.dt(e,s,t).values}update(s,[t,r,c]){var d;const a=directive_helpers_a(s),{values:p,keys:v}=this.dt(t,r,c);if(!Array.isArray(a))return this.ut=v,p;const h=null!==(d=this.ut)&&void 0!==d?d:this.ut=[],m=[];let y,x,j=0,k=a.length-1,w=0,A=p.length-1;for(;j<=k&&w<=A;)if(null===a[j])j++;else if(null===a[k])k--;else if(h[j]===v[w])m[w]=directive_helpers_c(a[j],p[w]),j++,w++;else if(h[k]===v[A])m[A]=directive_helpers_c(a[k],p[A]),k--,A--;else if(h[j]===v[A])m[A]=directive_helpers_c(a[j],p[A]),u(s,m[A+1],a[j]),j++,A--;else if(h[k]===v[w])m[w]=directive_helpers_c(a[k],p[w]),u(s,a[j],a[k]),k--,w++;else if(void 0===y&&(y=repeat_u(v,w,A),x=repeat_u(h,j,k)),y.has(h[j]))if(y.has(h[k])){const e=x.get(v[w]),t=void 0!==e?a[e]:null;if(null===t){const e=u(s,a[j]);directive_helpers_c(e,p[w]),m[w]=e}else m[w]=directive_helpers_c(t,p[w]),u(s,a[j],t),a[e]=null;w++}else directive_helpers_m(a[k]),k--;else directive_helpers_m(a[j]),j++;for(;w<=A;){const e=u(s,m[A+1]);directive_helpers_c(e,p[w]),m[w++]=e}for(;j<=k;){const e=a[j++];null!==e&&directive_helpers_m(e)}return this.ut=v,directive_helpers_s(s,m),lit_html/* noChange */.Jb}});
//# sourceMappingURL=repeat.js.map

;// CONCATENATED MODULE: ./node_modules/lit/directives/repeat.js

//# sourceMappingURL=repeat.js.map


/***/ }),

/***/ 3959:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "styleMap": function() { return /* reexport */ i; }
});

// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(3692);
// EXTERNAL MODULE: ./node_modules/lit-html/directive.js
var directive = __webpack_require__(875);
;// CONCATENATED MODULE: ./node_modules/lit-html/directives/style-map.js

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const i=(0,directive/* directive */.XM)(class extends directive/* Directive */.Xe{constructor(t){var e;if(super(t),t.type!==directive/* PartType.ATTRIBUTE */.pX.ATTRIBUTE||"style"!==t.name||(null===(e=t.strings)||void 0===e?void 0:e.length)>2)throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.")}render(t){return Object.keys(t).reduce(((e,r)=>{const s=t[r];return null==s?e:e+`${r=r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g,"-$&").toLowerCase()}:${s};`}),"")}update(e,[r]){const{style:s}=e.element;if(void 0===this.ct){this.ct=new Set;for(const t in r)this.ct.add(t);return this.render(r)}this.ct.forEach((t=>{null==r[t]&&(this.ct.delete(t),t.includes("-")?s.removeProperty(t):s[t]="")}));for(const t in r){const e=r[t];null!=e&&(this.ct.add(t),t.includes("-")?s.setProperty(t,e):s[t]=e)}return lit_html/* noChange */.Jb}});
//# sourceMappingURL=style-map.js.map

;// CONCATENATED MODULE: ./node_modules/lit/directives/style-map.js

//# sourceMappingURL=style-map.js.map


/***/ }),

/***/ 9392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CSSResult": function() { return /* reexport */ s; },
  "LitElement": function() { return /* reexport */ lit_element_s; },
  "ReactiveElement": function() { return /* reexport */ a; },
  "UpdatingElement": function() { return /* reexport */ lit_element_r; },
  "_$LE": function() { return /* reexport */ lit_element_h; },
  "_$LH": function() { return /* reexport */ lit_html/* _$LH */.Al; },
  "adoptStyles": function() { return /* reexport */ i; },
  "css": function() { return /* reexport */ r; },
  "defaultConverter": function() { return /* reexport */ reactive_element_o; },
  "getCompatibleStyle": function() { return /* reexport */ S; },
  "html": function() { return /* reexport */ lit_html/* html */.dy; },
  "noChange": function() { return /* reexport */ lit_html/* noChange */.Jb; },
  "notEqual": function() { return /* reexport */ reactive_element_n; },
  "nothing": function() { return /* reexport */ lit_html/* nothing */.Ld; },
  "render": function() { return /* reexport */ lit_html/* render */.sY; },
  "supportsAdoptingStyleSheets": function() { return /* reexport */ t; },
  "svg": function() { return /* reexport */ lit_html/* svg */.YP; },
  "unsafeCSS": function() { return /* reexport */ o; }
});

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/css-tag.js
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,e=Symbol(),n=new Map;class s{constructor(t,n){if(this._$cssResult$=!0,n!==e)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t}get styleSheet(){let e=n.get(this.cssText);return t&&void 0===e&&(n.set(this.cssText,e=new CSSStyleSheet),e.replaceSync(this.cssText)),e}toString(){return this.cssText}}const o=t=>new s("string"==typeof t?t:t+"",e),r=(t,...n)=>{const o=1===t.length?t[0]:n.reduce(((e,n,s)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(n)+t[s+1]),t[0]);return new s(o,e)},i=(e,n)=>{t?e.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((t=>{const n=document.createElement("style"),s=window.litNonce;void 0!==s&&n.setAttribute("nonce",s),n.textContent=t.cssText,e.appendChild(n)}))},S=t?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const n of t.cssRules)e+=n.cssText;return o(e)})(t):t;
//# sourceMappingURL=css-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/reactive-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var reactive_element_s;const reactive_element_e=window.trustedTypes,reactive_element_r=reactive_element_e?reactive_element_e.emptyScript:"",h=window.reactiveElementPolyfillSupport,reactive_element_o={toAttribute(t,i){switch(i){case Boolean:t=t?reactive_element_r:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t)}catch(t){s=null}}return s}},reactive_element_n=(t,i)=>i!==t&&(i==i||t==t),l={attribute:!0,type:String,converter:reactive_element_o,reflect:!1,hasChanged:reactive_element_n};class a extends HTMLElement{constructor(){super(),this._$Et=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Ei=null,this.o()}static addInitializer(t){var i;null!==(i=this.l)&&void 0!==i||(this.l=[]),this.l.push(t)}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Eh(s,i);void 0!==e&&(this._$Eu.set(e,s),t.push(e))})),t}static createProperty(t,i=l){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e)}}static getPropertyDescriptor(t,i,s){return{get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l}static finalize(){if(this.hasOwnProperty("finalized"))return!1;this.finalized=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),this.elementProperties=new Map(t.elementProperties),this._$Eu=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(S(i))}else void 0!==i&&s.push(S(i));return s}static _$Eh(t,i){const s=i.attribute;return!1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}o(){var t;this._$Ep=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Em(),this.requestUpdate(),null===(t=this.constructor.l)||void 0===t||t.forEach((t=>t(this)))}addController(t){var i,s;(null!==(i=this._$Eg)&&void 0!==i?i:this._$Eg=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t))}removeController(t){var i;null===(i=this._$Eg)||void 0===i||i.splice(this._$Eg.indexOf(t)>>>0,1)}_$Em(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Et.set(i,this[i]),delete this[i])}))}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return i(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}))}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}))}attributeChangedCallback(t,i,s){this._$AK(t,s)}_$ES(t,i,s=l){var e,r;const h=this.constructor._$Eh(t,s);if(void 0!==h&&!0===s.reflect){const n=(null!==(r=null===(e=s.converter)||void 0===e?void 0:e.toAttribute)&&void 0!==r?r:reactive_element_o.toAttribute)(i,s.type);this._$Ei=t,null==n?this.removeAttribute(h):this.setAttribute(h,n),this._$Ei=null}}_$AK(t,i){var s,e,r;const h=this.constructor,n=h._$Eu.get(t);if(void 0!==n&&this._$Ei!==n){const t=h.getPropertyOptions(n),l=t.converter,a=null!==(r=null!==(e=null===(s=l)||void 0===s?void 0:s.fromAttribute)&&void 0!==e?e:"function"==typeof l?l:null)&&void 0!==r?r:reactive_element_o.fromAttribute;this._$Ei=n,this[n]=a(i,t.type),this._$Ei=null}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||reactive_element_n)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$Ei!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$Ep=this._$E_())}async _$E_(){this.isUpdatePending=!0;try{await this._$Ep}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Et&&(this._$Et.forEach(((t,i)=>this[i]=t)),this._$Et=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$EU()}catch(t){throw i=!1,this._$EU(),t}i&&this._$AE(s)}willUpdate(t){}_$AE(t){var i;null===(i=this._$Eg)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EU(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$Ep}shouldUpdate(t){return!0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$ES(i,this[i],t))),this._$EC=void 0),this._$EU()}updated(t){}firstUpdated(t){}}a.finalized=!0,a.elementProperties=new Map,a.elementStyles=[],a.shadowRootOptions={mode:"open"},null==h||h({ReactiveElement:a}),(null!==(reactive_element_s=globalThis.reactiveElementVersions)&&void 0!==reactive_element_s?reactive_element_s:globalThis.reactiveElementVersions=[]).push("1.3.0");
//# sourceMappingURL=reactive-element.js.map

// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js
var lit_html = __webpack_require__(3692);
;// CONCATENATED MODULE: ./node_modules/lit-element/lit-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var lit_element_l,lit_element_o;const lit_element_r=a;class lit_element_s extends a{constructor(){super(...arguments),this.renderOptions={host:this},this._$Dt=void 0}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Dt=(0,lit_html/* render */.sY)(i,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!1)}render(){return lit_html/* noChange */.Jb}}lit_element_s.finalized=!0,lit_element_s._$litElement$=!0,null===(lit_element_l=globalThis.litElementHydrateSupport)||void 0===lit_element_l||lit_element_l.call(globalThis,{LitElement:lit_element_s});const lit_element_n=globalThis.litElementPolyfillSupport;null==lit_element_n||lit_element_n({LitElement:lit_element_s});const lit_element_h={_$AK:(t,e,i)=>{t._$AK(e,i)},_$AL:t=>t._$AL};(null!==(lit_element_o=globalThis.litElementVersions)&&void 0!==lit_element_o?lit_element_o:globalThis.litElementVersions=[]).push("3.2.0");
//# sourceMappingURL=lit-element.js.map

;// CONCATENATED MODULE: ./node_modules/lit/index.js

//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1020:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A11y": function() { return /* reexport */ A11y; },
  "Autoplay": function() { return /* reexport */ Autoplay; },
  "Controller": function() { return /* reexport */ Controller; },
  "EffectCards": function() { return /* reexport */ EffectCards; },
  "EffectCoverflow": function() { return /* reexport */ EffectCoverflow; },
  "EffectCreative": function() { return /* reexport */ EffectCreative; },
  "EffectCube": function() { return /* reexport */ EffectCube; },
  "EffectFade": function() { return /* reexport */ EffectFade; },
  "EffectFlip": function() { return /* reexport */ EffectFlip; },
  "FreeMode": function() { return /* reexport */ freeMode; },
  "Grid": function() { return /* reexport */ Grid; },
  "HashNavigation": function() { return /* reexport */ HashNavigation; },
  "History": function() { return /* reexport */ History; },
  "Keyboard": function() { return /* reexport */ Keyboard; },
  "Lazy": function() { return /* reexport */ Lazy; },
  "Manipulation": function() { return /* reexport */ Manipulation; },
  "Mousewheel": function() { return /* reexport */ Mousewheel; },
  "Navigation": function() { return /* reexport */ Navigation; },
  "Pagination": function() { return /* reexport */ Pagination; },
  "Parallax": function() { return /* reexport */ Parallax; },
  "Scrollbar": function() { return /* reexport */ Scrollbar; },
  "Swiper": function() { return /* reexport */ core; },
  "Thumbs": function() { return /* reexport */ Thumb; },
  "Virtual": function() { return /* reexport */ Virtual; },
  "Zoom": function() { return /* reexport */ Zoom; },
  "default": function() { return /* reexport */ core; }
});

;// CONCATENATED MODULE: ./node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js
/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */


/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  const window = ssr_window_esm_getWindow();
  const document = getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  let el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    const dataKey = el.getAttribute(`data-${key}`);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      const attr = el.attributes[i];

      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }

  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    const el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      const values = [];

      for (let i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = $(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger(...args) {
  const window = ssr_window_esm_getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = ssr_window_esm_getWindow();
    const document = getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  const window = getWindow();

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  const window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = ssr_window_esm_getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = ssr_window_esm_getWindow();
  const document = getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append(...els) {
  let newChild;
  const document = getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  $(parent).append(this);
  return this;
}

function prepend(newChild) {
  const document = getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  const before = $(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  const after = $(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return $(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  const dom = this;
  let i;
  let j;

  for (i = 0; i < els.length; i += 1) {
    const toAdd = $(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

// eslint-disable-next-line

function scrollTo(...args) {
  const window = getWindow();
  let [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line

    let scrollLeft; // eslint-disable-line

    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      let done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  let [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

// eslint-disable-next-line

function animate(initialProps, initialParams) {
  const window = getWindow();
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      const elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            const currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;

  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;

  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (let i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

const click = shortcut('click');
const dom7_esm_blur = shortcut('blur');
const dom7_esm_focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const dom7_esm_submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && ($)));


;// CONCATENATED MODULE: ./node_modules/swiper/shared/dom.js

const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = ($);
;// CONCATENATED MODULE: ./node_modules/swiper/shared/utils.js


function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  const window = ssr_window_esm_getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  const window = ssr_window_esm_getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend() {
  const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window = ssr_window_esm_getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-support.js

let support;

function calcSupport() {
  const window = ssr_window_esm_getWindow();
  const document = getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-device.js


let deviceCached;

function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support = getSupport();
  const window = ssr_window_esm_getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-browser.js

let browser;

function calcBrowser() {
  const window = ssr_window_esm_getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/resize/resize.js

function Resize(_ref) {
  let {
    swiper,
    on,
    emit
  } = _ref;
  const window = ssr_window_esm_getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(_ref2 => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/observer/observer.js

function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const observers = [];
  const window = ssr_window_esm_getWindow();

  const attach = function (target, options) {
    if (options === void 0) {
      options = {};
    }

    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit() {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSize.js
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlides.js

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateAutoHeight.js

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || dom([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateProgress.js
function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateActiveIndex.js
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = dom(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/getTranslate.js

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/translateTo.js

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/setTransition.js
function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEmit.js
function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionStart.js

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEnd.js

function transitionEnd_transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideTo.js

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  const translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToLoop.js
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopCreate.js


function loopCreate() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? dom($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = dom(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = dom(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append(dom(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend(dom(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopFix.js
function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopDestroy.js
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = getDocument();
  const window = ssr_window_esm_getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = dom(event.path[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchMove.js



function onTouchMove(event) {
  const document = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!dom(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchEnd.js

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onResize.js
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onClick.js
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onScroll.js
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/index.js







let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

/* harmony default export */ var core_events = ({
  attachEvents,
  detachEvents
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/setBreakpoint.js


const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = ssr_window_esm_getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/removeClasses.js
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = ssr_window_esm_getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/preloadImages.js
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/check-overflow/index.js
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/moduleExtendParams.js

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }

    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    utils_extend(allModulesParams, obj);
  };
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/core.js
/* eslint no-param-reassign: "off" */






















const prototypes = {
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  events: core_events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
const extendedDefaults = {};

class Swiper {
  constructor() {
    let el;
    let params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      const swipers = [];
      dom(params.el).each(containerEl => {
        const newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = 'current';
    }

    if (exact === void 0) {
      exact = false;
    }

    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return dom($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
/* harmony default export */ var core = (Swiper);
;// CONCATENATED MODULE: ./node_modules/swiper/modules/virtual/virtual.js


function Virtual(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    const params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    const $slideEl = params.renderSlide ? dom(params.renderSlide.call(swiper, slide, index)) : dom(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];

          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    const prependIndexes = [];
    const appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
/* eslint-disable consistent-return */


function Keyboard(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = getDocument();
  const window = ssr_window_esm_getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    dom(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    dom(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
/* eslint-disable consistent-return */



function Mousewheel(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = ssr_window_esm_getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = dom(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = dom(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-element-if-not-defined.js

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/navigation/navigation.js


function Navigation(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = dom(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/classes-to-selector.js
function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/pagination/pagination.js



function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = dom(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = dom(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if (dom(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = dom(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.js




function Scrollbar(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = dom(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = dom(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/parallax/parallax.js

function Parallax(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = dom(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      dom(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = function (duration) {
    if (duration === void 0) {
      duration = swiper.params.speed;
    }

    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = dom(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/zoom/zoom.js



function Zoom(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = ssr_window_esm_getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let gesturesEnabled;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  } // Events


  function onGestureStart(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = dom(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }

    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function onGestureEnd(e) {
    const device = swiper.device;
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTransitionEnd() {
    const zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = dom(e.target).closest(`.${swiper.params.slideClass}`);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    const support = swiper.support;
    const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }

  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners();
    const slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const support = swiper.support;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support = swiper.support;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/lazy/lazy.js


function Lazy(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate) {
    if (loadInDuplicate === void 0) {
      loadInDuplicate = true;
    }

    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = dom(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = dom(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return dom(slideEl).attr('data-swiper-slide-index');
      }

      return dom(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? dom(slideEl).attr('data-swiper-slide-index') : dom(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = ssr_window_esm_getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? dom(swiper.params.lazy.scrollingElement) : dom(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/controller/controller.js
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function Controller(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/a11y/a11y.js


function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }

    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = dom(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = dom(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handleFocus = e => {
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(dom(swiper.slides), params.itemRoleDescriptionMessage);
    }

    addElRole(dom(swiper.slides), params.slideRole);
    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = dom(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
  }

  on('beforeInit', () => {
    liveRegion = dom(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/history/history.js

function History(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};

  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  const getPathValues = urlOverride => {
    const window = ssr_window_esm_getWindow();
    let location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  const setHistory = (key, index) => {
    const window = ssr_window_esm_getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    const slide = swiper.slides.eq(index);
    let value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key}/${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }

    if (swiper.params.history.keepQuery) {
      value += location.search;
    }

    const currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };

  const init = () => {
    const window = ssr_window_esm_getWindow();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  const destroy = () => {
    const window = ssr_window_esm_getWindow();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/hash-navigation/hash-navigation.js


function HashNavigation(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    on
  } = _ref;
  let initialized = false;
  const document = getDocument();
  const window = ssr_window_esm_getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
      emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');

    if (hash) {
      const speed = 0;

      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      dom(window).on('hashchange', onHashChange);
    }
  };

  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      dom(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/thumbs/thumbs.js


function Thumb(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && dom(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(dom(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (utils_isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }
  }

  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/free-mode/free-mode.js

function freeMode(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    once
  } = _ref;
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }

  function onTouchEnd(_ref2) {
    let {
      currentPos
    } = _ref2;
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/grid/grid.js
function Grid(_ref) {
  let {
    swiper,
    extendParams
  } = _ref;
  extendParams({
    grid: {
      rows: 1,
      fill: 'column'
    }
  });
  let slidesNumberEvenToRows;
  let slidesPerRow;
  let numFullColumns;

  const initSlides = slidesLength => {
    const {
      slidesPerView
    } = swiper.params;
    const {
      rows,
      fill
    } = swiper.params.grid;
    slidesPerRow = slidesNumberEvenToRows / rows;
    numFullColumns = Math.floor(slidesLength / rows);

    if (Math.floor(slidesLength / rows) === slidesLength / rows) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
    }

    if (slidesPerView !== 'auto' && fill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    }
  };

  const updateSlide = (i, slide, slidesLength, getDirectionLabel) => {
    const {
      slidesPerGroup,
      spaceBetween
    } = swiper.params;
    const {
      rows,
      fill
    } = swiper.params.grid; // Set slides order

    let newSlideOrderIndex;
    let column;
    let row;

    if (fill === 'row' && slidesPerGroup > 1) {
      const groupIndex = Math.floor(i / (slidesPerGroup * rows));
      const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
      const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
      row = Math.floor(slideIndexInGroup / columnsInGroup);
      column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
      newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
      slide.css({
        '-webkit-order': newSlideOrderIndex,
        order: newSlideOrderIndex
      });
    } else if (fill === 'column') {
      column = Math.floor(i / rows);
      row = i - column * rows;

      if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
        row += 1;

        if (row >= rows) {
          row = 0;
          column += 1;
        }
      }
    } else {
      row = Math.floor(i / slidesPerRow);
      column = i - row * slidesPerRow;
    }

    slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
  };

  const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel) => {
    const {
      spaceBetween,
      centeredSlides,
      roundLengths
    } = swiper.params;
    const {
      rows
    } = swiper.params.grid;
    swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
    swiper.$wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
    });

    if (centeredSlides) {
      snapGrid.splice(0, snapGrid.length);
      const newSlidesGrid = [];

      for (let i = 0; i < snapGrid.length; i += 1) {
        let slidesGridItem = snapGrid[i];
        if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid.push(...newSlidesGrid);
    }
  };

  swiper.grid = {
    initSlides,
    updateSlide,
    updateWrapperSize
  };
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/appendSlide.js
function appendSlide(slides) {
  const swiper = this;
  const {
    $wrapperEl,
    params
  } = swiper;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/prependSlide.js
function prependSlide(slides) {
  const swiper = this;
  const {
    params,
    $wrapperEl,
    activeIndex
  } = swiper;

  if (params.loop) {
    swiper.loopDestroy();
  }

  let newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/addSlide.js
function addSlide(index, slides) {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    activeIndex
  } = swiper;
  let activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
  }

  const baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  const slidesBuffer = [];

  for (let i = baseLength - 1; i >= index; i -= 1) {
    const currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (let i = 0; i < slidesBuffer.length; i += 1) {
    $wrapperEl.append(slidesBuffer[i]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/removeSlide.js
function removeSlide(slidesIndexes) {
  const swiper = this;
  const {
    params,
    $wrapperEl,
    activeIndex
  } = swiper;
  let activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
  }

  let newActiveIndex = activeIndexBuffer;
  let indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (let i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!params.observer) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/removeAllSlides.js
function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];

  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/manipulation.js





function Manipulation(_ref) {
  let {
    swiper
  } = _ref;
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper)
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-init.js
function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);

    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }

    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;

    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows

      swiper.slides.each(slideEl => {
        const $slideEl = swiper.$(slideEl);
        $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
      }); // create new one

      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;

    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }

    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-target.js
function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/effect-virtual-transition-end.js
function effectVirtualTransitionEnd(_ref) {
  let {
    swiper,
    duration,
    transformEl,
    allSlides
  } = _ref;
  const {
    slides,
    activeIndex,
    $wrapperEl
  } = swiper;

  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let $transitionEndTarget;

    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
    }

    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered) return;
      if (!swiper || swiper.destroyed) return;
      eventTriggered = true;
      swiper.animating = false;
      const triggerEvents = ['webkitTransitionEnd', 'transitionend'];

      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.js



function EffectFade(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    fadeEffect: {
      crossFade: false,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = swiper.slides.eq(i);
      const offset = $slideEl[0].swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.css({
        opacity: slideOpacity
      }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.fadeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cube/effect-cube.js


function EffectCube(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  const createSlideShadows = ($slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = dom(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
      $slideEl.append(shadowBefore);
    }

    if (shadowAfter.length === 0) {
      shadowAfter = dom(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
      $slideEl.append(shadowAfter);
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.each(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows(dom(slideEl), progress, isHorizontal);
    });
  };

  const setTranslate = () => {
    const {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = dom('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: `${swiperWidth}px`
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = dom('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, isHorizontal);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }

    const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };

  const setTransition = duration => {
    const {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-shadow.js

function createShadow(params, $slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

  if (!$shadowEl.length) {
    $shadowEl = dom(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-flip/effect-flip.js





function EffectFlip(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  const createSlideShadows = ($slideEl, progress, params) => {
    let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = createShadow(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }

    if (shadowAfter.length === 0) {
      shadowAfter = createShadow(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // Set shadows
    const params = swiper.params.flipEffect;
    swiper.slides.each(slideEl => {
      const $slideEl = dom(slideEl);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }

      createSlideShadows($slideEl, progress, params);
    });
  };

  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, params);
      }

      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.flipEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js



function EffectCoverflow(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth; // Each slide offset from center

    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = createShadow(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = createShadow(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.coverflowEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-creative/effect-creative.js




function EffectCreative(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };

  const setTranslate = () => {
    const {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

      if (custom && data.shadow || !custom) {
        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.creativeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cards/effect-cards.js




function EffectCards(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null,
      rotate: true
    }
  });

  const setTranslate = () => {
    const {
      slides,
      activeIndex
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = swiper.translate;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -2 * progress;
      let tXAdd = 8 - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }

      if (progress < 0) {
        // next
        tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }

      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }

      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;

      if (params.slideShadows) {
        // Set shadows
        let $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.cardsEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/swiper.esm.js
/**
 * Swiper 8.2.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2022 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 10, 2022
 */



























/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		__webpack_require__.b = document.baseURI || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			610: 0,
/******/ 			653: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// no jsonp function
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
var exports = {};
var __webpack_unused_export__;


__webpack_require__(6699);

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = void 0;
/*Lit */

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);

const class_map_js_1 = __webpack_require__(9455);
/*SCSS*/


const hamburger_menu_scss_1 = __importDefault(__webpack_require__(7560));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);
/*Helpers*/


const sizeHelper_1 = __importDefault(__webpack_require__(6995));

const pathHelper_1 = __importDefault(__webpack_require__(4093));
/*Components*/


__webpack_require__(589);

__webpack_require__(1417);

let HamburgerMenu = class HamburgerMenu extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

    super();
    this.messages = [];
    this.portalBaseUrl = (_a = "") !== null && _a !== void 0 ? _a : '';
    this.favoritesPortletCardSize = 'small';
    this.gridPortletCardSize = 'medium';
    this.defaultOrgLogo = '';
    this.forceOrgLogo = '';
    this.contextApiUrl = (_b = "/uPortal") !== null && _b !== void 0 ? _b : '';
    this.favoriteApiUrl = ((_c = "/uPortal") !== null && _c !== void 0 ? _c : '') + ((_d = "/api/layout") !== null && _d !== void 0 ? _d : '');
    this.layoutApiUrl = ((_e = "/uPortal") !== null && _e !== void 0 ? _e : '') + ((_f = "/api/v4-3/dlm/layout.json") !== null && _f !== void 0 ? _f : '');
    this.portletApiUrl = ((_g = "/uPortal") !== null && _g !== void 0 ? _g : '') + ((_h = "/api/v4-3/dlm/portletRegistry.json") !== null && _h !== void 0 ? _h : '');
    this.organizationApiUrl = '';
    this.userInfoApiUrl = ((_j = "/uPortal") !== null && _j !== void 0 ? _j : '') + ((_k = "/api/v5-1/userinfo") !== null && _k !== void 0 ? _k : '');
    this.userInfo = null;
    this.signoutUrl = (_l = "/uPortal/Logout") !== null && _l !== void 0 ? _l : '';
    this.userInfoPortletUrl = '';
    this.switchOrgPortletUrl = '';
    this.switchOrgEvent = false;
    this.orgAttributeName = 'ESCOSIRENCourant[0]';
    this.orgLogoUrlAttributeName = 'otherAttributes.ESCOStructureLogo[0]';
    this.userAllOrgsIdAttributeName = 'ESCOSIREN';
    this.hideActionMode = 'auto';
    this.showFavoritesInSlider = false;
    this.iconType = 'hamburger';
    this.disableCache = false;
    this.cacheTTL = (_m = "60") !== null && _m !== void 0 ? _m : 60;
    this.debug = false;
    this._isAppended = false;
    this._isVisible = false;
    this._isLoaded = false;
    this._isSwitchOrg = false;
    this.debugLog('Component loaded');
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('switch-org', this.toggleSwitchOrg.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('switch-org', this.toggleSwitchOrg.bind(this));
  }

  shouldUpdate() {
    if (this.defaultOrgLogo === '') {
      this.errorLog('default-org-logo attribute is required');
      return false;
    }

    return true;
  }

  toggleMenu(e) {
    e.preventDefault();
    this._isVisible = !this._isVisible;

    if (this._isVisible && !this._isLoaded) {
      this._isLoaded = true;
    }

    const html = document.querySelector('html');

    if (html) {
      html.style.overflowY = this._isVisible ? 'hidden' : 'auto';
    }

    const toggleEvt = new CustomEvent('toggle', {
      detail: {
        isVisible: this._isVisible
      }
    });
    this.dispatchEvent(toggleEvt);
  }

  toggleSwitchOrg(e) {
    e.preventDefault();
    this._isSwitchOrg = !this._isSwitchOrg;
  }

  render() {
    const isSwitchOrgEvent = this.switchOrgEvent && !this.switchOrgPortletUrl.includes('/p/');
    return (0, lit_1.html)`
      <div class="hamburger-menu">
        <button
          class="content-menu-toggle"
          role="button"
          title="Menu"
          @click=${this.toggleMenu}
        >
          ${this._renderIcon()}
        </button>
        ${this._isLoaded ? (0, lit_1.html)`
              <div>
                <slot name="menu-content">
                  <esco-content-menu
                    class="${(0, class_map_js_1.classMap)({
      'active-menu': this._isVisible
    })}"
                    portal-base-url="${this.portalBaseUrl}"
                    context-api-url="${this.contextApiUrl}"
                    ?debug="${this.debug}"
                    default-org-logo="${this.defaultOrgLogo}"
                    favorite-api-url="${this.favoriteApiUrl}"
                    favorites-portlet-card-size="${this.favoritesPortletCardSize}"
                    force-org-logo="${this.forceOrgLogo}"
                    grid-portlet-card-size="${this.gridPortletCardSize}"
                    hide-action-mode="${this.hideActionMode}"
                    ?is-hidden="${!this._isVisible}"
                    layout-api-url="${this.layoutApiUrl}"
                    .messages="${this.messages}"
                    organization-api-url="${this.organizationApiUrl}"
                    org-logo-url-attribute-name="${this.orgLogoUrlAttributeName}"
                    portlet-api-url="${this.portletApiUrl}"
                    sign-out-url="${this.signoutUrl}"
                    ?show-favorites-in-slider="${this.showFavoritesInSlider}"
                    switch-org-portlet-url="${this.switchOrgPortletUrl}"
                    user-org-id-attribute-name="${this.orgAttributeName}"
                    user-all-orgs-id-attribute-name="${this.userAllOrgsIdAttributeName}"
                    user-info-api-url="${this.userInfoApiUrl}"
                    user-info=${this.userInfo ? JSON.stringify(this.userInfo) : lit_1.nothing}
                    user-info-portlet-url="${this.userInfoPortletUrl}"
                    @close=${this.toggleMenu.bind(this)}
                    ?fake-attribute="${true}"
                    ?disable-cache="${this.disableCache}"
                    cache-ttl="${this.cacheTTL}"
                    ?switch-org-event="${isSwitchOrgEvent}"
                    @switch-org=${this.toggleSwitchOrg}
                  ></esco-content-menu>
                </slot>
              </div>
            ` : (0, lit_1.html)``}
      </div>
      ${isSwitchOrgEvent ? (0, lit_1.html)`
            <change-etab
              show="${this._isSwitchOrg}"
              change-etab-api="${this.switchOrgPortletUrl}"
              user-info-api-url="${pathHelper_1.default.getUrl(this.userInfoApiUrl, this.portalBaseUrl, this.debug)}"
            ></change-etab>
          ` : (0, lit_1.html)``}
    `;
  }

  _renderIcon() {
    const classes = {
      'menu-icon': true,
      'hamburger-icon': false,
      'four-square-icon': false,
      'nine-square-icon': false,
      'four-circle-icon': false,
      'nine-circle-icon': false,
      'empty-icon': false
    };
    let elNumber = 3;

    switch (this.iconType) {
      case 'four-empty-square':
        classes['empty-icon'] = true;
      // eslint-disable-next-line no-fallthrough

      case 'four-square':
        classes['four-square-icon'] = true;
        elNumber = 4;
        break;

      case 'nine-empty-square':
        classes['empty-icon'] = true;
      // eslint-disable-next-line no-fallthrough

      case 'nine-square':
        classes['nine-square-icon'] = true;
        elNumber = 9;
        break;

      case 'four-empty-circle':
        classes['empty-icon'] = true;
      // eslint-disable-next-line no-fallthrough

      case 'four-circle':
        classes['four-circle-icon'] = true;
        elNumber = 4;
        break;

      case 'nine-empty-circle':
        classes['empty-icon'] = true;
      // eslint-disable-next-line no-fallthrough

      case 'nine-circle':
        classes['nine-circle-icon'] = true;
        elNumber = 9;
        break;

      default:
        classes['hamburger-icon'] = true;
        elNumber = 3;
        break;
    }

    return (0, lit_1.html)`
      <slot name="menu-icon" slot="menu-icon">
        <div class="${(0, class_map_js_1.classMap)(classes)}">
          ${[...Array(elNumber)].map((element, index) => (0, lit_1.html)`<div id="icon-elem-${index}" class="icon-elem"></div>`)}
        </div>
      </slot>
    `;
  }

};
HamburgerMenu.styles = [(0, lit_1.css)`
      ${(0, lit_1.unsafeCSS)(hamburger_menu_scss_1.default)}
    `];

__decorate([(0, decorators_js_1.property)({
  type: Array
})], HamburgerMenu.prototype, "messages", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portal-base-url'
})], HamburgerMenu.prototype, "portalBaseUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'favorites-portlet-card-size'
})], HamburgerMenu.prototype, "favoritesPortletCardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return sizeHelper_1.default.validate(newVal, true, true);
  },

  attribute: 'grid-portlet-card-size'
})], HamburgerMenu.prototype, "gridPortletCardSize", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'default-org-logo'
})], HamburgerMenu.prototype, "defaultOrgLogo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'force-org-logo'
})], HamburgerMenu.prototype, "forceOrgLogo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'context-api-url'
})], HamburgerMenu.prototype, "contextApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'favorite-api-url'
})], HamburgerMenu.prototype, "favoriteApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'layout-api-url'
})], HamburgerMenu.prototype, "layoutApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'portlet-api-url'
})], HamburgerMenu.prototype, "portletApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'organization-api-url'
})], HamburgerMenu.prototype, "organizationApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-api-url'
})], HamburgerMenu.prototype, "userInfoApiUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Object,
  attribute: 'user-info'
})], HamburgerMenu.prototype, "userInfo", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'sign-out-url'
})], HamburgerMenu.prototype, "signoutUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-info-portlet-url'
})], HamburgerMenu.prototype, "userInfoPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'switch-org-portlet-url'
})], HamburgerMenu.prototype, "switchOrgPortletUrl", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'switch-org-event'
})], HamburgerMenu.prototype, "switchOrgEvent", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-org-id-attribute-name'
})], HamburgerMenu.prototype, "orgAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'org-logo-url-attribute-name'
})], HamburgerMenu.prototype, "orgLogoUrlAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'user-all-orgs-id-attribute-name'
})], HamburgerMenu.prototype, "userAllOrgsIdAttributeName", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return ['auto', 'always', 'never'].includes(newVal);
  },

  attribute: 'hide-action-mode'
})], HamburgerMenu.prototype, "hideActionMode", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'show-favorites-in-slider'
})], HamburgerMenu.prototype, "showFavoritesInSlider", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,

  hasChanged(newVal) {
    return ['hamburger', 'four-square', 'four-empty-square', 'nine-square', 'nine-empty-square', 'four-circle', 'four-empty-circle', 'nine-circle', 'nine-empty-circle'].includes(newVal);
  },

  attribute: 'icon-type'
})], HamburgerMenu.prototype, "iconType", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean,
  attribute: 'disable-cache'
})], HamburgerMenu.prototype, "disableCache", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Number,
  attribute: 'cache-ttl'
})], HamburgerMenu.prototype, "cacheTTL", void 0);

__decorate([(0, decorators_js_1.property)({
  type: Boolean
})], HamburgerMenu.prototype, "debug", void 0);

__decorate([(0, decorators_js_1.state)()], HamburgerMenu.prototype, "_isAppended", void 0);

__decorate([(0, decorators_js_1.state)()], HamburgerMenu.prototype, "_isVisible", void 0);

__decorate([(0, decorators_js_1.state)()], HamburgerMenu.prototype, "_isLoaded", void 0);

__decorate([(0, decorators_js_1.state)()], HamburgerMenu.prototype, "_isSwitchOrg", void 0);

HamburgerMenu = __decorate([(0, decorators_js_1.customElement)('esco-hamburger-menu')], HamburgerMenu);
__webpack_unused_export__ = HamburgerMenu;
}();
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
var exports = __webpack_exports__;
var __webpack_unused_export__;


__webpack_require__(6699);

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = void 0;
/*Lit*/

const lit_1 = __webpack_require__(9392);

const decorators_js_1 = __webpack_require__(5595);
/*SCSS*/


const content_grid_filter_scss_1 = __importDefault(__webpack_require__(2939));
/*Localization*/


const localize_1 = __webpack_require__(1799);

const localization_1 = __webpack_require__(82);

const langHelper_1 = __importDefault(__webpack_require__(203));
/*Mixins*/


const litLoggable_1 = __webpack_require__(9937);

let ContentGridFilter = class ContentGridFilter extends (0, litLoggable_1.LitLoggable)(lit_1.LitElement) {
  constructor() {
    super();
    this.categories = [];
    this.filterCategory = null;
    this.debugLog('Component loaded');
    const lhOpts = {
      languageCodeOnly: true,
      availableLanguages: ['fr', 'en'],
      defaultLanguage: 'en'
    };
    const lang = langHelper_1.default.getPageLang(lhOpts);
    (0, localization_1.setLocale)(lang);
    langHelper_1.default.setLocale(lang);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('esco-cm-grid-filter', this.getExternalFilter.bind(this));
    window.addEventListener('esco-cm-request-grid-filter', this.sendExternalFilter);
    window.addEventListener('esco-cm-categories', this.getCategories.bind(this));
  }

  disconnectedCallback() {
    super.connectedCallback();
    window.removeEventListener('esco-cm-grid-filter', this.getExternalFilter.bind(this));
    window.removeEventListener('esco-cm-request-grid-filter', this.sendExternalFilter);
    window.removeEventListener('esco-cm-categories', this.getCategories.bind(this));
  }

  firstUpdated() {
    if (this.categories.length == 0) {
      this.requestCategories();
    }

    if (this.filterCategory !== null) {
      this.sendExternalFilter();
    }
  }

  getCategories(e) {
    var _a;

    if ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.categories) {
      this.categories = e.detail.categories;
    }
  }

  getExternalFilter(e) {
    if ((this.categories.includes(e.detail.category) || e.detail.category == '') && this.filterCategory != e.detail.category) {
      this.filterCategory = e.detail.category;
    }
  }

  requestCategories() {
    const reqCatEvt = new CustomEvent('esco-cm-request-categories');
    window.dispatchEvent(reqCatEvt);
  }

  sendExternalFilter() {
    const filterEvt = new CustomEvent('esco-cm-grid-filter', {
      detail: {
        category: this.filterCategory
      }
    });
    window.dispatchEvent(filterEvt);
  }

  onFilter(e) {
    const target = e.target || e.srcElement;
    this.filterCategory = target === null || target === void 0 ? void 0 : target.value;
    this.sendExternalFilter();
  }

  render() {
    return (0, lit_1.html)`
      <select @change=${this.onFilter.bind(this)} class="grid-categories">
        <option class="default" selected value="">
          ${langHelper_1.default.localTransation('message.filter.selectOption', (0, localize_1.msg)((0, localize_1.str)`Search a service...`))}
        </option>
        ${this.categories.map(cat => {
      return (0, lit_1.html)`
            <option
              value="${cat}"
              label="${cat}"
              ?selected="${cat == this.filterCategory}"
            >
              ${cat}
            </option>
          `;
    })}
      </select>
    `;
  }

};
ContentGridFilter.styles = (0, lit_1.css)`
    ${(0, lit_1.unsafeCSS)(content_grid_filter_scss_1.default)}
  `;

__decorate([(0, decorators_js_1.property)({
  type: Array
})], ContentGridFilter.prototype, "categories", void 0);

__decorate([(0, decorators_js_1.property)({
  type: String,
  attribute: 'filter-Category',
  reflect: true
})], ContentGridFilter.prototype, "filterCategory", void 0);

ContentGridFilter = __decorate([(0, localize_1.localized)(), (0, decorators_js_1.customElement)('esco-content-grid-filter')], ContentGridFilter);
__webpack_unused_export__ = ContentGridFilter;
}();
/******/ })()
;